/* Auto-generated from node ref/framer_complete_tree*.html — do not edit by hand */
export const CIRCUIT_ANIM = {
  "incoming": [
    {
      "colors": {
        "framer-1w8ax9q": "rgba(255, 255, 255, 0.2)",
        "framer-10zqzn8": "rgba(255, 255, 255, 0.25)",
        "framer-16aps75": "rgba(255, 255, 255, 0.25)",
        "framer-zxjavu": "rgba(255, 255, 255, 0.25)",
        "framer-1cbnxi6": "rgba(255, 255, 255, 0.25)",
        "framer-509c9k": "rgba(255, 255, 255, 0.2)",
        "framer-1p2nd0x": "rgba(255, 255, 255, 0.25)",
        "framer-5zdsy3": "rgba(255, 255, 255, 0.25)",
        "framer-rb7tgg": "rgba(255, 255, 255, 0.25)",
        "framer-l9h9t": "rgba(255, 255, 255, 0.25)",
        "framer-1vebirv": "rgba(255, 255, 255, 0.25)",
        "framer-1ek2ntw": "rgba(255, 255, 255, 0.2)",
        "framer-udx3b7": "rgba(255, 255, 255, 0.25)",
        "framer-1srqsok": "rgba(255, 255, 255, 0.25)",
        "framer-9nc9id": "rgba(255, 255, 255, 0.2)",
        "framer-1ofdk4s": "rgba(255, 255, 255, 0.25)",
        "framer-1k6exy": "rgba(255, 255, 255, 0.2)",
        "framer-mc2qtp": "rgba(255, 255, 255, 0.25)",
        "framer-81ti9p": "rgba(255, 255, 255, 0.2)",
        "framer-hlbzv7": "rgba(255, 255, 255, 0.25)",
        "framer-coqz6k": "rgba(255, 255, 255, 0.25)",
        "framer-lju48b": "rgba(255, 255, 255, 0.2)",
        "framer-1py28mu": "rgba(255, 255, 255, 0.25)",
        "framer-d7lr7a": "rgba(255, 255, 255, 0.2)",
        "framer-qgi9rw": "rgba(255, 255, 255, 0.2)",
        "framer-1wx0g94": "rgba(255, 255, 255, 0.25)",
        "framer-1bi8trk": "rgba(255, 255, 255, 0.2)",
        "framer-pdaimz": "rgba(255, 255, 255, 0.25)",
        "framer-1uilx9a": "rgba(255, 255, 255, 0.25)",
        "framer-241d3h": "rgba(255, 255, 255, 0.2)",
        "framer-14friu6": "rgba(255, 255, 255, 0.25)",
        "framer-bnmz84": "rgba(255, 255, 255, 0.2)",
        "framer-y9p8sz": "rgba(255, 255, 255, 0.25)",
        "framer-38bfbr": "rgba(255, 255, 255, 0.25)",
        "framer-835p5p": "rgba(255, 255, 255, 0.25)",
        "framer-avufpe": "rgba(255, 255, 255, 0.25)",
        "framer-19pc0kj": "rgba(255, 255, 255, 0.25)",
        "framer-5qn9pd": "rgba(255, 255, 255, 0.25)",
        "framer-6ptcky": "rgba(255, 255, 255, 0.25)",
        "framer-1bj87uo": "rgba(255, 255, 255, 0.25)",
        "framer-18pms2q": "rgba(255, 255, 255, 0.25)",
        "framer-1c1kal9": "rgba(255, 255, 255, 0.25)",
        "framer-1gmddus": "rgba(255, 255, 255, 0.25)",
        "framer-1ezdpyx": "rgba(255, 255, 255, 0.25)",
        "framer-1p8exka": "rgba(255, 255, 255, 0.25)",
        "framer-189dxp8": "rgba(255, 255, 255, 0.25)",
        "framer-1ulq471": "rgba(255, 255, 255, 0.25)",
        "framer-10z8y9q": "rgba(255, 255, 255, 0.25)",
        "framer-1apznw0": "rgba(255, 255, 255, 0.25)",
        "framer-m3tzga": "rgba(255, 255, 255, 0.2)",
        "framer-1loag9g": "rgba(255, 255, 255, 0.25)",
        "framer-nga6nl": "rgba(255, 255, 255, 0.2)",
        "framer-m0s6fb": "rgba(255, 255, 255, 0.2)",
        "framer-a6p501": "rgba(255, 255, 255, 0.25)",
        "framer-1fzzjgo": "rgba(255, 255, 255, 0.2)",
        "framer-tz4lb": "rgba(255, 255, 255, 0.25)",
        "framer-1x5el1k": "rgba(255, 255, 255, 0.2)",
        "framer-z8ozv6": "rgba(255, 255, 255, 0.2)",
        "framer-18tigbk": "rgba(255, 255, 255, 0.25)",
        "framer-1wvkwoy": "rgba(255, 255, 255, 0.25)",
        "framer-iqni9n": "rgba(255, 255, 255, 0.25)",
        "framer-1szxjbv": "rgba(255, 255, 255, 0.25)",
        "framer-9cy2q7": "rgba(255, 255, 255, 0.2)",
        "framer-150y87y": "rgba(255, 255, 255, 0.2)",
        "framer-1rxhzpr": "rgba(255, 255, 255, 0.2)",
        "framer-8axohn": "rgba(255, 255, 255, 0.25)",
        "framer-1hjgm86": "rgba(255, 255, 255, 0.25)",
        "framer-1ed9ris": "rgba(255, 255, 255, 0.2)",
        "framer-11gf6c6": "rgba(255, 255, 255, 0.25)",
        "framer-ghoiiw": "rgba(255, 255, 255, 0.2)",
        "framer-9czbtf": "rgba(255, 255, 255, 0.25)",
        "framer-6b9cdp": "rgba(255, 255, 255, 0.2)",
        "framer-yls8eq": "rgba(255, 255, 255, 0.2)",
        "framer-hpo01f": "rgba(255, 255, 255, 0.25)",
        "framer-1o4ul04": "rgba(255, 255, 255, 0.2)",
        "framer-1phyaib": "rgba(255, 255, 255, 0.25)",
        "framer-hobs9u": "rgba(255, 255, 255, 0.25)",
        "framer-d3rapa": "rgba(255, 255, 255, 0.2)",
        "framer-7g76hm": "rgba(255, 255, 255, 0.25)",
        "framer-1vkr8cb": "rgba(255, 255, 255, 0.2)",
        "framer-1n4yjyc": "rgba(255, 255, 255, 0.25)",
        "framer-u5k3fd": "rgba(255, 255, 255, 0.25)",
        "framer-11twtea": "rgba(255, 255, 255, 0.25)",
        "framer-17ypuap": "rgba(255, 255, 255, 0.25)",
        "framer-1ws7c6v": "rgba(255, 255, 255, 0.25)",
        "framer-1yr6lkt": "rgba(255, 255, 255, 0.25)",
        "framer-m99uc9": "rgba(255, 255, 255, 0.25)",
        "framer-b9ztq4": "rgba(255, 255, 255, 0.25)",
        "framer-1bj1ntz": "rgba(255, 255, 255, 0.25)",
        "framer-1wb246e": "rgba(255, 255, 255, 0.25)",
        "framer-ytou5k": "rgba(255, 255, 255, 0.25)",
        "framer-ak21r0": "rgba(255, 255, 255, 0.25)",
        "framer-frl2xa": "rgba(255, 255, 255, 0.25)",
        "framer-5vsmr8": "rgba(255, 255, 255, 0.25)",
        "framer-ie39ga": "rgba(255, 255, 255, 0.25)",
        "framer-312syl": "rgba(255, 255, 255, 0.25)",
        "framer-iamo1c": "rgba(255, 255, 255, 0.25)",
        "framer-1w16k1k": "rgba(255, 255, 255, 0.2)",
        "framer-hskubr": "rgba(255, 255, 255, 0.25)",
        "framer-1vfnnof": "rgba(255, 255, 255, 0.2)",
        "framer-1hlpk06": "rgba(255, 255, 255, 0.25)",
        "framer-u7gl98": "rgba(255, 255, 255, 0.2)",
        "framer-190rppy": "rgba(255, 255, 255, 0.25)",
        "framer-koeiog": "rgba(255, 255, 255, 0.2)",
        "framer-1vvs522": "rgba(255, 255, 255, 0.2)",
        "framer-1pne890": "rgba(255, 255, 255, 0.25)",
        "framer-4hgyp4": "rgba(255, 255, 255, 0.2)",
        "framer-o93pit": "rgba(255, 255, 255, 0.25)",
        "framer-1adkulj": "rgba(255, 255, 255, 0.2)",
        "framer-hcii4i": "rgba(255, 255, 255, 0.25)",
        "framer-zf5eqc": "rgba(255, 255, 255, 0.2)",
        "framer-1luxg98": "rgba(255, 255, 255, 0.25)",
        "framer-jzsjbf": "rgba(255, 255, 255, 0.25)",
        "framer-gw5epp": "rgba(255, 255, 255, 0.25)",
        "framer-2z297n": "rgba(255, 255, 255, 0.25)",
        "framer-1wcvqav": "rgba(255, 255, 255, 0.25)",
        "framer-1dn8st2": "rgba(255, 255, 255, 0.25)",
        "framer-n2ea51": "rgba(255, 255, 255, 0.25)",
        "framer-y5raoz": "rgba(255, 255, 255, 0.25)",
        "framer-1x00w45": "rgba(255, 255, 255, 0.25)",
        "framer-wz662h": "rgba(255, 255, 255, 0.25)",
        "framer-vwe6fu": "rgba(255, 255, 255, 0.25)",
        "framer-zgre45": "rgba(255, 255, 255, 0.25)",
        "framer-nlmebn": "rgba(255, 255, 255, 0.25)",
        "framer-1ahvqss": "rgba(255, 255, 255, 0.25)",
        "framer-25ngdh": "rgba(255, 255, 255, 0.25)",
        "framer-1geqn87": "rgba(255, 255, 255, 0.25)",
        "framer-1hc7xpv": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": "framer-v-wrbd6c",
      "variantName": null,
      "source": "framer_complete_tree.html"
    },
    {
      "colors": {
        "framer-1w8ax9q": "rgba(255, 255, 255, 0.224)",
        "framer-10zqzn8": "rgba(255, 255, 255, 0.243)",
        "framer-16aps75": "rgba(255, 255, 255, 0.243)",
        "framer-zxjavu": "rgba(255, 255, 255, 0.243)",
        "framer-1cbnxi6": "rgba(255, 255, 255, 0.243)",
        "framer-509c9k": "rgba(255, 255, 255, 0.224)",
        "framer-1p2nd0x": "rgba(255, 255, 255, 0.243)",
        "framer-5zdsy3": "rgba(255, 255, 255, 0.243)",
        "framer-rb7tgg": "rgba(255, 255, 255, 0.243)",
        "framer-l9h9t": "rgba(255, 255, 255, 0.243)",
        "framer-1vebirv": "rgba(255, 255, 255, 0.243)",
        "framer-1ek2ntw": "rgba(255, 255, 255, 0.224)",
        "framer-udx3b7": "rgba(255, 255, 255, 0.243)",
        "framer-1srqsok": "rgba(255, 255, 255, 0.243)",
        "framer-9nc9id": "rgba(255, 255, 255, 0.224)",
        "framer-1ofdk4s": "rgba(255, 255, 255, 0.243)",
        "framer-1k6exy": "rgba(255, 255, 255, 0.2)",
        "framer-mc2qtp": "rgba(255, 255, 255, 0.267)",
        "framer-81ti9p": "rgba(255, 255, 255, 0.2)",
        "framer-hlbzv7": "rgba(255, 255, 255, 0.243)",
        "framer-coqz6k": "rgba(255, 255, 255, 0.267)",
        "framer-lju48b": "rgba(255, 255, 255, 0.2)",
        "framer-1py28mu": "rgba(255, 255, 255, 0.243)",
        "framer-d7lr7a": "rgba(255, 255, 255, 0.2)",
        "framer-qgi9rw": "rgba(255, 255, 255, 0.2)",
        "framer-1wx0g94": "rgba(255, 255, 255, 0.243)",
        "framer-1bi8trk": "rgba(255, 255, 255, 0.2)",
        "framer-pdaimz": "rgba(255, 255, 255, 0.267)",
        "framer-1uilx9a": "rgba(255, 255, 255, 0.243)",
        "framer-241d3h": "rgba(255, 255, 255, 0.2)",
        "framer-14friu6": "rgba(255, 255, 255, 0.267)",
        "framer-bnmz84": "rgba(255, 255, 255, 0.2)",
        "framer-y9p8sz": "rgba(255, 255, 255, 0.243)",
        "framer-38bfbr": "rgba(255, 255, 255, 0.243)",
        "framer-835p5p": "rgba(255, 255, 255, 0.267)",
        "framer-avufpe": "rgba(255, 255, 255, 0.243)",
        "framer-19pc0kj": "rgba(255, 255, 255, 0.267)",
        "framer-5qn9pd": "rgba(255, 255, 255, 0.243)",
        "framer-6ptcky": "rgba(255, 255, 255, 0.243)",
        "framer-1bj87uo": "rgba(255, 255, 255, 0.243)",
        "framer-18pms2q": "rgba(255, 255, 255, 0.243)",
        "framer-1c1kal9": "rgba(255, 255, 255, 0.267)",
        "framer-1gmddus": "rgba(255, 255, 255, 0.243)",
        "framer-1ezdpyx": "rgba(255, 255, 255, 0.243)",
        "framer-1p8exka": "rgba(255, 255, 255, 0.243)",
        "framer-189dxp8": "rgba(255, 255, 255, 0.243)",
        "framer-1ulq471": "rgba(255, 255, 255, 0.243)",
        "framer-10z8y9q": "rgba(255, 255, 255, 0.267)",
        "framer-1apznw0": "rgba(255, 255, 255, 0.267)",
        "framer-m3tzga": "rgba(255, 255, 255, 0.2)",
        "framer-1loag9g": "rgba(255, 255, 255, 0.243)",
        "framer-nga6nl": "rgba(255, 255, 255, 0.2)",
        "framer-m0s6fb": "rgba(255, 255, 255, 0.2)",
        "framer-a6p501": "rgba(255, 255, 255, 0.243)",
        "framer-1fzzjgo": "rgba(255, 255, 255, 0.2)",
        "framer-tz4lb": "rgba(255, 255, 255, 0.267)",
        "framer-1x5el1k": "rgba(255, 255, 255, 0.2)",
        "framer-z8ozv6": "rgba(255, 255, 255, 0.2)",
        "framer-18tigbk": "rgba(255, 255, 255, 0.267)",
        "framer-1wvkwoy": "rgba(255, 255, 255, 0.243)",
        "framer-iqni9n": "rgba(255, 255, 255, 0.243)",
        "framer-1szxjbv": "rgba(255, 255, 255, 0.267)",
        "framer-9cy2q7": "rgba(255, 255, 255, 0.2)",
        "framer-150y87y": "rgba(255, 255, 255, 0.2)",
        "framer-1rxhzpr": "rgba(255, 255, 255, 0.2)",
        "framer-8axohn": "rgba(255, 255, 255, 0.267)",
        "framer-1hjgm86": "rgba(255, 255, 255, 0.243)",
        "framer-1ed9ris": "rgba(255, 255, 255, 0.2)",
        "framer-11gf6c6": "rgba(255, 255, 255, 0.243)",
        "framer-ghoiiw": "rgba(255, 255, 255, 0.2)",
        "framer-9czbtf": "rgba(255, 255, 255, 0.267)",
        "framer-6b9cdp": "rgba(255, 255, 255, 0.2)",
        "framer-yls8eq": "rgba(255, 255, 255, 0.2)",
        "framer-hpo01f": "rgba(255, 255, 255, 0.243)",
        "framer-1o4ul04": "rgba(255, 255, 255, 0.2)",
        "framer-1phyaib": "rgba(255, 255, 255, 0.267)",
        "framer-hobs9u": "rgba(255, 255, 255, 0.267)",
        "framer-d3rapa": "rgba(255, 255, 255, 0.2)",
        "framer-7g76hm": "rgba(255, 255, 255, 0.243)",
        "framer-1vkr8cb": "rgba(255, 255, 255, 0.2)",
        "framer-1n4yjyc": "rgba(255, 255, 255, 0.267)",
        "framer-u5k3fd": "rgba(255, 255, 255, 0.243)",
        "framer-11twtea": "rgba(255, 255, 255, 0.243)",
        "framer-17ypuap": "rgba(255, 255, 255, 0.243)",
        "framer-1ws7c6v": "rgba(255, 255, 255, 0.243)",
        "framer-1yr6lkt": "rgba(255, 255, 255, 0.267)",
        "framer-m99uc9": "rgba(255, 255, 255, 0.243)",
        "framer-b9ztq4": "rgba(255, 255, 255, 0.243)",
        "framer-1bj1ntz": "rgba(255, 255, 255, 0.243)",
        "framer-1wb246e": "rgba(255, 255, 255, 0.267)",
        "framer-ytou5k": "rgba(255, 255, 255, 0.243)",
        "framer-ak21r0": "rgba(255, 255, 255, 0.243)",
        "framer-frl2xa": "rgba(255, 255, 255, 0.243)",
        "framer-5vsmr8": "rgba(255, 255, 255, 0.243)",
        "framer-ie39ga": "rgba(255, 255, 255, 0.243)",
        "framer-312syl": "rgba(255, 255, 255, 0.267)",
        "framer-iamo1c": "rgba(255, 255, 255, 0.243)",
        "framer-1w16k1k": "rgba(255, 255, 255, 0.2)",
        "framer-hskubr": "rgba(255, 255, 255, 0.267)",
        "framer-1vfnnof": "rgba(255, 255, 255, 0.2)",
        "framer-1hlpk06": "rgba(255, 255, 255, 0.267)",
        "framer-u7gl98": "rgba(255, 255, 255, 0.2)",
        "framer-190rppy": "rgba(255, 255, 255, 0.243)",
        "framer-koeiog": "rgba(255, 255, 255, 0.2)",
        "framer-1vvs522": "rgba(255, 255, 255, 0.2)",
        "framer-1pne890": "rgba(255, 255, 255, 0.243)",
        "framer-4hgyp4": "rgba(255, 255, 255, 0.2)",
        "framer-o93pit": "rgba(255, 255, 255, 0.267)",
        "framer-1adkulj": "rgba(255, 255, 255, 0.2)",
        "framer-hcii4i": "rgba(255, 255, 255, 0.267)",
        "framer-zf5eqc": "rgba(255, 255, 255, 0.2)",
        "framer-1luxg98": "rgba(255, 255, 255, 0.243)",
        "framer-jzsjbf": "rgba(255, 255, 255, 0.243)",
        "framer-gw5epp": "rgba(255, 255, 255, 0.243)",
        "framer-2z297n": "rgba(255, 255, 255, 0.243)",
        "framer-1wcvqav": "rgba(255, 255, 255, 0.267)",
        "framer-1dn8st2": "rgba(255, 255, 255, 0.243)",
        "framer-n2ea51": "rgba(255, 255, 255, 0.243)",
        "framer-y5raoz": "rgba(255, 255, 255, 0.267)",
        "framer-1x00w45": "rgba(255, 255, 255, 0.243)",
        "framer-wz662h": "rgba(255, 255, 255, 0.267)",
        "framer-vwe6fu": "rgba(255, 255, 255, 0.243)",
        "framer-zgre45": "rgba(255, 255, 255, 0.243)",
        "framer-nlmebn": "rgba(255, 255, 255, 0.243)",
        "framer-1ahvqss": "rgba(255, 255, 255, 0.243)",
        "framer-25ngdh": "rgba(255, 255, 255, 0.267)",
        "framer-1geqn87": "rgba(255, 255, 255, 0.243)",
        "framer-1hc7xpv": "rgba(255, 255, 255, 0.243)"
      },
      "vClass": "framer-v-z63jcn",
      "variantName": null,
      "source": "framer_complete_tree (2).html"
    },
    {
      "colors": {
        "framer-1w8ax9q": "rgba(255, 255, 255, 0.376)",
        "framer-10zqzn8": "rgba(255, 255, 255, 0.208)",
        "framer-16aps75": "rgba(255, 255, 255, 0.208)",
        "framer-zxjavu": "rgba(255, 255, 255, 0.208)",
        "framer-1cbnxi6": "rgba(255, 255, 255, 0.208)",
        "framer-509c9k": "rgba(255, 255, 255, 0.376)",
        "framer-1p2nd0x": "rgba(255, 255, 255, 0.208)",
        "framer-5zdsy3": "rgba(255, 255, 255, 0.208)",
        "framer-rb7tgg": "rgba(255, 255, 255, 0.208)",
        "framer-l9h9t": "rgba(255, 255, 255, 0.208)",
        "framer-1vebirv": "rgba(255, 255, 255, 0.208)",
        "framer-1ek2ntw": "rgba(255, 255, 255, 0.376)",
        "framer-udx3b7": "rgba(255, 255, 255, 0.208)",
        "framer-1srqsok": "rgba(255, 255, 255, 0.208)",
        "framer-9nc9id": "rgba(255, 255, 255, 0.376)",
        "framer-1ofdk4s": "rgba(255, 255, 255, 0.208)",
        "framer-1k6exy": "rgba(255, 255, 255, 0.2)",
        "framer-mc2qtp": "rgba(255, 255, 255, 0.38)",
        "framer-81ti9p": "rgba(255, 255, 255, 0.2)",
        "framer-hlbzv7": "rgba(255, 255, 255, 0.208)",
        "framer-coqz6k": "rgba(255, 255, 255, 0.38)",
        "framer-lju48b": "rgba(255, 255, 255, 0.2)",
        "framer-1py28mu": "rgba(255, 255, 255, 0.208)",
        "framer-d7lr7a": "rgba(255, 255, 255, 0.2)",
        "framer-qgi9rw": "rgba(255, 255, 255, 0.2)",
        "framer-1wx0g94": "rgba(255, 255, 255, 0.208)",
        "framer-1bi8trk": "rgba(255, 255, 255, 0.2)",
        "framer-pdaimz": "rgba(255, 255, 255, 0.38)",
        "framer-1uilx9a": "rgba(255, 255, 255, 0.208)",
        "framer-241d3h": "rgba(255, 255, 255, 0.2)",
        "framer-14friu6": "rgba(255, 255, 255, 0.38)",
        "framer-bnmz84": "rgba(255, 255, 255, 0.2)",
        "framer-y9p8sz": "rgba(255, 255, 255, 0.208)",
        "framer-38bfbr": "rgba(255, 255, 255, 0.208)",
        "framer-835p5p": "rgba(255, 255, 255, 0.38)",
        "framer-avufpe": "rgba(255, 255, 255, 0.208)",
        "framer-19pc0kj": "rgba(255, 255, 255, 0.38)",
        "framer-5qn9pd": "rgba(255, 255, 255, 0.208)",
        "framer-6ptcky": "rgba(255, 255, 255, 0.208)",
        "framer-1bj87uo": "rgba(255, 255, 255, 0.208)",
        "framer-18pms2q": "rgba(255, 255, 255, 0.208)",
        "framer-1c1kal9": "rgba(255, 255, 255, 0.38)",
        "framer-1gmddus": "rgba(255, 255, 255, 0.208)",
        "framer-1ezdpyx": "rgba(255, 255, 255, 0.208)",
        "framer-1p8exka": "rgba(255, 255, 255, 0.208)",
        "framer-189dxp8": "rgba(255, 255, 255, 0.208)",
        "framer-1ulq471": "rgba(255, 255, 255, 0.208)",
        "framer-10z8y9q": "rgba(255, 255, 255, 0.38)",
        "framer-1apznw0": "rgba(255, 255, 255, 0.38)",
        "framer-m3tzga": "rgba(255, 255, 255, 0.2)",
        "framer-1loag9g": "rgba(255, 255, 255, 0.208)",
        "framer-nga6nl": "rgba(255, 255, 255, 0.2)",
        "framer-m0s6fb": "rgba(255, 255, 255, 0.2)",
        "framer-a6p501": "rgba(255, 255, 255, 0.208)",
        "framer-1fzzjgo": "rgba(255, 255, 255, 0.2)",
        "framer-tz4lb": "rgba(255, 255, 255, 0.38)",
        "framer-1x5el1k": "rgba(255, 255, 255, 0.2)",
        "framer-z8ozv6": "rgba(255, 255, 255, 0.2)",
        "framer-18tigbk": "rgba(255, 255, 255, 0.38)",
        "framer-1wvkwoy": "rgba(255, 255, 255, 0.208)",
        "framer-iqni9n": "rgba(255, 255, 255, 0.208)",
        "framer-1szxjbv": "rgba(255, 255, 255, 0.38)",
        "framer-9cy2q7": "rgba(255, 255, 255, 0.2)",
        "framer-150y87y": "rgba(255, 255, 255, 0.2)",
        "framer-1rxhzpr": "rgba(255, 255, 255, 0.2)",
        "framer-8axohn": "rgba(255, 255, 255, 0.38)",
        "framer-1hjgm86": "rgba(255, 255, 255, 0.208)",
        "framer-1ed9ris": "rgba(255, 255, 255, 0.2)",
        "framer-11gf6c6": "rgba(255, 255, 255, 0.208)",
        "framer-ghoiiw": "rgba(255, 255, 255, 0.2)",
        "framer-9czbtf": "rgba(255, 255, 255, 0.38)",
        "framer-6b9cdp": "rgba(255, 255, 255, 0.2)",
        "framer-yls8eq": "rgba(255, 255, 255, 0.2)",
        "framer-hpo01f": "rgba(255, 255, 255, 0.208)",
        "framer-1o4ul04": "rgba(255, 255, 255, 0.2)",
        "framer-1phyaib": "rgba(255, 255, 255, 0.38)",
        "framer-hobs9u": "rgba(255, 255, 255, 0.38)",
        "framer-d3rapa": "rgba(255, 255, 255, 0.2)",
        "framer-7g76hm": "rgba(255, 255, 255, 0.208)",
        "framer-1vkr8cb": "rgba(255, 255, 255, 0.2)",
        "framer-1n4yjyc": "rgba(255, 255, 255, 0.38)",
        "framer-u5k3fd": "rgba(255, 255, 255, 0.208)",
        "framer-11twtea": "rgba(255, 255, 255, 0.208)",
        "framer-17ypuap": "rgba(255, 255, 255, 0.208)",
        "framer-1ws7c6v": "rgba(255, 255, 255, 0.208)",
        "framer-1yr6lkt": "rgba(255, 255, 255, 0.38)",
        "framer-m99uc9": "rgba(255, 255, 255, 0.208)",
        "framer-b9ztq4": "rgba(255, 255, 255, 0.208)",
        "framer-1bj1ntz": "rgba(255, 255, 255, 0.208)",
        "framer-1wb246e": "rgba(255, 255, 255, 0.38)",
        "framer-ytou5k": "rgba(255, 255, 255, 0.208)",
        "framer-ak21r0": "rgba(255, 255, 255, 0.208)",
        "framer-frl2xa": "rgba(255, 255, 255, 0.208)",
        "framer-5vsmr8": "rgba(255, 255, 255, 0.208)",
        "framer-ie39ga": "rgba(255, 255, 255, 0.208)",
        "framer-312syl": "rgba(255, 255, 255, 0.38)",
        "framer-iamo1c": "rgba(255, 255, 255, 0.208)",
        "framer-1w16k1k": "rgba(255, 255, 255, 0.2)",
        "framer-hskubr": "rgba(255, 255, 255, 0.38)",
        "framer-1vfnnof": "rgba(255, 255, 255, 0.2)",
        "framer-1hlpk06": "rgba(255, 255, 255, 0.38)",
        "framer-u7gl98": "rgba(255, 255, 255, 0.2)",
        "framer-190rppy": "rgba(255, 255, 255, 0.208)",
        "framer-koeiog": "rgba(255, 255, 255, 0.2)",
        "framer-1vvs522": "rgba(255, 255, 255, 0.2)",
        "framer-1pne890": "rgba(255, 255, 255, 0.208)",
        "framer-4hgyp4": "rgba(255, 255, 255, 0.2)",
        "framer-o93pit": "rgba(255, 255, 255, 0.38)",
        "framer-1adkulj": "rgba(255, 255, 255, 0.2)",
        "framer-hcii4i": "rgba(255, 255, 255, 0.38)",
        "framer-zf5eqc": "rgba(255, 255, 255, 0.2)",
        "framer-1luxg98": "rgba(255, 255, 255, 0.208)",
        "framer-jzsjbf": "rgba(255, 255, 255, 0.208)",
        "framer-gw5epp": "rgba(255, 255, 255, 0.208)",
        "framer-2z297n": "rgba(255, 255, 255, 0.208)",
        "framer-1wcvqav": "rgba(255, 255, 255, 0.38)",
        "framer-1dn8st2": "rgba(255, 255, 255, 0.208)",
        "framer-n2ea51": "rgba(255, 255, 255, 0.208)",
        "framer-y5raoz": "rgba(255, 255, 255, 0.38)",
        "framer-1x00w45": "rgba(255, 255, 255, 0.208)",
        "framer-wz662h": "rgba(255, 255, 255, 0.38)",
        "framer-vwe6fu": "rgba(255, 255, 255, 0.208)",
        "framer-zgre45": "rgba(255, 255, 255, 0.208)",
        "framer-nlmebn": "rgba(255, 255, 255, 0.208)",
        "framer-1ahvqss": "rgba(255, 255, 255, 0.208)",
        "framer-25ngdh": "rgba(255, 255, 255, 0.38)",
        "framer-1geqn87": "rgba(255, 255, 255, 0.208)",
        "framer-1hc7xpv": "rgba(255, 255, 255, 0.208)"
      },
      "vClass": "framer-v-898ro1",
      "variantName": null,
      "source": "framer_complete_tree (3).html"
    },
    {
      "colors": {
        "framer-1w8ax9q": "rgba(255, 255, 255, 0.2)",
        "framer-10zqzn8": "rgba(255, 255, 255, 0.25)",
        "framer-16aps75": "rgba(255, 255, 255, 0.25)",
        "framer-zxjavu": "rgba(255, 255, 255, 0.25)",
        "framer-1cbnxi6": "rgba(255, 255, 255, 0.25)",
        "framer-509c9k": "rgba(255, 255, 255, 0.2)",
        "framer-1p2nd0x": "rgba(255, 255, 255, 0.25)",
        "framer-5zdsy3": "rgba(255, 255, 255, 0.25)",
        "framer-rb7tgg": "rgba(255, 255, 255, 0.25)",
        "framer-l9h9t": "rgba(255, 255, 255, 0.25)",
        "framer-1vebirv": "rgba(255, 255, 255, 0.25)",
        "framer-1ek2ntw": "rgba(255, 255, 255, 0.2)",
        "framer-udx3b7": "rgba(255, 255, 255, 0.25)",
        "framer-1srqsok": "rgba(255, 255, 255, 0.25)",
        "framer-9nc9id": "rgba(255, 255, 255, 0.2)",
        "framer-1ofdk4s": "rgba(255, 255, 255, 0.25)",
        "framer-1k6exy": "rgba(255, 255, 255, 0.2)",
        "framer-mc2qtp": "rgba(255, 255, 255, 0.25)",
        "framer-81ti9p": "rgba(255, 255, 255, 0.2)",
        "framer-hlbzv7": "rgba(255, 255, 255, 0.25)",
        "framer-coqz6k": "rgba(255, 255, 255, 0.25)",
        "framer-lju48b": "rgba(255, 255, 255, 0.2)",
        "framer-1py28mu": "rgba(255, 255, 255, 0.25)",
        "framer-d7lr7a": "rgba(255, 255, 255, 0.2)",
        "framer-qgi9rw": "rgba(255, 255, 255, 0.2)",
        "framer-1wx0g94": "rgba(255, 255, 255, 0.25)",
        "framer-1bi8trk": "rgba(255, 255, 255, 0.2)",
        "framer-pdaimz": "rgba(255, 255, 255, 0.25)",
        "framer-1uilx9a": "rgba(255, 255, 255, 0.25)",
        "framer-241d3h": "rgba(255, 255, 255, 0.2)",
        "framer-14friu6": "rgba(255, 255, 255, 0.25)",
        "framer-bnmz84": "rgba(255, 255, 255, 0.2)",
        "framer-y9p8sz": "rgba(255, 255, 255, 0.25)",
        "framer-38bfbr": "rgba(255, 255, 255, 0.25)",
        "framer-835p5p": "rgba(255, 255, 255, 0.25)",
        "framer-avufpe": "rgba(255, 255, 255, 0.25)",
        "framer-19pc0kj": "rgba(255, 255, 255, 0.25)",
        "framer-5qn9pd": "rgba(255, 255, 255, 0.25)",
        "framer-6ptcky": "rgba(255, 255, 255, 0.25)",
        "framer-1bj87uo": "rgba(255, 255, 255, 0.25)",
        "framer-18pms2q": "rgba(255, 255, 255, 0.25)",
        "framer-1c1kal9": "rgba(255, 255, 255, 0.25)",
        "framer-1gmddus": "rgba(255, 255, 255, 0.25)",
        "framer-1ezdpyx": "rgba(255, 255, 255, 0.25)",
        "framer-1p8exka": "rgba(255, 255, 255, 0.25)",
        "framer-189dxp8": "rgba(255, 255, 255, 0.25)",
        "framer-1ulq471": "rgba(255, 255, 255, 0.25)",
        "framer-10z8y9q": "rgba(255, 255, 255, 0.25)",
        "framer-1apznw0": "rgba(255, 255, 255, 0.25)",
        "framer-m3tzga": "rgba(255, 255, 255, 0.2)",
        "framer-1loag9g": "rgba(255, 255, 255, 0.25)",
        "framer-nga6nl": "rgba(255, 255, 255, 0.2)",
        "framer-m0s6fb": "rgba(255, 255, 255, 0.2)",
        "framer-a6p501": "rgba(255, 255, 255, 0.25)",
        "framer-1fzzjgo": "rgba(255, 255, 255, 0.2)",
        "framer-tz4lb": "rgba(255, 255, 255, 0.25)",
        "framer-1x5el1k": "rgba(255, 255, 255, 0.2)",
        "framer-z8ozv6": "rgba(255, 255, 255, 0.2)",
        "framer-18tigbk": "rgba(255, 255, 255, 0.25)",
        "framer-1wvkwoy": "rgba(255, 255, 255, 0.25)",
        "framer-iqni9n": "rgba(255, 255, 255, 0.25)",
        "framer-1szxjbv": "rgba(255, 255, 255, 0.25)",
        "framer-9cy2q7": "rgba(255, 255, 255, 0.2)",
        "framer-150y87y": "rgba(255, 255, 255, 0.2)",
        "framer-1rxhzpr": "rgba(255, 255, 255, 0.2)",
        "framer-8axohn": "rgba(255, 255, 255, 0.25)",
        "framer-1hjgm86": "rgba(255, 255, 255, 0.25)",
        "framer-1ed9ris": "rgba(255, 255, 255, 0.2)",
        "framer-11gf6c6": "rgba(255, 255, 255, 0.25)",
        "framer-ghoiiw": "rgba(255, 255, 255, 0.2)",
        "framer-9czbtf": "rgba(255, 255, 255, 0.25)",
        "framer-6b9cdp": "rgba(255, 255, 255, 0.2)",
        "framer-yls8eq": "rgba(255, 255, 255, 0.2)",
        "framer-hpo01f": "rgba(255, 255, 255, 0.25)",
        "framer-1o4ul04": "rgba(255, 255, 255, 0.2)",
        "framer-1phyaib": "rgba(255, 255, 255, 0.25)",
        "framer-hobs9u": "rgba(255, 255, 255, 0.25)",
        "framer-d3rapa": "rgba(255, 255, 255, 0.2)",
        "framer-7g76hm": "rgba(255, 255, 255, 0.25)",
        "framer-1vkr8cb": "rgba(255, 255, 255, 0.2)",
        "framer-1n4yjyc": "rgba(255, 255, 255, 0.25)",
        "framer-u5k3fd": "rgba(255, 255, 255, 0.25)",
        "framer-11twtea": "rgba(255, 255, 255, 0.25)",
        "framer-17ypuap": "rgba(255, 255, 255, 0.25)",
        "framer-1ws7c6v": "rgba(255, 255, 255, 0.25)",
        "framer-1yr6lkt": "rgba(255, 255, 255, 0.25)",
        "framer-m99uc9": "rgba(255, 255, 255, 0.25)",
        "framer-b9ztq4": "rgba(255, 255, 255, 0.25)",
        "framer-1bj1ntz": "rgba(255, 255, 255, 0.25)",
        "framer-1wb246e": "rgba(255, 255, 255, 0.25)",
        "framer-ytou5k": "rgba(255, 255, 255, 0.25)",
        "framer-ak21r0": "rgba(255, 255, 255, 0.25)",
        "framer-frl2xa": "rgba(255, 255, 255, 0.25)",
        "framer-5vsmr8": "rgba(255, 255, 255, 0.25)",
        "framer-ie39ga": "rgba(255, 255, 255, 0.25)",
        "framer-312syl": "rgba(255, 255, 255, 0.25)",
        "framer-iamo1c": "rgba(255, 255, 255, 0.25)",
        "framer-1w16k1k": "rgba(255, 255, 255, 0.2)",
        "framer-hskubr": "rgba(255, 255, 255, 0.25)",
        "framer-1vfnnof": "rgba(255, 255, 255, 0.2)",
        "framer-1hlpk06": "rgba(255, 255, 255, 0.25)",
        "framer-u7gl98": "rgba(255, 255, 255, 0.2)",
        "framer-190rppy": "rgba(255, 255, 255, 0.25)",
        "framer-koeiog": "rgba(255, 255, 255, 0.2)",
        "framer-1vvs522": "rgba(255, 255, 255, 0.2)",
        "framer-1pne890": "rgba(255, 255, 255, 0.25)",
        "framer-4hgyp4": "rgba(255, 255, 255, 0.2)",
        "framer-o93pit": "rgba(255, 255, 255, 0.25)",
        "framer-1adkulj": "rgba(255, 255, 255, 0.2)",
        "framer-hcii4i": "rgba(255, 255, 255, 0.25)",
        "framer-zf5eqc": "rgba(255, 255, 255, 0.2)",
        "framer-1luxg98": "rgba(255, 255, 255, 0.25)",
        "framer-jzsjbf": "rgba(255, 255, 255, 0.25)",
        "framer-gw5epp": "rgba(255, 255, 255, 0.25)",
        "framer-2z297n": "rgba(255, 255, 255, 0.25)",
        "framer-1wcvqav": "rgba(255, 255, 255, 0.25)",
        "framer-1dn8st2": "rgba(255, 255, 255, 0.25)",
        "framer-n2ea51": "rgba(255, 255, 255, 0.25)",
        "framer-y5raoz": "rgba(255, 255, 255, 0.25)",
        "framer-1x00w45": "rgba(255, 255, 255, 0.25)",
        "framer-wz662h": "rgba(255, 255, 255, 0.25)",
        "framer-vwe6fu": "rgba(255, 255, 255, 0.25)",
        "framer-zgre45": "rgba(255, 255, 255, 0.25)",
        "framer-nlmebn": "rgba(255, 255, 255, 0.25)",
        "framer-1ahvqss": "rgba(255, 255, 255, 0.25)",
        "framer-25ngdh": "rgba(255, 255, 255, 0.25)",
        "framer-1geqn87": "rgba(255, 255, 255, 0.25)",
        "framer-1hc7xpv": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": "framer-v-wrbd6c",
      "variantName": null,
      "source": "framer_complete_tree (4).html"
    }
  ],
  "queue": [
    {
      "colors": {
        "framer-1l1aas3": "rgba(209, 219, 255, 0.87)",
        "framer-1w3x67m": "rgba(209, 219, 255, 0.87)",
        "framer-ll6m6s": "rgba(209, 219, 255, 0.87)",
        "framer-wjz1sh": "rgba(209, 219, 255, 0.87)",
        "framer-1hflg6n": "rgba(209, 219, 255, 0.87)",
        "framer-1n93qt7": "rgba(209, 219, 255, 0.87)",
        "framer-198edd4": "rgba(209, 219, 255, 0.87)",
        "framer-z2m9qw": "rgba(209, 219, 255, 0.87)",
        "framer-a4roa1": "rgba(209, 219, 255, 0.875)",
        "framer-1gmitgm": "rgba(209, 219, 255, 0.875)",
        "framer-2z9788": "rgba(209, 219, 255, 0.875)",
        "framer-xmnqmt": "rgba(209, 219, 255, 0.875)",
        "framer-tqwmm4": "rgba(209, 219, 255, 0.87)",
        "framer-1prr6ob": "rgba(209, 219, 255, 0.87)",
        "framer-oqx20o": "rgba(209, 219, 255, 0.87)",
        "framer-1shp5ym": "rgba(209, 219, 255, 0.87)",
        "framer-nrkk9z": "rgba(209, 219, 255, 0.87)",
        "framer-7434cq": "rgba(209, 219, 255, 0.87)",
        "framer-1d0u0d4": "rgba(209, 219, 255, 0.87)",
        "framer-1rwizqt": "rgba(209, 219, 255, 0.87)",
        "framer-1u122vr": "rgba(209, 219, 255, 0.875)",
        "framer-jg0scu": "rgba(209, 219, 255, 0.875)",
        "framer-y4ffnh": "rgba(209, 219, 255, 0.875)",
        "framer-ztorm5": "rgba(209, 219, 255, 0.875)"
      },
      "vClass": "framer-v-qbin1p",
      "variantName": null,
      "source": "framer_complete_tree (5).html"
    },
    {
      "colors": {
        "framer-1l1aas3": "rgba(158, 182, 255, 0.76)",
        "framer-1w3x67m": "rgba(158, 182, 255, 0.76)",
        "framer-ll6m6s": "rgba(158, 182, 255, 0.76)",
        "framer-wjz1sh": "rgba(158, 182, 255, 0.76)",
        "framer-1hflg6n": "rgba(158, 182, 255, 0.76)",
        "framer-1n93qt7": "rgba(158, 182, 255, 0.76)",
        "framer-198edd4": "rgba(158, 182, 255, 0.76)",
        "framer-z2m9qw": "rgba(158, 182, 255, 0.76)",
        "framer-a4roa1": "rgba(158, 182, 255, 0.77)",
        "framer-1gmitgm": "rgba(158, 182, 255, 0.77)",
        "framer-2z9788": "rgba(158, 182, 255, 0.77)",
        "framer-xmnqmt": "rgba(158, 182, 255, 0.77)",
        "framer-tqwmm4": "rgba(158, 182, 255, 0.76)",
        "framer-1prr6ob": "rgba(158, 182, 255, 0.76)",
        "framer-oqx20o": "rgba(158, 182, 255, 0.76)",
        "framer-1shp5ym": "rgba(158, 182, 255, 0.76)",
        "framer-nrkk9z": "rgba(158, 182, 255, 0.76)",
        "framer-7434cq": "rgba(158, 182, 255, 0.76)",
        "framer-1d0u0d4": "rgba(158, 182, 255, 0.76)",
        "framer-1rwizqt": "rgba(158, 182, 255, 0.76)",
        "framer-1u122vr": "rgba(158, 182, 255, 0.77)",
        "framer-jg0scu": "rgba(158, 182, 255, 0.77)",
        "framer-y4ffnh": "rgba(158, 182, 255, 0.77)",
        "framer-ztorm5": "rgba(158, 182, 255, 0.77)"
      },
      "vClass": "framer-v-olnixh",
      "variantName": null,
      "source": "framer_complete_tree (6).html"
    },
    {
      "colors": {
        "framer-1l1aas3": "rgba(255, 255, 255, 0.25)",
        "framer-1w3x67m": "rgba(255, 255, 255, 0.25)",
        "framer-ll6m6s": "rgba(255, 255, 255, 0.25)",
        "framer-wjz1sh": "rgba(255, 255, 255, 0.25)",
        "framer-1hflg6n": "rgba(255, 255, 255, 0.25)",
        "framer-1n93qt7": "rgba(255, 255, 255, 0.25)",
        "framer-198edd4": "rgba(255, 255, 255, 0.25)",
        "framer-z2m9qw": "rgba(255, 255, 255, 0.25)",
        "framer-a4roa1": "rgba(255, 255, 255, 0.25)",
        "framer-1gmitgm": "rgba(255, 255, 255, 0.25)",
        "framer-2z9788": "rgba(255, 255, 255, 0.25)",
        "framer-xmnqmt": "rgba(255, 255, 255, 0.25)",
        "framer-tqwmm4": "rgba(255, 255, 255, 0.25)",
        "framer-1prr6ob": "rgba(255, 255, 255, 0.25)",
        "framer-oqx20o": "rgba(255, 255, 255, 0.25)",
        "framer-1shp5ym": "rgba(255, 255, 255, 0.25)",
        "framer-nrkk9z": "rgba(255, 255, 255, 0.25)",
        "framer-7434cq": "rgba(255, 255, 255, 0.25)",
        "framer-1d0u0d4": "rgba(255, 255, 255, 0.25)",
        "framer-1rwizqt": "rgba(255, 255, 255, 0.25)",
        "framer-1u122vr": "rgba(255, 255, 255, 0.25)",
        "framer-jg0scu": "rgba(255, 255, 255, 0.25)",
        "framer-y4ffnh": "rgba(255, 255, 255, 0.25)",
        "framer-ztorm5": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": "framer-v-qbin1p",
      "variantName": null,
      "source": "framer_complete_tree (7).html"
    },
    {
      "colors": {
        "framer-1l1aas3": "rgba(158, 182, 255, 0.76)",
        "framer-1w3x67m": "rgba(158, 182, 255, 0.76)",
        "framer-ll6m6s": "rgba(158, 182, 255, 0.76)",
        "framer-wjz1sh": "rgba(158, 182, 255, 0.76)",
        "framer-1hflg6n": "rgba(158, 182, 255, 0.333)",
        "framer-1n93qt7": "rgba(158, 182, 255, 0.333)",
        "framer-198edd4": "rgba(158, 182, 255, 0.333)",
        "framer-z2m9qw": "rgba(158, 182, 255, 0.333)",
        "framer-a4roa1": "rgba(249, 250, 255, 0.208)",
        "framer-1gmitgm": "rgba(249, 250, 255, 0.208)",
        "framer-2z9788": "rgba(249, 250, 255, 0.208)",
        "framer-xmnqmt": "rgba(249, 250, 255, 0.208)",
        "framer-tqwmm4": "rgba(158, 182, 255, 0.76)",
        "framer-1prr6ob": "rgba(158, 182, 255, 0.76)",
        "framer-oqx20o": "rgba(158, 182, 255, 0.76)",
        "framer-1shp5ym": "rgba(158, 182, 255, 0.76)",
        "framer-nrkk9z": "rgba(158, 182, 255, 0.333)",
        "framer-7434cq": "rgba(158, 182, 255, 0.333)",
        "framer-1d0u0d4": "rgba(158, 182, 255, 0.333)",
        "framer-1rwizqt": "rgba(158, 182, 255, 0.333)",
        "framer-1u122vr": "rgba(249, 250, 255, 0.208)",
        "framer-jg0scu": "rgba(249, 250, 255, 0.208)",
        "framer-y4ffnh": "rgba(249, 250, 255, 0.208)",
        "framer-ztorm5": "rgba(249, 250, 255, 0.208)"
      },
      "vClass": "framer-v-fkkzmm",
      "variantName": null,
      "source": "framer_complete_tree (8).html"
    },
    {
      "colors": {
        "framer-1l1aas3": "rgba(158, 182, 255, 0.76)",
        "framer-1w3x67m": "rgba(158, 182, 255, 0.76)",
        "framer-ll6m6s": "rgba(158, 182, 255, 0.76)",
        "framer-wjz1sh": "rgba(158, 182, 255, 0.76)",
        "framer-1hflg6n": "rgba(158, 182, 255, 0.76)",
        "framer-1n93qt7": "rgba(158, 182, 255, 0.76)",
        "framer-198edd4": "rgba(158, 182, 255, 0.76)",
        "framer-z2m9qw": "rgba(158, 182, 255, 0.76)",
        "framer-a4roa1": "rgba(158, 182, 255, 0.3)",
        "framer-1gmitgm": "rgba(158, 182, 255, 0.3)",
        "framer-2z9788": "rgba(158, 182, 255, 0.3)",
        "framer-xmnqmt": "rgba(158, 182, 255, 0.3)",
        "framer-tqwmm4": "rgba(158, 182, 255, 0.76)",
        "framer-1prr6ob": "rgba(158, 182, 255, 0.76)",
        "framer-oqx20o": "rgba(158, 182, 255, 0.76)",
        "framer-1shp5ym": "rgba(158, 182, 255, 0.76)",
        "framer-nrkk9z": "rgba(158, 182, 255, 0.76)",
        "framer-7434cq": "rgba(158, 182, 255, 0.76)",
        "framer-1d0u0d4": "rgba(158, 182, 255, 0.76)",
        "framer-1rwizqt": "rgba(158, 182, 255, 0.76)",
        "framer-1u122vr": "rgba(158, 182, 255, 0.3)",
        "framer-jg0scu": "rgba(158, 182, 255, 0.3)",
        "framer-y4ffnh": "rgba(158, 182, 255, 0.3)",
        "framer-ztorm5": "rgba(158, 182, 255, 0.3)"
      },
      "vClass": "framer-v-olnixh",
      "variantName": null,
      "source": "framer_complete_tree (9).html"
    },
    {
      "colors": {
        "framer-1l1aas3": "rgba(255, 255, 255, 0.25)",
        "framer-1w3x67m": "rgba(255, 255, 255, 0.25)",
        "framer-ll6m6s": "rgba(255, 255, 255, 0.25)",
        "framer-wjz1sh": "rgba(255, 255, 255, 0.25)",
        "framer-1hflg6n": "rgba(255, 255, 255, 0.25)",
        "framer-1n93qt7": "rgba(255, 255, 255, 0.25)",
        "framer-198edd4": "rgba(255, 255, 255, 0.25)",
        "framer-z2m9qw": "rgba(255, 255, 255, 0.25)",
        "framer-a4roa1": "rgba(255, 255, 255, 0.25)",
        "framer-1gmitgm": "rgba(255, 255, 255, 0.25)",
        "framer-2z9788": "rgba(255, 255, 255, 0.25)",
        "framer-xmnqmt": "rgba(255, 255, 255, 0.25)",
        "framer-tqwmm4": "rgba(255, 255, 255, 0.25)",
        "framer-1prr6ob": "rgba(255, 255, 255, 0.25)",
        "framer-oqx20o": "rgba(255, 255, 255, 0.25)",
        "framer-1shp5ym": "rgba(255, 255, 255, 0.25)",
        "framer-nrkk9z": "rgba(255, 255, 255, 0.25)",
        "framer-7434cq": "rgba(255, 255, 255, 0.25)",
        "framer-1d0u0d4": "rgba(255, 255, 255, 0.25)",
        "framer-1rwizqt": "rgba(255, 255, 255, 0.25)",
        "framer-1u122vr": "rgba(255, 255, 255, 0.25)",
        "framer-jg0scu": "rgba(255, 255, 255, 0.25)",
        "framer-y4ffnh": "rgba(255, 255, 255, 0.25)",
        "framer-ztorm5": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": "framer-v-qbin1p",
      "variantName": null,
      "source": "framer_complete_tree (10).html"
    }
  ],
  "executor": [
    {
      "colors": {
        "framer-1j52sld": "rgba(255, 255, 255, 0.05)",
        "framer-gehpcg": "rgba(174, 188, 229, 0.25)",
        "framer-8x19lf": "rgba(174, 188, 229, 0.25)",
        "framer-knm3lj": "rgba(174, 188, 229, 0.25)",
        "framer-1dmld5n": "rgba(174, 188, 229, 0.247)",
        "framer-uowqcg": "rgba(174, 188, 229, 0.318)",
        "framer-1dtqkwe": "rgba(174, 188, 229, 0.733)",
        "framer-1d23v23": "rgba(255, 255, 255, 0.05)",
        "framer-1qu365o": "rgba(174, 188, 229, 0.25)",
        "framer-1mmci20": "rgba(174, 188, 229, 0.25)",
        "framer-miej2s": "rgba(174, 188, 229, 0.25)",
        "framer-sasqsa": "rgba(174, 188, 229, 0.247)",
        "framer-1kgemv6": "rgba(174, 188, 229, 0.318)",
        "framer-1cxurzz": "rgba(174, 188, 229, 0.733)",
        "framer-q9y8xc": "rgba(255, 255, 255, 0.05)",
        "framer-1yqwbni": "rgba(174, 188, 229, 0.25)",
        "framer-d16p3l": "rgba(174, 188, 229, 0.25)",
        "framer-4mbxuq": "rgba(174, 188, 229, 0.25)",
        "framer-1et7wxn": "rgba(174, 188, 229, 0.247)",
        "framer-16cct62": "rgba(174, 188, 229, 0.318)",
        "framer-1ghpgks": "rgba(174, 188, 229, 0.733)",
        "framer-6mt54z": "rgba(255, 255, 255, 0.05)",
        "framer-1oo2wb3": "rgba(174, 188, 229, 0.25)",
        "framer-1xq7tt7": "rgba(174, 188, 229, 0.25)",
        "framer-1f7gz2q": "rgba(174, 188, 229, 0.25)",
        "framer-6oheae": "rgba(174, 188, 229, 0.247)",
        "framer-16dfwnm": "rgba(174, 188, 229, 0.318)",
        "framer-159bmwr": "rgba(174, 188, 229, 0.733)",
        "framer-s62qf": "rgba(255, 255, 255, 0.05)",
        "framer-dxgtbv": "rgba(174, 188, 229, 0.25)",
        "framer-dpv8i9": "rgba(174, 188, 229, 0.25)",
        "framer-1sa9ux3": "rgba(174, 188, 229, 0.25)",
        "framer-1p1vqsn": "rgba(174, 188, 229, 0.247)",
        "framer-5dtsk": "rgba(174, 188, 229, 0.318)",
        "framer-1ous5i2": "rgba(174, 188, 229, 0.733)",
        "framer-1scgyrh": "rgba(255, 255, 255, 0.05)",
        "framer-1ktaku4": "rgba(174, 188, 229, 0.25)",
        "framer-139g0if": "rgba(174, 188, 229, 0.25)",
        "framer-94grge": "rgba(174, 188, 229, 0.25)",
        "framer-1py6a95": "rgba(174, 188, 229, 0.247)",
        "framer-9sel6v": "rgba(174, 188, 229, 0.318)",
        "framer-c6xnnw": "rgba(174, 188, 229, 0.733)",
        "framer-11dwcfl": "rgba(255, 255, 255, 0.05)",
        "framer-17sbsqj": "rgba(174, 188, 229, 0.25)",
        "framer-1k04812": "rgba(174, 188, 229, 0.25)",
        "framer-1ofowvp": "rgba(174, 188, 229, 0.25)",
        "framer-1yc7nkx": "rgba(174, 188, 229, 0.247)",
        "framer-6x8zit": "rgba(174, 188, 229, 0.318)",
        "framer-1xgqlqz": "rgba(174, 188, 229, 0.733)",
        "framer-nyyiw0": "rgba(255, 255, 255, 0.05)",
        "framer-1v6ox53": "rgba(174, 188, 229, 0.25)",
        "framer-11ywq1a": "rgba(174, 188, 229, 0.25)",
        "framer-191s3p8": "rgba(174, 188, 229, 0.25)",
        "framer-10znthb": "rgba(174, 188, 229, 0.25)",
        "framer-1fvegu4": "rgba(174, 188, 229, 0.25)",
        "framer-rin559": "rgba(174, 188, 229, 0.25)",
        "framer-1eyav6c": "rgba(255, 255, 255, 0.05)",
        "framer-e3afyy": "rgba(174, 188, 229, 0.25)",
        "framer-1q1g9yv": "rgba(174, 188, 229, 0.25)",
        "framer-1gnnzrg": "rgba(174, 188, 229, 0.25)",
        "framer-12kekrz": "rgba(174, 188, 229, 0.25)",
        "framer-vozpd9": "rgba(174, 188, 229, 0.25)",
        "framer-31f8j1": "rgba(174, 188, 229, 0.25)",
        "framer-potqf9": "rgba(255, 255, 255, 0.05)",
        "framer-1l0cpn1": "rgba(174, 188, 229, 0.25)",
        "framer-sfbfhf": "rgba(174, 188, 229, 0.25)",
        "framer-15elbbk": "rgba(174, 188, 229, 0.25)",
        "framer-1t4oq6h": "rgba(174, 188, 229, 0.25)",
        "framer-63xkpc": "rgba(174, 188, 229, 0.25)",
        "framer-18wopk0": "rgba(174, 188, 229, 0.25)",
        "framer-7tt9j2": "rgba(255, 255, 255, 0.05)",
        "framer-qjxyc0": "rgba(174, 188, 229, 0.25)",
        "framer-2o336a": "rgba(174, 188, 229, 0.25)",
        "framer-io8hck": "rgba(174, 188, 229, 0.25)",
        "framer-l1pcin": "rgba(174, 188, 229, 0.25)",
        "framer-byw55i": "rgba(174, 188, 229, 0.25)",
        "framer-1bnefrh": "rgba(174, 188, 229, 0.25)",
        "framer-9bjmd": "rgba(255, 255, 255, 0.05)",
        "framer-ctsvdu": "rgba(174, 188, 229, 0.25)",
        "framer-tnljj9": "rgba(174, 188, 229, 0.25)",
        "framer-12zfrg4": "rgba(174, 188, 229, 0.25)",
        "framer-17c6cci": "rgba(174, 188, 229, 0.25)",
        "framer-1uqr6lu": "rgba(174, 188, 229, 0.25)",
        "framer-1ewrs3r": "rgba(174, 188, 229, 0.25)",
        "framer-b5vxef": "rgba(255, 255, 255, 0.05)",
        "framer-ubndnz": "rgba(174, 188, 229, 0.25)",
        "framer-n32ujw": "rgba(174, 188, 229, 0.25)",
        "framer-ea3vrs": "rgba(174, 188, 229, 0.25)",
        "framer-xe5tlh": "rgba(174, 188, 229, 0.25)",
        "framer-1thpx4x": "rgba(174, 188, 229, 0.25)",
        "framer-1nhkl21": "rgba(174, 188, 229, 0.25)",
        "framer-1j67inc": "rgba(255, 255, 255, 0.05)",
        "framer-1w8vm35": "rgba(174, 188, 229, 0.25)",
        "framer-q93b1f": "rgba(174, 188, 229, 0.25)",
        "framer-p56roq": "rgba(174, 188, 229, 0.25)",
        "framer-xxo5tq": "rgba(174, 188, 229, 0.25)",
        "framer-jei9sz": "rgba(174, 188, 229, 0.25)",
        "framer-1xd9ey1": "rgba(174, 188, 229, 0.25)",
        "framer-tta55x": "rgba(255, 255, 255, 0.05)",
        "framer-1yaeplo": "rgba(174, 188, 229, 0.25)",
        "framer-s315hq": "rgba(174, 188, 229, 0.25)",
        "framer-zhjgjs": "rgba(174, 188, 229, 0.25)",
        "framer-1onunez": "rgba(174, 188, 229, 0.25)",
        "framer-1kxdsaw": "rgba(174, 188, 229, 0.25)",
        "framer-x5zjc4": "rgba(174, 188, 229, 0.25)",
        "framer-1ogoxvw": "rgba(255, 255, 255, 0.05)",
        "framer-1ej8s96": "rgba(174, 188, 229, 0.25)",
        "framer-1ljxraj": "rgba(174, 188, 229, 0.25)",
        "framer-bvs3nh": "rgba(174, 188, 229, 0.25)",
        "framer-1jfhd3e": "rgba(174, 188, 229, 0.25)",
        "framer-1mf5s1w": "rgba(174, 188, 229, 0.25)",
        "framer-15hu7eo": "rgba(174, 188, 229, 0.25)",
        "framer-fkiu5i": "rgba(255, 255, 255, 0.05)",
        "framer-nll1ev": "rgba(174, 188, 229, 0.25)",
        "framer-1k18bi5": "rgba(174, 188, 229, 0.25)",
        "framer-1ejsdal": "rgba(174, 188, 229, 0.25)",
        "framer-yo9gne": "rgba(174, 188, 229, 0.25)",
        "framer-avufn9": "rgba(174, 188, 229, 0.25)",
        "framer-1uz6g49": "rgba(174, 188, 229, 0.25)",
        "framer-14j4ae0": "rgba(255, 255, 255, 0.05)",
        "framer-ikkyoe": "rgba(174, 188, 229, 0.25)",
        "framer-1ofbsd5": "rgba(174, 188, 229, 0.25)",
        "framer-1uiqk6d": "rgba(174, 188, 229, 0.25)",
        "framer-1n5i4bx": "rgba(174, 188, 229, 0.25)",
        "framer-1tn5838": "rgba(174, 188, 229, 0.25)",
        "framer-jhrq6e": "rgba(174, 188, 229, 0.25)",
        "framer-116z81w": "rgba(255, 255, 255, 0.05)",
        "framer-17q4w9p": "rgba(174, 188, 229, 0.25)",
        "framer-g7v8uo": "rgba(174, 188, 229, 0.25)",
        "framer-yi9vtt": "rgba(174, 188, 229, 0.25)",
        "framer-1f588is": "rgba(174, 188, 229, 0.25)",
        "framer-1dc6xk8": "rgba(174, 188, 229, 0.25)",
        "framer-on6tgz": "rgba(174, 188, 229, 0.25)",
        "framer-s5tagr": "rgba(255, 255, 255, 0.05)",
        "framer-1aexuar": "rgba(174, 188, 229, 0.25)",
        "framer-143pemu": "rgba(174, 188, 229, 0.25)",
        "framer-1xb97ia": "rgba(174, 188, 229, 0.25)",
        "framer-1qk7o4j": "rgba(174, 188, 229, 0.25)",
        "framer-105csk4": "rgba(174, 188, 229, 0.25)",
        "framer-m8elzm": "rgba(174, 188, 229, 0.25)",
        "framer-j77cpk": "rgba(255, 255, 255, 0.05)",
        "framer-blm95e": "rgba(174, 188, 229, 0.25)",
        "framer-1yey69v": "rgba(174, 188, 229, 0.25)",
        "framer-1cnksu0": "rgba(174, 188, 229, 0.25)",
        "framer-1trkbym": "rgba(174, 188, 229, 0.25)",
        "framer-sj8w9r": "rgba(174, 188, 229, 0.25)",
        "framer-hf37wh": "rgba(174, 188, 229, 0.25)"
      },
      "vClass": "framer-v-v0eeto",
      "variantName": null,
      "source": "framer_complete_tree (19).html"
    },
    {
      "colors": {
        "framer-1j52sld": "rgba(255, 255, 255, 0.05)",
        "framer-gehpcg": "rgba(174, 188, 229, 0.25)",
        "framer-8x19lf": "rgba(174, 188, 229, 0.25)",
        "framer-knm3lj": "rgba(174, 188, 229, 0.25)",
        "framer-1dmld5n": "rgba(174, 188, 229, 0.25)",
        "framer-uowqcg": "rgba(174, 188, 229, 0.25)",
        "framer-1dtqkwe": "rgba(174, 188, 229, 0.25)",
        "framer-1d23v23": "rgba(255, 255, 255, 0.05)",
        "framer-1qu365o": "rgba(174, 188, 229, 0.25)",
        "framer-1mmci20": "rgba(174, 188, 229, 0.25)",
        "framer-miej2s": "rgba(174, 188, 229, 0.25)",
        "framer-sasqsa": "rgba(174, 188, 229, 0.25)",
        "framer-1kgemv6": "rgba(174, 188, 229, 0.25)",
        "framer-1cxurzz": "rgba(174, 188, 229, 0.25)",
        "framer-q9y8xc": "rgba(255, 255, 255, 0.05)",
        "framer-1yqwbni": "rgba(174, 188, 229, 0.25)",
        "framer-d16p3l": "rgba(174, 188, 229, 0.25)",
        "framer-4mbxuq": "rgba(174, 188, 229, 0.25)",
        "framer-1et7wxn": "rgba(174, 188, 229, 0.25)",
        "framer-16cct62": "rgba(174, 188, 229, 0.25)",
        "framer-1ghpgks": "rgba(174, 188, 229, 0.25)",
        "framer-6mt54z": "rgba(255, 255, 255, 0.05)",
        "framer-1oo2wb3": "rgba(174, 188, 229, 0.25)",
        "framer-1xq7tt7": "rgba(174, 188, 229, 0.25)",
        "framer-1f7gz2q": "rgba(174, 188, 229, 0.25)",
        "framer-6oheae": "rgba(174, 188, 229, 0.25)",
        "framer-16dfwnm": "rgba(174, 188, 229, 0.25)",
        "framer-159bmwr": "rgba(174, 188, 229, 0.25)",
        "framer-s62qf": "rgba(255, 255, 255, 0.05)",
        "framer-dxgtbv": "rgba(174, 188, 229, 0.25)",
        "framer-dpv8i9": "rgba(174, 188, 229, 0.25)",
        "framer-1sa9ux3": "rgba(174, 188, 229, 0.25)",
        "framer-1p1vqsn": "rgba(174, 188, 229, 0.25)",
        "framer-5dtsk": "rgba(174, 188, 229, 0.25)",
        "framer-1ous5i2": "rgba(174, 188, 229, 0.25)",
        "framer-1scgyrh": "rgba(255, 255, 255, 0.05)",
        "framer-1ktaku4": "rgba(174, 188, 229, 0.25)",
        "framer-139g0if": "rgba(174, 188, 229, 0.25)",
        "framer-94grge": "rgba(174, 188, 229, 0.25)",
        "framer-1py6a95": "rgba(174, 188, 229, 0.25)",
        "framer-9sel6v": "rgba(174, 188, 229, 0.25)",
        "framer-c6xnnw": "rgba(174, 188, 229, 0.25)",
        "framer-11dwcfl": "rgba(255, 255, 255, 0.05)",
        "framer-17sbsqj": "rgba(174, 188, 229, 0.25)",
        "framer-1k04812": "rgba(174, 188, 229, 0.25)",
        "framer-1ofowvp": "rgba(174, 188, 229, 0.25)",
        "framer-1yc7nkx": "rgba(174, 188, 229, 0.25)",
        "framer-6x8zit": "rgba(174, 188, 229, 0.25)",
        "framer-1xgqlqz": "rgba(174, 188, 229, 0.25)",
        "framer-nyyiw0": "rgba(255, 255, 255, 0.05)",
        "framer-1v6ox53": "rgba(174, 188, 229, 0.25)",
        "framer-11ywq1a": "rgba(174, 188, 229, 0.25)",
        "framer-191s3p8": "rgba(174, 188, 229, 0.25)",
        "framer-10znthb": "rgba(174, 188, 229, 0.25)",
        "framer-1fvegu4": "rgba(174, 188, 229, 0.25)",
        "framer-rin559": "rgba(174, 188, 229, 0.247)",
        "framer-1eyav6c": "rgba(255, 255, 255, 0.05)",
        "framer-e3afyy": "rgba(174, 188, 229, 0.25)",
        "framer-1q1g9yv": "rgba(174, 188, 229, 0.25)",
        "framer-1gnnzrg": "rgba(174, 188, 229, 0.25)",
        "framer-12kekrz": "rgba(174, 188, 229, 0.25)",
        "framer-vozpd9": "rgba(174, 188, 229, 0.25)",
        "framer-31f8j1": "rgba(174, 188, 229, 0.247)",
        "framer-potqf9": "rgba(255, 255, 255, 0.05)",
        "framer-1l0cpn1": "rgba(174, 188, 229, 0.25)",
        "framer-sfbfhf": "rgba(174, 188, 229, 0.25)",
        "framer-15elbbk": "rgba(174, 188, 229, 0.25)",
        "framer-1t4oq6h": "rgba(174, 188, 229, 0.25)",
        "framer-63xkpc": "rgba(174, 188, 229, 0.25)",
        "framer-18wopk0": "rgba(174, 188, 229, 0.247)",
        "framer-7tt9j2": "rgba(255, 255, 255, 0.05)",
        "framer-qjxyc0": "rgba(174, 188, 229, 0.25)",
        "framer-2o336a": "rgba(174, 188, 229, 0.25)",
        "framer-io8hck": "rgba(174, 188, 229, 0.25)",
        "framer-l1pcin": "rgba(174, 188, 229, 0.25)",
        "framer-byw55i": "rgba(174, 188, 229, 0.25)",
        "framer-1bnefrh": "rgba(174, 188, 229, 0.247)",
        "framer-9bjmd": "rgba(255, 255, 255, 0.05)",
        "framer-ctsvdu": "rgba(174, 188, 229, 0.25)",
        "framer-tnljj9": "rgba(174, 188, 229, 0.25)",
        "framer-12zfrg4": "rgba(174, 188, 229, 0.25)",
        "framer-17c6cci": "rgba(174, 188, 229, 0.25)",
        "framer-1uqr6lu": "rgba(174, 188, 229, 0.25)",
        "framer-1ewrs3r": "rgba(174, 188, 229, 0.247)",
        "framer-b5vxef": "rgba(255, 255, 255, 0.05)",
        "framer-ubndnz": "rgba(174, 188, 229, 0.25)",
        "framer-n32ujw": "rgba(174, 188, 229, 0.25)",
        "framer-ea3vrs": "rgba(174, 188, 229, 0.25)",
        "framer-xe5tlh": "rgba(174, 188, 229, 0.25)",
        "framer-1thpx4x": "rgba(174, 188, 229, 0.25)",
        "framer-1nhkl21": "rgba(174, 188, 229, 0.247)",
        "framer-1j67inc": "rgba(255, 255, 255, 0.05)",
        "framer-1w8vm35": "rgba(174, 188, 229, 0.25)",
        "framer-q93b1f": "rgba(174, 188, 229, 0.25)",
        "framer-p56roq": "rgba(174, 188, 229, 0.25)",
        "framer-xxo5tq": "rgba(174, 188, 229, 0.25)",
        "framer-jei9sz": "rgba(174, 188, 229, 0.25)",
        "framer-1xd9ey1": "rgba(174, 188, 229, 0.247)",
        "framer-tta55x": "rgba(255, 255, 255, 0.05)",
        "framer-1yaeplo": "rgba(174, 188, 229, 0.345)",
        "framer-s315hq": "rgba(174, 188, 229, 0.706)",
        "framer-zhjgjs": "rgba(174, 188, 229, 0.25)",
        "framer-1onunez": "rgba(174, 188, 229, 0.25)",
        "framer-1kxdsaw": "rgba(174, 188, 229, 0.25)",
        "framer-x5zjc4": "rgba(174, 188, 229, 0.25)",
        "framer-1ogoxvw": "rgba(255, 255, 255, 0.05)",
        "framer-1ej8s96": "rgba(174, 188, 229, 0.345)",
        "framer-1ljxraj": "rgba(174, 188, 229, 0.706)",
        "framer-bvs3nh": "rgba(174, 188, 229, 0.25)",
        "framer-1jfhd3e": "rgba(174, 188, 229, 0.25)",
        "framer-1mf5s1w": "rgba(174, 188, 229, 0.25)",
        "framer-15hu7eo": "rgba(174, 188, 229, 0.25)",
        "framer-fkiu5i": "rgba(255, 255, 255, 0.05)",
        "framer-nll1ev": "rgba(174, 188, 229, 0.345)",
        "framer-1k18bi5": "rgba(174, 188, 229, 0.706)",
        "framer-1ejsdal": "rgba(174, 188, 229, 0.25)",
        "framer-yo9gne": "rgba(174, 188, 229, 0.25)",
        "framer-avufn9": "rgba(174, 188, 229, 0.25)",
        "framer-1uz6g49": "rgba(174, 188, 229, 0.25)",
        "framer-14j4ae0": "rgba(255, 255, 255, 0.05)",
        "framer-ikkyoe": "rgba(174, 188, 229, 0.345)",
        "framer-1ofbsd5": "rgba(174, 188, 229, 0.706)",
        "framer-1uiqk6d": "rgba(174, 188, 229, 0.25)",
        "framer-1n5i4bx": "rgba(174, 188, 229, 0.25)",
        "framer-1tn5838": "rgba(174, 188, 229, 0.25)",
        "framer-jhrq6e": "rgba(174, 188, 229, 0.25)",
        "framer-116z81w": "rgba(255, 255, 255, 0.05)",
        "framer-17q4w9p": "rgba(174, 188, 229, 0.345)",
        "framer-g7v8uo": "rgba(174, 188, 229, 0.706)",
        "framer-yi9vtt": "rgba(174, 188, 229, 0.25)",
        "framer-1f588is": "rgba(174, 188, 229, 0.25)",
        "framer-1dc6xk8": "rgba(174, 188, 229, 0.25)",
        "framer-on6tgz": "rgba(174, 188, 229, 0.25)",
        "framer-s5tagr": "rgba(255, 255, 255, 0.05)",
        "framer-1aexuar": "rgba(174, 188, 229, 0.345)",
        "framer-143pemu": "rgba(174, 188, 229, 0.706)",
        "framer-1xb97ia": "rgba(174, 188, 229, 0.25)",
        "framer-1qk7o4j": "rgba(174, 188, 229, 0.25)",
        "framer-105csk4": "rgba(174, 188, 229, 0.25)",
        "framer-m8elzm": "rgba(174, 188, 229, 0.25)",
        "framer-j77cpk": "rgba(255, 255, 255, 0.05)",
        "framer-blm95e": "rgba(174, 188, 229, 0.345)",
        "framer-1yey69v": "rgba(174, 188, 229, 0.25)",
        "framer-1cnksu0": "rgba(174, 188, 229, 0.706)",
        "framer-1trkbym": "rgba(174, 188, 229, 0.25)",
        "framer-sj8w9r": "rgba(174, 188, 229, 0.25)",
        "framer-hf37wh": "rgba(174, 188, 229, 0.25)"
      },
      "vClass": "framer-v-2qbz0y",
      "variantName": null,
      "source": "framer_complete_tree (20).html"
    },
    {
      "colors": {
        "framer-1j52sld": "rgba(255, 255, 255, 0.05)",
        "framer-gehpcg": "rgba(174, 188, 229, 0.25)",
        "framer-8x19lf": "rgba(174, 188, 229, 0.25)",
        "framer-knm3lj": "rgba(174, 188, 229, 0.25)",
        "framer-1dmld5n": "rgba(174, 188, 229, 0.25)",
        "framer-uowqcg": "rgba(174, 188, 229, 0.25)",
        "framer-1dtqkwe": "rgba(174, 188, 229, 0.25)",
        "framer-1d23v23": "rgba(255, 255, 255, 0.05)",
        "framer-1qu365o": "rgba(174, 188, 229, 0.25)",
        "framer-1mmci20": "rgba(174, 188, 229, 0.25)",
        "framer-miej2s": "rgba(174, 188, 229, 0.25)",
        "framer-sasqsa": "rgba(174, 188, 229, 0.25)",
        "framer-1kgemv6": "rgba(174, 188, 229, 0.25)",
        "framer-1cxurzz": "rgba(174, 188, 229, 0.25)",
        "framer-q9y8xc": "rgba(255, 255, 255, 0.05)",
        "framer-1yqwbni": "rgba(174, 188, 229, 0.25)",
        "framer-d16p3l": "rgba(174, 188, 229, 0.25)",
        "framer-4mbxuq": "rgba(174, 188, 229, 0.25)",
        "framer-1et7wxn": "rgba(174, 188, 229, 0.25)",
        "framer-16cct62": "rgba(174, 188, 229, 0.25)",
        "framer-1ghpgks": "rgba(174, 188, 229, 0.25)",
        "framer-6mt54z": "rgba(255, 255, 255, 0.05)",
        "framer-1oo2wb3": "rgba(174, 188, 229, 0.25)",
        "framer-1xq7tt7": "rgba(174, 188, 229, 0.25)",
        "framer-1f7gz2q": "rgba(174, 188, 229, 0.25)",
        "framer-6oheae": "rgba(174, 188, 229, 0.25)",
        "framer-16dfwnm": "rgba(174, 188, 229, 0.25)",
        "framer-159bmwr": "rgba(174, 188, 229, 0.25)",
        "framer-s62qf": "rgba(255, 255, 255, 0.05)",
        "framer-dxgtbv": "rgba(174, 188, 229, 0.25)",
        "framer-dpv8i9": "rgba(174, 188, 229, 0.25)",
        "framer-1sa9ux3": "rgba(174, 188, 229, 0.25)",
        "framer-1p1vqsn": "rgba(174, 188, 229, 0.25)",
        "framer-5dtsk": "rgba(174, 188, 229, 0.25)",
        "framer-1ous5i2": "rgba(174, 188, 229, 0.25)",
        "framer-1scgyrh": "rgba(255, 255, 255, 0.05)",
        "framer-1ktaku4": "rgba(174, 188, 229, 0.25)",
        "framer-139g0if": "rgba(174, 188, 229, 0.25)",
        "framer-94grge": "rgba(174, 188, 229, 0.25)",
        "framer-1py6a95": "rgba(174, 188, 229, 0.25)",
        "framer-9sel6v": "rgba(174, 188, 229, 0.25)",
        "framer-c6xnnw": "rgba(174, 188, 229, 0.25)",
        "framer-11dwcfl": "rgba(255, 255, 255, 0.05)",
        "framer-17sbsqj": "rgba(174, 188, 229, 0.25)",
        "framer-1k04812": "rgba(174, 188, 229, 0.25)",
        "framer-1ofowvp": "rgba(174, 188, 229, 0.25)",
        "framer-1yc7nkx": "rgba(174, 188, 229, 0.25)",
        "framer-6x8zit": "rgba(174, 188, 229, 0.25)",
        "framer-1xgqlqz": "rgba(174, 188, 229, 0.25)",
        "framer-nyyiw0": "rgba(255, 255, 255, 0.05)",
        "framer-1v6ox53": "rgba(174, 188, 229, 0.25)",
        "framer-11ywq1a": "rgba(174, 188, 229, 0.25)",
        "framer-191s3p8": "rgba(174, 188, 229, 0.25)",
        "framer-10znthb": "rgba(174, 188, 229, 0.25)",
        "framer-1fvegu4": "rgba(174, 188, 229, 0.25)",
        "framer-rin559": "rgba(174, 188, 229, 0.25)",
        "framer-1eyav6c": "rgba(255, 255, 255, 0.05)",
        "framer-e3afyy": "rgba(174, 188, 229, 0.25)",
        "framer-1q1g9yv": "rgba(174, 188, 229, 0.25)",
        "framer-1gnnzrg": "rgba(174, 188, 229, 0.25)",
        "framer-12kekrz": "rgba(174, 188, 229, 0.25)",
        "framer-vozpd9": "rgba(174, 188, 229, 0.25)",
        "framer-31f8j1": "rgba(174, 188, 229, 0.25)",
        "framer-potqf9": "rgba(255, 255, 255, 0.05)",
        "framer-1l0cpn1": "rgba(174, 188, 229, 0.25)",
        "framer-sfbfhf": "rgba(174, 188, 229, 0.25)",
        "framer-15elbbk": "rgba(174, 188, 229, 0.25)",
        "framer-1t4oq6h": "rgba(174, 188, 229, 0.25)",
        "framer-63xkpc": "rgba(174, 188, 229, 0.25)",
        "framer-18wopk0": "rgba(174, 188, 229, 0.25)",
        "framer-7tt9j2": "rgba(255, 255, 255, 0.05)",
        "framer-qjxyc0": "rgba(174, 188, 229, 0.25)",
        "framer-2o336a": "rgba(174, 188, 229, 0.25)",
        "framer-io8hck": "rgba(174, 188, 229, 0.25)",
        "framer-l1pcin": "rgba(174, 188, 229, 0.25)",
        "framer-byw55i": "rgba(174, 188, 229, 0.25)",
        "framer-1bnefrh": "rgba(174, 188, 229, 0.25)",
        "framer-9bjmd": "rgba(255, 255, 255, 0.05)",
        "framer-ctsvdu": "rgba(174, 188, 229, 0.25)",
        "framer-tnljj9": "rgba(174, 188, 229, 0.25)",
        "framer-12zfrg4": "rgba(174, 188, 229, 0.25)",
        "framer-17c6cci": "rgba(174, 188, 229, 0.25)",
        "framer-1uqr6lu": "rgba(174, 188, 229, 0.25)",
        "framer-1ewrs3r": "rgba(174, 188, 229, 0.25)",
        "framer-b5vxef": "rgba(255, 255, 255, 0.05)",
        "framer-ubndnz": "rgba(174, 188, 229, 0.25)",
        "framer-n32ujw": "rgba(174, 188, 229, 0.25)",
        "framer-ea3vrs": "rgba(174, 188, 229, 0.25)",
        "framer-xe5tlh": "rgba(174, 188, 229, 0.25)",
        "framer-1thpx4x": "rgba(174, 188, 229, 0.25)",
        "framer-1nhkl21": "rgba(174, 188, 229, 0.25)",
        "framer-1j67inc": "rgba(255, 255, 255, 0.05)",
        "framer-1w8vm35": "rgba(174, 188, 229, 0.25)",
        "framer-q93b1f": "rgba(174, 188, 229, 0.25)",
        "framer-p56roq": "rgba(174, 188, 229, 0.25)",
        "framer-xxo5tq": "rgba(174, 188, 229, 0.25)",
        "framer-jei9sz": "rgba(174, 188, 229, 0.25)",
        "framer-1xd9ey1": "rgba(174, 188, 229, 0.25)",
        "framer-tta55x": "rgba(255, 255, 255, 0.05)",
        "framer-1yaeplo": "rgba(174, 188, 229, 0.25)",
        "framer-s315hq": "rgba(174, 188, 229, 0.25)",
        "framer-zhjgjs": "rgba(174, 188, 229, 0.25)",
        "framer-1onunez": "rgba(174, 188, 229, 0.25)",
        "framer-1kxdsaw": "rgba(174, 188, 229, 0.25)",
        "framer-x5zjc4": "rgba(174, 188, 229, 0.25)",
        "framer-1ogoxvw": "rgba(255, 255, 255, 0.05)",
        "framer-1ej8s96": "rgba(174, 188, 229, 0.25)",
        "framer-1ljxraj": "rgba(174, 188, 229, 0.25)",
        "framer-bvs3nh": "rgba(174, 188, 229, 0.25)",
        "framer-1jfhd3e": "rgba(174, 188, 229, 0.25)",
        "framer-1mf5s1w": "rgba(174, 188, 229, 0.25)",
        "framer-15hu7eo": "rgba(174, 188, 229, 0.25)",
        "framer-fkiu5i": "rgba(255, 255, 255, 0.05)",
        "framer-nll1ev": "rgba(174, 188, 229, 0.25)",
        "framer-1k18bi5": "rgba(174, 188, 229, 0.25)",
        "framer-1ejsdal": "rgba(174, 188, 229, 0.25)",
        "framer-yo9gne": "rgba(174, 188, 229, 0.25)",
        "framer-avufn9": "rgba(174, 188, 229, 0.25)",
        "framer-1uz6g49": "rgba(174, 188, 229, 0.25)",
        "framer-14j4ae0": "rgba(255, 255, 255, 0.05)",
        "framer-ikkyoe": "rgba(174, 188, 229, 0.25)",
        "framer-1ofbsd5": "rgba(174, 188, 229, 0.25)",
        "framer-1uiqk6d": "rgba(174, 188, 229, 0.25)",
        "framer-1n5i4bx": "rgba(174, 188, 229, 0.25)",
        "framer-1tn5838": "rgba(174, 188, 229, 0.25)",
        "framer-jhrq6e": "rgba(174, 188, 229, 0.25)",
        "framer-116z81w": "rgba(255, 255, 255, 0.05)",
        "framer-17q4w9p": "rgba(174, 188, 229, 0.25)",
        "framer-g7v8uo": "rgba(174, 188, 229, 0.25)",
        "framer-yi9vtt": "rgba(174, 188, 229, 0.25)",
        "framer-1f588is": "rgba(174, 188, 229, 0.25)",
        "framer-1dc6xk8": "rgba(174, 188, 229, 0.25)",
        "framer-on6tgz": "rgba(174, 188, 229, 0.25)",
        "framer-s5tagr": "rgba(255, 255, 255, 0.05)",
        "framer-1aexuar": "rgba(174, 188, 229, 0.25)",
        "framer-143pemu": "rgba(174, 188, 229, 0.25)",
        "framer-1xb97ia": "rgba(174, 188, 229, 0.25)",
        "framer-1qk7o4j": "rgba(174, 188, 229, 0.25)",
        "framer-105csk4": "rgba(174, 188, 229, 0.25)",
        "framer-m8elzm": "rgba(174, 188, 229, 0.25)",
        "framer-j77cpk": "rgba(255, 255, 255, 0.05)",
        "framer-blm95e": "rgba(174, 188, 229, 0.25)",
        "framer-1yey69v": "rgba(174, 188, 229, 0.25)",
        "framer-1cnksu0": "rgba(174, 188, 229, 0.25)",
        "framer-1trkbym": "rgba(174, 188, 229, 0.25)",
        "framer-sj8w9r": "rgba(174, 188, 229, 0.25)",
        "framer-hf37wh": "rgba(174, 188, 229, 0.25)"
      },
      "vClass": "framer-v-1cvfk3x",
      "variantName": null,
      "source": "framer_complete_tree (22).html"
    },
    {
      "colors": {
        "framer-1j52sld": "rgba(255, 255, 255, 0.05)",
        "framer-gehpcg": "rgba(174, 188, 229, 0.25)",
        "framer-8x19lf": "rgba(174, 188, 229, 0.25)",
        "framer-knm3lj": "rgba(174, 188, 229, 0.65)",
        "framer-1dmld5n": "rgba(174, 188, 229, 0.404)",
        "framer-uowqcg": "rgba(174, 188, 229, 0.25)",
        "framer-1dtqkwe": "rgba(174, 188, 229, 0.25)",
        "framer-1d23v23": "rgba(255, 255, 255, 0.05)",
        "framer-1qu365o": "rgba(174, 188, 229, 0.25)",
        "framer-1mmci20": "rgba(174, 188, 229, 0.25)",
        "framer-miej2s": "rgba(174, 188, 229, 0.65)",
        "framer-sasqsa": "rgba(174, 188, 229, 0.404)",
        "framer-1kgemv6": "rgba(174, 188, 229, 0.25)",
        "framer-1cxurzz": "rgba(174, 188, 229, 0.25)",
        "framer-q9y8xc": "rgba(255, 255, 255, 0.05)",
        "framer-1yqwbni": "rgba(174, 188, 229, 0.25)",
        "framer-d16p3l": "rgba(174, 188, 229, 0.25)",
        "framer-4mbxuq": "rgba(174, 188, 229, 0.65)",
        "framer-1et7wxn": "rgba(174, 188, 229, 0.404)",
        "framer-16cct62": "rgba(174, 188, 229, 0.25)",
        "framer-1ghpgks": "rgba(174, 188, 229, 0.25)",
        "framer-6mt54z": "rgba(255, 255, 255, 0.05)",
        "framer-1oo2wb3": "rgba(174, 188, 229, 0.25)",
        "framer-1xq7tt7": "rgba(174, 188, 229, 0.25)",
        "framer-1f7gz2q": "rgba(174, 188, 229, 0.65)",
        "framer-6oheae": "rgba(174, 188, 229, 0.404)",
        "framer-16dfwnm": "rgba(174, 188, 229, 0.25)",
        "framer-159bmwr": "rgba(174, 188, 229, 0.25)",
        "framer-s62qf": "rgba(255, 255, 255, 0.05)",
        "framer-dxgtbv": "rgba(174, 188, 229, 0.25)",
        "framer-dpv8i9": "rgba(174, 188, 229, 0.25)",
        "framer-1sa9ux3": "rgba(174, 188, 229, 0.25)",
        "framer-1p1vqsn": "rgba(174, 188, 229, 0.8)",
        "framer-5dtsk": "rgba(174, 188, 229, 0.25)",
        "framer-1ous5i2": "rgba(174, 188, 229, 0.25)",
        "framer-1scgyrh": "rgba(255, 255, 255, 0.05)",
        "framer-1ktaku4": "rgba(174, 188, 229, 0.25)",
        "framer-139g0if": "rgba(174, 188, 229, 0.25)",
        "framer-94grge": "rgba(174, 188, 229, 0.65)",
        "framer-1py6a95": "rgba(174, 188, 229, 0.404)",
        "framer-9sel6v": "rgba(174, 188, 229, 0.25)",
        "framer-c6xnnw": "rgba(174, 188, 229, 0.25)",
        "framer-11dwcfl": "rgba(255, 255, 255, 0.05)",
        "framer-17sbsqj": "rgba(174, 188, 229, 0.25)",
        "framer-1k04812": "rgba(174, 188, 229, 0.25)",
        "framer-1ofowvp": "rgba(174, 188, 229, 0.65)",
        "framer-1yc7nkx": "rgba(174, 188, 229, 0.404)",
        "framer-6x8zit": "rgba(174, 188, 229, 0.25)",
        "framer-1xgqlqz": "rgba(174, 188, 229, 0.25)",
        "framer-nyyiw0": "rgba(255, 255, 255, 0.05)",
        "framer-1v6ox53": "rgba(174, 188, 229, 0.25)",
        "framer-11ywq1a": "rgba(174, 188, 229, 0.25)",
        "framer-191s3p8": "rgba(174, 188, 229, 0.25)",
        "framer-10znthb": "rgba(174, 188, 229, 0.25)",
        "framer-1fvegu4": "rgba(174, 188, 229, 0.25)",
        "framer-rin559": "rgba(174, 188, 229, 0.25)",
        "framer-1eyav6c": "rgba(255, 255, 255, 0.05)",
        "framer-e3afyy": "rgba(174, 188, 229, 0.25)",
        "framer-1q1g9yv": "rgba(174, 188, 229, 0.25)",
        "framer-1gnnzrg": "rgba(174, 188, 229, 0.25)",
        "framer-12kekrz": "rgba(174, 188, 229, 0.25)",
        "framer-vozpd9": "rgba(174, 188, 229, 0.25)",
        "framer-31f8j1": "rgba(174, 188, 229, 0.25)",
        "framer-potqf9": "rgba(255, 255, 255, 0.05)",
        "framer-1l0cpn1": "rgba(174, 188, 229, 0.25)",
        "framer-sfbfhf": "rgba(174, 188, 229, 0.25)",
        "framer-15elbbk": "rgba(174, 188, 229, 0.25)",
        "framer-1t4oq6h": "rgba(174, 188, 229, 0.25)",
        "framer-63xkpc": "rgba(174, 188, 229, 0.25)",
        "framer-18wopk0": "rgba(174, 188, 229, 0.25)",
        "framer-7tt9j2": "rgba(255, 255, 255, 0.05)",
        "framer-qjxyc0": "rgba(174, 188, 229, 0.25)",
        "framer-2o336a": "rgba(174, 188, 229, 0.25)",
        "framer-io8hck": "rgba(174, 188, 229, 0.25)",
        "framer-l1pcin": "rgba(174, 188, 229, 0.25)",
        "framer-byw55i": "rgba(174, 188, 229, 0.25)",
        "framer-1bnefrh": "rgba(174, 188, 229, 0.25)",
        "framer-9bjmd": "rgba(255, 255, 255, 0.05)",
        "framer-ctsvdu": "rgba(174, 188, 229, 0.25)",
        "framer-tnljj9": "rgba(174, 188, 229, 0.25)",
        "framer-12zfrg4": "rgba(174, 188, 229, 0.25)",
        "framer-17c6cci": "rgba(174, 188, 229, 0.25)",
        "framer-1uqr6lu": "rgba(174, 188, 229, 0.25)",
        "framer-1ewrs3r": "rgba(174, 188, 229, 0.25)",
        "framer-b5vxef": "rgba(255, 255, 255, 0.05)",
        "framer-ubndnz": "rgba(174, 188, 229, 0.25)",
        "framer-n32ujw": "rgba(174, 188, 229, 0.25)",
        "framer-ea3vrs": "rgba(174, 188, 229, 0.25)",
        "framer-xe5tlh": "rgba(174, 188, 229, 0.25)",
        "framer-1thpx4x": "rgba(174, 188, 229, 0.25)",
        "framer-1nhkl21": "rgba(174, 188, 229, 0.25)",
        "framer-1j67inc": "rgba(255, 255, 255, 0.05)",
        "framer-1w8vm35": "rgba(174, 188, 229, 0.25)",
        "framer-q93b1f": "rgba(174, 188, 229, 0.25)",
        "framer-p56roq": "rgba(174, 188, 229, 0.25)",
        "framer-xxo5tq": "rgba(174, 188, 229, 0.25)",
        "framer-jei9sz": "rgba(174, 188, 229, 0.25)",
        "framer-1xd9ey1": "rgba(174, 188, 229, 0.25)",
        "framer-tta55x": "rgba(255, 255, 255, 0.05)",
        "framer-1yaeplo": "rgba(174, 188, 229, 0.25)",
        "framer-s315hq": "rgba(174, 188, 229, 0.25)",
        "framer-zhjgjs": "rgba(174, 188, 229, 0.25)",
        "framer-1onunez": "rgba(174, 188, 229, 0.25)",
        "framer-1kxdsaw": "rgba(174, 188, 229, 0.25)",
        "framer-x5zjc4": "rgba(174, 188, 229, 0.25)",
        "framer-1ogoxvw": "rgba(255, 255, 255, 0.05)",
        "framer-1ej8s96": "rgba(174, 188, 229, 0.25)",
        "framer-1ljxraj": "rgba(174, 188, 229, 0.25)",
        "framer-bvs3nh": "rgba(174, 188, 229, 0.25)",
        "framer-1jfhd3e": "rgba(174, 188, 229, 0.25)",
        "framer-1mf5s1w": "rgba(174, 188, 229, 0.25)",
        "framer-15hu7eo": "rgba(174, 188, 229, 0.25)",
        "framer-fkiu5i": "rgba(255, 255, 255, 0.05)",
        "framer-nll1ev": "rgba(174, 188, 229, 0.25)",
        "framer-1k18bi5": "rgba(174, 188, 229, 0.25)",
        "framer-1ejsdal": "rgba(174, 188, 229, 0.25)",
        "framer-yo9gne": "rgba(174, 188, 229, 0.25)",
        "framer-avufn9": "rgba(174, 188, 229, 0.25)",
        "framer-1uz6g49": "rgba(174, 188, 229, 0.25)",
        "framer-14j4ae0": "rgba(255, 255, 255, 0.05)",
        "framer-ikkyoe": "rgba(174, 188, 229, 0.25)",
        "framer-1ofbsd5": "rgba(174, 188, 229, 0.25)",
        "framer-1uiqk6d": "rgba(174, 188, 229, 0.25)",
        "framer-1n5i4bx": "rgba(174, 188, 229, 0.25)",
        "framer-1tn5838": "rgba(174, 188, 229, 0.25)",
        "framer-jhrq6e": "rgba(174, 188, 229, 0.25)",
        "framer-116z81w": "rgba(255, 255, 255, 0.05)",
        "framer-17q4w9p": "rgba(174, 188, 229, 0.25)",
        "framer-g7v8uo": "rgba(174, 188, 229, 0.25)",
        "framer-yi9vtt": "rgba(174, 188, 229, 0.25)",
        "framer-1f588is": "rgba(174, 188, 229, 0.25)",
        "framer-1dc6xk8": "rgba(174, 188, 229, 0.25)",
        "framer-on6tgz": "rgba(174, 188, 229, 0.25)",
        "framer-s5tagr": "rgba(255, 255, 255, 0.05)",
        "framer-1aexuar": "rgba(174, 188, 229, 0.25)",
        "framer-143pemu": "rgba(174, 188, 229, 0.25)",
        "framer-1xb97ia": "rgba(174, 188, 229, 0.25)",
        "framer-1qk7o4j": "rgba(174, 188, 229, 0.25)",
        "framer-105csk4": "rgba(174, 188, 229, 0.25)",
        "framer-m8elzm": "rgba(174, 188, 229, 0.25)",
        "framer-j77cpk": "rgba(255, 255, 255, 0.05)",
        "framer-blm95e": "rgba(174, 188, 229, 0.25)",
        "framer-1yey69v": "rgba(174, 188, 229, 0.25)",
        "framer-1cnksu0": "rgba(174, 188, 229, 0.25)",
        "framer-1trkbym": "rgba(174, 188, 229, 0.25)",
        "framer-sj8w9r": "rgba(174, 188, 229, 0.25)",
        "framer-hf37wh": "rgba(174, 188, 229, 0.25)"
      },
      "vClass": "framer-v-lq5zi8",
      "variantName": null,
      "source": "framer_complete_tree (23).html"
    }
  ],
  "batch": [
    {
      "colors": {
        "framer-3pozg9": "rgb(26, 26, 28)",
        "framer-13sg4gy": "rgb(26, 26, 28)",
        "framer-7x0ib4": "rgb(26, 26, 28)",
        "framer-1pi4ez7": "rgb(26, 26, 28)",
        "framer-iqs1wz": "rgb(26, 26, 28)",
        "framer-1bzoqol": "rgb(26, 26, 28)",
        "framer-rt17wz": "rgb(26, 26, 28)",
        "framer-ezg90b": "rgb(26, 26, 28)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (25).html"
    },
    {
      "colors": {
        "framer-3pozg9": "rgba(255, 255, 255, 0.7)",
        "framer-13sg4gy": "rgba(255, 255, 255, 0.7)",
        "framer-7x0ib4": "rgba(255, 255, 255, 0.7)",
        "framer-1pi4ez7": "rgba(255, 255, 255, 0.7)",
        "framer-iqs1wz": "rgba(255, 255, 255, 0.7)",
        "framer-1bzoqol": "rgba(255, 255, 255, 0.698)",
        "framer-rt17wz": "rgb(6, 6, 12)",
        "framer-ezg90b": "rgb(6, 6, 12)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (26).html"
    },
    {
      "colors": {
        "framer-3pozg9": "rgb(6, 6, 12)",
        "framer-13sg4gy": "rgb(6, 6, 12)",
        "framer-7x0ib4": "rgb(6, 6, 12)",
        "framer-1pi4ez7": "rgb(6, 6, 12)",
        "framer-iqs1wz": "rgb(6, 6, 12)",
        "framer-1bzoqol": "rgb(6, 6, 12)",
        "framer-rt17wz": "rgb(6, 6, 12)",
        "framer-ezg90b": "rgb(6, 6, 12)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (27).html"
    },
    {
      "colors": {
        "framer-3pozg9": "rgb(255, 255, 255)",
        "framer-13sg4gy": "rgb(255, 255, 255)",
        "framer-7x0ib4": "rgb(255, 255, 255)",
        "framer-1pi4ez7": "rgb(255, 255, 255)",
        "framer-iqs1wz": "rgb(255, 255, 255)",
        "framer-1bzoqol": "rgb(255, 255, 255)",
        "framer-rt17wz": "rgb(255, 255, 255)",
        "framer-ezg90b": "rgb(255, 255, 255)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (28).html"
    }
  ],
  "risk": [
    {
      "colors": {
        "framer-1jj0ifc": "rgba(255, 255, 255, 0.04)",
        "framer-dpwm0b": "rgba(255, 255, 255, 0.04)",
        "framer-11sh3kl": "rgba(255, 255, 255, 0.04)",
        "framer-atydiq": "rgba(255, 255, 255, 0.04)",
        "framer-ndx6n2": "rgba(255, 255, 255, 0.04)",
        "framer-wmpa9h": "rgba(255, 255, 255, 0.04)",
        "framer-yu6s5s": "rgba(255, 255, 255, 0.04)",
        "framer-16j6ocd": "rgba(255, 255, 255, 0.04)",
        "framer-1swijur": "rgba(255, 255, 255, 0.25)",
        "framer-dcpd2y": "rgba(255, 255, 255, 0.25)",
        "framer-19lpopk": "rgba(255, 255, 255, 0.04)",
        "framer-1gy3pmp": "rgba(255, 255, 255, 0.04)",
        "framer-1v1x89z": "rgba(255, 255, 255, 0.25)",
        "framer-1bl2k9n": "rgba(255, 255, 255, 0.25)",
        "framer-1l22rll": "rgba(255, 255, 255, 0.04)",
        "framer-p404w8": "rgba(255, 255, 255, 0.04)",
        "framer-12u4h2y": "rgba(255, 255, 255, 0.25)",
        "framer-mcx67j": "rgba(255, 255, 255, 0.25)",
        "framer-9bt0ow": "rgba(255, 255, 255, 0.04)",
        "framer-1hxcvmh": "rgba(255, 255, 255, 0.04)",
        "framer-zsvztq": "rgba(255, 255, 255, 0.25)",
        "framer-bfd5pd": "rgba(255, 255, 255, 0.25)",
        "framer-1fkr5hp": "rgba(255, 255, 255, 0.04)",
        "framer-16tdrzi": "rgba(255, 255, 255, 0.04)",
        "framer-1upn6hk": "rgba(255, 255, 255, 0.25)",
        "framer-12s24r2": "rgba(255, 255, 255, 0.25)",
        "framer-mju97v": "rgba(255, 255, 255, 0.04)",
        "framer-hk0b4p": "rgba(255, 255, 255, 0.04)",
        "framer-1nob4pv": "rgba(255, 255, 255, 0.25)",
        "framer-8pyn9g": "rgba(255, 255, 255, 0.25)",
        "framer-1fjaf3s": "rgba(255, 255, 255, 0.04)",
        "framer-d98h5j": "rgba(255, 255, 255, 0.04)",
        "framer-1j5bhac": "rgba(255, 255, 255, 0.25)",
        "framer-13jkm5b": "rgba(255, 255, 255, 0.25)",
        "framer-17qv8u8": "rgba(255, 255, 255, 0.04)",
        "framer-69q9y1": "rgba(255, 255, 255, 0.04)",
        "framer-17ayp1e": "rgba(255, 255, 255, 0.25)",
        "framer-1cqt4kz": "rgba(255, 255, 255, 0.25)",
        "framer-1lo8o3t": "rgba(255, 255, 255, 0.04)",
        "framer-zdc5sg": "rgba(255, 255, 255, 0.04)",
        "framer-1of3gxf": "rgba(255, 255, 255, 0.25)",
        "framer-1cp4vei": "rgba(255, 255, 255, 0.25)",
        "framer-kkby6z": "rgba(255, 255, 255, 0.04)",
        "framer-v7u6as": "rgba(255, 255, 255, 0.04)",
        "framer-mvorvo": "rgba(255, 255, 255, 0.25)",
        "framer-kq0fap": "rgba(255, 255, 255, 0.25)",
        "framer-itnu1k": "rgba(255, 255, 255, 0.04)",
        "framer-dvz24s": "rgba(255, 255, 255, 0.04)",
        "framer-p0q4zf": "rgba(255, 255, 255, 0.25)",
        "framer-1k5jk6l": "rgba(255, 255, 255, 0.25)",
        "framer-1x657tl": "rgba(255, 255, 255, 0.04)",
        "framer-1g37od": "rgba(255, 255, 255, 0.04)",
        "framer-10yw6sv": "rgba(255, 255, 255, 0.25)",
        "framer-bxygyb": "rgba(255, 255, 255, 0.25)",
        "framer-1wx1bo8": "rgba(255, 255, 255, 0.04)",
        "framer-rlvslr": "rgba(255, 255, 255, 0.04)",
        "framer-xbc3d2": "rgba(255, 255, 255, 0.25)",
        "framer-1wot0vl": "rgba(255, 255, 255, 0.25)",
        "framer-gfqp5f": "rgba(255, 255, 255, 0.04)",
        "framer-vsen48": "rgba(255, 255, 255, 0.04)",
        "framer-1q0gr72": "rgba(255, 255, 255, 0.25)",
        "framer-1dh0ekj": "rgba(255, 255, 255, 0.25)",
        "framer-t0d6f4": "rgba(255, 255, 255, 0.04)",
        "framer-1u2kj51": "rgba(255, 255, 255, 0.04)",
        "framer-wqsupw": "rgba(255, 255, 255, 0.25)",
        "framer-1nh8wlf": "rgba(255, 255, 255, 0.25)",
        "framer-5ja1up": "rgba(255, 255, 255, 0.04)",
        "framer-1ahk1dw": "rgba(255, 255, 255, 0.04)",
        "framer-tmre0j": "rgba(255, 255, 255, 0.25)",
        "framer-1fecrzm": "rgba(255, 255, 255, 0.25)",
        "framer-14v7fn6": "rgba(255, 255, 255, 0.04)",
        "framer-1kt7zzt": "rgba(255, 255, 255, 0.04)",
        "framer-77yo50": "rgba(255, 255, 255, 0.25)",
        "framer-m6t74m": "rgba(255, 255, 255, 0.25)",
        "framer-fny01e": "rgba(255, 255, 255, 0.04)",
        "framer-bsrptp": "rgba(255, 255, 255, 0.04)",
        "framer-1sctmbp": "rgba(255, 255, 255, 0.25)",
        "framer-1xtzavl": "rgba(255, 255, 255, 0.25)",
        "framer-1j6nou9": "rgba(255, 255, 255, 0.04)",
        "framer-18wavnh": "rgba(255, 255, 255, 0.04)",
        "framer-13ft1pc": "rgba(255, 255, 255, 0.25)",
        "framer-lwi2nv": "rgba(255, 255, 255, 0.25)",
        "framer-1p0ta5s": "rgba(255, 255, 255, 0.04)",
        "framer-okk9na": "rgba(255, 255, 255, 0.04)",
        "framer-1wscuse": "rgba(255, 255, 255, 0.25)",
        "framer-ckjief": "rgba(255, 255, 255, 0.25)",
        "framer-1wd74n9": "rgba(255, 255, 255, 0.04)",
        "framer-je1js9": "rgba(255, 255, 255, 0.04)",
        "framer-11vb55v": "rgba(255, 255, 255, 0.25)",
        "framer-zxu9g1": "rgba(255, 255, 255, 0.25)",
        "framer-175a80z": "rgba(255, 255, 255, 0.04)",
        "framer-qhv2jx": "rgba(255, 255, 255, 0.04)",
        "framer-1fuomwv": "rgba(255, 255, 255, 0.25)",
        "framer-1pvftwy": "rgba(255, 255, 255, 0.25)",
        "framer-7bxvqv": "rgba(255, 255, 255, 0.04)",
        "framer-1ebwbwm": "rgba(255, 255, 255, 0.04)",
        "framer-1t4div0": "rgba(255, 255, 255, 0.25)",
        "framer-18l77et": "rgba(255, 255, 255, 0.25)",
        "framer-i5cm9v": "rgba(255, 255, 255, 0.04)",
        "framer-va4ics": "rgba(255, 255, 255, 0.04)",
        "framer-emgwcw": "rgba(255, 255, 255, 0.25)",
        "framer-1s4aw3h": "rgba(255, 255, 255, 0.25)",
        "framer-1kr91hz": "rgba(255, 255, 255, 0.04)",
        "framer-1fiw6w0": "rgba(255, 255, 255, 0.04)",
        "framer-1pil1hc": "rgba(255, 255, 255, 0.25)",
        "framer-1bef5is": "rgba(255, 255, 255, 0.25)",
        "framer-1s4soym": "rgba(255, 255, 255, 0.04)",
        "framer-e5pbl1": "rgba(255, 255, 255, 0.04)",
        "framer-tq6zkq": "rgba(255, 255, 255, 0.25)",
        "framer-1we93t": "rgba(255, 255, 255, 0.25)",
        "framer-nehzx1": "rgba(255, 255, 255, 0.04)",
        "framer-1we71xp": "rgba(255, 255, 255, 0.04)",
        "framer-1yltltg": "rgba(255, 255, 255, 0.25)",
        "framer-b62ir1": "rgba(255, 255, 255, 0.25)",
        "framer-qx7dca": "rgba(255, 255, 255, 0.04)",
        "framer-97zyep": "rgba(255, 255, 255, 0.04)",
        "framer-1hx6plk": "rgba(255, 255, 255, 0.25)",
        "framer-187r6wo": "rgba(255, 255, 255, 0.25)",
        "framer-1suu08m": "rgba(255, 255, 255, 0.04)",
        "framer-1k1f9td": "rgba(255, 255, 255, 0.04)",
        "framer-10z6mja": "rgba(255, 255, 255, 0.25)",
        "framer-1c6vijq": "rgba(255, 255, 255, 0.25)",
        "framer-1dp7hdl": "rgba(255, 255, 255, 0.04)",
        "framer-1cuttk9": "rgba(255, 255, 255, 0.04)",
        "framer-1x2xnil": "rgba(255, 255, 255, 0.25)",
        "framer-1cwvdqi": "rgba(255, 255, 255, 0.25)",
        "framer-lhhssf": "rgba(255, 255, 255, 0.04)",
        "framer-aeocs": "rgba(255, 255, 255, 0.04)",
        "framer-3zdcj2": "rgba(255, 255, 255, 0.25)",
        "framer-vpipdz": "rgba(255, 255, 255, 0.25)",
        "framer-dev0uk": "rgba(255, 255, 255, 0.04)",
        "framer-op9xil": "rgba(255, 255, 255, 0.04)",
        "framer-tik92e": "rgba(255, 255, 255, 0.25)",
        "framer-iqjc80": "rgba(255, 255, 255, 0.25)",
        "framer-tl1004": "rgba(255, 255, 255, 0.04)",
        "framer-qaw95m": "rgba(255, 255, 255, 0.04)",
        "framer-3h8x2s": "rgba(255, 255, 255, 0.25)",
        "framer-m70ahb": "rgba(255, 255, 255, 0.25)",
        "framer-1idhpfp": "rgba(255, 255, 255, 0.04)",
        "framer-1ypbpdo": "rgba(255, 255, 255, 0.04)",
        "framer-128zqc6": "rgba(255, 255, 255, 0.25)",
        "framer-1ytw3om": "rgba(255, 255, 255, 0.25)",
        "framer-13ytebk": "rgba(255, 255, 255, 0.04)",
        "framer-1ww14do": "rgba(255, 255, 255, 0.04)",
        "framer-a8pcov": "rgba(255, 255, 255, 0.25)",
        "framer-ab8tx3": "rgba(255, 255, 255, 0.25)",
        "framer-5uqmqq": "rgba(255, 255, 255, 0.04)",
        "framer-1ofu2ul": "rgba(255, 255, 255, 0.04)",
        "framer-9gbi0z": "rgba(255, 255, 255, 0.25)",
        "framer-f39cdm": "rgba(255, 255, 255, 0.25)",
        "framer-74v5au": "rgba(255, 255, 255, 0.04)",
        "framer-4jd8se": "rgba(255, 255, 255, 0.04)",
        "framer-1v11feq": "rgba(255, 255, 255, 0.25)",
        "framer-b7yay1": "rgba(255, 255, 255, 0.25)",
        "framer-ib20gg": "rgba(255, 255, 255, 0.04)",
        "framer-nmz8wd": "rgba(255, 255, 255, 0.04)"
      },
      "vClass": null,
      "variantName": "Risk Scan A",
      "source": "framer_complete_tree (16+18).html"
    },
    {
      "colors": {
        "framer-1jj0ifc": "rgba(255, 255, 255, 0.25)",
        "framer-dpwm0b": "rgba(255, 255, 255, 0.25)",
        "framer-11sh3kl": "rgba(255, 255, 255, 0.25)",
        "framer-atydiq": "rgba(255, 255, 255, 0.25)",
        "framer-ndx6n2": "rgba(255, 255, 255, 0.25)",
        "framer-wmpa9h": "rgba(255, 255, 255, 0.25)",
        "framer-yu6s5s": "rgba(255, 255, 255, 0.25)",
        "framer-16j6ocd": "rgba(255, 255, 255, 0.25)",
        "framer-1swijur": "rgba(255, 255, 255, 0.04)",
        "framer-dcpd2y": "rgba(255, 255, 255, 0.04)",
        "framer-19lpopk": "rgba(255, 255, 255, 0.25)",
        "framer-1gy3pmp": "rgba(255, 255, 255, 0.25)",
        "framer-1v1x89z": "rgba(255, 255, 255, 0.04)",
        "framer-1bl2k9n": "rgba(255, 255, 255, 0.04)",
        "framer-1l22rll": "rgba(255, 255, 255, 0.25)",
        "framer-p404w8": "rgba(255, 255, 255, 0.25)",
        "framer-12u4h2y": "rgba(255, 255, 255, 0.04)",
        "framer-mcx67j": "rgba(255, 255, 255, 0.04)",
        "framer-9bt0ow": "rgba(255, 255, 255, 0.25)",
        "framer-1hxcvmh": "rgba(255, 255, 255, 0.25)",
        "framer-zsvztq": "rgba(255, 255, 255, 0.04)",
        "framer-bfd5pd": "rgba(255, 255, 255, 0.04)",
        "framer-1fkr5hp": "rgba(255, 255, 255, 0.25)",
        "framer-16tdrzi": "rgba(255, 255, 255, 0.25)",
        "framer-1upn6hk": "rgba(255, 255, 255, 0.04)",
        "framer-12s24r2": "rgba(255, 255, 255, 0.04)",
        "framer-mju97v": "rgba(255, 255, 255, 0.25)",
        "framer-hk0b4p": "rgba(255, 255, 255, 0.25)",
        "framer-1nob4pv": "rgba(255, 255, 255, 0.04)",
        "framer-8pyn9g": "rgba(255, 255, 255, 0.04)",
        "framer-1fjaf3s": "rgba(255, 255, 255, 0.25)",
        "framer-d98h5j": "rgba(255, 255, 255, 0.25)",
        "framer-1j5bhac": "rgba(255, 255, 255, 0.04)",
        "framer-13jkm5b": "rgba(255, 255, 255, 0.04)",
        "framer-17qv8u8": "rgba(255, 255, 255, 0.25)",
        "framer-69q9y1": "rgba(255, 255, 255, 0.25)",
        "framer-17ayp1e": "rgba(255, 255, 255, 0.04)",
        "framer-1cqt4kz": "rgba(255, 255, 255, 0.04)",
        "framer-1lo8o3t": "rgba(255, 255, 255, 0.25)",
        "framer-zdc5sg": "rgba(255, 255, 255, 0.25)",
        "framer-1of3gxf": "rgba(255, 255, 255, 0.04)",
        "framer-1cp4vei": "rgba(255, 255, 255, 0.04)",
        "framer-kkby6z": "rgba(255, 255, 255, 0.25)",
        "framer-v7u6as": "rgba(255, 255, 255, 0.25)",
        "framer-mvorvo": "rgba(255, 255, 255, 0.04)",
        "framer-kq0fap": "rgba(255, 255, 255, 0.04)",
        "framer-itnu1k": "rgba(255, 255, 255, 0.25)",
        "framer-dvz24s": "rgba(255, 255, 255, 0.25)",
        "framer-p0q4zf": "rgba(255, 255, 255, 0.04)",
        "framer-1k5jk6l": "rgba(255, 255, 255, 0.04)",
        "framer-1x657tl": "rgba(255, 255, 255, 0.25)",
        "framer-1g37od": "rgba(255, 255, 255, 0.25)",
        "framer-10yw6sv": "rgba(255, 255, 255, 0.04)",
        "framer-bxygyb": "rgba(255, 255, 255, 0.04)",
        "framer-1wx1bo8": "rgba(255, 255, 255, 0.25)",
        "framer-rlvslr": "rgba(255, 255, 255, 0.25)",
        "framer-xbc3d2": "rgba(255, 255, 255, 0.04)",
        "framer-1wot0vl": "rgba(255, 255, 255, 0.04)",
        "framer-gfqp5f": "rgba(255, 255, 255, 0.25)",
        "framer-vsen48": "rgba(255, 255, 255, 0.25)",
        "framer-1q0gr72": "rgba(255, 255, 255, 0.04)",
        "framer-1dh0ekj": "rgba(255, 255, 255, 0.04)",
        "framer-t0d6f4": "rgba(255, 255, 255, 0.25)",
        "framer-1u2kj51": "rgba(255, 255, 255, 0.25)",
        "framer-wqsupw": "rgba(255, 255, 255, 0.04)",
        "framer-1nh8wlf": "rgba(255, 255, 255, 0.04)",
        "framer-5ja1up": "rgba(255, 255, 255, 0.25)",
        "framer-1ahk1dw": "rgba(255, 255, 255, 0.25)",
        "framer-tmre0j": "rgba(255, 255, 255, 0.04)",
        "framer-1fecrzm": "rgba(255, 255, 255, 0.04)",
        "framer-14v7fn6": "rgba(255, 255, 255, 0.25)",
        "framer-1kt7zzt": "rgba(255, 255, 255, 0.25)",
        "framer-77yo50": "rgba(255, 255, 255, 0.04)",
        "framer-m6t74m": "rgba(255, 255, 255, 0.04)",
        "framer-fny01e": "rgba(255, 255, 255, 0.25)",
        "framer-bsrptp": "rgba(255, 255, 255, 0.25)",
        "framer-1sctmbp": "rgba(255, 255, 255, 0.04)",
        "framer-1xtzavl": "rgba(255, 255, 255, 0.04)",
        "framer-1j6nou9": "rgba(255, 255, 255, 0.25)",
        "framer-18wavnh": "rgba(255, 255, 255, 0.25)",
        "framer-13ft1pc": "rgba(255, 255, 255, 0.04)",
        "framer-lwi2nv": "rgba(255, 255, 255, 0.04)",
        "framer-1p0ta5s": "rgba(255, 255, 255, 0.25)",
        "framer-okk9na": "rgba(255, 255, 255, 0.25)",
        "framer-1wscuse": "rgba(255, 255, 255, 0.04)",
        "framer-ckjief": "rgba(255, 255, 255, 0.04)",
        "framer-1wd74n9": "rgba(255, 255, 255, 0.25)",
        "framer-je1js9": "rgba(255, 255, 255, 0.25)",
        "framer-11vb55v": "rgba(255, 255, 255, 0.04)",
        "framer-zxu9g1": "rgba(255, 255, 255, 0.04)",
        "framer-175a80z": "rgba(255, 255, 255, 0.25)",
        "framer-qhv2jx": "rgba(255, 255, 255, 0.25)",
        "framer-1fuomwv": "rgba(255, 255, 255, 0.04)",
        "framer-1pvftwy": "rgba(255, 255, 255, 0.04)",
        "framer-7bxvqv": "rgba(255, 255, 255, 0.25)",
        "framer-1ebwbwm": "rgba(255, 255, 255, 0.25)",
        "framer-1t4div0": "rgba(255, 255, 255, 0.04)",
        "framer-18l77et": "rgba(255, 255, 255, 0.04)",
        "framer-i5cm9v": "rgba(255, 255, 255, 0.25)",
        "framer-va4ics": "rgba(255, 255, 255, 0.25)",
        "framer-emgwcw": "rgba(255, 255, 255, 0.04)",
        "framer-1s4aw3h": "rgba(255, 255, 255, 0.04)",
        "framer-1kr91hz": "rgba(255, 255, 255, 0.25)",
        "framer-1fiw6w0": "rgba(255, 255, 255, 0.25)",
        "framer-1pil1hc": "rgba(255, 255, 255, 0.04)",
        "framer-1bef5is": "rgba(255, 255, 255, 0.04)",
        "framer-1s4soym": "rgba(255, 255, 255, 0.25)",
        "framer-e5pbl1": "rgba(255, 255, 255, 0.25)",
        "framer-tq6zkq": "rgba(255, 255, 255, 0.04)",
        "framer-1we93t": "rgba(255, 255, 255, 0.04)",
        "framer-nehzx1": "rgba(255, 255, 255, 0.25)",
        "framer-1we71xp": "rgba(255, 255, 255, 0.25)",
        "framer-1yltltg": "rgba(255, 255, 255, 0.04)",
        "framer-b62ir1": "rgba(255, 255, 255, 0.04)",
        "framer-qx7dca": "rgba(255, 255, 255, 0.25)",
        "framer-97zyep": "rgba(255, 255, 255, 0.25)",
        "framer-1hx6plk": "rgba(255, 255, 255, 0.04)",
        "framer-187r6wo": "rgba(255, 255, 255, 0.04)",
        "framer-1suu08m": "rgba(255, 255, 255, 0.25)",
        "framer-1k1f9td": "rgba(255, 255, 255, 0.25)",
        "framer-10z6mja": "rgba(255, 255, 255, 0.04)",
        "framer-1c6vijq": "rgba(255, 255, 255, 0.04)",
        "framer-1dp7hdl": "rgba(255, 255, 255, 0.25)",
        "framer-1cuttk9": "rgba(255, 255, 255, 0.25)",
        "framer-1x2xnil": "rgba(255, 255, 255, 0.04)",
        "framer-1cwvdqi": "rgba(255, 255, 255, 0.04)",
        "framer-lhhssf": "rgba(255, 255, 255, 0.25)",
        "framer-aeocs": "rgba(255, 255, 255, 0.25)",
        "framer-3zdcj2": "rgba(255, 255, 255, 0.04)",
        "framer-vpipdz": "rgba(255, 255, 255, 0.04)",
        "framer-dev0uk": "rgba(255, 255, 255, 0.25)",
        "framer-op9xil": "rgba(255, 255, 255, 0.25)",
        "framer-tik92e": "rgba(255, 255, 255, 0.04)",
        "framer-iqjc80": "rgba(255, 255, 255, 0.04)",
        "framer-tl1004": "rgba(255, 255, 255, 0.25)",
        "framer-qaw95m": "rgba(255, 255, 255, 0.25)",
        "framer-3h8x2s": "rgba(255, 255, 255, 0.04)",
        "framer-m70ahb": "rgba(255, 255, 255, 0.04)",
        "framer-1idhpfp": "rgba(255, 255, 255, 0.25)",
        "framer-1ypbpdo": "rgba(255, 255, 255, 0.25)",
        "framer-128zqc6": "rgba(255, 255, 255, 0.04)",
        "framer-1ytw3om": "rgba(255, 255, 255, 0.04)",
        "framer-13ytebk": "rgba(255, 255, 255, 0.25)",
        "framer-1ww14do": "rgba(255, 255, 255, 0.25)",
        "framer-a8pcov": "rgba(255, 255, 255, 0.04)",
        "framer-ab8tx3": "rgba(255, 255, 255, 0.04)",
        "framer-5uqmqq": "rgba(255, 255, 255, 0.25)",
        "framer-1ofu2ul": "rgba(255, 255, 255, 0.25)",
        "framer-9gbi0z": "rgba(255, 255, 255, 0.04)",
        "framer-f39cdm": "rgba(255, 255, 255, 0.04)",
        "framer-74v5au": "rgba(255, 255, 255, 0.25)",
        "framer-4jd8se": "rgba(255, 255, 255, 0.25)",
        "framer-1v11feq": "rgba(255, 255, 255, 0.04)",
        "framer-b7yay1": "rgba(255, 255, 255, 0.04)",
        "framer-ib20gg": "rgba(255, 255, 255, 0.25)",
        "framer-nmz8wd": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": null,
      "variantName": "Risk Scan B",
      "source": "framer_complete_tree (16+18).html"
    },
    {
      "colors": {
        "framer-1jj0ifc": "rgba(255, 255, 255, 0.04)",
        "framer-dpwm0b": "rgba(255, 255, 255, 0.04)",
        "framer-11sh3kl": "rgba(255, 255, 255, 0.04)",
        "framer-atydiq": "rgba(255, 255, 255, 0.04)",
        "framer-ndx6n2": "rgba(255, 255, 255, 0.04)",
        "framer-wmpa9h": "rgba(255, 255, 255, 0.04)",
        "framer-yu6s5s": "rgba(255, 255, 255, 0.04)",
        "framer-16j6ocd": "rgba(255, 255, 255, 0.04)",
        "framer-1swijur": "rgba(255, 255, 255, 0.25)",
        "framer-dcpd2y": "rgba(255, 255, 255, 0.04)",
        "framer-19lpopk": "rgba(255, 255, 255, 0.04)",
        "framer-1gy3pmp": "rgba(255, 255, 255, 0.25)",
        "framer-1v1x89z": "rgba(255, 255, 255, 0.25)",
        "framer-1bl2k9n": "rgba(255, 255, 255, 0.04)",
        "framer-1l22rll": "rgba(255, 255, 255, 0.04)",
        "framer-p404w8": "rgba(255, 255, 255, 0.25)",
        "framer-12u4h2y": "rgba(255, 255, 255, 0.25)",
        "framer-mcx67j": "rgba(255, 255, 255, 0.04)",
        "framer-9bt0ow": "rgba(255, 255, 255, 0.04)",
        "framer-1hxcvmh": "rgba(255, 255, 255, 0.25)",
        "framer-zsvztq": "rgba(255, 255, 255, 0.25)",
        "framer-bfd5pd": "rgba(255, 255, 255, 0.04)",
        "framer-1fkr5hp": "rgba(255, 255, 255, 0.04)",
        "framer-16tdrzi": "rgba(255, 255, 255, 0.25)",
        "framer-1upn6hk": "rgba(255, 255, 255, 0.25)",
        "framer-12s24r2": "rgba(255, 255, 255, 0.04)",
        "framer-mju97v": "rgba(255, 255, 255, 0.04)",
        "framer-hk0b4p": "rgba(255, 255, 255, 0.25)",
        "framer-1nob4pv": "rgba(255, 255, 255, 0.25)",
        "framer-8pyn9g": "rgba(255, 255, 255, 0.04)",
        "framer-1fjaf3s": "rgba(255, 255, 255, 0.04)",
        "framer-d98h5j": "rgba(255, 255, 255, 0.25)",
        "framer-1j5bhac": "rgba(255, 255, 255, 0.25)",
        "framer-13jkm5b": "rgba(255, 255, 255, 0.04)",
        "framer-17qv8u8": "rgba(255, 255, 255, 0.04)",
        "framer-69q9y1": "rgba(255, 255, 255, 0.25)",
        "framer-17ayp1e": "rgba(255, 255, 255, 0.25)",
        "framer-1cqt4kz": "rgba(255, 255, 255, 0.04)",
        "framer-1lo8o3t": "rgba(255, 255, 255, 0.04)",
        "framer-zdc5sg": "rgba(255, 255, 255, 0.25)",
        "framer-1of3gxf": "rgba(255, 255, 255, 0.25)",
        "framer-1cp4vei": "rgba(255, 255, 255, 0.04)",
        "framer-kkby6z": "rgba(255, 255, 255, 0.04)",
        "framer-v7u6as": "rgba(255, 255, 255, 0.25)",
        "framer-mvorvo": "rgba(255, 255, 255, 0.25)",
        "framer-kq0fap": "rgba(255, 255, 255, 0.04)",
        "framer-itnu1k": "rgba(255, 255, 255, 0.04)",
        "framer-dvz24s": "rgba(255, 255, 255, 0.25)",
        "framer-p0q4zf": "rgba(255, 255, 255, 0.25)",
        "framer-1k5jk6l": "rgba(255, 255, 255, 0.04)",
        "framer-1x657tl": "rgba(255, 255, 255, 0.04)",
        "framer-1g37od": "rgba(255, 255, 255, 0.25)",
        "framer-10yw6sv": "rgba(255, 255, 255, 0.25)",
        "framer-bxygyb": "rgba(255, 255, 255, 0.04)",
        "framer-1wx1bo8": "rgba(255, 255, 255, 0.04)",
        "framer-rlvslr": "rgba(255, 255, 255, 0.25)",
        "framer-xbc3d2": "rgba(255, 255, 255, 0.25)",
        "framer-1wot0vl": "rgba(255, 255, 255, 0.04)",
        "framer-gfqp5f": "rgba(255, 255, 255, 0.04)",
        "framer-vsen48": "rgba(255, 255, 255, 0.25)",
        "framer-1q0gr72": "rgba(255, 255, 255, 0.25)",
        "framer-1dh0ekj": "rgba(255, 255, 255, 0.04)",
        "framer-t0d6f4": "rgba(255, 255, 255, 0.04)",
        "framer-1u2kj51": "rgba(255, 255, 255, 0.25)",
        "framer-wqsupw": "rgba(255, 255, 255, 0.25)",
        "framer-1nh8wlf": "rgba(255, 255, 255, 0.04)",
        "framer-5ja1up": "rgba(255, 255, 255, 0.04)",
        "framer-1ahk1dw": "rgba(255, 255, 255, 0.25)",
        "framer-tmre0j": "rgba(255, 255, 255, 0.25)",
        "framer-1fecrzm": "rgba(255, 255, 255, 0.04)",
        "framer-14v7fn6": "rgba(255, 255, 255, 0.04)",
        "framer-1kt7zzt": "rgba(255, 255, 255, 0.25)",
        "framer-77yo50": "rgba(255, 255, 255, 0.25)",
        "framer-m6t74m": "rgba(255, 255, 255, 0.04)",
        "framer-fny01e": "rgba(255, 255, 255, 0.04)",
        "framer-bsrptp": "rgba(255, 255, 255, 0.25)",
        "framer-1sctmbp": "rgba(255, 255, 255, 0.25)",
        "framer-1xtzavl": "rgba(255, 255, 255, 0.04)",
        "framer-1j6nou9": "rgba(255, 255, 255, 0.04)",
        "framer-18wavnh": "rgba(255, 255, 255, 0.25)",
        "framer-13ft1pc": "rgba(255, 255, 255, 0.25)",
        "framer-lwi2nv": "rgba(255, 255, 255, 0.04)",
        "framer-1p0ta5s": "rgba(255, 255, 255, 0.04)",
        "framer-okk9na": "rgba(255, 255, 255, 0.25)",
        "framer-1wscuse": "rgba(255, 255, 255, 0.25)",
        "framer-ckjief": "rgba(255, 255, 255, 0.04)",
        "framer-1wd74n9": "rgba(255, 255, 255, 0.04)",
        "framer-je1js9": "rgba(255, 255, 255, 0.25)",
        "framer-11vb55v": "rgba(255, 255, 255, 0.25)",
        "framer-zxu9g1": "rgba(255, 255, 255, 0.04)",
        "framer-175a80z": "rgba(255, 255, 255, 0.04)",
        "framer-qhv2jx": "rgba(255, 255, 255, 0.25)",
        "framer-1fuomwv": "rgba(255, 255, 255, 0.25)",
        "framer-1pvftwy": "rgba(255, 255, 255, 0.04)",
        "framer-7bxvqv": "rgba(255, 255, 255, 0.04)",
        "framer-1ebwbwm": "rgba(255, 255, 255, 0.25)",
        "framer-1t4div0": "rgba(255, 255, 255, 0.25)",
        "framer-18l77et": "rgba(255, 255, 255, 0.04)",
        "framer-i5cm9v": "rgba(255, 255, 255, 0.04)",
        "framer-va4ics": "rgba(255, 255, 255, 0.25)",
        "framer-emgwcw": "rgba(255, 255, 255, 0.25)",
        "framer-1s4aw3h": "rgba(255, 255, 255, 0.04)",
        "framer-1kr91hz": "rgba(255, 255, 255, 0.04)",
        "framer-1fiw6w0": "rgba(255, 255, 255, 0.25)",
        "framer-1pil1hc": "rgba(255, 255, 255, 0.25)",
        "framer-1bef5is": "rgba(255, 255, 255, 0.04)",
        "framer-1s4soym": "rgba(255, 255, 255, 0.04)",
        "framer-e5pbl1": "rgba(255, 255, 255, 0.25)",
        "framer-tq6zkq": "rgba(255, 255, 255, 0.25)",
        "framer-1we93t": "rgba(255, 255, 255, 0.04)",
        "framer-nehzx1": "rgba(255, 255, 255, 0.04)",
        "framer-1we71xp": "rgba(255, 255, 255, 0.25)",
        "framer-1yltltg": "rgba(255, 255, 255, 0.25)",
        "framer-b62ir1": "rgba(255, 255, 255, 0.04)",
        "framer-qx7dca": "rgba(255, 255, 255, 0.04)",
        "framer-97zyep": "rgba(255, 255, 255, 0.25)",
        "framer-1hx6plk": "rgba(255, 255, 255, 0.25)",
        "framer-187r6wo": "rgba(255, 255, 255, 0.04)",
        "framer-1suu08m": "rgba(255, 255, 255, 0.04)",
        "framer-1k1f9td": "rgba(255, 255, 255, 0.25)",
        "framer-10z6mja": "rgba(255, 255, 255, 0.25)",
        "framer-1c6vijq": "rgba(255, 255, 255, 0.04)",
        "framer-1dp7hdl": "rgba(255, 255, 255, 0.04)",
        "framer-1cuttk9": "rgba(255, 255, 255, 0.25)",
        "framer-1x2xnil": "rgba(255, 255, 255, 0.25)",
        "framer-1cwvdqi": "rgba(255, 255, 255, 0.04)",
        "framer-lhhssf": "rgba(255, 255, 255, 0.04)",
        "framer-aeocs": "rgba(255, 255, 255, 0.25)",
        "framer-3zdcj2": "rgba(255, 255, 255, 0.25)",
        "framer-vpipdz": "rgba(255, 255, 255, 0.04)",
        "framer-dev0uk": "rgba(255, 255, 255, 0.04)",
        "framer-op9xil": "rgba(255, 255, 255, 0.25)",
        "framer-tik92e": "rgba(255, 255, 255, 0.25)",
        "framer-iqjc80": "rgba(255, 255, 255, 0.04)",
        "framer-tl1004": "rgba(255, 255, 255, 0.04)",
        "framer-qaw95m": "rgba(255, 255, 255, 0.25)",
        "framer-3h8x2s": "rgba(255, 255, 255, 0.25)",
        "framer-m70ahb": "rgba(255, 255, 255, 0.04)",
        "framer-1idhpfp": "rgba(255, 255, 255, 0.04)",
        "framer-1ypbpdo": "rgba(255, 255, 255, 0.25)",
        "framer-128zqc6": "rgba(255, 255, 255, 0.25)",
        "framer-1ytw3om": "rgba(255, 255, 255, 0.04)",
        "framer-13ytebk": "rgba(255, 255, 255, 0.04)",
        "framer-1ww14do": "rgba(255, 255, 255, 0.25)",
        "framer-a8pcov": "rgba(255, 255, 255, 0.25)",
        "framer-ab8tx3": "rgba(255, 255, 255, 0.04)",
        "framer-5uqmqq": "rgba(255, 255, 255, 0.04)",
        "framer-1ofu2ul": "rgba(255, 255, 255, 0.25)",
        "framer-9gbi0z": "rgba(255, 255, 255, 0.25)",
        "framer-f39cdm": "rgba(255, 255, 255, 0.04)",
        "framer-74v5au": "rgba(255, 255, 255, 0.04)",
        "framer-4jd8se": "rgba(255, 255, 255, 0.25)",
        "framer-1v11feq": "rgba(255, 255, 255, 0.25)",
        "framer-b7yay1": "rgba(255, 255, 255, 0.04)",
        "framer-ib20gg": "rgba(255, 255, 255, 0.04)",
        "framer-nmz8wd": "rgba(255, 255, 255, 0.25)"
      },
      "vClass": null,
      "variantName": "Risk Scan C",
      "source": "framer_complete_tree (16+18).html"
    },
    {
      "colors": {
        "framer-1jj0ifc": "rgba(255, 255, 255, 0.25)",
        "framer-dpwm0b": "rgba(255, 255, 255, 0.25)",
        "framer-11sh3kl": "rgba(255, 255, 255, 0.25)",
        "framer-atydiq": "rgba(255, 255, 255, 0.25)",
        "framer-ndx6n2": "rgba(255, 255, 255, 0.25)",
        "framer-wmpa9h": "rgba(255, 255, 255, 0.25)",
        "framer-yu6s5s": "rgba(255, 255, 255, 0.25)",
        "framer-16j6ocd": "rgba(255, 255, 255, 0.25)",
        "framer-1swijur": "rgba(255, 255, 255, 0.04)",
        "framer-dcpd2y": "rgba(255, 255, 255, 0.25)",
        "framer-19lpopk": "rgba(255, 255, 255, 0.25)",
        "framer-1gy3pmp": "rgba(255, 255, 255, 0.04)",
        "framer-1v1x89z": "rgba(255, 255, 255, 0.04)",
        "framer-1bl2k9n": "rgba(255, 255, 255, 0.25)",
        "framer-1l22rll": "rgba(255, 255, 255, 0.25)",
        "framer-p404w8": "rgba(255, 255, 255, 0.04)",
        "framer-12u4h2y": "rgba(255, 255, 255, 0.04)",
        "framer-mcx67j": "rgba(255, 255, 255, 0.25)",
        "framer-9bt0ow": "rgba(255, 255, 255, 0.25)",
        "framer-1hxcvmh": "rgba(255, 255, 255, 0.04)",
        "framer-zsvztq": "rgba(255, 255, 255, 0.04)",
        "framer-bfd5pd": "rgba(255, 255, 255, 0.25)",
        "framer-1fkr5hp": "rgba(255, 255, 255, 0.25)",
        "framer-16tdrzi": "rgba(255, 255, 255, 0.04)",
        "framer-1upn6hk": "rgba(255, 255, 255, 0.04)",
        "framer-12s24r2": "rgba(255, 255, 255, 0.25)",
        "framer-mju97v": "rgba(255, 255, 255, 0.25)",
        "framer-hk0b4p": "rgba(255, 255, 255, 0.04)",
        "framer-1nob4pv": "rgba(255, 255, 255, 0.04)",
        "framer-8pyn9g": "rgba(255, 255, 255, 0.25)",
        "framer-1fjaf3s": "rgba(255, 255, 255, 0.25)",
        "framer-d98h5j": "rgba(255, 255, 255, 0.04)",
        "framer-1j5bhac": "rgba(255, 255, 255, 0.04)",
        "framer-13jkm5b": "rgba(255, 255, 255, 0.25)",
        "framer-17qv8u8": "rgba(255, 255, 255, 0.25)",
        "framer-69q9y1": "rgba(255, 255, 255, 0.04)",
        "framer-17ayp1e": "rgba(255, 255, 255, 0.04)",
        "framer-1cqt4kz": "rgba(255, 255, 255, 0.25)",
        "framer-1lo8o3t": "rgba(255, 255, 255, 0.25)",
        "framer-zdc5sg": "rgba(255, 255, 255, 0.04)",
        "framer-1of3gxf": "rgba(255, 255, 255, 0.04)",
        "framer-1cp4vei": "rgba(255, 255, 255, 0.25)",
        "framer-kkby6z": "rgba(255, 255, 255, 0.25)",
        "framer-v7u6as": "rgba(255, 255, 255, 0.04)",
        "framer-mvorvo": "rgba(255, 255, 255, 0.04)",
        "framer-kq0fap": "rgba(255, 255, 255, 0.25)",
        "framer-itnu1k": "rgba(255, 255, 255, 0.25)",
        "framer-dvz24s": "rgba(255, 255, 255, 0.04)",
        "framer-p0q4zf": "rgba(255, 255, 255, 0.04)",
        "framer-1k5jk6l": "rgba(255, 255, 255, 0.25)",
        "framer-1x657tl": "rgba(255, 255, 255, 0.25)",
        "framer-1g37od": "rgba(255, 255, 255, 0.04)",
        "framer-10yw6sv": "rgba(255, 255, 255, 0.04)",
        "framer-bxygyb": "rgba(255, 255, 255, 0.25)",
        "framer-1wx1bo8": "rgba(255, 255, 255, 0.25)",
        "framer-rlvslr": "rgba(255, 255, 255, 0.04)",
        "framer-xbc3d2": "rgba(255, 255, 255, 0.04)",
        "framer-1wot0vl": "rgba(255, 255, 255, 0.25)",
        "framer-gfqp5f": "rgba(255, 255, 255, 0.25)",
        "framer-vsen48": "rgba(255, 255, 255, 0.04)",
        "framer-1q0gr72": "rgba(255, 255, 255, 0.04)",
        "framer-1dh0ekj": "rgba(255, 255, 255, 0.25)",
        "framer-t0d6f4": "rgba(255, 255, 255, 0.25)",
        "framer-1u2kj51": "rgba(255, 255, 255, 0.04)",
        "framer-wqsupw": "rgba(255, 255, 255, 0.04)",
        "framer-1nh8wlf": "rgba(255, 255, 255, 0.25)",
        "framer-5ja1up": "rgba(255, 255, 255, 0.25)",
        "framer-1ahk1dw": "rgba(255, 255, 255, 0.04)",
        "framer-tmre0j": "rgba(255, 255, 255, 0.04)",
        "framer-1fecrzm": "rgba(255, 255, 255, 0.25)",
        "framer-14v7fn6": "rgba(255, 255, 255, 0.25)",
        "framer-1kt7zzt": "rgba(255, 255, 255, 0.04)",
        "framer-77yo50": "rgba(255, 255, 255, 0.04)",
        "framer-m6t74m": "rgba(255, 255, 255, 0.25)",
        "framer-fny01e": "rgba(255, 255, 255, 0.25)",
        "framer-bsrptp": "rgba(255, 255, 255, 0.04)",
        "framer-1sctmbp": "rgba(255, 255, 255, 0.04)",
        "framer-1xtzavl": "rgba(255, 255, 255, 0.25)",
        "framer-1j6nou9": "rgba(255, 255, 255, 0.25)",
        "framer-18wavnh": "rgba(255, 255, 255, 0.04)",
        "framer-13ft1pc": "rgba(255, 255, 255, 0.04)",
        "framer-lwi2nv": "rgba(255, 255, 255, 0.25)",
        "framer-1p0ta5s": "rgba(255, 255, 255, 0.25)",
        "framer-okk9na": "rgba(255, 255, 255, 0.04)",
        "framer-1wscuse": "rgba(255, 255, 255, 0.04)",
        "framer-ckjief": "rgba(255, 255, 255, 0.25)",
        "framer-1wd74n9": "rgba(255, 255, 255, 0.25)",
        "framer-je1js9": "rgba(255, 255, 255, 0.04)",
        "framer-11vb55v": "rgba(255, 255, 255, 0.04)",
        "framer-zxu9g1": "rgba(255, 255, 255, 0.25)",
        "framer-175a80z": "rgba(255, 255, 255, 0.25)",
        "framer-qhv2jx": "rgba(255, 255, 255, 0.04)",
        "framer-1fuomwv": "rgba(255, 255, 255, 0.04)",
        "framer-1pvftwy": "rgba(255, 255, 255, 0.25)",
        "framer-7bxvqv": "rgba(255, 255, 255, 0.25)",
        "framer-1ebwbwm": "rgba(255, 255, 255, 0.04)",
        "framer-1t4div0": "rgba(255, 255, 255, 0.04)",
        "framer-18l77et": "rgba(255, 255, 255, 0.25)",
        "framer-i5cm9v": "rgba(255, 255, 255, 0.25)",
        "framer-va4ics": "rgba(255, 255, 255, 0.04)",
        "framer-emgwcw": "rgba(255, 255, 255, 0.04)",
        "framer-1s4aw3h": "rgba(255, 255, 255, 0.25)",
        "framer-1kr91hz": "rgba(255, 255, 255, 0.25)",
        "framer-1fiw6w0": "rgba(255, 255, 255, 0.04)",
        "framer-1pil1hc": "rgba(255, 255, 255, 0.04)",
        "framer-1bef5is": "rgba(255, 255, 255, 0.25)",
        "framer-1s4soym": "rgba(255, 255, 255, 0.25)",
        "framer-e5pbl1": "rgba(255, 255, 255, 0.04)",
        "framer-tq6zkq": "rgba(255, 255, 255, 0.04)",
        "framer-1we93t": "rgba(255, 255, 255, 0.25)",
        "framer-nehzx1": "rgba(255, 255, 255, 0.25)",
        "framer-1we71xp": "rgba(255, 255, 255, 0.04)",
        "framer-1yltltg": "rgba(255, 255, 255, 0.04)",
        "framer-b62ir1": "rgba(255, 255, 255, 0.25)",
        "framer-qx7dca": "rgba(255, 255, 255, 0.25)",
        "framer-97zyep": "rgba(255, 255, 255, 0.04)",
        "framer-1hx6plk": "rgba(255, 255, 255, 0.04)",
        "framer-187r6wo": "rgba(255, 255, 255, 0.25)",
        "framer-1suu08m": "rgba(255, 255, 255, 0.25)",
        "framer-1k1f9td": "rgba(255, 255, 255, 0.04)",
        "framer-10z6mja": "rgba(255, 255, 255, 0.04)",
        "framer-1c6vijq": "rgba(255, 255, 255, 0.25)",
        "framer-1dp7hdl": "rgba(255, 255, 255, 0.25)",
        "framer-1cuttk9": "rgba(255, 255, 255, 0.04)",
        "framer-1x2xnil": "rgba(255, 255, 255, 0.04)",
        "framer-1cwvdqi": "rgba(255, 255, 255, 0.25)",
        "framer-lhhssf": "rgba(255, 255, 255, 0.25)",
        "framer-aeocs": "rgba(255, 255, 255, 0.04)",
        "framer-3zdcj2": "rgba(255, 255, 255, 0.04)",
        "framer-vpipdz": "rgba(255, 255, 255, 0.25)",
        "framer-dev0uk": "rgba(255, 255, 255, 0.25)",
        "framer-op9xil": "rgba(255, 255, 255, 0.04)",
        "framer-tik92e": "rgba(255, 255, 255, 0.04)",
        "framer-iqjc80": "rgba(255, 255, 255, 0.25)",
        "framer-tl1004": "rgba(255, 255, 255, 0.25)",
        "framer-qaw95m": "rgba(255, 255, 255, 0.04)",
        "framer-3h8x2s": "rgba(255, 255, 255, 0.04)",
        "framer-m70ahb": "rgba(255, 255, 255, 0.25)",
        "framer-1idhpfp": "rgba(255, 255, 255, 0.25)",
        "framer-1ypbpdo": "rgba(255, 255, 255, 0.04)",
        "framer-128zqc6": "rgba(255, 255, 255, 0.04)",
        "framer-1ytw3om": "rgba(255, 255, 255, 0.25)",
        "framer-13ytebk": "rgba(255, 255, 255, 0.25)",
        "framer-1ww14do": "rgba(255, 255, 255, 0.04)",
        "framer-a8pcov": "rgba(255, 255, 255, 0.04)",
        "framer-ab8tx3": "rgba(255, 255, 255, 0.25)",
        "framer-5uqmqq": "rgba(255, 255, 255, 0.25)",
        "framer-1ofu2ul": "rgba(255, 255, 255, 0.04)",
        "framer-9gbi0z": "rgba(255, 255, 255, 0.04)",
        "framer-f39cdm": "rgba(255, 255, 255, 0.25)",
        "framer-74v5au": "rgba(255, 255, 255, 0.25)",
        "framer-4jd8se": "rgba(255, 255, 255, 0.04)",
        "framer-1v11feq": "rgba(255, 255, 255, 0.04)",
        "framer-b7yay1": "rgba(255, 255, 255, 0.25)",
        "framer-ib20gg": "rgba(255, 255, 255, 0.25)",
        "framer-nmz8wd": "rgba(255, 255, 255, 0.04)"
      },
      "vClass": null,
      "variantName": "Risk Scan D",
      "source": "framer_complete_tree (16+18).html"
    }
  ],
  "prover": [
    {
      "colors": {
        "framer-fiyyst": "rgba(255, 255, 255, 0.05)",
        "framer-ciyq8x": "rgba(255, 255, 255, 0.2)",
        "framer-1q66old": "rgba(255, 255, 255, 0.2)",
        "framer-1qi4x9e": "rgba(255, 255, 255, 0.2)",
        "framer-1gptz2q": "rgba(255, 255, 255, 0.2)",
        "framer-1455pd0": "rgba(255, 255, 255, 0.2)",
        "framer-1fit9b7": "rgba(255, 255, 255, 0.2)",
        "framer-hi43jy": "rgba(255, 255, 255, 0.2)",
        "framer-1wd6cu5": "rgba(255, 255, 255, 0.2)",
        "framer-1ylwb2d": "rgba(255, 255, 255, 0.2)",
        "framer-1y9yxe2": "rgba(255, 255, 255, 0.2)",
        "framer-qvneen": "rgba(255, 255, 255, 0.2)",
        "framer-wjo0e9": "rgba(255, 255, 255, 0.2)",
        "framer-czpr7r": "rgba(255, 255, 255, 0.2)",
        "framer-vj2fgs": "rgba(255, 255, 255, 0.2)",
        "framer-hoxygt": "rgba(255, 255, 255, 0.2)",
        "framer-48kwqi": "rgba(255, 255, 255, 0.2)",
        "framer-u5krqo": "rgba(255, 255, 255, 0.2)",
        "framer-w896tp": "rgba(255, 255, 255, 0.2)",
        "framer-1wk1y40": "rgba(255, 255, 255, 0.2)",
        "framer-33r2dq": "rgba(255, 255, 255, 0.2)",
        "framer-1gbanx3": "rgba(255, 255, 255, 0.2)",
        "framer-1ux33dn": "rgba(255, 255, 255, 0.2)",
        "framer-3lw8u8": "rgba(255, 255, 255, 0.2)",
        "framer-1czikuk": "rgba(255, 255, 255, 0.2)",
        "framer-q6eebf": "rgba(255, 255, 255, 0.2)",
        "framer-1gdzggg": "rgba(255, 255, 255, 0.2)",
        "framer-tsui6n": "rgba(255, 255, 255, 0.2)",
        "framer-vgwsmu": "rgba(255, 255, 255, 0.2)",
        "framer-1tmsih3": "rgba(255, 255, 255, 0.2)",
        "framer-btodsk": "rgba(255, 255, 255, 0.2)",
        "framer-1c27p2n": "rgba(255, 255, 255, 0.2)",
        "framer-hj95w1": "rgba(255, 255, 255, 0.2)",
        "framer-1dyz5ca": "rgba(255, 255, 255, 0.2)",
        "framer-et0m12": "rgba(255, 255, 255, 0.2)",
        "framer-vnh2vx": "rgba(255, 255, 255, 0.2)",
        "framer-1l61glq": "rgba(255, 255, 255, 0.2)",
        "framer-qzjyt5": "rgba(255, 255, 255, 0.2)",
        "framer-1j65h5c": "rgba(255, 255, 255, 0.2)",
        "framer-ujqrvs": "rgba(255, 255, 255, 0.2)",
        "framer-ooft64": "rgba(255, 255, 255, 0.2)",
        "framer-1wfl7nv": "rgba(255, 255, 255, 0.2)",
        "framer-17irg2n": "rgba(255, 255, 255, 0.2)",
        "framer-l109y1": "rgba(255, 255, 255, 0.2)",
        "framer-14fhv1t": "rgba(255, 255, 255, 0.2)",
        "framer-763vv": "rgba(255, 255, 255, 0.2)",
        "framer-ekdddg": "rgba(255, 255, 255, 0.2)",
        "framer-lczi8i": "rgba(255, 255, 255, 0.2)",
        "framer-1k3zzg8": "rgba(255, 255, 255, 0.2)",
        "framer-1nze31j": "rgba(255, 255, 255, 0.2)",
        "framer-1izz6de": "rgba(255, 255, 255, 0.2)",
        "framer-cva9wu": "rgba(255, 255, 255, 0.2)",
        "framer-myr3v0": "rgba(255, 255, 255, 0.2)",
        "framer-3fv7cz": "rgba(255, 255, 255, 0.2)",
        "framer-1cb7j9a": "rgba(255, 255, 255, 0.2)",
        "framer-bvmogv": "rgba(255, 255, 255, 0.2)",
        "framer-1nvc6l8": "rgba(255, 255, 255, 0.2)",
        "framer-1k694lj": "rgba(255, 255, 255, 0.2)",
        "framer-1br5jo5": "rgba(255, 255, 255, 0.2)",
        "framer-91edth": "rgba(255, 255, 255, 0.2)",
        "framer-19nd5re": "rgba(255, 255, 255, 0.2)",
        "framer-11zy7gz": "rgba(255, 255, 255, 0.2)",
        "framer-183jbxw": "rgba(255, 255, 255, 0.2)",
        "framer-1k2kjzb": "rgba(255, 255, 255, 0.2)",
        "framer-e0p84p": "rgba(255, 255, 255, 0.2)",
        "framer-170af3e": "rgba(255, 255, 255, 0.2)",
        "framer-ghrn1n": "rgba(255, 255, 255, 0.2)",
        "framer-1djai4u": "rgba(255, 255, 255, 0.2)",
        "framer-1ibabel": "rgba(255, 255, 255, 0.2)",
        "framer-8y8sq7": "rgba(255, 255, 255, 0.2)",
        "framer-19kqjve": "rgba(255, 255, 255, 0.2)",
        "framer-1rf3dh1": "rgba(255, 255, 255, 0.2)",
        "framer-18lqt85": "rgba(255, 255, 255, 0.2)",
        "framer-1vt83fg": "rgba(255, 255, 255, 0.2)",
        "framer-1290qui": "rgba(255, 255, 255, 0.2)",
        "framer-10qen5q": "rgba(255, 255, 255, 0.2)",
        "framer-1x7y08s": "rgba(255, 255, 255, 0.2)",
        "framer-li1bn0": "rgba(255, 255, 255, 0.2)",
        "framer-1afif8m": "rgba(255, 255, 255, 0.2)",
        "framer-1xffmu1": "rgba(255, 255, 255, 0.2)",
        "framer-vxzka9": "rgba(255, 255, 255, 0.2)",
        "framer-1oenpnn": "rgba(255, 255, 255, 0.2)",
        "framer-xqqqan": "rgba(255, 255, 255, 0.2)",
        "framer-1xs3c5s": "rgba(255, 255, 255, 0.2)",
        "framer-g5b2fd": "rgba(255, 255, 255, 0.2)",
        "framer-15pc2n8": "rgba(255, 255, 255, 0.2)",
        "framer-dlkqju": "rgba(255, 255, 255, 0.2)",
        "framer-1662edz": "rgba(255, 255, 255, 0.2)",
        "framer-1o6ae4m": "rgba(255, 255, 255, 0.2)",
        "framer-7ut610": "rgba(255, 255, 255, 0.2)",
        "framer-4nsxaf": "rgba(255, 255, 255, 0.2)",
        "framer-kyye8q": "rgba(255, 255, 255, 0.2)",
        "framer-nge7c7": "rgba(255, 255, 255, 0.2)",
        "framer-153oid8": "rgba(255, 255, 255, 0.2)",
        "framer-1i5403r": "rgba(255, 255, 255, 0.2)",
        "framer-zdwg34": "rgba(255, 255, 255, 0.2)",
        "framer-1wosb63": "rgba(255, 255, 255, 0.2)",
        "framer-nf35ps": "rgba(255, 255, 255, 0.2)",
        "framer-qa34xq": "rgba(255, 255, 255, 0.2)",
        "framer-filgd4": "rgba(255, 255, 255, 0.2)",
        "framer-u4d6x3": "rgba(255, 255, 255, 0.2)",
        "framer-ev4n9h": "rgba(255, 255, 255, 0.2)",
        "framer-1jndxip": "rgba(255, 255, 255, 0.2)",
        "framer-ukalac": "rgba(255, 255, 255, 0.2)",
        "framer-7ra5u7": "rgba(255, 255, 255, 0.2)",
        "framer-1q0z42g": "rgba(255, 255, 255, 0.2)",
        "framer-o0cltq": "rgba(255, 255, 255, 0.2)",
        "framer-1ymomzd": "rgba(255, 255, 255, 0.2)",
        "framer-15ogixz": "rgba(255, 255, 255, 0.2)",
        "framer-4uq06b": "rgba(255, 255, 255, 0.2)",
        "framer-5pj1ss": "rgba(255, 255, 255, 0.2)",
        "framer-cjm6cm": "rgba(255, 255, 255, 0.2)",
        "framer-1nwn46": "rgba(255, 255, 255, 0.2)",
        "framer-l4xkwr": "rgba(255, 255, 255, 0.05)",
        "framer-tvhj2b": "rgba(255, 255, 255, 0.2)",
        "framer-86mmqq": "rgba(255, 255, 255, 0.2)",
        "framer-nc7bns": "rgba(255, 255, 255, 0.2)",
        "framer-1cg48np": "rgba(255, 255, 255, 0.2)",
        "framer-wnc4on": "rgba(255, 255, 255, 0.2)",
        "framer-14nw6a7": "rgba(255, 255, 255, 0.2)",
        "framer-xpktl5": "rgba(255, 255, 255, 0.2)",
        "framer-1mqce9a": "rgba(255, 255, 255, 0.2)",
        "framer-6xbkam": "rgba(255, 255, 255, 0.2)",
        "framer-131v8op": "rgba(255, 255, 255, 0.2)",
        "framer-1ddxcby": "rgba(255, 255, 255, 0.2)",
        "framer-1o9uvr4": "rgba(255, 255, 255, 0.2)",
        "framer-gt4ley": "rgba(255, 255, 255, 0.2)",
        "framer-11v9qa8": "rgba(255, 255, 255, 0.2)",
        "framer-h942sb": "rgba(255, 255, 255, 0.2)",
        "framer-2bbq4h": "rgba(255, 255, 255, 0.2)",
        "framer-1b5igrv": "rgba(255, 255, 255, 0.2)",
        "framer-170rkry": "rgba(255, 255, 255, 0.2)",
        "framer-kgstxs": "rgba(255, 255, 255, 0.2)",
        "framer-b7gua7": "rgba(255, 255, 255, 0.2)",
        "framer-1sldj1o": "rgba(255, 255, 255, 0.2)",
        "framer-1svd255": "rgba(255, 255, 255, 0.2)",
        "framer-138y9pl": "rgba(255, 255, 255, 0.2)",
        "framer-1dta0vu": "rgba(255, 255, 255, 0.2)",
        "framer-3z64oo": "rgba(255, 255, 255, 0.2)",
        "framer-1d2d49i": "rgba(255, 255, 255, 0.2)",
        "framer-oyhd3t": "rgba(255, 255, 255, 0.2)",
        "framer-20f2sf": "rgba(255, 255, 255, 0.2)",
        "framer-fd2gbu": "rgba(255, 255, 255, 0.2)",
        "framer-173iqm4": "rgba(255, 255, 255, 0.2)",
        "framer-1nw2i5u": "rgba(255, 255, 255, 0.2)",
        "framer-1gf8f74": "rgba(255, 255, 255, 0.2)",
        "framer-126if7k": "rgba(255, 255, 255, 0.2)",
        "framer-101393o": "rgba(255, 255, 255, 0.2)",
        "framer-1cttzfy": "rgba(255, 255, 255, 0.2)",
        "framer-1bchv1w": "rgba(255, 255, 255, 0.2)",
        "framer-1xspwzf": "rgba(255, 255, 255, 0.2)",
        "framer-hshnmx": "rgba(255, 255, 255, 0.2)",
        "framer-1atgup7": "rgba(255, 255, 255, 0.2)",
        "framer-rm0zjp": "rgba(255, 255, 255, 0.2)",
        "framer-1kk3rk0": "rgba(255, 255, 255, 0.2)",
        "framer-of0mcj": "rgba(255, 255, 255, 0.2)",
        "framer-ysh229": "rgba(255, 255, 255, 0.2)",
        "framer-13o3p9b": "rgba(255, 255, 255, 0.2)",
        "framer-cgvumc": "rgba(255, 255, 255, 0.2)",
        "framer-1vct5ds": "rgba(255, 255, 255, 0.2)",
        "framer-19h6kmj": "rgba(255, 255, 255, 0.2)",
        "framer-1cjvhsx": "rgba(255, 255, 255, 0.2)",
        "framer-12p3vzx": "rgba(255, 255, 255, 0.2)",
        "framer-1oksxci": "rgba(255, 255, 255, 0.2)",
        "framer-14pwok1": "rgba(255, 255, 255, 0.2)",
        "framer-1lswi2p": "rgba(255, 255, 255, 0.2)",
        "framer-19zr038": "rgba(255, 255, 255, 0.2)",
        "framer-mexy1c": "rgba(255, 255, 255, 0.2)",
        "framer-119p38r": "rgba(255, 255, 255, 0.2)",
        "framer-aokgsq": "rgba(255, 255, 255, 0.2)",
        "framer-1vgglw": "rgba(255, 255, 255, 0.2)",
        "framer-9wyu5": "rgba(255, 255, 255, 0.2)",
        "framer-1u89jrq": "rgba(255, 255, 255, 0.2)",
        "framer-ilwm1r": "rgba(255, 255, 255, 0.2)",
        "framer-6c7q3i": "rgba(255, 255, 255, 0.2)",
        "framer-1dhqmpa": "rgba(255, 255, 255, 0.2)",
        "framer-m6uoyn": "rgba(255, 255, 255, 0.2)",
        "framer-1abbc44": "rgba(255, 255, 255, 0.2)",
        "framer-1asdrnx": "rgba(255, 255, 255, 0.2)",
        "framer-1a81c3z": "rgba(255, 255, 255, 0.2)",
        "framer-1yjoi2": "rgba(255, 255, 255, 0.2)",
        "framer-34s8p0": "rgba(255, 255, 255, 0.2)",
        "framer-9wmkwc": "rgba(255, 255, 255, 0.2)",
        "framer-1rzdfox": "rgba(255, 255, 255, 0.2)",
        "framer-1v2j9m": "rgba(255, 255, 255, 0.2)",
        "framer-tvwehy": "rgba(255, 255, 255, 0.2)",
        "framer-19gskhe": "rgba(255, 255, 255, 0.2)",
        "framer-1r7znae": "rgba(255, 255, 255, 0.2)",
        "framer-1x9ttau": "rgba(255, 255, 255, 0.2)",
        "framer-19qi3rg": "rgba(255, 255, 255, 0.2)",
        "framer-1xazehi": "rgba(255, 255, 255, 0.2)",
        "framer-1vj77jj": "rgba(255, 255, 255, 0.2)",
        "framer-t89g24": "rgba(255, 255, 255, 0.2)",
        "framer-1ouxnre": "rgba(255, 255, 255, 0.2)",
        "framer-9izbi9": "rgba(255, 255, 255, 0.2)",
        "framer-hmhbu9": "rgba(255, 255, 255, 0.2)",
        "framer-ldccnz": "rgba(255, 255, 255, 0.2)",
        "framer-12qua62": "rgba(255, 255, 255, 0.2)",
        "framer-tn4f9n": "rgba(255, 255, 255, 0.2)",
        "framer-2bdteh": "rgba(255, 255, 255, 0.2)",
        "framer-26x32d": "rgba(255, 255, 255, 0.2)",
        "framer-z23vsj": "rgba(255, 255, 255, 0.2)",
        "framer-161xr59": "rgba(255, 255, 255, 0.2)",
        "framer-tuje6p": "rgba(255, 255, 255, 0.2)",
        "framer-144agw": "rgba(255, 255, 255, 0.2)",
        "framer-1hbb6d9": "rgba(255, 255, 255, 0.2)",
        "framer-1me8sh4": "rgba(255, 255, 255, 0.2)",
        "framer-1umq5aj": "rgba(255, 255, 255, 0.2)",
        "framer-1lhyzal": "rgba(255, 255, 255, 0.2)",
        "framer-1f3n39": "rgba(255, 255, 255, 0.2)",
        "framer-ilf9u3": "rgba(255, 255, 255, 0.2)",
        "framer-1qw0dpv": "rgba(255, 255, 255, 0.2)",
        "framer-1rs1xsd": "rgba(255, 255, 255, 0.2)",
        "framer-1t6lx8u": "rgba(255, 255, 255, 0.2)",
        "framer-7xapi8": "rgba(255, 255, 255, 0.2)",
        "framer-1yp8hos": "rgba(255, 255, 255, 0.2)",
        "framer-i2cq27": "rgba(255, 255, 255, 0.2)",
        "framer-h7ww8p": "rgba(255, 255, 255, 0.2)",
        "framer-1a5x4f6": "rgba(255, 255, 255, 0.2)",
        "framer-1qwmbzn": "rgba(255, 255, 255, 0.2)",
        "framer-1dmcjdq": "rgba(255, 255, 255, 0.2)",
        "framer-1n7pw7r": "rgba(255, 255, 255, 0.2)",
        "framer-1w51idz": "rgba(255, 255, 255, 0.2)",
        "framer-mxy4ao": "rgba(255, 255, 255, 0.2)",
        "framer-81issc": "rgba(255, 255, 255, 0.2)",
        "framer-1w1gkay": "rgba(255, 255, 255, 0.2)",
        "framer-4cpnfq": "rgba(255, 255, 255, 0.05)",
        "framer-1ewcuw0": "rgba(255, 255, 255, 0.2)",
        "framer-pwwysn": "rgba(255, 255, 255, 0.2)",
        "framer-1xtn7vm": "rgba(255, 255, 255, 0.2)",
        "framer-7dxsze": "rgba(255, 255, 255, 0.2)",
        "framer-9ev4bv": "rgba(255, 255, 255, 0.2)",
        "framer-1p7e9u2": "rgba(255, 255, 255, 0.2)",
        "framer-1a59dez": "rgba(255, 255, 255, 0.2)",
        "framer-7fgdhi": "rgba(255, 255, 255, 0.2)",
        "framer-k8j7my": "rgba(255, 255, 255, 0.2)",
        "framer-1ammoj2": "rgba(255, 255, 255, 0.2)",
        "framer-oivdw5": "rgba(255, 255, 255, 0.2)",
        "framer-14f6ekb": "rgba(255, 255, 255, 0.2)",
        "framer-khhuyo": "rgba(255, 255, 255, 0.2)",
        "framer-i2x3iv": "rgba(255, 255, 255, 0.2)",
        "framer-67j55g": "rgba(255, 255, 255, 0.2)",
        "framer-88mozs": "rgba(255, 255, 255, 0.2)",
        "framer-1dmnjar": "rgba(255, 255, 255, 0.2)",
        "framer-ncelpy": "rgba(255, 255, 255, 0.2)",
        "framer-123er8b": "rgba(255, 255, 255, 0.2)",
        "framer-6y7kl8": "rgba(255, 255, 255, 0.2)",
        "framer-1aa5m0p": "rgba(255, 255, 255, 0.2)",
        "framer-16krrxi": "rgba(255, 255, 255, 0.2)",
        "framer-1fn8zqk": "rgba(255, 255, 255, 0.2)",
        "framer-513uhu": "rgba(255, 255, 255, 0.2)",
        "framer-fa2shx": "rgba(255, 255, 255, 0.2)",
        "framer-1xoruxr": "rgba(255, 255, 255, 0.2)",
        "framer-1bihptf": "rgba(255, 255, 255, 0.2)",
        "framer-zrojpi": "rgba(255, 255, 255, 0.2)",
        "framer-cs61ef": "rgba(255, 255, 255, 0.2)",
        "framer-1q93xu9": "rgba(255, 255, 255, 0.2)",
        "framer-ib3bh1": "rgba(255, 255, 255, 0.2)",
        "framer-pbzt1h": "rgba(255, 255, 255, 0.2)",
        "framer-1h1ziie": "rgba(255, 255, 255, 0.2)",
        "framer-114tpb9": "rgba(255, 255, 255, 0.2)",
        "framer-1119xwz": "rgba(255, 255, 255, 0.2)",
        "framer-3c8f8y": "rgba(255, 255, 255, 0.2)",
        "framer-3luccy": "rgba(255, 255, 255, 0.2)",
        "framer-1mht7x2": "rgba(255, 255, 255, 0.2)",
        "framer-mnwipj": "rgba(255, 255, 255, 0.2)",
        "framer-lwj4e": "rgba(255, 255, 255, 0.2)",
        "framer-1ko98em": "rgba(255, 255, 255, 0.2)",
        "framer-17hq2ey": "rgba(255, 255, 255, 0.2)",
        "framer-dlyppx": "rgba(255, 255, 255, 0.2)",
        "framer-3vyltb": "rgba(255, 255, 255, 0.2)",
        "framer-xi0b9s": "rgba(255, 255, 255, 0.2)",
        "framer-bdvmsa": "rgba(255, 255, 255, 0.2)",
        "framer-1u3l0fl": "rgba(255, 255, 255, 0.2)",
        "framer-1yzqxh2": "rgba(255, 255, 255, 0.2)",
        "framer-1vnn6r": "rgba(255, 255, 255, 0.2)",
        "framer-sve3o0": "rgba(255, 255, 255, 0.2)",
        "framer-1p84nt4": "rgba(255, 255, 255, 0.2)",
        "framer-1pxzgce": "rgba(255, 255, 255, 0.2)",
        "framer-1b278qv": "rgba(255, 255, 255, 0.2)",
        "framer-2gnydd": "rgba(255, 255, 255, 0.2)",
        "framer-1137811": "rgba(255, 255, 255, 0.2)",
        "framer-19jj6c3": "rgba(255, 255, 255, 0.2)",
        "framer-1pzn1av": "rgba(255, 255, 255, 0.2)",
        "framer-tvid17": "rgba(255, 255, 255, 0.2)",
        "framer-11c54mx": "rgba(255, 255, 255, 0.2)",
        "framer-nevvim": "rgba(255, 255, 255, 0.2)",
        "framer-9v6bcb": "rgba(255, 255, 255, 0.2)",
        "framer-1vnrxsp": "rgba(255, 255, 255, 0.2)",
        "framer-wjbowq": "rgba(255, 255, 255, 0.2)",
        "framer-12400e0": "rgba(255, 255, 255, 0.2)",
        "framer-1cqo2n8": "rgba(255, 255, 255, 0.2)",
        "framer-qcjss1": "rgba(255, 255, 255, 0.2)",
        "framer-1ni2oxv": "rgba(255, 255, 255, 0.2)",
        "framer-5ztfcs": "rgba(255, 255, 255, 0.2)",
        "framer-154hrzw": "rgba(255, 255, 255, 0.2)",
        "framer-180ez6m": "rgba(255, 255, 255, 0.2)",
        "framer-h09ge5": "rgba(255, 255, 255, 0.2)",
        "framer-1se7318": "rgba(255, 255, 255, 0.2)",
        "framer-xxfm0q": "rgba(255, 255, 255, 0.2)",
        "framer-14apmt9": "rgba(255, 255, 255, 0.2)",
        "framer-3n8q0u": "rgba(255, 255, 255, 0.2)",
        "framer-j9tfzk": "rgba(255, 255, 255, 0.2)",
        "framer-1xd3thf": "rgba(255, 255, 255, 0.2)",
        "framer-1lfwj1u": "rgba(255, 255, 255, 0.2)",
        "framer-6d08mg": "rgba(255, 255, 255, 0.2)",
        "framer-re0cfu": "rgba(255, 255, 255, 0.2)",
        "framer-1iivgo9": "rgba(255, 255, 255, 0.2)",
        "framer-o3z3op": "rgba(255, 255, 255, 0.2)",
        "framer-182hs8p": "rgba(255, 255, 255, 0.2)",
        "framer-1wdiof9": "rgba(255, 255, 255, 0.2)",
        "framer-wwe331": "rgba(255, 255, 255, 0.2)",
        "framer-k8hw6u": "rgba(255, 255, 255, 0.2)",
        "framer-1j2vt7b": "rgba(255, 255, 255, 0.2)",
        "framer-4iiqzy": "rgba(255, 255, 255, 0.2)",
        "framer-1wwf1us": "rgba(255, 255, 255, 0.2)",
        "framer-7neodo": "rgba(255, 255, 255, 0.2)",
        "framer-724voj": "rgba(255, 255, 255, 0.2)",
        "framer-fn7au": "rgba(255, 255, 255, 0.2)",
        "framer-vi0aff": "rgba(255, 255, 255, 0.2)",
        "framer-8ssv48": "rgba(255, 255, 255, 0.2)",
        "framer-172e0pi": "rgba(255, 255, 255, 0.2)",
        "framer-14t05wr": "rgba(255, 255, 255, 0.2)",
        "framer-15pkux9": "rgba(255, 255, 255, 0.2)",
        "framer-jtyaes": "rgba(255, 255, 255, 0.2)",
        "framer-nt3phc": "rgba(255, 255, 255, 0.2)",
        "framer-ayg0jb": "rgba(255, 255, 255, 0.2)",
        "framer-1pztsn9": "rgba(255, 255, 255, 0.2)",
        "framer-lgrx4h": "rgba(255, 255, 255, 0.2)",
        "framer-inxrm5": "rgba(255, 255, 255, 0.2)",
        "framer-1b16f9k": "rgba(255, 255, 255, 0.2)",
        "framer-mh5rnp": "rgba(255, 255, 255, 0.2)",
        "framer-lutab8": "rgba(255, 255, 255, 0.2)",
        "framer-19j46hv": "rgba(255, 255, 255, 0.2)",
        "framer-1nsspm6": "rgba(255, 255, 255, 0.2)",
        "framer-elrkjf": "rgba(255, 255, 255, 0.2)",
        "framer-1aju3s8": "rgba(255, 255, 255, 0.2)",
        "framer-1tryoci": "rgba(255, 255, 255, 0.2)",
        "framer-s0ja87": "rgba(255, 255, 255, 0.2)",
        "framer-64lgy": "rgba(255, 255, 255, 0.05)",
        "framer-1hxr8zf": "rgba(255, 255, 255, 0.2)",
        "framer-4yinfa": "rgba(255, 255, 255, 0.2)",
        "framer-caipz8": "rgba(255, 255, 255, 0.2)",
        "framer-1pbmtd3": "rgba(255, 255, 255, 0.2)",
        "framer-hd47jj": "rgba(255, 255, 255, 0.2)",
        "framer-7waupn": "rgba(255, 255, 255, 0.2)",
        "framer-1w58xeq": "rgba(255, 255, 255, 0.2)",
        "framer-hjf8gm": "rgba(255, 255, 255, 0.2)",
        "framer-35xeoq": "rgba(255, 255, 255, 0.2)",
        "framer-31hql4": "rgba(255, 255, 255, 0.2)",
        "framer-1btvdyn": "rgba(255, 255, 255, 0.2)",
        "framer-17m8ffk": "rgba(255, 255, 255, 0.2)",
        "framer-1cp9zav": "rgba(255, 255, 255, 0.2)",
        "framer-sc8xd3": "rgba(255, 255, 255, 0.2)",
        "framer-1f7kpi4": "rgba(255, 255, 255, 0.2)",
        "framer-piuxkm": "rgba(255, 255, 255, 0.2)",
        "framer-b3utc5": "rgba(255, 255, 255, 0.2)",
        "framer-35276o": "rgba(255, 255, 255, 0.2)",
        "framer-9foe1e": "rgba(255, 255, 255, 0.2)",
        "framer-1p6p5n9": "rgba(255, 255, 255, 0.2)",
        "framer-fxzqdp": "rgba(255, 255, 255, 0.2)",
        "framer-1259uij": "rgba(255, 255, 255, 0.2)",
        "framer-2b7tb1": "rgba(255, 255, 255, 0.2)",
        "framer-1q067af": "rgba(255, 255, 255, 0.2)",
        "framer-1ia009e": "rgba(255, 255, 255, 0.2)",
        "framer-3lymfn": "rgba(255, 255, 255, 0.2)",
        "framer-dqfk43": "rgba(255, 255, 255, 0.2)",
        "framer-1ren7pe": "rgba(255, 255, 255, 0.2)",
        "framer-3fmmvk": "rgba(255, 255, 255, 0.2)",
        "framer-1xf11tn": "rgba(255, 255, 255, 0.2)",
        "framer-1tzghd": "rgba(255, 255, 255, 0.2)",
        "framer-1j37cf1": "rgba(255, 255, 255, 0.2)",
        "framer-1hzhw0m": "rgba(255, 255, 255, 0.2)",
        "framer-1o0bkla": "rgba(255, 255, 255, 0.2)",
        "framer-op6ecw": "rgba(255, 255, 255, 0.2)",
        "framer-1fcx5x1": "rgba(255, 255, 255, 0.2)",
        "framer-1rby5nx": "rgba(255, 255, 255, 0.2)",
        "framer-1kjsbwd": "rgba(255, 255, 255, 0.2)",
        "framer-1ojfxs9": "rgba(255, 255, 255, 0.2)",
        "framer-z6ek3k": "rgba(255, 255, 255, 0.2)",
        "framer-1qhbfh6": "rgba(255, 255, 255, 0.2)",
        "framer-1pj0haq": "rgba(255, 255, 255, 0.2)",
        "framer-vd0s5d": "rgba(255, 255, 255, 0.2)",
        "framer-1e93pup": "rgba(255, 255, 255, 0.2)",
        "framer-h9oic": "rgba(255, 255, 255, 0.2)",
        "framer-jo8cx0": "rgba(255, 255, 255, 0.2)",
        "framer-1f8ru9z": "rgba(255, 255, 255, 0.2)",
        "framer-1n4ht9o": "rgba(255, 255, 255, 0.2)",
        "framer-d353th": "rgba(255, 255, 255, 0.2)",
        "framer-13orx46": "rgba(255, 255, 255, 0.2)",
        "framer-14izw09": "rgba(255, 255, 255, 0.2)",
        "framer-1ibkax": "rgba(255, 255, 255, 0.2)",
        "framer-r24ou6": "rgba(255, 255, 255, 0.2)",
        "framer-5pakqt": "rgba(255, 255, 255, 0.2)",
        "framer-1d4yakz": "rgba(255, 255, 255, 0.2)",
        "framer-19985uk": "rgba(255, 255, 255, 0.2)",
        "framer-gb01s5": "rgba(255, 255, 255, 0.2)",
        "framer-wcsctp": "rgba(255, 255, 255, 0.2)",
        "framer-gbxnjm": "rgba(255, 255, 255, 0.2)",
        "framer-1n3latx": "rgba(255, 255, 255, 0.2)",
        "framer-ww49ko": "rgba(255, 255, 255, 0.2)",
        "framer-wuga8j": "rgba(255, 255, 255, 0.2)",
        "framer-19eh725": "rgba(255, 255, 255, 0.2)",
        "framer-spao7m": "rgba(255, 255, 255, 0.2)",
        "framer-p37xcr": "rgba(255, 255, 255, 0.2)",
        "framer-9lae15": "rgba(255, 255, 255, 0.2)",
        "framer-1djurc4": "rgba(255, 255, 255, 0.2)",
        "framer-1f9z9h2": "rgba(255, 255, 255, 0.2)",
        "framer-4nf7cp": "rgba(255, 255, 255, 0.2)",
        "framer-ib6lq2": "rgba(255, 255, 255, 0.2)",
        "framer-16jrhdt": "rgba(255, 255, 255, 0.2)",
        "framer-pb4qx6": "rgba(255, 255, 255, 0.2)",
        "framer-1bnvsbw": "rgba(255, 255, 255, 0.2)",
        "framer-svuws1": "rgba(255, 255, 255, 0.2)",
        "framer-18vrrai": "rgba(255, 255, 255, 0.2)",
        "framer-p75je3": "rgba(255, 255, 255, 0.2)",
        "framer-1oim4ap": "rgba(255, 255, 255, 0.2)",
        "framer-ets58q": "rgba(255, 255, 255, 0.2)",
        "framer-189qgi": "rgba(255, 255, 255, 0.2)",
        "framer-1se8eji": "rgba(255, 255, 255, 0.2)",
        "framer-xpdw0t": "rgba(255, 255, 255, 0.2)",
        "framer-114gjxu": "rgba(255, 255, 255, 0.2)",
        "framer-1ckranj": "rgba(255, 255, 255, 0.2)",
        "framer-yd49zj": "rgba(255, 255, 255, 0.2)",
        "framer-832d6a": "rgba(255, 255, 255, 0.2)",
        "framer-9j1mqt": "rgba(255, 255, 255, 0.2)",
        "framer-15qmn6v": "rgba(255, 255, 255, 0.2)",
        "framer-bosrq5": "rgba(255, 255, 255, 0.2)",
        "framer-e7rxl7": "rgba(255, 255, 255, 0.2)",
        "framer-t0me7w": "rgba(255, 255, 255, 0.2)",
        "framer-arxyzc": "rgba(255, 255, 255, 0.2)",
        "framer-w1f0c5": "rgba(255, 255, 255, 0.2)",
        "framer-1gx2zd": "rgba(255, 255, 255, 0.2)",
        "framer-1l5jzao": "rgba(255, 255, 255, 0.2)",
        "framer-lfxxyo": "rgba(255, 255, 255, 0.2)",
        "framer-1938ukf": "rgba(255, 255, 255, 0.2)",
        "framer-1uz9g4b": "rgba(255, 255, 255, 0.2)",
        "framer-skhb4e": "rgba(255, 255, 255, 0.2)",
        "framer-1nc562f": "rgba(255, 255, 255, 0.2)",
        "framer-1r1nb90": "rgba(255, 255, 255, 0.2)",
        "framer-1l7p7cw": "rgba(255, 255, 255, 0.2)",
        "framer-bbd8ba": "rgba(255, 255, 255, 0.2)",
        "framer-174359s": "rgba(255, 255, 255, 0.2)",
        "framer-o1cm7l": "rgba(255, 255, 255, 0.2)",
        "framer-1r2q58v": "rgba(255, 255, 255, 0.2)",
        "framer-ckhbc1": "rgba(255, 255, 255, 0.2)",
        "framer-25euhf": "rgba(255, 255, 255, 0.2)",
        "framer-1bg9jqr": "rgba(255, 255, 255, 0.2)",
        "framer-1hp2xsm": "rgba(255, 255, 255, 0.2)",
        "framer-1w08ot3": "rgba(255, 255, 255, 0.2)",
        "framer-hzs6gu": "rgba(255, 255, 255, 0.2)",
        "framer-1tn0auv": "rgba(255, 255, 255, 0.2)",
        "framer-1yuauh0": "rgb(6, 6, 12)",
        "framer-q39ych": "rgba(255, 255, 255, 0.05)",
        "framer-1la9doo": "rgba(255, 255, 255, 0.2)",
        "framer-1i6s172": "rgba(255, 255, 255, 0.2)",
        "framer-1bhiwq4": "rgba(255, 255, 255, 0.2)",
        "framer-1finjmh": "rgba(255, 255, 255, 0.2)",
        "framer-c4f7i5": "rgba(255, 255, 255, 0.2)",
        "framer-3ba7y6": "rgba(255, 255, 255, 0.2)",
        "framer-8o5z7u": "rgba(255, 255, 255, 0.2)",
        "framer-5vb13r": "rgba(255, 255, 255, 0.2)",
        "framer-1qg8j5j": "rgba(255, 255, 255, 0.2)",
        "framer-1cpq7cz": "rgba(255, 255, 255, 0.2)",
        "framer-1e24whu": "rgba(255, 255, 255, 0.2)",
        "framer-f9w1b0": "rgba(255, 255, 255, 0.2)",
        "framer-154i7ad": "rgba(255, 255, 255, 0.2)",
        "framer-trnmme": "rgba(255, 255, 255, 0.2)",
        "framer-1g03gzo": "rgba(255, 255, 255, 0.2)",
        "framer-2uv9z5": "rgba(255, 255, 255, 0.2)",
        "framer-1kh10xg": "rgba(255, 255, 255, 0.2)",
        "framer-177340h": "rgba(255, 255, 255, 0.2)",
        "framer-147tj1p": "rgba(255, 255, 255, 0.2)",
        "framer-1cjjf7q": "rgba(255, 255, 255, 0.2)",
        "framer-jjeffs": "rgba(255, 255, 255, 0.2)",
        "framer-b3oq5w": "rgba(255, 255, 255, 0.2)",
        "framer-lgkn64": "rgba(255, 255, 255, 0.2)",
        "framer-ftinbp": "rgba(255, 255, 255, 0.2)",
        "framer-1qgwf2q": "rgba(255, 255, 255, 0.2)",
        "framer-1s1q0zj": "rgba(255, 255, 255, 0.2)",
        "framer-szasz2": "rgba(255, 255, 255, 0.2)",
        "framer-1bh2qom": "rgba(255, 255, 255, 0.2)",
        "framer-vbr5qt": "rgba(255, 255, 255, 0.2)",
        "framer-ayiqn": "rgba(255, 255, 255, 0.2)",
        "framer-ng52my": "rgba(255, 255, 255, 0.2)",
        "framer-1qc3xh2": "rgba(255, 255, 255, 0.2)",
        "framer-17xhwxn": "rgba(255, 255, 255, 0.2)",
        "framer-kd3teb": "rgba(255, 255, 255, 0.2)",
        "framer-1ds9pvm": "rgba(255, 255, 255, 0.2)",
        "framer-9ou7kr": "rgba(255, 255, 255, 0.2)",
        "framer-19hkz1m": "rgba(255, 255, 255, 0.2)",
        "framer-z7coyc": "rgba(255, 255, 255, 0.2)",
        "framer-hxqr6r": "rgba(255, 255, 255, 0.2)",
        "framer-ssdjgy": "rgba(255, 255, 255, 0.2)",
        "framer-170fwp7": "rgba(255, 255, 255, 0.2)",
        "framer-iorqmd": "rgba(255, 255, 255, 0.2)",
        "framer-ly5had": "rgba(255, 255, 255, 0.2)",
        "framer-kyuip0": "rgba(255, 255, 255, 0.2)",
        "framer-m2toq0": "rgba(255, 255, 255, 0.2)",
        "framer-1hak2gy": "rgba(255, 255, 255, 0.2)",
        "framer-oe69v3": "rgba(255, 255, 255, 0.2)",
        "framer-tfrupv": "rgba(255, 255, 255, 0.2)",
        "framer-ados7m": "rgba(255, 255, 255, 0.2)",
        "framer-1b1arxe": "rgba(255, 255, 255, 0.2)",
        "framer-t2bzkx": "rgba(255, 255, 255, 0.2)",
        "framer-19h60xi": "rgba(255, 255, 255, 0.2)",
        "framer-1roowyp": "rgba(255, 255, 255, 0.2)",
        "framer-b33ovj": "rgba(255, 255, 255, 0.2)",
        "framer-2xrhr6": "rgba(255, 255, 255, 0.2)",
        "framer-bp4hmm": "rgba(255, 255, 255, 0.2)",
        "framer-bj9ogc": "rgba(255, 255, 255, 0.2)",
        "framer-dv99ve": "rgba(255, 255, 255, 0.2)",
        "framer-1o691fb": "rgba(255, 255, 255, 0.2)",
        "framer-1o7i21q": "rgba(255, 255, 255, 0.2)",
        "framer-7y8ymw": "rgba(255, 255, 255, 0.2)",
        "framer-259e94": "rgba(255, 255, 255, 0.2)",
        "framer-1vrgp1i": "rgba(255, 255, 255, 0.2)",
        "framer-1hkr8gz": "rgba(255, 255, 255, 0.2)",
        "framer-1cpl3ru": "rgba(255, 255, 255, 0.2)",
        "framer-4vg5fm": "rgba(255, 255, 255, 0.2)",
        "framer-6yep7x": "rgba(255, 255, 255, 0.2)",
        "framer-yo90z1": "rgba(255, 255, 255, 0.2)",
        "framer-1ffyrfe": "rgba(255, 255, 255, 0.2)",
        "framer-17sy2h9": "rgba(255, 255, 255, 0.2)",
        "framer-1nexr12": "rgba(255, 255, 255, 0.2)",
        "framer-1nxam09": "rgba(255, 255, 255, 0.2)",
        "framer-1u7tsmf": "rgba(255, 255, 255, 0.2)",
        "framer-1s1lgs9": "rgba(255, 255, 255, 0.2)",
        "framer-1tsc97t": "rgba(255, 255, 255, 0.2)",
        "framer-1lik10g": "rgba(255, 255, 255, 0.2)",
        "framer-w91j3h": "rgba(255, 255, 255, 0.2)",
        "framer-1t0gcur": "rgba(255, 255, 255, 0.2)",
        "framer-7i1u99": "rgba(255, 255, 255, 0.2)",
        "framer-zeyecd": "rgba(255, 255, 255, 0.2)",
        "framer-1sm3fde": "rgba(255, 255, 255, 0.2)",
        "framer-hpfi4e": "rgba(255, 255, 255, 0.2)",
        "framer-11nihoc": "rgba(255, 255, 255, 0.2)",
        "framer-dyf9qm": "rgba(255, 255, 255, 0.2)",
        "framer-issvd8": "rgba(255, 255, 255, 0.2)",
        "framer-wtmsdd": "rgba(255, 255, 255, 0.2)",
        "framer-1b7vdsu": "rgba(255, 255, 255, 0.2)",
        "framer-mhhl4m": "rgba(255, 255, 255, 0.2)",
        "framer-kr5yb3": "rgba(255, 255, 255, 0.2)",
        "framer-8s5abl": "rgba(255, 255, 255, 0.2)",
        "framer-f20w32": "rgba(255, 255, 255, 0.2)",
        "framer-1v5wb0d": "rgba(255, 255, 255, 0.2)",
        "framer-4tlth8": "rgba(255, 255, 255, 0.2)",
        "framer-kxfckx": "rgba(255, 255, 255, 0.2)",
        "framer-69n7ji": "rgba(255, 255, 255, 0.2)",
        "framer-1qqpucz": "rgba(255, 255, 255, 0.2)",
        "framer-1kt8yiq": "rgba(255, 255, 255, 0.2)",
        "framer-1qoqjv3": "rgba(255, 255, 255, 0.2)",
        "framer-16obh5m": "rgba(255, 255, 255, 0.2)",
        "framer-1tpfy33": "rgba(255, 255, 255, 0.2)",
        "framer-zxg4my": "rgba(255, 255, 255, 0.2)",
        "framer-c9ojjv": "rgba(255, 255, 255, 0.2)",
        "framer-1j4u6r2": "rgba(255, 255, 255, 0.2)",
        "framer-tclpau": "rgba(255, 255, 255, 0.2)",
        "framer-1ni6xjv": "rgba(255, 255, 255, 0.2)",
        "framer-1es2jab": "rgba(255, 255, 255, 0.2)",
        "framer-10jrcc6": "rgba(255, 255, 255, 0.2)",
        "framer-jcrjvd": "rgba(255, 255, 255, 0.2)",
        "framer-bvrrkp": "rgba(255, 255, 255, 0.2)",
        "framer-18mdrb0": "rgba(255, 255, 255, 0.2)",
        "framer-19ufz0c": "rgba(255, 255, 255, 0.2)",
        "framer-a4eq25": "rgba(255, 255, 255, 0.2)",
        "framer-fnwwxo": "rgba(255, 255, 255, 0.05)",
        "framer-1wyam6m": "rgba(255, 255, 255, 0.2)",
        "framer-1pp6x1n": "rgba(255, 255, 255, 0.2)",
        "framer-1kx8h30": "rgba(255, 255, 255, 0.2)",
        "framer-38qo6l": "rgba(255, 255, 255, 0.2)",
        "framer-1bgkq86": "rgba(255, 255, 255, 0.2)",
        "framer-1odgaps": "rgba(255, 255, 255, 0.2)",
        "framer-ocebul": "rgba(255, 255, 255, 0.2)",
        "framer-htsvoh": "rgba(255, 255, 255, 0.2)",
        "framer-1rjcid1": "rgba(255, 255, 255, 0.2)",
        "framer-1ppu9nu": "rgba(255, 255, 255, 0.2)",
        "framer-b26c6s": "rgba(255, 255, 255, 0.2)",
        "framer-k15ji": "rgba(255, 255, 255, 0.2)",
        "framer-w1jb1u": "rgba(255, 255, 255, 0.2)",
        "framer-1b65fof": "rgba(255, 255, 255, 0.2)",
        "framer-ag946t": "rgba(255, 255, 255, 0.2)",
        "framer-njpiav": "rgba(255, 255, 255, 0.2)",
        "framer-fzosm0": "rgba(255, 255, 255, 0.2)",
        "framer-31j99c": "rgba(255, 255, 255, 0.2)",
        "framer-wbharp": "rgba(255, 255, 255, 0.2)",
        "framer-1o6h43g": "rgba(255, 255, 255, 0.2)",
        "framer-w8h1i4": "rgba(255, 255, 255, 0.2)",
        "framer-u08o4f": "rgba(255, 255, 255, 0.2)",
        "framer-1883ili": "rgba(255, 255, 255, 0.2)",
        "framer-hhqq21": "rgba(255, 255, 255, 0.2)",
        "framer-1qddyrc": "rgba(255, 255, 255, 0.2)",
        "framer-36rsch": "rgba(255, 255, 255, 0.2)",
        "framer-1vhup78": "rgba(255, 255, 255, 0.2)",
        "framer-1wy0vut": "rgba(255, 255, 255, 0.2)",
        "framer-1tldixq": "rgba(255, 255, 255, 0.2)",
        "framer-vcglv4": "rgba(255, 255, 255, 0.2)",
        "framer-mnkyk9": "rgba(255, 255, 255, 0.2)",
        "framer-1gd8uia": "rgba(255, 255, 255, 0.2)",
        "framer-4v17kk": "rgba(255, 255, 255, 0.2)",
        "framer-wcgbdx": "rgba(255, 255, 255, 0.2)",
        "framer-19ge0mq": "rgba(255, 255, 255, 0.2)",
        "framer-142xl0d": "rgba(255, 255, 255, 0.2)",
        "framer-ao5kmt": "rgba(255, 255, 255, 0.2)",
        "framer-1rc6i1r": "rgba(255, 255, 255, 0.2)",
        "framer-1wlwqo": "rgba(255, 255, 255, 0.2)",
        "framer-1tzx2st": "rgba(255, 255, 255, 0.2)",
        "framer-z8gsz9": "rgba(255, 255, 255, 0.2)",
        "framer-1fgz62q": "rgba(255, 255, 255, 0.2)",
        "framer-n6tpd7": "rgba(255, 255, 255, 0.2)",
        "framer-1otl1h8": "rgba(255, 255, 255, 0.2)",
        "framer-1vi730u": "rgba(255, 255, 255, 0.2)",
        "framer-1klteqi": "rgba(255, 255, 255, 0.2)",
        "framer-36msax": "rgba(255, 255, 255, 0.2)",
        "framer-1feur12": "rgba(255, 255, 255, 0.2)",
        "framer-1lyqxag": "rgba(255, 255, 255, 0.2)",
        "framer-5a7aqr": "rgba(255, 255, 255, 0.2)",
        "framer-82cjev": "rgba(255, 255, 255, 0.2)",
        "framer-10a7t8v": "rgba(255, 255, 255, 0.2)",
        "framer-7pex0i": "rgba(255, 255, 255, 0.2)",
        "framer-1r4ihlp": "rgba(255, 255, 255, 0.2)",
        "framer-1cjy5e6": "rgba(255, 255, 255, 0.2)",
        "framer-1f59xpm": "rgba(255, 255, 255, 0.2)",
        "framer-13qpo9p": "rgba(255, 255, 255, 0.2)",
        "framer-160oi7c": "rgba(255, 255, 255, 0.2)",
        "framer-8v07ff": "rgba(255, 255, 255, 0.2)",
        "framer-ry0yv5": "rgba(255, 255, 255, 0.2)",
        "framer-427f3i": "rgba(255, 255, 255, 0.2)",
        "framer-jufpfh": "rgba(255, 255, 255, 0.2)",
        "framer-1c3n6lw": "rgba(255, 255, 255, 0.2)",
        "framer-ekq5up": "rgba(255, 255, 255, 0.2)",
        "framer-1ki962m": "rgba(255, 255, 255, 0.2)",
        "framer-15t1dfp": "rgba(255, 255, 255, 0.2)",
        "framer-3s7e4w": "rgba(255, 255, 255, 0.2)",
        "framer-1w1r0c7": "rgba(255, 255, 255, 0.2)",
        "framer-cvvwij": "rgba(255, 255, 255, 0.2)",
        "framer-1vpvxxf": "rgba(255, 255, 255, 0.2)",
        "framer-149u646": "rgba(255, 255, 255, 0.2)",
        "framer-1o7mum0": "rgba(255, 255, 255, 0.2)",
        "framer-ki1v17": "rgba(255, 255, 255, 0.2)",
        "framer-lhdvz8": "rgba(255, 255, 255, 0.2)",
        "framer-jy0fht": "rgba(255, 255, 255, 0.2)",
        "framer-99ymz4": "rgba(255, 255, 255, 0.2)",
        "framer-p09ia0": "rgba(255, 255, 255, 0.2)",
        "framer-13ehaqm": "rgba(255, 255, 255, 0.2)",
        "framer-1wbmnsw": "rgba(255, 255, 255, 0.2)",
        "framer-1ikz5w4": "rgba(255, 255, 255, 0.2)",
        "framer-z4q1to": "rgba(255, 255, 255, 0.2)",
        "framer-18xz9es": "rgba(255, 255, 255, 0.2)",
        "framer-1l729uo": "rgba(255, 255, 255, 0.2)",
        "framer-ft28bw": "rgba(255, 255, 255, 0.2)",
        "framer-1ewgg5n": "rgba(255, 255, 255, 0.2)",
        "framer-1qmstsw": "rgba(255, 255, 255, 0.2)",
        "framer-cxuw29": "rgba(255, 255, 255, 0.2)",
        "framer-cg40le": "rgba(255, 255, 255, 0.2)",
        "framer-dutair": "rgba(255, 255, 255, 0.2)",
        "framer-4oapi9": "rgba(255, 255, 255, 0.2)",
        "framer-1erawlh": "rgba(255, 255, 255, 0.2)",
        "framer-1y5k2gj": "rgba(255, 255, 255, 0.2)",
        "framer-1lbic0v": "rgba(255, 255, 255, 0.2)",
        "framer-1opocxv": "rgba(255, 255, 255, 0.2)",
        "framer-12khtk0": "rgba(255, 255, 255, 0.2)",
        "framer-bwyhrh": "rgba(255, 255, 255, 0.2)",
        "framer-1uubtjq": "rgba(255, 255, 255, 0.2)",
        "framer-140mxx7": "rgba(255, 255, 255, 0.2)",
        "framer-1cx2l59": "rgba(255, 255, 255, 0.2)",
        "framer-11lvdrf": "rgba(255, 255, 255, 0.2)",
        "framer-10s17r7": "rgba(255, 255, 255, 0.2)",
        "framer-1jsn0l4": "rgba(255, 255, 255, 0.2)",
        "framer-7xfhaj": "rgba(255, 255, 255, 0.2)",
        "framer-1rrd2yl": "rgba(255, 255, 255, 0.2)",
        "framer-wr2mdi": "rgba(255, 255, 255, 0.2)",
        "framer-tm9wqz": "rgba(255, 255, 255, 0.2)",
        "framer-112ouxp": "rgba(255, 255, 255, 0.2)",
        "framer-1wn4wwg": "rgba(255, 255, 255, 0.2)",
        "framer-1qbbaf": "rgba(255, 255, 255, 0.2)",
        "framer-rxy7g3": "rgba(255, 255, 255, 0.2)",
        "framer-18g76l8": "rgba(255, 255, 255, 0.2)",
        "framer-s30zx7": "rgba(255, 255, 255, 0.2)",
        "framer-116wxpu": "rgba(255, 255, 255, 0.05)",
        "framer-1c5xnue": "rgba(255, 255, 255, 0.2)",
        "framer-qf8qx3": "rgba(255, 255, 255, 0.2)",
        "framer-1odc6hn": "rgba(255, 255, 255, 0.2)",
        "framer-19ap9de": "rgba(255, 255, 255, 0.2)",
        "framer-1vff8z3": "rgba(255, 255, 255, 0.2)",
        "framer-ythjyv": "rgba(255, 255, 255, 0.2)",
        "framer-9z37yi": "rgba(255, 255, 255, 0.2)",
        "framer-16w1k6o": "rgba(255, 255, 255, 0.2)",
        "framer-1xcik3l": "rgba(255, 255, 255, 0.2)",
        "framer-oukkhq": "rgba(255, 255, 255, 0.2)",
        "framer-lqila1": "rgba(255, 255, 255, 0.2)",
        "framer-1fdpwik": "rgba(255, 255, 255, 0.2)",
        "framer-ekzdww": "rgba(255, 255, 255, 0.2)",
        "framer-m2a85j": "rgba(255, 255, 255, 0.2)",
        "framer-41rnem": "rgba(255, 255, 255, 0.2)",
        "framer-19zo0xy": "rgba(255, 255, 255, 0.2)",
        "framer-xk8c1l": "rgba(255, 255, 255, 0.2)",
        "framer-lvrz1c": "rgba(255, 255, 255, 0.2)",
        "framer-x277m4": "rgba(255, 255, 255, 0.2)",
        "framer-jkqkpl": "rgba(255, 255, 255, 0.2)",
        "framer-5hr7x3": "rgba(255, 255, 255, 0.2)",
        "framer-1m0phhu": "rgba(255, 255, 255, 0.2)",
        "framer-yi8kxp": "rgba(255, 255, 255, 0.2)",
        "framer-1rjqh9s": "rgba(255, 255, 255, 0.2)",
        "framer-g47dyw": "rgba(255, 255, 255, 0.2)",
        "framer-q0k5a6": "rgba(255, 255, 255, 0.2)",
        "framer-pcgh1x": "rgba(255, 255, 255, 0.2)",
        "framer-xw0rvq": "rgba(255, 255, 255, 0.2)",
        "framer-c3k2a9": "rgba(255, 255, 255, 0.2)",
        "framer-1pdnlep": "rgba(255, 255, 255, 0.2)",
        "framer-1isj3ve": "rgba(255, 255, 255, 0.2)",
        "framer-1nzo316": "rgba(255, 255, 255, 0.2)",
        "framer-ny2nrf": "rgba(255, 255, 255, 0.2)",
        "framer-1dtzjxr": "rgba(255, 255, 255, 0.2)",
        "framer-mu508z": "rgba(255, 255, 255, 0.2)",
        "framer-qpfp6n": "rgba(255, 255, 255, 0.2)",
        "framer-14eawsu": "rgba(255, 255, 255, 0.2)",
        "framer-s21ssb": "rgba(255, 255, 255, 0.2)",
        "framer-hqplw1": "rgba(255, 255, 255, 0.2)",
        "framer-bklpz1": "rgba(255, 255, 255, 0.2)",
        "framer-1imnrwl": "rgba(255, 255, 255, 0.2)",
        "framer-gzpem3": "rgba(255, 255, 255, 0.2)",
        "framer-1idhh85": "rgba(255, 255, 255, 0.2)",
        "framer-1j46jly": "rgba(255, 255, 255, 0.2)",
        "framer-1dsuymd": "rgba(255, 255, 255, 0.2)",
        "framer-zogoby": "rgba(255, 255, 255, 0.2)",
        "framer-1d3g9c1": "rgba(255, 255, 255, 0.2)",
        "framer-1o544t5": "rgba(255, 255, 255, 0.2)",
        "framer-1m6q3w4": "rgba(255, 255, 255, 0.2)",
        "framer-mg2djc": "rgba(255, 255, 255, 0.2)",
        "framer-17ralnl": "rgba(255, 255, 255, 0.2)",
        "framer-1rurt58": "rgba(255, 255, 255, 0.2)",
        "framer-gf48he": "rgba(255, 255, 255, 0.2)",
        "framer-17zgy7z": "rgba(255, 255, 255, 0.2)",
        "framer-1rzm2gb": "rgba(255, 255, 255, 0.2)",
        "framer-y89xtg": "rgba(255, 255, 255, 0.2)",
        "framer-106i2vh": "rgba(255, 255, 255, 0.2)",
        "framer-p1tl7s": "rgba(255, 255, 255, 0.2)",
        "framer-mtqgug": "rgba(255, 255, 255, 0.2)",
        "framer-1788u0c": "rgba(255, 255, 255, 0.2)",
        "framer-1wmn822": "rgba(255, 255, 255, 0.2)",
        "framer-1v5bd5y": "rgba(255, 255, 255, 0.2)",
        "framer-uo544c": "rgba(255, 255, 255, 0.2)",
        "framer-7qtus5": "rgba(255, 255, 255, 0.2)",
        "framer-gqq0zi": "rgba(255, 255, 255, 0.2)",
        "framer-1drnvw6": "rgba(255, 255, 255, 0.2)",
        "framer-17z9tw4": "rgba(255, 255, 255, 0.2)",
        "framer-3bymer": "rgba(255, 255, 255, 0.2)",
        "framer-mnk1l5": "rgba(255, 255, 255, 0.2)",
        "framer-m79my0": "rgba(255, 255, 255, 0.2)",
        "framer-14o7iob": "rgba(255, 255, 255, 0.2)",
        "framer-wez924": "rgba(255, 255, 255, 0.2)",
        "framer-1mgfm9b": "rgba(255, 255, 255, 0.2)",
        "framer-45l0gt": "rgba(255, 255, 255, 0.2)",
        "framer-zf9unh": "rgba(255, 255, 255, 0.2)",
        "framer-11ud222": "rgba(255, 255, 255, 0.2)",
        "framer-1mzlzv1": "rgba(255, 255, 255, 0.2)",
        "framer-1fib5c": "rgba(255, 255, 255, 0.2)",
        "framer-oaiogv": "rgba(255, 255, 255, 0.2)",
        "framer-zep14j": "rgba(255, 255, 255, 0.2)",
        "framer-1brj1ht": "rgba(255, 255, 255, 0.2)",
        "framer-1pqx6tg": "rgba(255, 255, 255, 0.2)",
        "framer-2wbw88": "rgba(255, 255, 255, 0.2)",
        "framer-97hh1c": "rgba(255, 255, 255, 0.2)",
        "framer-1scvxj2": "rgba(255, 255, 255, 0.2)",
        "framer-usy4xf": "rgba(255, 255, 255, 0.2)",
        "framer-1nrqj7q": "rgba(255, 255, 255, 0.2)",
        "framer-1l8jyo7": "rgba(255, 255, 255, 0.2)",
        "framer-1wj5wmr": "rgba(255, 255, 255, 0.2)",
        "framer-5dbofz": "rgba(255, 255, 255, 0.2)",
        "framer-1p29g0f": "rgba(255, 255, 255, 0.2)",
        "framer-13hsqgp": "rgba(255, 255, 255, 0.2)",
        "framer-k3f6s7": "rgba(255, 255, 255, 0.2)",
        "framer-czp6kw": "rgba(255, 255, 255, 0.2)",
        "framer-b8p4so": "rgba(255, 255, 255, 0.2)",
        "framer-td5exg": "rgba(255, 255, 255, 0.2)",
        "framer-rlul9t": "rgba(255, 255, 255, 0.2)",
        "framer-1qbi01j": "rgba(255, 255, 255, 0.2)",
        "framer-11yihtu": "rgba(255, 255, 255, 0.2)",
        "framer-1jw3h1j": "rgba(255, 255, 255, 0.2)",
        "framer-1982gyu": "rgba(255, 255, 255, 0.2)",
        "framer-1kx8z1s": "rgba(255, 255, 255, 0.2)",
        "framer-1jo2xb0": "rgba(255, 255, 255, 0.2)",
        "framer-ozo1q7": "rgba(255, 255, 255, 0.2)",
        "framer-lndw3q": "rgba(255, 255, 255, 0.2)",
        "framer-1ggyd5i": "rgba(255, 255, 255, 0.2)",
        "framer-1hi908g": "rgba(255, 255, 255, 0.2)",
        "framer-1y8hrwf": "rgba(255, 255, 255, 0.2)",
        "framer-bnxcb5": "rgba(255, 255, 255, 0.2)",
        "framer-6ip5m0": "rgba(255, 255, 255, 0.2)",
        "framer-5lgj4i": "rgba(255, 255, 255, 0.2)",
        "framer-15gcew7": "rgba(255, 255, 255, 0.2)",
        "framer-1h71ow4": "rgba(255, 255, 255, 0.05)",
        "framer-1n1itqm": "rgba(255, 255, 255, 0.2)",
        "framer-yyvhfo": "rgba(255, 255, 255, 0.2)",
        "framer-1fh5h8g": "rgba(255, 255, 255, 0.2)",
        "framer-1xq5s95": "rgba(255, 255, 255, 0.2)",
        "framer-tecic8": "rgba(255, 255, 255, 0.2)",
        "framer-cdfvoq": "rgba(255, 255, 255, 0.2)",
        "framer-1gkcgnr": "rgba(255, 255, 255, 0.2)",
        "framer-1xajlqd": "rgba(255, 255, 255, 0.2)",
        "framer-wobegw": "rgba(255, 255, 255, 0.2)",
        "framer-xezr57": "rgba(255, 255, 255, 0.2)",
        "framer-is8obf": "rgba(255, 255, 255, 0.2)",
        "framer-1adwqk8": "rgba(255, 255, 255, 0.2)",
        "framer-zgffy0": "rgba(255, 255, 255, 0.2)",
        "framer-1j53vuy": "rgba(255, 255, 255, 0.2)",
        "framer-xsn7x8": "rgba(255, 255, 255, 0.2)",
        "framer-1s80omz": "rgba(255, 255, 255, 0.2)",
        "framer-k6zy4o": "rgba(255, 255, 255, 0.2)",
        "framer-1wflc0e": "rgba(255, 255, 255, 0.2)",
        "framer-2rt8zl": "rgba(255, 255, 255, 0.2)",
        "framer-1drs3dv": "rgba(255, 255, 255, 0.2)",
        "framer-f4fnpl": "rgba(255, 255, 255, 0.2)",
        "framer-1oh6k57": "rgba(255, 255, 255, 0.2)",
        "framer-15ghu57": "rgba(255, 255, 255, 0.2)",
        "framer-u9hm8p": "rgba(255, 255, 255, 0.2)",
        "framer-9ayv4y": "rgba(255, 255, 255, 0.2)",
        "framer-uiax3g": "rgba(255, 255, 255, 0.2)",
        "framer-nhfppx": "rgba(255, 255, 255, 0.2)",
        "framer-10skth4": "rgba(255, 255, 255, 0.2)",
        "framer-zvsym": "rgba(255, 255, 255, 0.2)",
        "framer-1dguqyv": "rgba(255, 255, 255, 0.2)",
        "framer-10j66y7": "rgba(255, 255, 255, 0.2)",
        "framer-asyr5b": "rgba(255, 255, 255, 0.2)",
        "framer-1kiw2qy": "rgba(255, 255, 255, 0.2)",
        "framer-f4zdyj": "rgba(255, 255, 255, 0.2)",
        "framer-qp5ir6": "rgba(255, 255, 255, 0.2)",
        "framer-ugpy4l": "rgba(255, 255, 255, 0.2)",
        "framer-1v5qg4b": "rgba(255, 255, 255, 0.2)",
        "framer-l8awnf": "rgba(255, 255, 255, 0.2)",
        "framer-1gmovvw": "rgba(255, 255, 255, 0.2)",
        "framer-sutdmt": "rgba(255, 255, 255, 0.2)",
        "framer-1trny2v": "rgba(255, 255, 255, 0.2)",
        "framer-1cdohfe": "rgba(255, 255, 255, 0.2)",
        "framer-t9fqjc": "rgba(255, 255, 255, 0.2)",
        "framer-1xtosav": "rgba(255, 255, 255, 0.2)",
        "framer-vk3hjo": "rgba(255, 255, 255, 0.2)",
        "framer-sreof1": "rgba(255, 255, 255, 0.2)",
        "framer-3qmhxn": "rgba(255, 255, 255, 0.2)",
        "framer-hplkdw": "rgba(255, 255, 255, 0.2)",
        "framer-1pthapd": "rgba(255, 255, 255, 0.2)",
        "framer-xc32tt": "rgba(255, 255, 255, 0.2)",
        "framer-1u11iky": "rgba(255, 255, 255, 0.2)",
        "framer-d6cngf": "rgba(255, 255, 255, 0.2)",
        "framer-1i34tns": "rgba(255, 255, 255, 0.2)",
        "framer-906618": "rgba(255, 255, 255, 0.2)",
        "framer-1y2a24g": "rgba(255, 255, 255, 0.2)",
        "framer-1i7zrv5": "rgba(255, 255, 255, 0.2)",
        "framer-1suuahx": "rgba(255, 255, 255, 0.2)",
        "framer-1oyg0cr": "rgba(255, 255, 255, 0.2)",
        "framer-n55er7": "rgba(255, 255, 255, 0.2)",
        "framer-1en2cnq": "rgba(255, 255, 255, 0.2)",
        "framer-psjjo8": "rgba(255, 255, 255, 0.2)",
        "framer-14r2wfh": "rgba(255, 255, 255, 0.2)",
        "framer-fbzlsf": "rgba(255, 255, 255, 0.2)",
        "framer-vmchm3": "rgba(255, 255, 255, 0.2)",
        "framer-i91vgm": "rgba(255, 255, 255, 0.2)",
        "framer-yi8kes": "rgba(255, 255, 255, 0.2)",
        "framer-1n4420v": "rgba(255, 255, 255, 0.2)",
        "framer-198giob": "rgba(255, 255, 255, 0.2)",
        "framer-g8x8gx": "rgba(255, 255, 255, 0.2)",
        "framer-1mhsv49": "rgba(255, 255, 255, 0.2)",
        "framer-1nh0jro": "rgba(255, 255, 255, 0.2)",
        "framer-1lwq65t": "rgba(255, 255, 255, 0.2)",
        "framer-1qd6oi": "rgba(255, 255, 255, 0.2)",
        "framer-7ps415": "rgba(255, 255, 255, 0.2)",
        "framer-sljn5b": "rgba(255, 255, 255, 0.2)",
        "framer-gbdnvn": "rgba(255, 255, 255, 0.2)",
        "framer-1hbglek": "rgba(255, 255, 255, 0.2)",
        "framer-pdko06": "rgba(255, 255, 255, 0.2)",
        "framer-1mx2enx": "rgba(255, 255, 255, 0.2)",
        "framer-sr9rxt": "rgba(255, 255, 255, 0.2)",
        "framer-68e1wx": "rgba(255, 255, 255, 0.2)",
        "framer-1x2z7rq": "rgba(255, 255, 255, 0.2)",
        "framer-15apzd": "rgba(255, 255, 255, 0.2)",
        "framer-iytitg": "rgba(255, 255, 255, 0.2)",
        "framer-v0ogr5": "rgba(255, 255, 255, 0.2)",
        "framer-9vo8zm": "rgba(255, 255, 255, 0.2)",
        "framer-ud6nss": "rgba(255, 255, 255, 0.2)",
        "framer-978p0s": "rgba(255, 255, 255, 0.2)",
        "framer-8pji0e": "rgba(255, 255, 255, 0.2)",
        "framer-12jhrfd": "rgba(255, 255, 255, 0.2)",
        "framer-d2s7aa": "rgba(255, 255, 255, 0.2)",
        "framer-l0sqmy": "rgba(255, 255, 255, 0.2)",
        "framer-1qa7u6k": "rgba(255, 255, 255, 0.2)",
        "framer-tquodz": "rgba(255, 255, 255, 0.2)",
        "framer-yncmmi": "rgba(255, 255, 255, 0.2)",
        "framer-1xx4aok": "rgba(255, 255, 255, 0.2)",
        "framer-1mqv4oz": "rgba(255, 255, 255, 0.2)",
        "framer-vhaobv": "rgba(255, 255, 255, 0.2)",
        "framer-6pkxu0": "rgba(255, 255, 255, 0.2)",
        "framer-c34o2l": "rgba(255, 255, 255, 0.2)",
        "framer-txmp65": "rgba(255, 255, 255, 0.2)",
        "framer-od41ta": "rgba(255, 255, 255, 0.2)",
        "framer-78b9vw": "rgba(255, 255, 255, 0.2)",
        "framer-p4w8us": "rgba(255, 255, 255, 0.2)",
        "framer-1e1cat9": "rgba(255, 255, 255, 0.2)",
        "framer-47lkyg": "rgba(255, 255, 255, 0.2)",
        "framer-1nyvkz": "rgba(255, 255, 255, 0.2)",
        "framer-16wwq2l": "rgba(255, 255, 255, 0.2)",
        "framer-ohb4se": "rgba(255, 255, 255, 0.2)",
        "framer-fdn6q4": "rgba(255, 255, 255, 0.2)",
        "framer-1rsqnb8": "rgba(255, 255, 255, 0.2)",
        "framer-18lxnea": "rgba(255, 255, 255, 0.2)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (29).html"
    },
    {
      "colors": {
        "framer-fiyyst": "rgba(255, 255, 255, 0.05)",
        "framer-ciyq8x": "rgba(255, 255, 255, 0.5)",
        "framer-1q66old": "rgba(255, 255, 255, 0.5)",
        "framer-1qi4x9e": "rgba(255, 255, 255, 0.5)",
        "framer-1gptz2q": "rgba(255, 255, 255, 0.5)",
        "framer-1455pd0": "rgba(255, 255, 255, 0.5)",
        "framer-1fit9b7": "rgba(255, 255, 255, 0.5)",
        "framer-hi43jy": "rgba(255, 255, 255, 0.5)",
        "framer-1wd6cu5": "rgba(255, 255, 255, 0.5)",
        "framer-1ylwb2d": "rgba(255, 255, 255, 0.5)",
        "framer-1y9yxe2": "rgba(255, 255, 255, 0.5)",
        "framer-qvneen": "rgba(255, 255, 255, 0.5)",
        "framer-wjo0e9": "rgba(255, 255, 255, 0.5)",
        "framer-czpr7r": "rgba(255, 255, 255, 0.5)",
        "framer-vj2fgs": "rgba(255, 255, 255, 0.5)",
        "framer-hoxygt": "rgba(255, 255, 255, 0.5)",
        "framer-48kwqi": "rgba(255, 255, 255, 0.5)",
        "framer-u5krqo": "rgba(255, 255, 255, 0.5)",
        "framer-w896tp": "rgba(255, 255, 255, 0.5)",
        "framer-1wk1y40": "rgba(255, 255, 255, 0.5)",
        "framer-33r2dq": "rgba(255, 255, 255, 0.5)",
        "framer-1gbanx3": "rgba(255, 255, 255, 0.5)",
        "framer-1ux33dn": "rgba(255, 255, 255, 0.5)",
        "framer-3lw8u8": "rgba(255, 255, 255, 0.5)",
        "framer-1czikuk": "rgba(255, 255, 255, 0.5)",
        "framer-q6eebf": "rgba(255, 255, 255, 0.5)",
        "framer-1gdzggg": "rgba(255, 255, 255, 0.5)",
        "framer-tsui6n": "rgba(255, 255, 255, 0.5)",
        "framer-vgwsmu": "rgba(255, 255, 255, 0.5)",
        "framer-1tmsih3": "rgba(255, 255, 255, 0.5)",
        "framer-btodsk": "rgba(255, 255, 255, 0.5)",
        "framer-1c27p2n": "rgba(255, 255, 255, 0.5)",
        "framer-hj95w1": "rgba(255, 255, 255, 0.5)",
        "framer-1dyz5ca": "rgba(255, 255, 255, 0.5)",
        "framer-et0m12": "rgba(255, 255, 255, 0.5)",
        "framer-vnh2vx": "rgba(255, 255, 255, 0.5)",
        "framer-1l61glq": "rgba(255, 255, 255, 0.5)",
        "framer-qzjyt5": "rgba(255, 255, 255, 0.5)",
        "framer-1j65h5c": "rgba(255, 255, 255, 0.5)",
        "framer-ujqrvs": "rgba(255, 255, 255, 0.5)",
        "framer-ooft64": "rgba(255, 255, 255, 0.5)",
        "framer-1wfl7nv": "rgba(255, 255, 255, 0.5)",
        "framer-17irg2n": "rgba(255, 255, 255, 0.5)",
        "framer-l109y1": "rgba(255, 255, 255, 0.5)",
        "framer-14fhv1t": "rgba(255, 255, 255, 0.5)",
        "framer-763vv": "rgba(255, 255, 255, 0.5)",
        "framer-ekdddg": "rgba(255, 255, 255, 0.5)",
        "framer-lczi8i": "rgba(255, 255, 255, 0.5)",
        "framer-1k3zzg8": "rgba(255, 255, 255, 0.5)",
        "framer-1nze31j": "rgba(255, 255, 255, 0.5)",
        "framer-1izz6de": "rgba(255, 255, 255, 0.5)",
        "framer-cva9wu": "rgba(255, 255, 255, 0.5)",
        "framer-myr3v0": "rgba(255, 255, 255, 0.5)",
        "framer-3fv7cz": "rgba(255, 255, 255, 0.5)",
        "framer-1cb7j9a": "rgba(255, 255, 255, 0.5)",
        "framer-bvmogv": "rgba(255, 255, 255, 0.5)",
        "framer-1nvc6l8": "rgba(255, 255, 255, 0.5)",
        "framer-1k694lj": "rgba(255, 255, 255, 0.5)",
        "framer-1br5jo5": "rgba(255, 255, 255, 0.5)",
        "framer-91edth": "rgba(255, 255, 255, 0.5)",
        "framer-19nd5re": "rgba(255, 255, 255, 0.5)",
        "framer-11zy7gz": "rgba(255, 255, 255, 0.5)",
        "framer-183jbxw": "rgba(255, 255, 255, 0.5)",
        "framer-1k2kjzb": "rgba(255, 255, 255, 0.5)",
        "framer-e0p84p": "rgba(255, 255, 255, 0.5)",
        "framer-170af3e": "rgba(255, 255, 255, 0.5)",
        "framer-ghrn1n": "rgba(255, 255, 255, 0.5)",
        "framer-1djai4u": "rgba(255, 255, 255, 0.5)",
        "framer-1ibabel": "rgba(255, 255, 255, 0.5)",
        "framer-8y8sq7": "rgba(255, 255, 255, 0.5)",
        "framer-19kqjve": "rgba(255, 255, 255, 0.5)",
        "framer-1rf3dh1": "rgba(255, 255, 255, 0.5)",
        "framer-18lqt85": "rgba(255, 255, 255, 0.5)",
        "framer-1vt83fg": "rgba(255, 255, 255, 0.5)",
        "framer-1290qui": "rgba(255, 255, 255, 0.5)",
        "framer-10qen5q": "rgba(255, 255, 255, 0.5)",
        "framer-1x7y08s": "rgba(255, 255, 255, 0.5)",
        "framer-li1bn0": "rgba(255, 255, 255, 0.5)",
        "framer-1afif8m": "rgba(255, 255, 255, 0.5)",
        "framer-1xffmu1": "rgba(255, 255, 255, 0.5)",
        "framer-vxzka9": "rgba(255, 255, 255, 0.5)",
        "framer-1oenpnn": "rgba(255, 255, 255, 0.5)",
        "framer-xqqqan": "rgba(255, 255, 255, 0.5)",
        "framer-1xs3c5s": "rgba(255, 255, 255, 0.5)",
        "framer-g5b2fd": "rgba(255, 255, 255, 0.5)",
        "framer-15pc2n8": "rgba(255, 255, 255, 0.5)",
        "framer-dlkqju": "rgba(255, 255, 255, 0.5)",
        "framer-1662edz": "rgba(255, 255, 255, 0.5)",
        "framer-1o6ae4m": "rgba(255, 255, 255, 0.5)",
        "framer-7ut610": "rgba(255, 255, 255, 0.5)",
        "framer-4nsxaf": "rgba(255, 255, 255, 0.5)",
        "framer-kyye8q": "rgba(255, 255, 255, 0.5)",
        "framer-nge7c7": "rgba(255, 255, 255, 0.5)",
        "framer-153oid8": "rgba(255, 255, 255, 0.5)",
        "framer-1i5403r": "rgba(255, 255, 255, 0.5)",
        "framer-zdwg34": "rgba(255, 255, 255, 0.5)",
        "framer-1wosb63": "rgba(255, 255, 255, 0.5)",
        "framer-nf35ps": "rgba(255, 255, 255, 0.5)",
        "framer-qa34xq": "rgba(255, 255, 255, 0.5)",
        "framer-filgd4": "rgba(255, 255, 255, 0.5)",
        "framer-u4d6x3": "rgba(255, 255, 255, 0.5)",
        "framer-ev4n9h": "rgba(255, 255, 255, 0.5)",
        "framer-1jndxip": "rgba(255, 255, 255, 0.5)",
        "framer-ukalac": "rgba(255, 255, 255, 0.5)",
        "framer-7ra5u7": "rgba(255, 255, 255, 0.5)",
        "framer-1q0z42g": "rgba(255, 255, 255, 0.5)",
        "framer-o0cltq": "rgba(255, 255, 255, 0.5)",
        "framer-1ymomzd": "rgba(255, 255, 255, 0.5)",
        "framer-15ogixz": "rgba(255, 255, 255, 0.5)",
        "framer-4uq06b": "rgba(255, 255, 255, 0.5)",
        "framer-5pj1ss": "rgba(255, 255, 255, 0.5)",
        "framer-cjm6cm": "rgba(255, 255, 255, 0.5)",
        "framer-1nwn46": "rgba(255, 255, 255, 0.5)",
        "framer-l4xkwr": "rgba(255, 255, 255, 0.05)",
        "framer-tvhj2b": "rgba(255, 255, 255, 0.5)",
        "framer-86mmqq": "rgba(255, 255, 255, 0.5)",
        "framer-nc7bns": "rgba(255, 255, 255, 0.5)",
        "framer-1cg48np": "rgba(255, 255, 255, 0.5)",
        "framer-wnc4on": "rgba(255, 255, 255, 0.5)",
        "framer-14nw6a7": "rgba(255, 255, 255, 0.5)",
        "framer-xpktl5": "rgba(255, 255, 255, 0.5)",
        "framer-1mqce9a": "rgba(255, 255, 255, 0.5)",
        "framer-6xbkam": "rgba(255, 255, 255, 0.5)",
        "framer-131v8op": "rgba(255, 255, 255, 0.5)",
        "framer-1ddxcby": "rgba(255, 255, 255, 0.5)",
        "framer-1o9uvr4": "rgba(255, 255, 255, 0.5)",
        "framer-gt4ley": "rgba(255, 255, 255, 0.5)",
        "framer-11v9qa8": "rgba(255, 255, 255, 0.5)",
        "framer-h942sb": "rgba(255, 255, 255, 0.5)",
        "framer-2bbq4h": "rgba(255, 255, 255, 0.5)",
        "framer-1b5igrv": "rgba(255, 255, 255, 0.5)",
        "framer-170rkry": "rgba(255, 255, 255, 0.5)",
        "framer-kgstxs": "rgba(255, 255, 255, 0.5)",
        "framer-b7gua7": "rgba(255, 255, 255, 0.5)",
        "framer-1sldj1o": "rgba(255, 255, 255, 0.5)",
        "framer-1svd255": "rgba(255, 255, 255, 0.5)",
        "framer-138y9pl": "rgba(255, 255, 255, 0.5)",
        "framer-1dta0vu": "rgba(255, 255, 255, 0.5)",
        "framer-3z64oo": "rgba(255, 255, 255, 0.5)",
        "framer-1d2d49i": "rgba(255, 255, 255, 0.5)",
        "framer-oyhd3t": "rgba(255, 255, 255, 0.5)",
        "framer-20f2sf": "rgba(255, 255, 255, 0.5)",
        "framer-fd2gbu": "rgba(255, 255, 255, 0.5)",
        "framer-173iqm4": "rgba(255, 255, 255, 0.5)",
        "framer-1nw2i5u": "rgba(255, 255, 255, 0.5)",
        "framer-1gf8f74": "rgba(255, 255, 255, 0.5)",
        "framer-126if7k": "rgba(255, 255, 255, 0.5)",
        "framer-101393o": "rgba(255, 255, 255, 0.5)",
        "framer-1cttzfy": "rgba(255, 255, 255, 0.5)",
        "framer-1bchv1w": "rgba(255, 255, 255, 0.5)",
        "framer-1xspwzf": "rgba(255, 255, 255, 0.5)",
        "framer-hshnmx": "rgba(255, 255, 255, 0.5)",
        "framer-1atgup7": "rgba(255, 255, 255, 0.5)",
        "framer-rm0zjp": "rgba(255, 255, 255, 0.5)",
        "framer-1kk3rk0": "rgba(255, 255, 255, 0.5)",
        "framer-of0mcj": "rgba(255, 255, 255, 0.5)",
        "framer-ysh229": "rgba(255, 255, 255, 0.5)",
        "framer-13o3p9b": "rgba(255, 255, 255, 0.5)",
        "framer-cgvumc": "rgba(255, 255, 255, 0.5)",
        "framer-1vct5ds": "rgba(255, 255, 255, 0.5)",
        "framer-19h6kmj": "rgba(255, 255, 255, 0.5)",
        "framer-1cjvhsx": "rgba(255, 255, 255, 0.5)",
        "framer-12p3vzx": "rgba(255, 255, 255, 0.5)",
        "framer-1oksxci": "rgba(255, 255, 255, 0.5)",
        "framer-14pwok1": "rgba(255, 255, 255, 0.5)",
        "framer-1lswi2p": "rgba(255, 255, 255, 0.5)",
        "framer-19zr038": "rgba(255, 255, 255, 0.5)",
        "framer-mexy1c": "rgba(255, 255, 255, 0.5)",
        "framer-119p38r": "rgba(255, 255, 255, 0.5)",
        "framer-aokgsq": "rgba(255, 255, 255, 0.5)",
        "framer-1vgglw": "rgba(255, 255, 255, 0.5)",
        "framer-9wyu5": "rgba(255, 255, 255, 0.5)",
        "framer-1u89jrq": "rgba(255, 255, 255, 0.5)",
        "framer-ilwm1r": "rgba(255, 255, 255, 0.5)",
        "framer-6c7q3i": "rgba(255, 255, 255, 0.5)",
        "framer-1dhqmpa": "rgba(255, 255, 255, 0.5)",
        "framer-m6uoyn": "rgba(255, 255, 255, 0.5)",
        "framer-1abbc44": "rgba(255, 255, 255, 0.5)",
        "framer-1asdrnx": "rgba(255, 255, 255, 0.5)",
        "framer-1a81c3z": "rgba(255, 255, 255, 0.5)",
        "framer-1yjoi2": "rgba(255, 255, 255, 0.5)",
        "framer-34s8p0": "rgba(255, 255, 255, 0.5)",
        "framer-9wmkwc": "rgba(255, 255, 255, 0.5)",
        "framer-1rzdfox": "rgba(255, 255, 255, 0.5)",
        "framer-1v2j9m": "rgba(255, 255, 255, 0.5)",
        "framer-tvwehy": "rgba(255, 255, 255, 0.5)",
        "framer-19gskhe": "rgba(255, 255, 255, 0.5)",
        "framer-1r7znae": "rgba(255, 255, 255, 0.5)",
        "framer-1x9ttau": "rgba(255, 255, 255, 0.5)",
        "framer-19qi3rg": "rgba(255, 255, 255, 0.5)",
        "framer-1xazehi": "rgba(255, 255, 255, 0.5)",
        "framer-1vj77jj": "rgba(255, 255, 255, 0.5)",
        "framer-t89g24": "rgba(255, 255, 255, 0.5)",
        "framer-1ouxnre": "rgba(255, 255, 255, 0.5)",
        "framer-9izbi9": "rgba(255, 255, 255, 0.5)",
        "framer-hmhbu9": "rgba(255, 255, 255, 0.5)",
        "framer-ldccnz": "rgba(255, 255, 255, 0.5)",
        "framer-12qua62": "rgba(255, 255, 255, 0.5)",
        "framer-tn4f9n": "rgba(255, 255, 255, 0.5)",
        "framer-2bdteh": "rgba(255, 255, 255, 0.5)",
        "framer-26x32d": "rgba(255, 255, 255, 0.5)",
        "framer-z23vsj": "rgba(255, 255, 255, 0.5)",
        "framer-161xr59": "rgba(255, 255, 255, 0.5)",
        "framer-tuje6p": "rgba(255, 255, 255, 0.5)",
        "framer-144agw": "rgba(255, 255, 255, 0.5)",
        "framer-1hbb6d9": "rgba(255, 255, 255, 0.5)",
        "framer-1me8sh4": "rgba(255, 255, 255, 0.5)",
        "framer-1umq5aj": "rgba(255, 255, 255, 0.5)",
        "framer-1lhyzal": "rgba(255, 255, 255, 0.5)",
        "framer-1f3n39": "rgba(255, 255, 255, 0.5)",
        "framer-ilf9u3": "rgba(255, 255, 255, 0.5)",
        "framer-1qw0dpv": "rgba(255, 255, 255, 0.5)",
        "framer-1rs1xsd": "rgba(255, 255, 255, 0.5)",
        "framer-1t6lx8u": "rgba(255, 255, 255, 0.5)",
        "framer-7xapi8": "rgba(255, 255, 255, 0.5)",
        "framer-1yp8hos": "rgba(255, 255, 255, 0.5)",
        "framer-i2cq27": "rgba(255, 255, 255, 0.5)",
        "framer-h7ww8p": "rgba(255, 255, 255, 0.5)",
        "framer-1a5x4f6": "rgba(255, 255, 255, 0.5)",
        "framer-1qwmbzn": "rgba(255, 255, 255, 0.5)",
        "framer-1dmcjdq": "rgba(255, 255, 255, 0.5)",
        "framer-1n7pw7r": "rgba(255, 255, 255, 0.5)",
        "framer-1w51idz": "rgba(255, 255, 255, 0.5)",
        "framer-mxy4ao": "rgba(255, 255, 255, 0.5)",
        "framer-81issc": "rgba(255, 255, 255, 0.5)",
        "framer-1w1gkay": "rgba(255, 255, 255, 0.5)",
        "framer-4cpnfq": "rgba(255, 255, 255, 0.05)",
        "framer-1ewcuw0": "rgba(255, 255, 255, 0.5)",
        "framer-pwwysn": "rgba(255, 255, 255, 0.5)",
        "framer-1xtn7vm": "rgba(255, 255, 255, 0.5)",
        "framer-7dxsze": "rgba(255, 255, 255, 0.5)",
        "framer-9ev4bv": "rgba(255, 255, 255, 0.5)",
        "framer-1p7e9u2": "rgba(255, 255, 255, 0.5)",
        "framer-1a59dez": "rgba(255, 255, 255, 0.5)",
        "framer-7fgdhi": "rgba(255, 255, 255, 0.5)",
        "framer-k8j7my": "rgba(255, 255, 255, 0.5)",
        "framer-1ammoj2": "rgba(255, 255, 255, 0.5)",
        "framer-oivdw5": "rgba(255, 255, 255, 0.5)",
        "framer-14f6ekb": "rgba(255, 255, 255, 0.5)",
        "framer-khhuyo": "rgba(255, 255, 255, 0.5)",
        "framer-i2x3iv": "rgba(255, 255, 255, 0.5)",
        "framer-67j55g": "rgba(255, 255, 255, 0.5)",
        "framer-88mozs": "rgba(255, 255, 255, 0.5)",
        "framer-1dmnjar": "rgba(255, 255, 255, 0.5)",
        "framer-ncelpy": "rgba(255, 255, 255, 0.5)",
        "framer-123er8b": "rgba(255, 255, 255, 0.5)",
        "framer-6y7kl8": "rgba(255, 255, 255, 0.5)",
        "framer-1aa5m0p": "rgba(255, 255, 255, 0.5)",
        "framer-16krrxi": "rgba(255, 255, 255, 0.5)",
        "framer-1fn8zqk": "rgba(255, 255, 255, 0.5)",
        "framer-513uhu": "rgba(255, 255, 255, 0.5)",
        "framer-fa2shx": "rgba(255, 255, 255, 0.5)",
        "framer-1xoruxr": "rgba(255, 255, 255, 0.5)",
        "framer-1bihptf": "rgba(255, 255, 255, 0.5)",
        "framer-zrojpi": "rgba(255, 255, 255, 0.5)",
        "framer-cs61ef": "rgba(255, 255, 255, 0.5)",
        "framer-1q93xu9": "rgba(255, 255, 255, 0.5)",
        "framer-ib3bh1": "rgba(255, 255, 255, 0.5)",
        "framer-pbzt1h": "rgba(255, 255, 255, 0.5)",
        "framer-1h1ziie": "rgba(255, 255, 255, 0.5)",
        "framer-114tpb9": "rgba(255, 255, 255, 0.5)",
        "framer-1119xwz": "rgba(255, 255, 255, 0.5)",
        "framer-3c8f8y": "rgba(255, 255, 255, 0.5)",
        "framer-3luccy": "rgba(255, 255, 255, 0.5)",
        "framer-1mht7x2": "rgba(255, 255, 255, 0.5)",
        "framer-mnwipj": "rgba(255, 255, 255, 0.5)",
        "framer-lwj4e": "rgba(255, 255, 255, 0.5)",
        "framer-1ko98em": "rgba(255, 255, 255, 0.5)",
        "framer-17hq2ey": "rgba(255, 255, 255, 0.5)",
        "framer-dlyppx": "rgba(255, 255, 255, 0.5)",
        "framer-3vyltb": "rgba(255, 255, 255, 0.5)",
        "framer-xi0b9s": "rgba(255, 255, 255, 0.5)",
        "framer-bdvmsa": "rgba(255, 255, 255, 0.5)",
        "framer-1u3l0fl": "rgba(255, 255, 255, 0.5)",
        "framer-1yzqxh2": "rgba(255, 255, 255, 0.5)",
        "framer-1vnn6r": "rgba(255, 255, 255, 0.5)",
        "framer-sve3o0": "rgba(255, 255, 255, 0.5)",
        "framer-1p84nt4": "rgba(255, 255, 255, 0.5)",
        "framer-1pxzgce": "rgba(255, 255, 255, 0.5)",
        "framer-1b278qv": "rgba(255, 255, 255, 0.5)",
        "framer-2gnydd": "rgba(255, 255, 255, 0.5)",
        "framer-1137811": "rgba(255, 255, 255, 0.5)",
        "framer-19jj6c3": "rgba(255, 255, 255, 0.5)",
        "framer-1pzn1av": "rgba(255, 255, 255, 0.5)",
        "framer-tvid17": "rgba(255, 255, 255, 0.5)",
        "framer-11c54mx": "rgba(255, 255, 255, 0.5)",
        "framer-nevvim": "rgba(255, 255, 255, 0.5)",
        "framer-9v6bcb": "rgba(255, 255, 255, 0.5)",
        "framer-1vnrxsp": "rgba(255, 255, 255, 0.5)",
        "framer-wjbowq": "rgba(255, 255, 255, 0.5)",
        "framer-12400e0": "rgba(255, 255, 255, 0.5)",
        "framer-1cqo2n8": "rgba(255, 255, 255, 0.5)",
        "framer-qcjss1": "rgba(255, 255, 255, 0.5)",
        "framer-1ni2oxv": "rgba(255, 255, 255, 0.5)",
        "framer-5ztfcs": "rgba(255, 255, 255, 0.5)",
        "framer-154hrzw": "rgba(255, 255, 255, 0.5)",
        "framer-180ez6m": "rgba(255, 255, 255, 0.5)",
        "framer-h09ge5": "rgba(255, 255, 255, 0.5)",
        "framer-1se7318": "rgba(255, 255, 255, 0.5)",
        "framer-xxfm0q": "rgba(255, 255, 255, 0.5)",
        "framer-14apmt9": "rgba(255, 255, 255, 0.5)",
        "framer-3n8q0u": "rgba(255, 255, 255, 0.5)",
        "framer-j9tfzk": "rgba(255, 255, 255, 0.5)",
        "framer-1xd3thf": "rgba(255, 255, 255, 0.5)",
        "framer-1lfwj1u": "rgba(255, 255, 255, 0.5)",
        "framer-6d08mg": "rgba(255, 255, 255, 0.5)",
        "framer-re0cfu": "rgba(255, 255, 255, 0.5)",
        "framer-1iivgo9": "rgba(255, 255, 255, 0.5)",
        "framer-o3z3op": "rgba(255, 255, 255, 0.5)",
        "framer-182hs8p": "rgba(255, 255, 255, 0.5)",
        "framer-1wdiof9": "rgba(255, 255, 255, 0.5)",
        "framer-wwe331": "rgba(255, 255, 255, 0.5)",
        "framer-k8hw6u": "rgba(255, 255, 255, 0.5)",
        "framer-1j2vt7b": "rgba(255, 255, 255, 0.5)",
        "framer-4iiqzy": "rgba(255, 255, 255, 0.5)",
        "framer-1wwf1us": "rgba(255, 255, 255, 0.5)",
        "framer-7neodo": "rgba(255, 255, 255, 0.5)",
        "framer-724voj": "rgba(255, 255, 255, 0.5)",
        "framer-fn7au": "rgba(255, 255, 255, 0.5)",
        "framer-vi0aff": "rgba(255, 255, 255, 0.5)",
        "framer-8ssv48": "rgba(255, 255, 255, 0.5)",
        "framer-172e0pi": "rgba(255, 255, 255, 0.5)",
        "framer-14t05wr": "rgba(255, 255, 255, 0.5)",
        "framer-15pkux9": "rgba(255, 255, 255, 0.5)",
        "framer-jtyaes": "rgba(255, 255, 255, 0.5)",
        "framer-nt3phc": "rgba(255, 255, 255, 0.5)",
        "framer-ayg0jb": "rgba(255, 255, 255, 0.5)",
        "framer-1pztsn9": "rgba(255, 255, 255, 0.5)",
        "framer-lgrx4h": "rgba(255, 255, 255, 0.5)",
        "framer-inxrm5": "rgba(255, 255, 255, 0.5)",
        "framer-1b16f9k": "rgba(255, 255, 255, 0.5)",
        "framer-mh5rnp": "rgba(255, 255, 255, 0.5)",
        "framer-lutab8": "rgba(255, 255, 255, 0.5)",
        "framer-19j46hv": "rgba(255, 255, 255, 0.5)",
        "framer-1nsspm6": "rgba(255, 255, 255, 0.5)",
        "framer-elrkjf": "rgba(255, 255, 255, 0.5)",
        "framer-1aju3s8": "rgba(255, 255, 255, 0.5)",
        "framer-1tryoci": "rgba(255, 255, 255, 0.5)",
        "framer-s0ja87": "rgba(255, 255, 255, 0.5)",
        "framer-64lgy": "rgba(255, 255, 255, 0.04)",
        "framer-1hxr8zf": "rgba(255, 255, 255, 0.04)",
        "framer-4yinfa": "rgba(255, 255, 255, 0.04)",
        "framer-caipz8": "rgba(255, 255, 255, 0.04)",
        "framer-1pbmtd3": "rgba(255, 255, 255, 0.04)",
        "framer-hd47jj": "rgba(255, 255, 255, 0.04)",
        "framer-7waupn": "rgba(255, 255, 255, 0.04)",
        "framer-1w58xeq": "rgba(255, 255, 255, 0.04)",
        "framer-hjf8gm": "rgba(255, 255, 255, 0.04)",
        "framer-35xeoq": "rgba(255, 255, 255, 0.04)",
        "framer-31hql4": "rgba(255, 255, 255, 0.04)",
        "framer-1btvdyn": "rgba(255, 255, 255, 0.04)",
        "framer-17m8ffk": "rgba(255, 255, 255, 0.04)",
        "framer-1cp9zav": "rgba(255, 255, 255, 0.04)",
        "framer-sc8xd3": "rgba(255, 255, 255, 0.04)",
        "framer-1f7kpi4": "rgba(255, 255, 255, 0.04)",
        "framer-piuxkm": "rgba(255, 255, 255, 0.04)",
        "framer-b3utc5": "rgba(255, 255, 255, 0.04)",
        "framer-35276o": "rgba(255, 255, 255, 0.04)",
        "framer-9foe1e": "rgba(255, 255, 255, 0.04)",
        "framer-1p6p5n9": "rgba(255, 255, 255, 0.04)",
        "framer-fxzqdp": "rgba(255, 255, 255, 0.04)",
        "framer-1259uij": "rgba(255, 255, 255, 0.04)",
        "framer-2b7tb1": "rgba(255, 255, 255, 0.04)",
        "framer-1q067af": "rgba(255, 255, 255, 0.04)",
        "framer-1ia009e": "rgba(255, 255, 255, 0.04)",
        "framer-3lymfn": "rgba(255, 255, 255, 0.04)",
        "framer-dqfk43": "rgba(255, 255, 255, 0.04)",
        "framer-1ren7pe": "rgba(255, 255, 255, 0.04)",
        "framer-3fmmvk": "rgba(255, 255, 255, 0.04)",
        "framer-1xf11tn": "rgba(255, 255, 255, 0.04)",
        "framer-1tzghd": "rgba(255, 255, 255, 0.04)",
        "framer-1j37cf1": "rgba(255, 255, 255, 0.04)",
        "framer-1hzhw0m": "rgba(255, 255, 255, 0.04)",
        "framer-1o0bkla": "rgba(255, 255, 255, 0.04)",
        "framer-op6ecw": "rgba(255, 255, 255, 0.04)",
        "framer-1fcx5x1": "rgba(255, 255, 255, 0.04)",
        "framer-1rby5nx": "rgba(255, 255, 255, 0.04)",
        "framer-1kjsbwd": "rgba(255, 255, 255, 0.04)",
        "framer-1ojfxs9": "rgba(255, 255, 255, 0.04)",
        "framer-z6ek3k": "rgba(255, 255, 255, 0.04)",
        "framer-1qhbfh6": "rgba(255, 255, 255, 0.04)",
        "framer-1pj0haq": "rgba(255, 255, 255, 0.04)",
        "framer-vd0s5d": "rgba(255, 255, 255, 0.04)",
        "framer-1e93pup": "rgba(255, 255, 255, 0.04)",
        "framer-h9oic": "rgba(255, 255, 255, 0.04)",
        "framer-jo8cx0": "rgba(255, 255, 255, 0.04)",
        "framer-1f8ru9z": "rgba(255, 255, 255, 0.04)",
        "framer-1n4ht9o": "rgba(255, 255, 255, 0.04)",
        "framer-d353th": "rgba(255, 255, 255, 0.04)",
        "framer-13orx46": "rgba(255, 255, 255, 0.04)",
        "framer-14izw09": "rgba(255, 255, 255, 0.04)",
        "framer-1ibkax": "rgba(255, 255, 255, 0.04)",
        "framer-r24ou6": "rgba(255, 255, 255, 0.04)",
        "framer-5pakqt": "rgba(255, 255, 255, 0.04)",
        "framer-1d4yakz": "rgba(255, 255, 255, 0.04)",
        "framer-19985uk": "rgba(255, 255, 255, 0.04)",
        "framer-gb01s5": "rgba(255, 255, 255, 0.04)",
        "framer-wcsctp": "rgba(255, 255, 255, 0.04)",
        "framer-gbxnjm": "rgba(255, 255, 255, 0.04)",
        "framer-1n3latx": "rgba(255, 255, 255, 0.04)",
        "framer-ww49ko": "rgba(255, 255, 255, 0.04)",
        "framer-wuga8j": "rgba(255, 255, 255, 0.04)",
        "framer-19eh725": "rgba(255, 255, 255, 0.04)",
        "framer-spao7m": "rgba(255, 255, 255, 0.04)",
        "framer-p37xcr": "rgba(255, 255, 255, 0.04)",
        "framer-9lae15": "rgba(255, 255, 255, 0.04)",
        "framer-1djurc4": "rgba(255, 255, 255, 0.04)",
        "framer-1f9z9h2": "rgba(255, 255, 255, 0.04)",
        "framer-4nf7cp": "rgba(255, 255, 255, 0.04)",
        "framer-ib6lq2": "rgba(255, 255, 255, 0.04)",
        "framer-16jrhdt": "rgba(255, 255, 255, 0.04)",
        "framer-pb4qx6": "rgba(255, 255, 255, 0.04)",
        "framer-1bnvsbw": "rgba(255, 255, 255, 0.04)",
        "framer-svuws1": "rgba(255, 255, 255, 0.04)",
        "framer-18vrrai": "rgba(255, 255, 255, 0.04)",
        "framer-p75je3": "rgba(255, 255, 255, 0.04)",
        "framer-1oim4ap": "rgba(255, 255, 255, 0.04)",
        "framer-ets58q": "rgba(255, 255, 255, 0.04)",
        "framer-189qgi": "rgba(255, 255, 255, 0.04)",
        "framer-1se8eji": "rgba(255, 255, 255, 0.04)",
        "framer-xpdw0t": "rgba(255, 255, 255, 0.04)",
        "framer-114gjxu": "rgba(255, 255, 255, 0.04)",
        "framer-1ckranj": "rgba(255, 255, 255, 0.04)",
        "framer-yd49zj": "rgba(255, 255, 255, 0.04)",
        "framer-832d6a": "rgba(255, 255, 255, 0.04)",
        "framer-9j1mqt": "rgba(255, 255, 255, 0.04)",
        "framer-15qmn6v": "rgba(255, 255, 255, 0.04)",
        "framer-bosrq5": "rgba(255, 255, 255, 0.04)",
        "framer-e7rxl7": "rgba(255, 255, 255, 0.04)",
        "framer-t0me7w": "rgba(255, 255, 255, 0.04)",
        "framer-arxyzc": "rgba(255, 255, 255, 0.04)",
        "framer-w1f0c5": "rgba(255, 255, 255, 0.04)",
        "framer-1gx2zd": "rgba(255, 255, 255, 0.04)",
        "framer-1l5jzao": "rgba(255, 255, 255, 0.04)",
        "framer-lfxxyo": "rgba(255, 255, 255, 0.04)",
        "framer-1938ukf": "rgba(255, 255, 255, 0.04)",
        "framer-1uz9g4b": "rgba(255, 255, 255, 0.04)",
        "framer-skhb4e": "rgba(255, 255, 255, 0.04)",
        "framer-1nc562f": "rgba(255, 255, 255, 0.04)",
        "framer-1r1nb90": "rgba(255, 255, 255, 0.04)",
        "framer-1l7p7cw": "rgba(255, 255, 255, 0.04)",
        "framer-bbd8ba": "rgba(255, 255, 255, 0.04)",
        "framer-174359s": "rgba(255, 255, 255, 0.04)",
        "framer-o1cm7l": "rgba(255, 255, 255, 0.04)",
        "framer-1r2q58v": "rgba(255, 255, 255, 0.04)",
        "framer-ckhbc1": "rgba(255, 255, 255, 0.04)",
        "framer-25euhf": "rgba(255, 255, 255, 0.04)",
        "framer-1bg9jqr": "rgba(255, 255, 255, 0.04)",
        "framer-1hp2xsm": "rgba(255, 255, 255, 0.04)",
        "framer-1w08ot3": "rgba(255, 255, 255, 0.04)",
        "framer-hzs6gu": "rgba(255, 255, 255, 0.04)",
        "framer-1tn0auv": "rgba(255, 255, 255, 0.04)",
        "framer-1yuauh0": "rgba(255, 255, 255, 0.04)",
        "framer-q39ych": "rgba(255, 255, 255, 0.04)",
        "framer-1la9doo": "rgba(255, 255, 255, 0.04)",
        "framer-1i6s172": "rgba(255, 255, 255, 0.04)",
        "framer-1bhiwq4": "rgba(255, 255, 255, 0.04)",
        "framer-1finjmh": "rgba(255, 255, 255, 0.04)",
        "framer-c4f7i5": "rgba(255, 255, 255, 0.04)",
        "framer-3ba7y6": "rgba(255, 255, 255, 0.04)",
        "framer-8o5z7u": "rgba(255, 255, 255, 0.04)",
        "framer-5vb13r": "rgba(255, 255, 255, 0.04)",
        "framer-1qg8j5j": "rgba(255, 255, 255, 0.04)",
        "framer-1cpq7cz": "rgba(255, 255, 255, 0.04)",
        "framer-1e24whu": "rgba(255, 255, 255, 0.04)",
        "framer-f9w1b0": "rgba(255, 255, 255, 0.04)",
        "framer-154i7ad": "rgba(255, 255, 255, 0.04)",
        "framer-trnmme": "rgba(255, 255, 255, 0.04)",
        "framer-1g03gzo": "rgba(255, 255, 255, 0.04)",
        "framer-2uv9z5": "rgba(255, 255, 255, 0.04)",
        "framer-1kh10xg": "rgba(255, 255, 255, 0.04)",
        "framer-177340h": "rgba(255, 255, 255, 0.04)",
        "framer-147tj1p": "rgba(255, 255, 255, 0.04)",
        "framer-1cjjf7q": "rgba(255, 255, 255, 0.04)",
        "framer-jjeffs": "rgba(255, 255, 255, 0.04)",
        "framer-b3oq5w": "rgba(255, 255, 255, 0.04)",
        "framer-lgkn64": "rgba(255, 255, 255, 0.04)",
        "framer-ftinbp": "rgba(255, 255, 255, 0.04)",
        "framer-1qgwf2q": "rgba(255, 255, 255, 0.04)",
        "framer-1s1q0zj": "rgba(255, 255, 255, 0.04)",
        "framer-szasz2": "rgba(255, 255, 255, 0.04)",
        "framer-1bh2qom": "rgba(255, 255, 255, 0.04)",
        "framer-vbr5qt": "rgba(255, 255, 255, 0.04)",
        "framer-ayiqn": "rgba(255, 255, 255, 0.04)",
        "framer-ng52my": "rgba(255, 255, 255, 0.04)",
        "framer-1qc3xh2": "rgba(255, 255, 255, 0.04)",
        "framer-17xhwxn": "rgba(255, 255, 255, 0.04)",
        "framer-kd3teb": "rgba(255, 255, 255, 0.04)",
        "framer-1ds9pvm": "rgba(255, 255, 255, 0.04)",
        "framer-9ou7kr": "rgba(255, 255, 255, 0.04)",
        "framer-19hkz1m": "rgba(255, 255, 255, 0.04)",
        "framer-z7coyc": "rgba(255, 255, 255, 0.04)",
        "framer-hxqr6r": "rgba(255, 255, 255, 0.04)",
        "framer-ssdjgy": "rgba(255, 255, 255, 0.04)",
        "framer-170fwp7": "rgba(255, 255, 255, 0.04)",
        "framer-iorqmd": "rgba(255, 255, 255, 0.04)",
        "framer-ly5had": "rgba(255, 255, 255, 0.04)",
        "framer-kyuip0": "rgba(255, 255, 255, 0.04)",
        "framer-m2toq0": "rgba(255, 255, 255, 0.04)",
        "framer-1hak2gy": "rgba(255, 255, 255, 0.04)",
        "framer-oe69v3": "rgba(255, 255, 255, 0.04)",
        "framer-tfrupv": "rgba(255, 255, 255, 0.04)",
        "framer-ados7m": "rgba(255, 255, 255, 0.04)",
        "framer-1b1arxe": "rgba(255, 255, 255, 0.04)",
        "framer-t2bzkx": "rgba(255, 255, 255, 0.04)",
        "framer-19h60xi": "rgba(255, 255, 255, 0.04)",
        "framer-1roowyp": "rgba(255, 255, 255, 0.04)",
        "framer-b33ovj": "rgba(255, 255, 255, 0.04)",
        "framer-2xrhr6": "rgba(255, 255, 255, 0.04)",
        "framer-bp4hmm": "rgba(255, 255, 255, 0.04)",
        "framer-bj9ogc": "rgba(255, 255, 255, 0.04)",
        "framer-dv99ve": "rgba(255, 255, 255, 0.04)",
        "framer-1o691fb": "rgba(255, 255, 255, 0.04)",
        "framer-1o7i21q": "rgba(255, 255, 255, 0.04)",
        "framer-7y8ymw": "rgba(255, 255, 255, 0.04)",
        "framer-259e94": "rgba(255, 255, 255, 0.04)",
        "framer-1vrgp1i": "rgba(255, 255, 255, 0.04)",
        "framer-1hkr8gz": "rgba(255, 255, 255, 0.04)",
        "framer-1cpl3ru": "rgba(255, 255, 255, 0.04)",
        "framer-4vg5fm": "rgba(255, 255, 255, 0.04)",
        "framer-6yep7x": "rgba(255, 255, 255, 0.04)",
        "framer-yo90z1": "rgba(255, 255, 255, 0.04)",
        "framer-1ffyrfe": "rgba(255, 255, 255, 0.04)",
        "framer-17sy2h9": "rgba(255, 255, 255, 0.04)",
        "framer-1nexr12": "rgba(255, 255, 255, 0.04)",
        "framer-1nxam09": "rgba(255, 255, 255, 0.04)",
        "framer-1u7tsmf": "rgba(255, 255, 255, 0.04)",
        "framer-1s1lgs9": "rgba(255, 255, 255, 0.04)",
        "framer-1tsc97t": "rgba(255, 255, 255, 0.04)",
        "framer-1lik10g": "rgba(255, 255, 255, 0.04)",
        "framer-w91j3h": "rgba(255, 255, 255, 0.04)",
        "framer-1t0gcur": "rgba(255, 255, 255, 0.04)",
        "framer-7i1u99": "rgba(255, 255, 255, 0.04)",
        "framer-zeyecd": "rgba(255, 255, 255, 0.04)",
        "framer-1sm3fde": "rgba(255, 255, 255, 0.04)",
        "framer-hpfi4e": "rgba(255, 255, 255, 0.04)",
        "framer-11nihoc": "rgba(255, 255, 255, 0.04)",
        "framer-dyf9qm": "rgba(255, 255, 255, 0.04)",
        "framer-issvd8": "rgba(255, 255, 255, 0.04)",
        "framer-wtmsdd": "rgba(255, 255, 255, 0.04)",
        "framer-1b7vdsu": "rgba(255, 255, 255, 0.04)",
        "framer-mhhl4m": "rgba(255, 255, 255, 0.04)",
        "framer-kr5yb3": "rgba(255, 255, 255, 0.04)",
        "framer-8s5abl": "rgba(255, 255, 255, 0.04)",
        "framer-f20w32": "rgba(255, 255, 255, 0.04)",
        "framer-1v5wb0d": "rgba(255, 255, 255, 0.04)",
        "framer-4tlth8": "rgba(255, 255, 255, 0.04)",
        "framer-kxfckx": "rgba(255, 255, 255, 0.04)",
        "framer-69n7ji": "rgba(255, 255, 255, 0.04)",
        "framer-1qqpucz": "rgba(255, 255, 255, 0.04)",
        "framer-1kt8yiq": "rgba(255, 255, 255, 0.04)",
        "framer-1qoqjv3": "rgba(255, 255, 255, 0.04)",
        "framer-16obh5m": "rgba(255, 255, 255, 0.04)",
        "framer-1tpfy33": "rgba(255, 255, 255, 0.04)",
        "framer-zxg4my": "rgba(255, 255, 255, 0.04)",
        "framer-c9ojjv": "rgba(255, 255, 255, 0.04)",
        "framer-1j4u6r2": "rgba(255, 255, 255, 0.04)",
        "framer-tclpau": "rgba(255, 255, 255, 0.04)",
        "framer-1ni6xjv": "rgba(255, 255, 255, 0.04)",
        "framer-1es2jab": "rgba(255, 255, 255, 0.04)",
        "framer-10jrcc6": "rgba(255, 255, 255, 0.04)",
        "framer-jcrjvd": "rgba(255, 255, 255, 0.04)",
        "framer-bvrrkp": "rgba(255, 255, 255, 0.04)",
        "framer-18mdrb0": "rgba(255, 255, 255, 0.04)",
        "framer-19ufz0c": "rgba(255, 255, 255, 0.04)",
        "framer-a4eq25": "rgba(255, 255, 255, 0.04)",
        "framer-fnwwxo": "rgba(255, 255, 255, 0.04)",
        "framer-1wyam6m": "rgba(255, 255, 255, 0.04)",
        "framer-1pp6x1n": "rgba(255, 255, 255, 0.04)",
        "framer-1kx8h30": "rgba(255, 255, 255, 0.04)",
        "framer-38qo6l": "rgba(255, 255, 255, 0.04)",
        "framer-1bgkq86": "rgba(255, 255, 255, 0.04)",
        "framer-1odgaps": "rgba(255, 255, 255, 0.04)",
        "framer-ocebul": "rgba(255, 255, 255, 0.04)",
        "framer-htsvoh": "rgba(255, 255, 255, 0.04)",
        "framer-1rjcid1": "rgba(255, 255, 255, 0.04)",
        "framer-1ppu9nu": "rgba(255, 255, 255, 0.04)",
        "framer-b26c6s": "rgba(255, 255, 255, 0.04)",
        "framer-k15ji": "rgba(255, 255, 255, 0.04)",
        "framer-w1jb1u": "rgba(255, 255, 255, 0.04)",
        "framer-1b65fof": "rgba(255, 255, 255, 0.04)",
        "framer-ag946t": "rgba(255, 255, 255, 0.04)",
        "framer-njpiav": "rgba(255, 255, 255, 0.04)",
        "framer-fzosm0": "rgba(255, 255, 255, 0.04)",
        "framer-31j99c": "rgba(255, 255, 255, 0.04)",
        "framer-wbharp": "rgba(255, 255, 255, 0.04)",
        "framer-1o6h43g": "rgba(255, 255, 255, 0.04)",
        "framer-w8h1i4": "rgba(255, 255, 255, 0.04)",
        "framer-u08o4f": "rgba(255, 255, 255, 0.04)",
        "framer-1883ili": "rgba(255, 255, 255, 0.04)",
        "framer-hhqq21": "rgba(255, 255, 255, 0.04)",
        "framer-1qddyrc": "rgba(255, 255, 255, 0.04)",
        "framer-36rsch": "rgba(255, 255, 255, 0.04)",
        "framer-1vhup78": "rgba(255, 255, 255, 0.04)",
        "framer-1wy0vut": "rgba(255, 255, 255, 0.04)",
        "framer-1tldixq": "rgba(255, 255, 255, 0.04)",
        "framer-vcglv4": "rgba(255, 255, 255, 0.04)",
        "framer-mnkyk9": "rgba(255, 255, 255, 0.04)",
        "framer-1gd8uia": "rgba(255, 255, 255, 0.04)",
        "framer-4v17kk": "rgba(255, 255, 255, 0.04)",
        "framer-wcgbdx": "rgba(255, 255, 255, 0.04)",
        "framer-19ge0mq": "rgba(255, 255, 255, 0.04)",
        "framer-142xl0d": "rgba(255, 255, 255, 0.04)",
        "framer-ao5kmt": "rgba(255, 255, 255, 0.04)",
        "framer-1rc6i1r": "rgba(255, 255, 255, 0.04)",
        "framer-1wlwqo": "rgba(255, 255, 255, 0.04)",
        "framer-1tzx2st": "rgba(255, 255, 255, 0.04)",
        "framer-z8gsz9": "rgba(255, 255, 255, 0.04)",
        "framer-1fgz62q": "rgba(255, 255, 255, 0.04)",
        "framer-n6tpd7": "rgba(255, 255, 255, 0.04)",
        "framer-1otl1h8": "rgba(255, 255, 255, 0.04)",
        "framer-1vi730u": "rgba(255, 255, 255, 0.04)",
        "framer-1klteqi": "rgba(255, 255, 255, 0.04)",
        "framer-36msax": "rgba(255, 255, 255, 0.04)",
        "framer-1feur12": "rgba(255, 255, 255, 0.04)",
        "framer-1lyqxag": "rgba(255, 255, 255, 0.04)",
        "framer-5a7aqr": "rgba(255, 255, 255, 0.04)",
        "framer-82cjev": "rgba(255, 255, 255, 0.04)",
        "framer-10a7t8v": "rgba(255, 255, 255, 0.04)",
        "framer-7pex0i": "rgba(255, 255, 255, 0.04)",
        "framer-1r4ihlp": "rgba(255, 255, 255, 0.04)",
        "framer-1cjy5e6": "rgba(255, 255, 255, 0.04)",
        "framer-1f59xpm": "rgba(255, 255, 255, 0.04)",
        "framer-13qpo9p": "rgba(255, 255, 255, 0.04)",
        "framer-160oi7c": "rgba(255, 255, 255, 0.04)",
        "framer-8v07ff": "rgba(255, 255, 255, 0.04)",
        "framer-ry0yv5": "rgba(255, 255, 255, 0.04)",
        "framer-427f3i": "rgba(255, 255, 255, 0.04)",
        "framer-jufpfh": "rgba(255, 255, 255, 0.04)",
        "framer-1c3n6lw": "rgba(255, 255, 255, 0.04)",
        "framer-ekq5up": "rgba(255, 255, 255, 0.04)",
        "framer-1ki962m": "rgba(255, 255, 255, 0.04)",
        "framer-15t1dfp": "rgba(255, 255, 255, 0.04)",
        "framer-3s7e4w": "rgba(255, 255, 255, 0.04)",
        "framer-1w1r0c7": "rgba(255, 255, 255, 0.04)",
        "framer-cvvwij": "rgba(255, 255, 255, 0.04)",
        "framer-1vpvxxf": "rgba(255, 255, 255, 0.04)",
        "framer-149u646": "rgba(255, 255, 255, 0.04)",
        "framer-1o7mum0": "rgba(255, 255, 255, 0.04)",
        "framer-ki1v17": "rgba(255, 255, 255, 0.04)",
        "framer-lhdvz8": "rgba(255, 255, 255, 0.04)",
        "framer-jy0fht": "rgba(255, 255, 255, 0.04)",
        "framer-99ymz4": "rgba(255, 255, 255, 0.04)",
        "framer-p09ia0": "rgba(255, 255, 255, 0.04)",
        "framer-13ehaqm": "rgba(255, 255, 255, 0.04)",
        "framer-1wbmnsw": "rgba(255, 255, 255, 0.04)",
        "framer-1ikz5w4": "rgba(255, 255, 255, 0.04)",
        "framer-z4q1to": "rgba(255, 255, 255, 0.04)",
        "framer-18xz9es": "rgba(255, 255, 255, 0.04)",
        "framer-1l729uo": "rgba(255, 255, 255, 0.04)",
        "framer-ft28bw": "rgba(255, 255, 255, 0.04)",
        "framer-1ewgg5n": "rgba(255, 255, 255, 0.04)",
        "framer-1qmstsw": "rgba(255, 255, 255, 0.04)",
        "framer-cxuw29": "rgba(255, 255, 255, 0.04)",
        "framer-cg40le": "rgba(255, 255, 255, 0.04)",
        "framer-dutair": "rgba(255, 255, 255, 0.04)",
        "framer-4oapi9": "rgba(255, 255, 255, 0.04)",
        "framer-1erawlh": "rgba(255, 255, 255, 0.04)",
        "framer-1y5k2gj": "rgba(255, 255, 255, 0.04)",
        "framer-1lbic0v": "rgba(255, 255, 255, 0.04)",
        "framer-1opocxv": "rgba(255, 255, 255, 0.04)",
        "framer-12khtk0": "rgba(255, 255, 255, 0.04)",
        "framer-bwyhrh": "rgba(255, 255, 255, 0.04)",
        "framer-1uubtjq": "rgba(255, 255, 255, 0.04)",
        "framer-140mxx7": "rgba(255, 255, 255, 0.04)",
        "framer-1cx2l59": "rgba(255, 255, 255, 0.04)",
        "framer-11lvdrf": "rgba(255, 255, 255, 0.04)",
        "framer-10s17r7": "rgba(255, 255, 255, 0.04)",
        "framer-1jsn0l4": "rgba(255, 255, 255, 0.04)",
        "framer-7xfhaj": "rgba(255, 255, 255, 0.04)",
        "framer-1rrd2yl": "rgba(255, 255, 255, 0.04)",
        "framer-wr2mdi": "rgba(255, 255, 255, 0.04)",
        "framer-tm9wqz": "rgba(255, 255, 255, 0.04)",
        "framer-112ouxp": "rgba(255, 255, 255, 0.04)",
        "framer-1wn4wwg": "rgba(255, 255, 255, 0.04)",
        "framer-1qbbaf": "rgba(255, 255, 255, 0.04)",
        "framer-rxy7g3": "rgba(255, 255, 255, 0.04)",
        "framer-18g76l8": "rgba(255, 255, 255, 0.04)",
        "framer-s30zx7": "rgba(255, 255, 255, 0.04)",
        "framer-116wxpu": "rgba(255, 255, 255, 0.04)",
        "framer-1c5xnue": "rgba(255, 255, 255, 0.04)",
        "framer-qf8qx3": "rgba(255, 255, 255, 0.04)",
        "framer-1odc6hn": "rgba(255, 255, 255, 0.04)",
        "framer-19ap9de": "rgba(255, 255, 255, 0.04)",
        "framer-1vff8z3": "rgba(255, 255, 255, 0.04)",
        "framer-ythjyv": "rgba(255, 255, 255, 0.04)",
        "framer-9z37yi": "rgba(255, 255, 255, 0.04)",
        "framer-16w1k6o": "rgba(255, 255, 255, 0.04)",
        "framer-1xcik3l": "rgba(255, 255, 255, 0.04)",
        "framer-oukkhq": "rgba(255, 255, 255, 0.04)",
        "framer-lqila1": "rgba(255, 255, 255, 0.04)",
        "framer-1fdpwik": "rgba(255, 255, 255, 0.04)",
        "framer-ekzdww": "rgba(255, 255, 255, 0.04)",
        "framer-m2a85j": "rgba(255, 255, 255, 0.04)",
        "framer-41rnem": "rgba(255, 255, 255, 0.04)",
        "framer-19zo0xy": "rgba(255, 255, 255, 0.04)",
        "framer-xk8c1l": "rgba(255, 255, 255, 0.04)",
        "framer-lvrz1c": "rgba(255, 255, 255, 0.04)",
        "framer-x277m4": "rgba(255, 255, 255, 0.04)",
        "framer-jkqkpl": "rgba(255, 255, 255, 0.04)",
        "framer-5hr7x3": "rgba(255, 255, 255, 0.04)",
        "framer-1m0phhu": "rgba(255, 255, 255, 0.04)",
        "framer-yi8kxp": "rgba(255, 255, 255, 0.04)",
        "framer-1rjqh9s": "rgba(255, 255, 255, 0.04)",
        "framer-g47dyw": "rgba(255, 255, 255, 0.04)",
        "framer-q0k5a6": "rgba(255, 255, 255, 0.04)",
        "framer-pcgh1x": "rgba(255, 255, 255, 0.04)",
        "framer-xw0rvq": "rgba(255, 255, 255, 0.04)",
        "framer-c3k2a9": "rgba(255, 255, 255, 0.04)",
        "framer-1pdnlep": "rgba(255, 255, 255, 0.04)",
        "framer-1isj3ve": "rgba(255, 255, 255, 0.04)",
        "framer-1nzo316": "rgba(255, 255, 255, 0.04)",
        "framer-ny2nrf": "rgba(255, 255, 255, 0.04)",
        "framer-1dtzjxr": "rgba(255, 255, 255, 0.04)",
        "framer-mu508z": "rgba(255, 255, 255, 0.04)",
        "framer-qpfp6n": "rgba(255, 255, 255, 0.04)",
        "framer-14eawsu": "rgba(255, 255, 255, 0.04)",
        "framer-s21ssb": "rgba(255, 255, 255, 0.04)",
        "framer-hqplw1": "rgba(255, 255, 255, 0.04)",
        "framer-bklpz1": "rgba(255, 255, 255, 0.04)",
        "framer-1imnrwl": "rgba(255, 255, 255, 0.04)",
        "framer-gzpem3": "rgba(255, 255, 255, 0.04)",
        "framer-1idhh85": "rgba(255, 255, 255, 0.04)",
        "framer-1j46jly": "rgba(255, 255, 255, 0.04)",
        "framer-1dsuymd": "rgba(255, 255, 255, 0.04)",
        "framer-zogoby": "rgba(255, 255, 255, 0.04)",
        "framer-1d3g9c1": "rgba(255, 255, 255, 0.04)",
        "framer-1o544t5": "rgba(255, 255, 255, 0.04)",
        "framer-1m6q3w4": "rgba(255, 255, 255, 0.04)",
        "framer-mg2djc": "rgba(255, 255, 255, 0.04)",
        "framer-17ralnl": "rgba(255, 255, 255, 0.04)",
        "framer-1rurt58": "rgba(255, 255, 255, 0.04)",
        "framer-gf48he": "rgba(255, 255, 255, 0.04)",
        "framer-17zgy7z": "rgba(255, 255, 255, 0.04)",
        "framer-1rzm2gb": "rgba(255, 255, 255, 0.04)",
        "framer-y89xtg": "rgba(255, 255, 255, 0.04)",
        "framer-106i2vh": "rgba(255, 255, 255, 0.04)",
        "framer-p1tl7s": "rgba(255, 255, 255, 0.04)",
        "framer-mtqgug": "rgba(255, 255, 255, 0.04)",
        "framer-1788u0c": "rgba(255, 255, 255, 0.04)",
        "framer-1wmn822": "rgba(255, 255, 255, 0.04)",
        "framer-1v5bd5y": "rgba(255, 255, 255, 0.04)",
        "framer-uo544c": "rgba(255, 255, 255, 0.04)",
        "framer-7qtus5": "rgba(255, 255, 255, 0.04)",
        "framer-gqq0zi": "rgba(255, 255, 255, 0.04)",
        "framer-1drnvw6": "rgba(255, 255, 255, 0.04)",
        "framer-17z9tw4": "rgba(255, 255, 255, 0.04)",
        "framer-3bymer": "rgba(255, 255, 255, 0.04)",
        "framer-mnk1l5": "rgba(255, 255, 255, 0.04)",
        "framer-m79my0": "rgba(255, 255, 255, 0.04)",
        "framer-14o7iob": "rgba(255, 255, 255, 0.04)",
        "framer-wez924": "rgba(255, 255, 255, 0.04)",
        "framer-1mgfm9b": "rgba(255, 255, 255, 0.04)",
        "framer-45l0gt": "rgba(255, 255, 255, 0.04)",
        "framer-zf9unh": "rgba(255, 255, 255, 0.04)",
        "framer-11ud222": "rgba(255, 255, 255, 0.04)",
        "framer-1mzlzv1": "rgba(255, 255, 255, 0.04)",
        "framer-1fib5c": "rgba(255, 255, 255, 0.04)",
        "framer-oaiogv": "rgba(255, 255, 255, 0.04)",
        "framer-zep14j": "rgba(255, 255, 255, 0.04)",
        "framer-1brj1ht": "rgba(255, 255, 255, 0.04)",
        "framer-1pqx6tg": "rgba(255, 255, 255, 0.04)",
        "framer-2wbw88": "rgba(255, 255, 255, 0.04)",
        "framer-97hh1c": "rgba(255, 255, 255, 0.04)",
        "framer-1scvxj2": "rgba(255, 255, 255, 0.04)",
        "framer-usy4xf": "rgba(255, 255, 255, 0.04)",
        "framer-1nrqj7q": "rgba(255, 255, 255, 0.04)",
        "framer-1l8jyo7": "rgba(255, 255, 255, 0.04)",
        "framer-1wj5wmr": "rgba(255, 255, 255, 0.04)",
        "framer-5dbofz": "rgba(255, 255, 255, 0.04)",
        "framer-1p29g0f": "rgba(255, 255, 255, 0.04)",
        "framer-13hsqgp": "rgba(255, 255, 255, 0.04)",
        "framer-k3f6s7": "rgba(255, 255, 255, 0.04)",
        "framer-czp6kw": "rgba(255, 255, 255, 0.04)",
        "framer-b8p4so": "rgba(255, 255, 255, 0.04)",
        "framer-td5exg": "rgba(255, 255, 255, 0.04)",
        "framer-rlul9t": "rgba(255, 255, 255, 0.04)",
        "framer-1qbi01j": "rgba(255, 255, 255, 0.04)",
        "framer-11yihtu": "rgba(255, 255, 255, 0.04)",
        "framer-1jw3h1j": "rgba(255, 255, 255, 0.04)",
        "framer-1982gyu": "rgba(255, 255, 255, 0.04)",
        "framer-1kx8z1s": "rgba(255, 255, 255, 0.04)",
        "framer-1jo2xb0": "rgba(255, 255, 255, 0.04)",
        "framer-ozo1q7": "rgba(255, 255, 255, 0.04)",
        "framer-lndw3q": "rgba(255, 255, 255, 0.04)",
        "framer-1ggyd5i": "rgba(255, 255, 255, 0.04)",
        "framer-1hi908g": "rgba(255, 255, 255, 0.04)",
        "framer-1y8hrwf": "rgba(255, 255, 255, 0.04)",
        "framer-bnxcb5": "rgba(255, 255, 255, 0.04)",
        "framer-6ip5m0": "rgba(255, 255, 255, 0.04)",
        "framer-5lgj4i": "rgba(255, 255, 255, 0.04)",
        "framer-15gcew7": "rgba(255, 255, 255, 0.04)",
        "framer-1h71ow4": "rgba(255, 255, 255, 0.04)",
        "framer-1n1itqm": "rgba(255, 255, 255, 0.04)",
        "framer-yyvhfo": "rgba(255, 255, 255, 0.04)",
        "framer-1fh5h8g": "rgba(255, 255, 255, 0.04)",
        "framer-1xq5s95": "rgba(255, 255, 255, 0.04)",
        "framer-tecic8": "rgba(255, 255, 255, 0.04)",
        "framer-cdfvoq": "rgba(255, 255, 255, 0.04)",
        "framer-1gkcgnr": "rgba(255, 255, 255, 0.04)",
        "framer-1xajlqd": "rgba(255, 255, 255, 0.04)",
        "framer-wobegw": "rgba(255, 255, 255, 0.04)",
        "framer-xezr57": "rgba(255, 255, 255, 0.04)",
        "framer-is8obf": "rgba(255, 255, 255, 0.04)",
        "framer-1adwqk8": "rgba(255, 255, 255, 0.04)",
        "framer-zgffy0": "rgba(255, 255, 255, 0.04)",
        "framer-1j53vuy": "rgba(255, 255, 255, 0.04)",
        "framer-xsn7x8": "rgba(255, 255, 255, 0.04)",
        "framer-1s80omz": "rgba(255, 255, 255, 0.04)",
        "framer-k6zy4o": "rgba(255, 255, 255, 0.04)",
        "framer-1wflc0e": "rgba(255, 255, 255, 0.04)",
        "framer-2rt8zl": "rgba(255, 255, 255, 0.04)",
        "framer-1drs3dv": "rgba(255, 255, 255, 0.04)",
        "framer-f4fnpl": "rgba(255, 255, 255, 0.04)",
        "framer-1oh6k57": "rgba(255, 255, 255, 0.04)",
        "framer-15ghu57": "rgba(255, 255, 255, 0.04)",
        "framer-u9hm8p": "rgba(255, 255, 255, 0.04)",
        "framer-9ayv4y": "rgba(255, 255, 255, 0.04)",
        "framer-uiax3g": "rgba(255, 255, 255, 0.04)",
        "framer-nhfppx": "rgba(255, 255, 255, 0.04)",
        "framer-10skth4": "rgba(255, 255, 255, 0.04)",
        "framer-zvsym": "rgba(255, 255, 255, 0.04)",
        "framer-1dguqyv": "rgba(255, 255, 255, 0.04)",
        "framer-10j66y7": "rgba(255, 255, 255, 0.04)",
        "framer-asyr5b": "rgba(255, 255, 255, 0.04)",
        "framer-1kiw2qy": "rgba(255, 255, 255, 0.04)",
        "framer-f4zdyj": "rgba(255, 255, 255, 0.04)",
        "framer-qp5ir6": "rgba(255, 255, 255, 0.04)",
        "framer-ugpy4l": "rgba(255, 255, 255, 0.04)",
        "framer-1v5qg4b": "rgba(255, 255, 255, 0.04)",
        "framer-l8awnf": "rgba(255, 255, 255, 0.04)",
        "framer-1gmovvw": "rgba(255, 255, 255, 0.04)",
        "framer-sutdmt": "rgba(255, 255, 255, 0.04)",
        "framer-1trny2v": "rgba(255, 255, 255, 0.04)",
        "framer-1cdohfe": "rgba(255, 255, 255, 0.04)",
        "framer-t9fqjc": "rgba(255, 255, 255, 0.04)",
        "framer-1xtosav": "rgba(255, 255, 255, 0.04)",
        "framer-vk3hjo": "rgba(255, 255, 255, 0.04)",
        "framer-sreof1": "rgba(255, 255, 255, 0.04)",
        "framer-3qmhxn": "rgba(255, 255, 255, 0.04)",
        "framer-hplkdw": "rgba(255, 255, 255, 0.04)",
        "framer-1pthapd": "rgba(255, 255, 255, 0.04)",
        "framer-xc32tt": "rgba(255, 255, 255, 0.04)",
        "framer-1u11iky": "rgba(255, 255, 255, 0.04)",
        "framer-d6cngf": "rgba(255, 255, 255, 0.04)",
        "framer-1i34tns": "rgba(255, 255, 255, 0.04)",
        "framer-906618": "rgba(255, 255, 255, 0.04)",
        "framer-1y2a24g": "rgba(255, 255, 255, 0.04)",
        "framer-1i7zrv5": "rgba(255, 255, 255, 0.04)",
        "framer-1suuahx": "rgba(255, 255, 255, 0.04)",
        "framer-1oyg0cr": "rgba(255, 255, 255, 0.04)",
        "framer-n55er7": "rgba(255, 255, 255, 0.04)",
        "framer-1en2cnq": "rgba(255, 255, 255, 0.04)",
        "framer-psjjo8": "rgba(255, 255, 255, 0.04)",
        "framer-14r2wfh": "rgba(255, 255, 255, 0.04)",
        "framer-fbzlsf": "rgba(255, 255, 255, 0.04)",
        "framer-vmchm3": "rgba(255, 255, 255, 0.04)",
        "framer-i91vgm": "rgba(255, 255, 255, 0.04)",
        "framer-yi8kes": "rgba(255, 255, 255, 0.04)",
        "framer-1n4420v": "rgba(255, 255, 255, 0.04)",
        "framer-198giob": "rgba(255, 255, 255, 0.04)",
        "framer-g8x8gx": "rgba(255, 255, 255, 0.04)",
        "framer-1mhsv49": "rgba(255, 255, 255, 0.04)",
        "framer-1nh0jro": "rgba(255, 255, 255, 0.04)",
        "framer-1lwq65t": "rgba(255, 255, 255, 0.04)",
        "framer-1qd6oi": "rgba(255, 255, 255, 0.04)",
        "framer-7ps415": "rgba(255, 255, 255, 0.04)",
        "framer-sljn5b": "rgba(255, 255, 255, 0.04)",
        "framer-gbdnvn": "rgba(255, 255, 255, 0.04)",
        "framer-1hbglek": "rgba(255, 255, 255, 0.04)",
        "framer-pdko06": "rgba(255, 255, 255, 0.04)",
        "framer-1mx2enx": "rgba(255, 255, 255, 0.04)",
        "framer-sr9rxt": "rgba(255, 255, 255, 0.04)",
        "framer-68e1wx": "rgba(255, 255, 255, 0.04)",
        "framer-1x2z7rq": "rgba(255, 255, 255, 0.04)",
        "framer-15apzd": "rgba(255, 255, 255, 0.04)",
        "framer-iytitg": "rgba(255, 255, 255, 0.04)",
        "framer-v0ogr5": "rgba(255, 255, 255, 0.04)",
        "framer-9vo8zm": "rgba(255, 255, 255, 0.04)",
        "framer-ud6nss": "rgba(255, 255, 255, 0.04)",
        "framer-978p0s": "rgba(255, 255, 255, 0.04)",
        "framer-8pji0e": "rgba(255, 255, 255, 0.04)",
        "framer-12jhrfd": "rgba(255, 255, 255, 0.04)",
        "framer-d2s7aa": "rgba(255, 255, 255, 0.04)",
        "framer-l0sqmy": "rgba(255, 255, 255, 0.04)",
        "framer-1qa7u6k": "rgba(255, 255, 255, 0.04)",
        "framer-tquodz": "rgba(255, 255, 255, 0.04)",
        "framer-yncmmi": "rgba(255, 255, 255, 0.04)",
        "framer-1xx4aok": "rgba(255, 255, 255, 0.04)",
        "framer-1mqv4oz": "rgba(255, 255, 255, 0.04)",
        "framer-vhaobv": "rgba(255, 255, 255, 0.04)",
        "framer-6pkxu0": "rgba(255, 255, 255, 0.04)",
        "framer-c34o2l": "rgba(255, 255, 255, 0.04)",
        "framer-txmp65": "rgba(255, 255, 255, 0.04)",
        "framer-od41ta": "rgba(255, 255, 255, 0.04)",
        "framer-78b9vw": "rgba(255, 255, 255, 0.04)",
        "framer-p4w8us": "rgba(255, 255, 255, 0.04)",
        "framer-1e1cat9": "rgba(255, 255, 255, 0.04)",
        "framer-47lkyg": "rgba(255, 255, 255, 0.04)",
        "framer-1nyvkz": "rgba(255, 255, 255, 0.04)",
        "framer-16wwq2l": "rgba(255, 255, 255, 0.04)",
        "framer-ohb4se": "rgba(255, 255, 255, 0.04)",
        "framer-fdn6q4": "rgba(255, 255, 255, 0.04)",
        "framer-1rsqnb8": "rgba(255, 255, 255, 0.04)",
        "framer-18lxnea": "rgba(255, 255, 255, 0.04)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (31).html"
    },
    {
      "colors": {
        "framer-64lgy": "rgba(255, 255, 255, 0.05)",
        "framer-1hxr8zf": "rgba(255, 255, 255, 0.9)",
        "framer-4yinfa": "rgba(255, 255, 255, 0.9)",
        "framer-caipz8": "rgba(255, 255, 255, 0.9)",
        "framer-1pbmtd3": "rgba(255, 255, 255, 0.9)",
        "framer-hd47jj": "rgba(255, 255, 255, 0.9)",
        "framer-7waupn": "rgba(255, 255, 255, 0.9)",
        "framer-1w58xeq": "rgba(255, 255, 255, 0.9)",
        "framer-hjf8gm": "rgba(255, 255, 255, 0.9)",
        "framer-35xeoq": "rgba(255, 255, 255, 0.9)",
        "framer-31hql4": "rgba(255, 255, 255, 0.9)",
        "framer-1btvdyn": "rgba(255, 255, 255, 0.9)",
        "framer-17m8ffk": "rgba(255, 255, 255, 0.9)",
        "framer-1cp9zav": "rgba(255, 255, 255, 0.9)",
        "framer-sc8xd3": "rgba(255, 255, 255, 0.9)",
        "framer-1f7kpi4": "rgba(255, 255, 255, 0.9)",
        "framer-piuxkm": "rgba(255, 255, 255, 0.9)",
        "framer-b3utc5": "rgba(255, 255, 255, 0.9)",
        "framer-35276o": "rgba(255, 255, 255, 0.9)",
        "framer-9foe1e": "rgba(255, 255, 255, 0.9)",
        "framer-1p6p5n9": "rgba(255, 255, 255, 0.9)",
        "framer-fxzqdp": "rgba(255, 255, 255, 0.9)",
        "framer-1259uij": "rgba(255, 255, 255, 0.9)",
        "framer-2b7tb1": "rgba(255, 255, 255, 0.9)",
        "framer-1q067af": "rgba(255, 255, 255, 0.9)",
        "framer-1ia009e": "rgba(255, 255, 255, 0.9)",
        "framer-3lymfn": "rgba(255, 255, 255, 0.9)",
        "framer-dqfk43": "rgba(255, 255, 255, 0.9)",
        "framer-1ren7pe": "rgba(255, 255, 255, 0.9)",
        "framer-3fmmvk": "rgba(255, 255, 255, 0.9)",
        "framer-1xf11tn": "rgba(255, 255, 255, 0.9)",
        "framer-1tzghd": "rgba(255, 255, 255, 0.9)",
        "framer-1j37cf1": "rgba(255, 255, 255, 0.9)",
        "framer-1hzhw0m": "rgba(255, 255, 255, 0.9)",
        "framer-1o0bkla": "rgba(255, 255, 255, 0.9)",
        "framer-op6ecw": "rgba(255, 255, 255, 0.9)",
        "framer-1fcx5x1": "rgba(255, 255, 255, 0.9)",
        "framer-1rby5nx": "rgba(255, 255, 255, 0.9)",
        "framer-1kjsbwd": "rgba(255, 255, 255, 0.9)",
        "framer-1ojfxs9": "rgba(255, 255, 255, 0.9)",
        "framer-z6ek3k": "rgba(255, 255, 255, 0.9)",
        "framer-1qhbfh6": "rgba(255, 255, 255, 0.9)",
        "framer-1pj0haq": "rgba(255, 255, 255, 0.9)",
        "framer-vd0s5d": "rgba(255, 255, 255, 0.9)",
        "framer-1e93pup": "rgba(255, 255, 255, 0.9)",
        "framer-h9oic": "rgba(255, 255, 255, 0.9)",
        "framer-jo8cx0": "rgba(255, 255, 255, 0.9)",
        "framer-1f8ru9z": "rgba(255, 255, 255, 0.9)",
        "framer-1n4ht9o": "rgba(255, 255, 255, 0.9)",
        "framer-d353th": "rgba(255, 255, 255, 0.9)",
        "framer-13orx46": "rgba(255, 255, 255, 0.9)",
        "framer-14izw09": "rgba(255, 255, 255, 0.9)",
        "framer-1ibkax": "rgba(255, 255, 255, 0.9)",
        "framer-r24ou6": "rgba(255, 255, 255, 0.9)",
        "framer-5pakqt": "rgba(255, 255, 255, 0.9)",
        "framer-1d4yakz": "rgba(255, 255, 255, 0.9)",
        "framer-19985uk": "rgba(255, 255, 255, 0.9)",
        "framer-gb01s5": "rgba(255, 255, 255, 0.9)",
        "framer-wcsctp": "rgba(255, 255, 255, 0.9)",
        "framer-gbxnjm": "rgba(255, 255, 255, 0.9)",
        "framer-1n3latx": "rgba(255, 255, 255, 0.9)",
        "framer-ww49ko": "rgba(255, 255, 255, 0.9)",
        "framer-wuga8j": "rgba(255, 255, 255, 0.9)",
        "framer-19eh725": "rgba(255, 255, 255, 0.9)",
        "framer-spao7m": "rgba(255, 255, 255, 0.9)",
        "framer-p37xcr": "rgba(255, 255, 255, 0.9)",
        "framer-9lae15": "rgba(255, 255, 255, 0.9)",
        "framer-1djurc4": "rgba(255, 255, 255, 0.9)",
        "framer-1f9z9h2": "rgba(255, 255, 255, 0.9)",
        "framer-4nf7cp": "rgba(255, 255, 255, 0.9)",
        "framer-ib6lq2": "rgba(255, 255, 255, 0.9)",
        "framer-16jrhdt": "rgba(255, 255, 255, 0.9)",
        "framer-pb4qx6": "rgba(255, 255, 255, 0.9)",
        "framer-1bnvsbw": "rgba(255, 255, 255, 0.9)",
        "framer-svuws1": "rgba(255, 255, 255, 0.9)",
        "framer-18vrrai": "rgba(255, 255, 255, 0.9)",
        "framer-p75je3": "rgba(255, 255, 255, 0.9)",
        "framer-1oim4ap": "rgba(255, 255, 255, 0.9)",
        "framer-ets58q": "rgba(255, 255, 255, 0.9)",
        "framer-189qgi": "rgba(255, 255, 255, 0.9)",
        "framer-1se8eji": "rgba(255, 255, 255, 0.9)",
        "framer-xpdw0t": "rgba(255, 255, 255, 0.9)",
        "framer-114gjxu": "rgba(255, 255, 255, 0.9)",
        "framer-1ckranj": "rgba(255, 255, 255, 0.9)",
        "framer-yd49zj": "rgba(255, 255, 255, 0.9)",
        "framer-832d6a": "rgba(255, 255, 255, 0.9)",
        "framer-9j1mqt": "rgba(255, 255, 255, 0.9)",
        "framer-15qmn6v": "rgba(255, 255, 255, 0.9)",
        "framer-bosrq5": "rgba(255, 255, 255, 0.9)",
        "framer-e7rxl7": "rgba(255, 255, 255, 0.9)",
        "framer-t0me7w": "rgba(255, 255, 255, 0.9)",
        "framer-arxyzc": "rgba(255, 255, 255, 0.9)",
        "framer-w1f0c5": "rgba(255, 255, 255, 0.9)",
        "framer-1gx2zd": "rgba(255, 255, 255, 0.9)",
        "framer-1l5jzao": "rgba(255, 255, 255, 0.9)",
        "framer-lfxxyo": "rgba(255, 255, 255, 0.9)",
        "framer-1938ukf": "rgba(255, 255, 255, 0.9)",
        "framer-1uz9g4b": "rgba(255, 255, 255, 0.9)",
        "framer-skhb4e": "rgba(255, 255, 255, 0.9)",
        "framer-1nc562f": "rgba(255, 255, 255, 0.9)",
        "framer-1r1nb90": "rgba(255, 255, 255, 0.9)",
        "framer-1l7p7cw": "rgba(255, 255, 255, 0.9)",
        "framer-bbd8ba": "rgba(255, 255, 255, 0.9)",
        "framer-174359s": "rgba(255, 255, 255, 0.9)",
        "framer-o1cm7l": "rgba(255, 255, 255, 0.9)",
        "framer-1r2q58v": "rgba(255, 255, 255, 0.9)",
        "framer-ckhbc1": "rgba(255, 255, 255, 0.9)",
        "framer-25euhf": "rgba(255, 255, 255, 0.9)",
        "framer-1bg9jqr": "rgba(255, 255, 255, 0.9)",
        "framer-1hp2xsm": "rgba(255, 255, 255, 0.9)",
        "framer-1w08ot3": "rgba(255, 255, 255, 0.9)",
        "framer-hzs6gu": "rgba(255, 255, 255, 0.9)",
        "framer-1tn0auv": "rgba(255, 255, 255, 0.9)",
        "framer-1yuauh0": "rgb(6, 6, 12)",
        "framer-q39ych": "rgba(255, 255, 255, 0.05)",
        "framer-1la9doo": "rgba(255, 255, 255, 0.9)",
        "framer-1i6s172": "rgba(255, 255, 255, 0.9)",
        "framer-1bhiwq4": "rgba(255, 255, 255, 0.9)",
        "framer-1finjmh": "rgba(255, 255, 255, 0.9)",
        "framer-c4f7i5": "rgba(255, 255, 255, 0.9)",
        "framer-3ba7y6": "rgba(255, 255, 255, 0.9)",
        "framer-8o5z7u": "rgba(255, 255, 255, 0.9)",
        "framer-5vb13r": "rgba(255, 255, 255, 0.9)",
        "framer-1qg8j5j": "rgba(255, 255, 255, 0.9)",
        "framer-1cpq7cz": "rgba(255, 255, 255, 0.9)",
        "framer-1e24whu": "rgba(255, 255, 255, 0.9)",
        "framer-f9w1b0": "rgba(255, 255, 255, 0.9)",
        "framer-154i7ad": "rgba(255, 255, 255, 0.9)",
        "framer-trnmme": "rgba(255, 255, 255, 0.9)",
        "framer-1g03gzo": "rgba(255, 255, 255, 0.9)",
        "framer-2uv9z5": "rgba(255, 255, 255, 0.9)",
        "framer-1kh10xg": "rgba(255, 255, 255, 0.9)",
        "framer-177340h": "rgba(255, 255, 255, 0.9)",
        "framer-147tj1p": "rgba(255, 255, 255, 0.9)",
        "framer-1cjjf7q": "rgba(255, 255, 255, 0.9)",
        "framer-jjeffs": "rgba(255, 255, 255, 0.9)",
        "framer-b3oq5w": "rgba(255, 255, 255, 0.9)",
        "framer-lgkn64": "rgba(255, 255, 255, 0.9)",
        "framer-ftinbp": "rgba(255, 255, 255, 0.9)",
        "framer-1qgwf2q": "rgba(255, 255, 255, 0.9)",
        "framer-1s1q0zj": "rgba(255, 255, 255, 0.9)",
        "framer-szasz2": "rgba(255, 255, 255, 0.9)",
        "framer-1bh2qom": "rgba(255, 255, 255, 0.9)",
        "framer-vbr5qt": "rgba(255, 255, 255, 0.9)",
        "framer-ayiqn": "rgba(255, 255, 255, 0.9)",
        "framer-ng52my": "rgba(255, 255, 255, 0.9)",
        "framer-1qc3xh2": "rgba(255, 255, 255, 0.9)",
        "framer-17xhwxn": "rgba(255, 255, 255, 0.9)",
        "framer-kd3teb": "rgba(255, 255, 255, 0.9)",
        "framer-1ds9pvm": "rgba(255, 255, 255, 0.9)",
        "framer-9ou7kr": "rgba(255, 255, 255, 0.9)",
        "framer-19hkz1m": "rgba(255, 255, 255, 0.9)",
        "framer-z7coyc": "rgba(255, 255, 255, 0.9)",
        "framer-hxqr6r": "rgba(255, 255, 255, 0.9)",
        "framer-ssdjgy": "rgba(255, 255, 255, 0.9)",
        "framer-170fwp7": "rgba(255, 255, 255, 0.9)",
        "framer-iorqmd": "rgba(255, 255, 255, 0.9)",
        "framer-ly5had": "rgba(255, 255, 255, 0.9)",
        "framer-kyuip0": "rgba(255, 255, 255, 0.9)",
        "framer-m2toq0": "rgba(255, 255, 255, 0.9)",
        "framer-1hak2gy": "rgba(255, 255, 255, 0.9)",
        "framer-oe69v3": "rgba(255, 255, 255, 0.9)",
        "framer-tfrupv": "rgba(255, 255, 255, 0.9)",
        "framer-ados7m": "rgba(255, 255, 255, 0.9)",
        "framer-1b1arxe": "rgba(255, 255, 255, 0.9)",
        "framer-t2bzkx": "rgba(255, 255, 255, 0.9)",
        "framer-19h60xi": "rgba(255, 255, 255, 0.9)",
        "framer-1roowyp": "rgba(255, 255, 255, 0.9)",
        "framer-b33ovj": "rgba(255, 255, 255, 0.9)",
        "framer-2xrhr6": "rgba(255, 255, 255, 0.9)",
        "framer-bp4hmm": "rgba(255, 255, 255, 0.9)",
        "framer-bj9ogc": "rgba(255, 255, 255, 0.9)",
        "framer-dv99ve": "rgba(255, 255, 255, 0.9)",
        "framer-1o691fb": "rgba(255, 255, 255, 0.9)",
        "framer-1o7i21q": "rgba(255, 255, 255, 0.9)",
        "framer-7y8ymw": "rgba(255, 255, 255, 0.9)",
        "framer-259e94": "rgba(255, 255, 255, 0.9)",
        "framer-1vrgp1i": "rgba(255, 255, 255, 0.9)",
        "framer-1hkr8gz": "rgba(255, 255, 255, 0.9)",
        "framer-1cpl3ru": "rgba(255, 255, 255, 0.9)",
        "framer-4vg5fm": "rgba(255, 255, 255, 0.9)",
        "framer-6yep7x": "rgba(255, 255, 255, 0.9)",
        "framer-yo90z1": "rgba(255, 255, 255, 0.9)",
        "framer-1ffyrfe": "rgba(255, 255, 255, 0.9)",
        "framer-17sy2h9": "rgba(255, 255, 255, 0.9)",
        "framer-1nexr12": "rgba(255, 255, 255, 0.9)",
        "framer-1nxam09": "rgba(255, 255, 255, 0.9)",
        "framer-1u7tsmf": "rgba(255, 255, 255, 0.9)",
        "framer-1s1lgs9": "rgba(255, 255, 255, 0.9)",
        "framer-1tsc97t": "rgba(255, 255, 255, 0.9)",
        "framer-1lik10g": "rgba(255, 255, 255, 0.9)",
        "framer-w91j3h": "rgba(255, 255, 255, 0.9)",
        "framer-1t0gcur": "rgba(255, 255, 255, 0.9)",
        "framer-7i1u99": "rgba(255, 255, 255, 0.9)",
        "framer-zeyecd": "rgba(255, 255, 255, 0.9)",
        "framer-1sm3fde": "rgba(255, 255, 255, 0.9)",
        "framer-hpfi4e": "rgba(255, 255, 255, 0.9)",
        "framer-11nihoc": "rgba(255, 255, 255, 0.9)",
        "framer-dyf9qm": "rgba(255, 255, 255, 0.9)",
        "framer-issvd8": "rgba(255, 255, 255, 0.9)",
        "framer-wtmsdd": "rgba(255, 255, 255, 0.9)",
        "framer-1b7vdsu": "rgba(255, 255, 255, 0.9)",
        "framer-mhhl4m": "rgba(255, 255, 255, 0.9)",
        "framer-kr5yb3": "rgba(255, 255, 255, 0.9)",
        "framer-8s5abl": "rgba(255, 255, 255, 0.9)",
        "framer-f20w32": "rgba(255, 255, 255, 0.9)",
        "framer-1v5wb0d": "rgba(255, 255, 255, 0.9)",
        "framer-4tlth8": "rgba(255, 255, 255, 0.9)",
        "framer-kxfckx": "rgba(255, 255, 255, 0.9)",
        "framer-69n7ji": "rgba(255, 255, 255, 0.9)",
        "framer-1qqpucz": "rgba(255, 255, 255, 0.9)",
        "framer-1kt8yiq": "rgba(255, 255, 255, 0.9)",
        "framer-1qoqjv3": "rgba(255, 255, 255, 0.9)",
        "framer-16obh5m": "rgba(255, 255, 255, 0.9)",
        "framer-1tpfy33": "rgba(255, 255, 255, 0.9)",
        "framer-zxg4my": "rgba(255, 255, 255, 0.9)",
        "framer-c9ojjv": "rgba(255, 255, 255, 0.9)",
        "framer-1j4u6r2": "rgba(255, 255, 255, 0.9)",
        "framer-tclpau": "rgba(255, 255, 255, 0.9)",
        "framer-1ni6xjv": "rgba(255, 255, 255, 0.9)",
        "framer-1es2jab": "rgba(255, 255, 255, 0.9)",
        "framer-10jrcc6": "rgba(255, 255, 255, 0.9)",
        "framer-jcrjvd": "rgba(255, 255, 255, 0.9)",
        "framer-bvrrkp": "rgba(255, 255, 255, 0.9)",
        "framer-18mdrb0": "rgba(255, 255, 255, 0.9)",
        "framer-19ufz0c": "rgba(255, 255, 255, 0.9)",
        "framer-a4eq25": "rgba(255, 255, 255, 0.9)",
        "framer-fiyyst": "rgba(255, 255, 255, 0.04)",
        "framer-ciyq8x": "rgba(255, 255, 255, 0.04)",
        "framer-1q66old": "rgba(255, 255, 255, 0.04)",
        "framer-1qi4x9e": "rgba(255, 255, 255, 0.04)",
        "framer-1gptz2q": "rgba(255, 255, 255, 0.04)",
        "framer-1455pd0": "rgba(255, 255, 255, 0.04)",
        "framer-1fit9b7": "rgba(255, 255, 255, 0.04)",
        "framer-hi43jy": "rgba(255, 255, 255, 0.04)",
        "framer-1wd6cu5": "rgba(255, 255, 255, 0.04)",
        "framer-1ylwb2d": "rgba(255, 255, 255, 0.04)",
        "framer-1y9yxe2": "rgba(255, 255, 255, 0.04)",
        "framer-qvneen": "rgba(255, 255, 255, 0.04)",
        "framer-wjo0e9": "rgba(255, 255, 255, 0.04)",
        "framer-czpr7r": "rgba(255, 255, 255, 0.04)",
        "framer-vj2fgs": "rgba(255, 255, 255, 0.04)",
        "framer-hoxygt": "rgba(255, 255, 255, 0.04)",
        "framer-48kwqi": "rgba(255, 255, 255, 0.04)",
        "framer-u5krqo": "rgba(255, 255, 255, 0.04)",
        "framer-w896tp": "rgba(255, 255, 255, 0.04)",
        "framer-1wk1y40": "rgba(255, 255, 255, 0.04)",
        "framer-33r2dq": "rgba(255, 255, 255, 0.04)",
        "framer-1gbanx3": "rgba(255, 255, 255, 0.04)",
        "framer-1ux33dn": "rgba(255, 255, 255, 0.04)",
        "framer-3lw8u8": "rgba(255, 255, 255, 0.04)",
        "framer-1czikuk": "rgba(255, 255, 255, 0.04)",
        "framer-q6eebf": "rgba(255, 255, 255, 0.04)",
        "framer-1gdzggg": "rgba(255, 255, 255, 0.04)",
        "framer-tsui6n": "rgba(255, 255, 255, 0.04)",
        "framer-vgwsmu": "rgba(255, 255, 255, 0.04)",
        "framer-1tmsih3": "rgba(255, 255, 255, 0.04)",
        "framer-btodsk": "rgba(255, 255, 255, 0.04)",
        "framer-1c27p2n": "rgba(255, 255, 255, 0.04)",
        "framer-hj95w1": "rgba(255, 255, 255, 0.04)",
        "framer-1dyz5ca": "rgba(255, 255, 255, 0.04)",
        "framer-et0m12": "rgba(255, 255, 255, 0.04)",
        "framer-vnh2vx": "rgba(255, 255, 255, 0.04)",
        "framer-1l61glq": "rgba(255, 255, 255, 0.04)",
        "framer-qzjyt5": "rgba(255, 255, 255, 0.04)",
        "framer-1j65h5c": "rgba(255, 255, 255, 0.04)",
        "framer-ujqrvs": "rgba(255, 255, 255, 0.04)",
        "framer-ooft64": "rgba(255, 255, 255, 0.04)",
        "framer-1wfl7nv": "rgba(255, 255, 255, 0.04)",
        "framer-17irg2n": "rgba(255, 255, 255, 0.04)",
        "framer-l109y1": "rgba(255, 255, 255, 0.04)",
        "framer-14fhv1t": "rgba(255, 255, 255, 0.04)",
        "framer-763vv": "rgba(255, 255, 255, 0.04)",
        "framer-ekdddg": "rgba(255, 255, 255, 0.04)",
        "framer-lczi8i": "rgba(255, 255, 255, 0.04)",
        "framer-1k3zzg8": "rgba(255, 255, 255, 0.04)",
        "framer-1nze31j": "rgba(255, 255, 255, 0.04)",
        "framer-1izz6de": "rgba(255, 255, 255, 0.04)",
        "framer-cva9wu": "rgba(255, 255, 255, 0.04)",
        "framer-myr3v0": "rgba(255, 255, 255, 0.04)",
        "framer-3fv7cz": "rgba(255, 255, 255, 0.04)",
        "framer-1cb7j9a": "rgba(255, 255, 255, 0.04)",
        "framer-bvmogv": "rgba(255, 255, 255, 0.04)",
        "framer-1nvc6l8": "rgba(255, 255, 255, 0.04)",
        "framer-1k694lj": "rgba(255, 255, 255, 0.04)",
        "framer-1br5jo5": "rgba(255, 255, 255, 0.04)",
        "framer-91edth": "rgba(255, 255, 255, 0.04)",
        "framer-19nd5re": "rgba(255, 255, 255, 0.04)",
        "framer-11zy7gz": "rgba(255, 255, 255, 0.04)",
        "framer-183jbxw": "rgba(255, 255, 255, 0.04)",
        "framer-1k2kjzb": "rgba(255, 255, 255, 0.04)",
        "framer-e0p84p": "rgba(255, 255, 255, 0.04)",
        "framer-170af3e": "rgba(255, 255, 255, 0.04)",
        "framer-ghrn1n": "rgba(255, 255, 255, 0.04)",
        "framer-1djai4u": "rgba(255, 255, 255, 0.04)",
        "framer-1ibabel": "rgba(255, 255, 255, 0.04)",
        "framer-8y8sq7": "rgba(255, 255, 255, 0.04)",
        "framer-19kqjve": "rgba(255, 255, 255, 0.04)",
        "framer-1rf3dh1": "rgba(255, 255, 255, 0.04)",
        "framer-18lqt85": "rgba(255, 255, 255, 0.04)",
        "framer-1vt83fg": "rgba(255, 255, 255, 0.04)",
        "framer-1290qui": "rgba(255, 255, 255, 0.04)",
        "framer-10qen5q": "rgba(255, 255, 255, 0.04)",
        "framer-1x7y08s": "rgba(255, 255, 255, 0.04)",
        "framer-li1bn0": "rgba(255, 255, 255, 0.04)",
        "framer-1afif8m": "rgba(255, 255, 255, 0.04)",
        "framer-1xffmu1": "rgba(255, 255, 255, 0.04)",
        "framer-vxzka9": "rgba(255, 255, 255, 0.04)",
        "framer-1oenpnn": "rgba(255, 255, 255, 0.04)",
        "framer-xqqqan": "rgba(255, 255, 255, 0.04)",
        "framer-1xs3c5s": "rgba(255, 255, 255, 0.04)",
        "framer-g5b2fd": "rgba(255, 255, 255, 0.04)",
        "framer-15pc2n8": "rgba(255, 255, 255, 0.04)",
        "framer-dlkqju": "rgba(255, 255, 255, 0.04)",
        "framer-1662edz": "rgba(255, 255, 255, 0.04)",
        "framer-1o6ae4m": "rgba(255, 255, 255, 0.04)",
        "framer-7ut610": "rgba(255, 255, 255, 0.04)",
        "framer-4nsxaf": "rgba(255, 255, 255, 0.04)",
        "framer-kyye8q": "rgba(255, 255, 255, 0.04)",
        "framer-nge7c7": "rgba(255, 255, 255, 0.04)",
        "framer-153oid8": "rgba(255, 255, 255, 0.04)",
        "framer-1i5403r": "rgba(255, 255, 255, 0.04)",
        "framer-zdwg34": "rgba(255, 255, 255, 0.04)",
        "framer-1wosb63": "rgba(255, 255, 255, 0.04)",
        "framer-nf35ps": "rgba(255, 255, 255, 0.04)",
        "framer-qa34xq": "rgba(255, 255, 255, 0.04)",
        "framer-filgd4": "rgba(255, 255, 255, 0.04)",
        "framer-u4d6x3": "rgba(255, 255, 255, 0.04)",
        "framer-ev4n9h": "rgba(255, 255, 255, 0.04)",
        "framer-1jndxip": "rgba(255, 255, 255, 0.04)",
        "framer-ukalac": "rgba(255, 255, 255, 0.04)",
        "framer-7ra5u7": "rgba(255, 255, 255, 0.04)",
        "framer-1q0z42g": "rgba(255, 255, 255, 0.04)",
        "framer-o0cltq": "rgba(255, 255, 255, 0.04)",
        "framer-1ymomzd": "rgba(255, 255, 255, 0.04)",
        "framer-15ogixz": "rgba(255, 255, 255, 0.04)",
        "framer-4uq06b": "rgba(255, 255, 255, 0.04)",
        "framer-5pj1ss": "rgba(255, 255, 255, 0.04)",
        "framer-cjm6cm": "rgba(255, 255, 255, 0.04)",
        "framer-1nwn46": "rgba(255, 255, 255, 0.04)",
        "framer-l4xkwr": "rgba(255, 255, 255, 0.04)",
        "framer-tvhj2b": "rgba(255, 255, 255, 0.04)",
        "framer-86mmqq": "rgba(255, 255, 255, 0.04)",
        "framer-nc7bns": "rgba(255, 255, 255, 0.04)",
        "framer-1cg48np": "rgba(255, 255, 255, 0.04)",
        "framer-wnc4on": "rgba(255, 255, 255, 0.04)",
        "framer-14nw6a7": "rgba(255, 255, 255, 0.04)",
        "framer-xpktl5": "rgba(255, 255, 255, 0.04)",
        "framer-1mqce9a": "rgba(255, 255, 255, 0.04)",
        "framer-6xbkam": "rgba(255, 255, 255, 0.04)",
        "framer-131v8op": "rgba(255, 255, 255, 0.04)",
        "framer-1ddxcby": "rgba(255, 255, 255, 0.04)",
        "framer-1o9uvr4": "rgba(255, 255, 255, 0.04)",
        "framer-gt4ley": "rgba(255, 255, 255, 0.04)",
        "framer-11v9qa8": "rgba(255, 255, 255, 0.04)",
        "framer-h942sb": "rgba(255, 255, 255, 0.04)",
        "framer-2bbq4h": "rgba(255, 255, 255, 0.04)",
        "framer-1b5igrv": "rgba(255, 255, 255, 0.04)",
        "framer-170rkry": "rgba(255, 255, 255, 0.04)",
        "framer-kgstxs": "rgba(255, 255, 255, 0.04)",
        "framer-b7gua7": "rgba(255, 255, 255, 0.04)",
        "framer-1sldj1o": "rgba(255, 255, 255, 0.04)",
        "framer-1svd255": "rgba(255, 255, 255, 0.04)",
        "framer-138y9pl": "rgba(255, 255, 255, 0.04)",
        "framer-1dta0vu": "rgba(255, 255, 255, 0.04)",
        "framer-3z64oo": "rgba(255, 255, 255, 0.04)",
        "framer-1d2d49i": "rgba(255, 255, 255, 0.04)",
        "framer-oyhd3t": "rgba(255, 255, 255, 0.04)",
        "framer-20f2sf": "rgba(255, 255, 255, 0.04)",
        "framer-fd2gbu": "rgba(255, 255, 255, 0.04)",
        "framer-173iqm4": "rgba(255, 255, 255, 0.04)",
        "framer-1nw2i5u": "rgba(255, 255, 255, 0.04)",
        "framer-1gf8f74": "rgba(255, 255, 255, 0.04)",
        "framer-126if7k": "rgba(255, 255, 255, 0.04)",
        "framer-101393o": "rgba(255, 255, 255, 0.04)",
        "framer-1cttzfy": "rgba(255, 255, 255, 0.04)",
        "framer-1bchv1w": "rgba(255, 255, 255, 0.04)",
        "framer-1xspwzf": "rgba(255, 255, 255, 0.04)",
        "framer-hshnmx": "rgba(255, 255, 255, 0.04)",
        "framer-1atgup7": "rgba(255, 255, 255, 0.04)",
        "framer-rm0zjp": "rgba(255, 255, 255, 0.04)",
        "framer-1kk3rk0": "rgba(255, 255, 255, 0.04)",
        "framer-of0mcj": "rgba(255, 255, 255, 0.04)",
        "framer-ysh229": "rgba(255, 255, 255, 0.04)",
        "framer-13o3p9b": "rgba(255, 255, 255, 0.04)",
        "framer-cgvumc": "rgba(255, 255, 255, 0.04)",
        "framer-1vct5ds": "rgba(255, 255, 255, 0.04)",
        "framer-19h6kmj": "rgba(255, 255, 255, 0.04)",
        "framer-1cjvhsx": "rgba(255, 255, 255, 0.04)",
        "framer-12p3vzx": "rgba(255, 255, 255, 0.04)",
        "framer-1oksxci": "rgba(255, 255, 255, 0.04)",
        "framer-14pwok1": "rgba(255, 255, 255, 0.04)",
        "framer-1lswi2p": "rgba(255, 255, 255, 0.04)",
        "framer-19zr038": "rgba(255, 255, 255, 0.04)",
        "framer-mexy1c": "rgba(255, 255, 255, 0.04)",
        "framer-119p38r": "rgba(255, 255, 255, 0.04)",
        "framer-aokgsq": "rgba(255, 255, 255, 0.04)",
        "framer-1vgglw": "rgba(255, 255, 255, 0.04)",
        "framer-9wyu5": "rgba(255, 255, 255, 0.04)",
        "framer-1u89jrq": "rgba(255, 255, 255, 0.04)",
        "framer-ilwm1r": "rgba(255, 255, 255, 0.04)",
        "framer-6c7q3i": "rgba(255, 255, 255, 0.04)",
        "framer-1dhqmpa": "rgba(255, 255, 255, 0.04)",
        "framer-m6uoyn": "rgba(255, 255, 255, 0.04)",
        "framer-1abbc44": "rgba(255, 255, 255, 0.04)",
        "framer-1asdrnx": "rgba(255, 255, 255, 0.04)",
        "framer-1a81c3z": "rgba(255, 255, 255, 0.04)",
        "framer-1yjoi2": "rgba(255, 255, 255, 0.04)",
        "framer-34s8p0": "rgba(255, 255, 255, 0.04)",
        "framer-9wmkwc": "rgba(255, 255, 255, 0.04)",
        "framer-1rzdfox": "rgba(255, 255, 255, 0.04)",
        "framer-1v2j9m": "rgba(255, 255, 255, 0.04)",
        "framer-tvwehy": "rgba(255, 255, 255, 0.04)",
        "framer-19gskhe": "rgba(255, 255, 255, 0.04)",
        "framer-1r7znae": "rgba(255, 255, 255, 0.04)",
        "framer-1x9ttau": "rgba(255, 255, 255, 0.04)",
        "framer-19qi3rg": "rgba(255, 255, 255, 0.04)",
        "framer-1xazehi": "rgba(255, 255, 255, 0.04)",
        "framer-1vj77jj": "rgba(255, 255, 255, 0.04)",
        "framer-t89g24": "rgba(255, 255, 255, 0.04)",
        "framer-1ouxnre": "rgba(255, 255, 255, 0.04)",
        "framer-9izbi9": "rgba(255, 255, 255, 0.04)",
        "framer-hmhbu9": "rgba(255, 255, 255, 0.04)",
        "framer-ldccnz": "rgba(255, 255, 255, 0.04)",
        "framer-12qua62": "rgba(255, 255, 255, 0.04)",
        "framer-tn4f9n": "rgba(255, 255, 255, 0.04)",
        "framer-2bdteh": "rgba(255, 255, 255, 0.04)",
        "framer-26x32d": "rgba(255, 255, 255, 0.04)",
        "framer-z23vsj": "rgba(255, 255, 255, 0.04)",
        "framer-161xr59": "rgba(255, 255, 255, 0.04)",
        "framer-tuje6p": "rgba(255, 255, 255, 0.04)",
        "framer-144agw": "rgba(255, 255, 255, 0.04)",
        "framer-1hbb6d9": "rgba(255, 255, 255, 0.04)",
        "framer-1me8sh4": "rgba(255, 255, 255, 0.04)",
        "framer-1umq5aj": "rgba(255, 255, 255, 0.04)",
        "framer-1lhyzal": "rgba(255, 255, 255, 0.04)",
        "framer-1f3n39": "rgba(255, 255, 255, 0.04)",
        "framer-ilf9u3": "rgba(255, 255, 255, 0.04)",
        "framer-1qw0dpv": "rgba(255, 255, 255, 0.04)",
        "framer-1rs1xsd": "rgba(255, 255, 255, 0.04)",
        "framer-1t6lx8u": "rgba(255, 255, 255, 0.04)",
        "framer-7xapi8": "rgba(255, 255, 255, 0.04)",
        "framer-1yp8hos": "rgba(255, 255, 255, 0.04)",
        "framer-i2cq27": "rgba(255, 255, 255, 0.04)",
        "framer-h7ww8p": "rgba(255, 255, 255, 0.04)",
        "framer-1a5x4f6": "rgba(255, 255, 255, 0.04)",
        "framer-1qwmbzn": "rgba(255, 255, 255, 0.04)",
        "framer-1dmcjdq": "rgba(255, 255, 255, 0.04)",
        "framer-1n7pw7r": "rgba(255, 255, 255, 0.04)",
        "framer-1w51idz": "rgba(255, 255, 255, 0.04)",
        "framer-mxy4ao": "rgba(255, 255, 255, 0.04)",
        "framer-81issc": "rgba(255, 255, 255, 0.04)",
        "framer-1w1gkay": "rgba(255, 255, 255, 0.04)",
        "framer-4cpnfq": "rgba(255, 255, 255, 0.04)",
        "framer-1ewcuw0": "rgba(255, 255, 255, 0.04)",
        "framer-pwwysn": "rgba(255, 255, 255, 0.04)",
        "framer-1xtn7vm": "rgba(255, 255, 255, 0.04)",
        "framer-7dxsze": "rgba(255, 255, 255, 0.04)",
        "framer-9ev4bv": "rgba(255, 255, 255, 0.04)",
        "framer-1p7e9u2": "rgba(255, 255, 255, 0.04)",
        "framer-1a59dez": "rgba(255, 255, 255, 0.04)",
        "framer-7fgdhi": "rgba(255, 255, 255, 0.04)",
        "framer-k8j7my": "rgba(255, 255, 255, 0.04)",
        "framer-1ammoj2": "rgba(255, 255, 255, 0.04)",
        "framer-oivdw5": "rgba(255, 255, 255, 0.04)",
        "framer-14f6ekb": "rgba(255, 255, 255, 0.04)",
        "framer-khhuyo": "rgba(255, 255, 255, 0.04)",
        "framer-i2x3iv": "rgba(255, 255, 255, 0.04)",
        "framer-67j55g": "rgba(255, 255, 255, 0.04)",
        "framer-88mozs": "rgba(255, 255, 255, 0.04)",
        "framer-1dmnjar": "rgba(255, 255, 255, 0.04)",
        "framer-ncelpy": "rgba(255, 255, 255, 0.04)",
        "framer-123er8b": "rgba(255, 255, 255, 0.04)",
        "framer-6y7kl8": "rgba(255, 255, 255, 0.04)",
        "framer-1aa5m0p": "rgba(255, 255, 255, 0.04)",
        "framer-16krrxi": "rgba(255, 255, 255, 0.04)",
        "framer-1fn8zqk": "rgba(255, 255, 255, 0.04)",
        "framer-513uhu": "rgba(255, 255, 255, 0.04)",
        "framer-fa2shx": "rgba(255, 255, 255, 0.04)",
        "framer-1xoruxr": "rgba(255, 255, 255, 0.04)",
        "framer-1bihptf": "rgba(255, 255, 255, 0.04)",
        "framer-zrojpi": "rgba(255, 255, 255, 0.04)",
        "framer-cs61ef": "rgba(255, 255, 255, 0.04)",
        "framer-1q93xu9": "rgba(255, 255, 255, 0.04)",
        "framer-ib3bh1": "rgba(255, 255, 255, 0.04)",
        "framer-pbzt1h": "rgba(255, 255, 255, 0.04)",
        "framer-1h1ziie": "rgba(255, 255, 255, 0.04)",
        "framer-114tpb9": "rgba(255, 255, 255, 0.04)",
        "framer-1119xwz": "rgba(255, 255, 255, 0.04)",
        "framer-3c8f8y": "rgba(255, 255, 255, 0.04)",
        "framer-3luccy": "rgba(255, 255, 255, 0.04)",
        "framer-1mht7x2": "rgba(255, 255, 255, 0.04)",
        "framer-mnwipj": "rgba(255, 255, 255, 0.04)",
        "framer-lwj4e": "rgba(255, 255, 255, 0.04)",
        "framer-1ko98em": "rgba(255, 255, 255, 0.04)",
        "framer-17hq2ey": "rgba(255, 255, 255, 0.04)",
        "framer-dlyppx": "rgba(255, 255, 255, 0.04)",
        "framer-3vyltb": "rgba(255, 255, 255, 0.04)",
        "framer-xi0b9s": "rgba(255, 255, 255, 0.04)",
        "framer-bdvmsa": "rgba(255, 255, 255, 0.04)",
        "framer-1u3l0fl": "rgba(255, 255, 255, 0.04)",
        "framer-1yzqxh2": "rgba(255, 255, 255, 0.04)",
        "framer-1vnn6r": "rgba(255, 255, 255, 0.04)",
        "framer-sve3o0": "rgba(255, 255, 255, 0.04)",
        "framer-1p84nt4": "rgba(255, 255, 255, 0.04)",
        "framer-1pxzgce": "rgba(255, 255, 255, 0.04)",
        "framer-1b278qv": "rgba(255, 255, 255, 0.04)",
        "framer-2gnydd": "rgba(255, 255, 255, 0.04)",
        "framer-1137811": "rgba(255, 255, 255, 0.04)",
        "framer-19jj6c3": "rgba(255, 255, 255, 0.04)",
        "framer-1pzn1av": "rgba(255, 255, 255, 0.04)",
        "framer-tvid17": "rgba(255, 255, 255, 0.04)",
        "framer-11c54mx": "rgba(255, 255, 255, 0.04)",
        "framer-nevvim": "rgba(255, 255, 255, 0.04)",
        "framer-9v6bcb": "rgba(255, 255, 255, 0.04)",
        "framer-1vnrxsp": "rgba(255, 255, 255, 0.04)",
        "framer-wjbowq": "rgba(255, 255, 255, 0.04)",
        "framer-12400e0": "rgba(255, 255, 255, 0.04)",
        "framer-1cqo2n8": "rgba(255, 255, 255, 0.04)",
        "framer-qcjss1": "rgba(255, 255, 255, 0.04)",
        "framer-1ni2oxv": "rgba(255, 255, 255, 0.04)",
        "framer-5ztfcs": "rgba(255, 255, 255, 0.04)",
        "framer-154hrzw": "rgba(255, 255, 255, 0.04)",
        "framer-180ez6m": "rgba(255, 255, 255, 0.04)",
        "framer-h09ge5": "rgba(255, 255, 255, 0.04)",
        "framer-1se7318": "rgba(255, 255, 255, 0.04)",
        "framer-xxfm0q": "rgba(255, 255, 255, 0.04)",
        "framer-14apmt9": "rgba(255, 255, 255, 0.04)",
        "framer-3n8q0u": "rgba(255, 255, 255, 0.04)",
        "framer-j9tfzk": "rgba(255, 255, 255, 0.04)",
        "framer-1xd3thf": "rgba(255, 255, 255, 0.04)",
        "framer-1lfwj1u": "rgba(255, 255, 255, 0.04)",
        "framer-6d08mg": "rgba(255, 255, 255, 0.04)",
        "framer-re0cfu": "rgba(255, 255, 255, 0.04)",
        "framer-1iivgo9": "rgba(255, 255, 255, 0.04)",
        "framer-o3z3op": "rgba(255, 255, 255, 0.04)",
        "framer-182hs8p": "rgba(255, 255, 255, 0.04)",
        "framer-1wdiof9": "rgba(255, 255, 255, 0.04)",
        "framer-wwe331": "rgba(255, 255, 255, 0.04)",
        "framer-k8hw6u": "rgba(255, 255, 255, 0.04)",
        "framer-1j2vt7b": "rgba(255, 255, 255, 0.04)",
        "framer-4iiqzy": "rgba(255, 255, 255, 0.04)",
        "framer-1wwf1us": "rgba(255, 255, 255, 0.04)",
        "framer-7neodo": "rgba(255, 255, 255, 0.04)",
        "framer-724voj": "rgba(255, 255, 255, 0.04)",
        "framer-fn7au": "rgba(255, 255, 255, 0.04)",
        "framer-vi0aff": "rgba(255, 255, 255, 0.04)",
        "framer-8ssv48": "rgba(255, 255, 255, 0.04)",
        "framer-172e0pi": "rgba(255, 255, 255, 0.04)",
        "framer-14t05wr": "rgba(255, 255, 255, 0.04)",
        "framer-15pkux9": "rgba(255, 255, 255, 0.04)",
        "framer-jtyaes": "rgba(255, 255, 255, 0.04)",
        "framer-nt3phc": "rgba(255, 255, 255, 0.04)",
        "framer-ayg0jb": "rgba(255, 255, 255, 0.04)",
        "framer-1pztsn9": "rgba(255, 255, 255, 0.04)",
        "framer-lgrx4h": "rgba(255, 255, 255, 0.04)",
        "framer-inxrm5": "rgba(255, 255, 255, 0.04)",
        "framer-1b16f9k": "rgba(255, 255, 255, 0.04)",
        "framer-mh5rnp": "rgba(255, 255, 255, 0.04)",
        "framer-lutab8": "rgba(255, 255, 255, 0.04)",
        "framer-19j46hv": "rgba(255, 255, 255, 0.04)",
        "framer-1nsspm6": "rgba(255, 255, 255, 0.04)",
        "framer-elrkjf": "rgba(255, 255, 255, 0.04)",
        "framer-1aju3s8": "rgba(255, 255, 255, 0.04)",
        "framer-1tryoci": "rgba(255, 255, 255, 0.04)",
        "framer-s0ja87": "rgba(255, 255, 255, 0.04)",
        "framer-fnwwxo": "rgba(255, 255, 255, 0.04)",
        "framer-1wyam6m": "rgba(255, 255, 255, 0.04)",
        "framer-1pp6x1n": "rgba(255, 255, 255, 0.04)",
        "framer-1kx8h30": "rgba(255, 255, 255, 0.04)",
        "framer-38qo6l": "rgba(255, 255, 255, 0.04)",
        "framer-1bgkq86": "rgba(255, 255, 255, 0.04)",
        "framer-1odgaps": "rgba(255, 255, 255, 0.04)",
        "framer-ocebul": "rgba(255, 255, 255, 0.04)",
        "framer-htsvoh": "rgba(255, 255, 255, 0.04)",
        "framer-1rjcid1": "rgba(255, 255, 255, 0.04)",
        "framer-1ppu9nu": "rgba(255, 255, 255, 0.04)",
        "framer-b26c6s": "rgba(255, 255, 255, 0.04)",
        "framer-k15ji": "rgba(255, 255, 255, 0.04)",
        "framer-w1jb1u": "rgba(255, 255, 255, 0.04)",
        "framer-1b65fof": "rgba(255, 255, 255, 0.04)",
        "framer-ag946t": "rgba(255, 255, 255, 0.04)",
        "framer-njpiav": "rgba(255, 255, 255, 0.04)",
        "framer-fzosm0": "rgba(255, 255, 255, 0.04)",
        "framer-31j99c": "rgba(255, 255, 255, 0.04)",
        "framer-wbharp": "rgba(255, 255, 255, 0.04)",
        "framer-1o6h43g": "rgba(255, 255, 255, 0.04)",
        "framer-w8h1i4": "rgba(255, 255, 255, 0.04)",
        "framer-u08o4f": "rgba(255, 255, 255, 0.04)",
        "framer-1883ili": "rgba(255, 255, 255, 0.04)",
        "framer-hhqq21": "rgba(255, 255, 255, 0.04)",
        "framer-1qddyrc": "rgba(255, 255, 255, 0.04)",
        "framer-36rsch": "rgba(255, 255, 255, 0.04)",
        "framer-1vhup78": "rgba(255, 255, 255, 0.04)",
        "framer-1wy0vut": "rgba(255, 255, 255, 0.04)",
        "framer-1tldixq": "rgba(255, 255, 255, 0.04)",
        "framer-vcglv4": "rgba(255, 255, 255, 0.04)",
        "framer-mnkyk9": "rgba(255, 255, 255, 0.04)",
        "framer-1gd8uia": "rgba(255, 255, 255, 0.04)",
        "framer-4v17kk": "rgba(255, 255, 255, 0.04)",
        "framer-wcgbdx": "rgba(255, 255, 255, 0.04)",
        "framer-19ge0mq": "rgba(255, 255, 255, 0.04)",
        "framer-142xl0d": "rgba(255, 255, 255, 0.04)",
        "framer-ao5kmt": "rgba(255, 255, 255, 0.04)",
        "framer-1rc6i1r": "rgba(255, 255, 255, 0.04)",
        "framer-1wlwqo": "rgba(255, 255, 255, 0.04)",
        "framer-1tzx2st": "rgba(255, 255, 255, 0.04)",
        "framer-z8gsz9": "rgba(255, 255, 255, 0.04)",
        "framer-1fgz62q": "rgba(255, 255, 255, 0.04)",
        "framer-n6tpd7": "rgba(255, 255, 255, 0.04)",
        "framer-1otl1h8": "rgba(255, 255, 255, 0.04)",
        "framer-1vi730u": "rgba(255, 255, 255, 0.04)",
        "framer-1klteqi": "rgba(255, 255, 255, 0.04)",
        "framer-36msax": "rgba(255, 255, 255, 0.04)",
        "framer-1feur12": "rgba(255, 255, 255, 0.04)",
        "framer-1lyqxag": "rgba(255, 255, 255, 0.04)",
        "framer-5a7aqr": "rgba(255, 255, 255, 0.04)",
        "framer-82cjev": "rgba(255, 255, 255, 0.04)",
        "framer-10a7t8v": "rgba(255, 255, 255, 0.04)",
        "framer-7pex0i": "rgba(255, 255, 255, 0.04)",
        "framer-1r4ihlp": "rgba(255, 255, 255, 0.04)",
        "framer-1cjy5e6": "rgba(255, 255, 255, 0.04)",
        "framer-1f59xpm": "rgba(255, 255, 255, 0.04)",
        "framer-13qpo9p": "rgba(255, 255, 255, 0.04)",
        "framer-160oi7c": "rgba(255, 255, 255, 0.04)",
        "framer-8v07ff": "rgba(255, 255, 255, 0.04)",
        "framer-ry0yv5": "rgba(255, 255, 255, 0.04)",
        "framer-427f3i": "rgba(255, 255, 255, 0.04)",
        "framer-jufpfh": "rgba(255, 255, 255, 0.04)",
        "framer-1c3n6lw": "rgba(255, 255, 255, 0.04)",
        "framer-ekq5up": "rgba(255, 255, 255, 0.04)",
        "framer-1ki962m": "rgba(255, 255, 255, 0.04)",
        "framer-15t1dfp": "rgba(255, 255, 255, 0.04)",
        "framer-3s7e4w": "rgba(255, 255, 255, 0.04)",
        "framer-1w1r0c7": "rgba(255, 255, 255, 0.04)",
        "framer-cvvwij": "rgba(255, 255, 255, 0.04)",
        "framer-1vpvxxf": "rgba(255, 255, 255, 0.04)",
        "framer-149u646": "rgba(255, 255, 255, 0.04)",
        "framer-1o7mum0": "rgba(255, 255, 255, 0.04)",
        "framer-ki1v17": "rgba(255, 255, 255, 0.04)",
        "framer-lhdvz8": "rgba(255, 255, 255, 0.04)",
        "framer-jy0fht": "rgba(255, 255, 255, 0.04)",
        "framer-99ymz4": "rgba(255, 255, 255, 0.04)",
        "framer-p09ia0": "rgba(255, 255, 255, 0.04)",
        "framer-13ehaqm": "rgba(255, 255, 255, 0.04)",
        "framer-1wbmnsw": "rgba(255, 255, 255, 0.04)",
        "framer-1ikz5w4": "rgba(255, 255, 255, 0.04)",
        "framer-z4q1to": "rgba(255, 255, 255, 0.04)",
        "framer-18xz9es": "rgba(255, 255, 255, 0.04)",
        "framer-1l729uo": "rgba(255, 255, 255, 0.04)",
        "framer-ft28bw": "rgba(255, 255, 255, 0.04)",
        "framer-1ewgg5n": "rgba(255, 255, 255, 0.04)",
        "framer-1qmstsw": "rgba(255, 255, 255, 0.04)",
        "framer-cxuw29": "rgba(255, 255, 255, 0.04)",
        "framer-cg40le": "rgba(255, 255, 255, 0.04)",
        "framer-dutair": "rgba(255, 255, 255, 0.04)",
        "framer-4oapi9": "rgba(255, 255, 255, 0.04)",
        "framer-1erawlh": "rgba(255, 255, 255, 0.04)",
        "framer-1y5k2gj": "rgba(255, 255, 255, 0.04)",
        "framer-1lbic0v": "rgba(255, 255, 255, 0.04)",
        "framer-1opocxv": "rgba(255, 255, 255, 0.04)",
        "framer-12khtk0": "rgba(255, 255, 255, 0.04)",
        "framer-bwyhrh": "rgba(255, 255, 255, 0.04)",
        "framer-1uubtjq": "rgba(255, 255, 255, 0.04)",
        "framer-140mxx7": "rgba(255, 255, 255, 0.04)",
        "framer-1cx2l59": "rgba(255, 255, 255, 0.04)",
        "framer-11lvdrf": "rgba(255, 255, 255, 0.04)",
        "framer-10s17r7": "rgba(255, 255, 255, 0.04)",
        "framer-1jsn0l4": "rgba(255, 255, 255, 0.04)",
        "framer-7xfhaj": "rgba(255, 255, 255, 0.04)",
        "framer-1rrd2yl": "rgba(255, 255, 255, 0.04)",
        "framer-wr2mdi": "rgba(255, 255, 255, 0.04)",
        "framer-tm9wqz": "rgba(255, 255, 255, 0.04)",
        "framer-112ouxp": "rgba(255, 255, 255, 0.04)",
        "framer-1wn4wwg": "rgba(255, 255, 255, 0.04)",
        "framer-1qbbaf": "rgba(255, 255, 255, 0.04)",
        "framer-rxy7g3": "rgba(255, 255, 255, 0.04)",
        "framer-18g76l8": "rgba(255, 255, 255, 0.04)",
        "framer-s30zx7": "rgba(255, 255, 255, 0.04)",
        "framer-116wxpu": "rgba(255, 255, 255, 0.04)",
        "framer-1c5xnue": "rgba(255, 255, 255, 0.04)",
        "framer-qf8qx3": "rgba(255, 255, 255, 0.04)",
        "framer-1odc6hn": "rgba(255, 255, 255, 0.04)",
        "framer-19ap9de": "rgba(255, 255, 255, 0.04)",
        "framer-1vff8z3": "rgba(255, 255, 255, 0.04)",
        "framer-ythjyv": "rgba(255, 255, 255, 0.04)",
        "framer-9z37yi": "rgba(255, 255, 255, 0.04)",
        "framer-16w1k6o": "rgba(255, 255, 255, 0.04)",
        "framer-1xcik3l": "rgba(255, 255, 255, 0.04)",
        "framer-oukkhq": "rgba(255, 255, 255, 0.04)",
        "framer-lqila1": "rgba(255, 255, 255, 0.04)",
        "framer-1fdpwik": "rgba(255, 255, 255, 0.04)",
        "framer-ekzdww": "rgba(255, 255, 255, 0.04)",
        "framer-m2a85j": "rgba(255, 255, 255, 0.04)",
        "framer-41rnem": "rgba(255, 255, 255, 0.04)",
        "framer-19zo0xy": "rgba(255, 255, 255, 0.04)",
        "framer-xk8c1l": "rgba(255, 255, 255, 0.04)",
        "framer-lvrz1c": "rgba(255, 255, 255, 0.04)",
        "framer-x277m4": "rgba(255, 255, 255, 0.04)",
        "framer-jkqkpl": "rgba(255, 255, 255, 0.04)",
        "framer-5hr7x3": "rgba(255, 255, 255, 0.04)",
        "framer-1m0phhu": "rgba(255, 255, 255, 0.04)",
        "framer-yi8kxp": "rgba(255, 255, 255, 0.04)",
        "framer-1rjqh9s": "rgba(255, 255, 255, 0.04)",
        "framer-g47dyw": "rgba(255, 255, 255, 0.04)",
        "framer-q0k5a6": "rgba(255, 255, 255, 0.04)",
        "framer-pcgh1x": "rgba(255, 255, 255, 0.04)",
        "framer-xw0rvq": "rgba(255, 255, 255, 0.04)",
        "framer-c3k2a9": "rgba(255, 255, 255, 0.04)",
        "framer-1pdnlep": "rgba(255, 255, 255, 0.04)",
        "framer-1isj3ve": "rgba(255, 255, 255, 0.04)",
        "framer-1nzo316": "rgba(255, 255, 255, 0.04)",
        "framer-ny2nrf": "rgba(255, 255, 255, 0.04)",
        "framer-1dtzjxr": "rgba(255, 255, 255, 0.04)",
        "framer-mu508z": "rgba(255, 255, 255, 0.04)",
        "framer-qpfp6n": "rgba(255, 255, 255, 0.04)",
        "framer-14eawsu": "rgba(255, 255, 255, 0.04)",
        "framer-s21ssb": "rgba(255, 255, 255, 0.04)",
        "framer-hqplw1": "rgba(255, 255, 255, 0.04)",
        "framer-bklpz1": "rgba(255, 255, 255, 0.04)",
        "framer-1imnrwl": "rgba(255, 255, 255, 0.04)",
        "framer-gzpem3": "rgba(255, 255, 255, 0.04)",
        "framer-1idhh85": "rgba(255, 255, 255, 0.04)",
        "framer-1j46jly": "rgba(255, 255, 255, 0.04)",
        "framer-1dsuymd": "rgba(255, 255, 255, 0.04)",
        "framer-zogoby": "rgba(255, 255, 255, 0.04)",
        "framer-1d3g9c1": "rgba(255, 255, 255, 0.04)",
        "framer-1o544t5": "rgba(255, 255, 255, 0.04)",
        "framer-1m6q3w4": "rgba(255, 255, 255, 0.04)",
        "framer-mg2djc": "rgba(255, 255, 255, 0.04)",
        "framer-17ralnl": "rgba(255, 255, 255, 0.04)",
        "framer-1rurt58": "rgba(255, 255, 255, 0.04)",
        "framer-gf48he": "rgba(255, 255, 255, 0.04)",
        "framer-17zgy7z": "rgba(255, 255, 255, 0.04)",
        "framer-1rzm2gb": "rgba(255, 255, 255, 0.04)",
        "framer-y89xtg": "rgba(255, 255, 255, 0.04)",
        "framer-106i2vh": "rgba(255, 255, 255, 0.04)",
        "framer-p1tl7s": "rgba(255, 255, 255, 0.04)",
        "framer-mtqgug": "rgba(255, 255, 255, 0.04)",
        "framer-1788u0c": "rgba(255, 255, 255, 0.04)",
        "framer-1wmn822": "rgba(255, 255, 255, 0.04)",
        "framer-1v5bd5y": "rgba(255, 255, 255, 0.04)",
        "framer-uo544c": "rgba(255, 255, 255, 0.04)",
        "framer-7qtus5": "rgba(255, 255, 255, 0.04)",
        "framer-gqq0zi": "rgba(255, 255, 255, 0.04)",
        "framer-1drnvw6": "rgba(255, 255, 255, 0.04)",
        "framer-17z9tw4": "rgba(255, 255, 255, 0.04)",
        "framer-3bymer": "rgba(255, 255, 255, 0.04)",
        "framer-mnk1l5": "rgba(255, 255, 255, 0.04)",
        "framer-m79my0": "rgba(255, 255, 255, 0.04)",
        "framer-14o7iob": "rgba(255, 255, 255, 0.04)",
        "framer-wez924": "rgba(255, 255, 255, 0.04)",
        "framer-1mgfm9b": "rgba(255, 255, 255, 0.04)",
        "framer-45l0gt": "rgba(255, 255, 255, 0.04)",
        "framer-zf9unh": "rgba(255, 255, 255, 0.04)",
        "framer-11ud222": "rgba(255, 255, 255, 0.04)",
        "framer-1mzlzv1": "rgba(255, 255, 255, 0.04)",
        "framer-1fib5c": "rgba(255, 255, 255, 0.04)",
        "framer-oaiogv": "rgba(255, 255, 255, 0.04)",
        "framer-zep14j": "rgba(255, 255, 255, 0.04)",
        "framer-1brj1ht": "rgba(255, 255, 255, 0.04)",
        "framer-1pqx6tg": "rgba(255, 255, 255, 0.04)",
        "framer-2wbw88": "rgba(255, 255, 255, 0.04)",
        "framer-97hh1c": "rgba(255, 255, 255, 0.04)",
        "framer-1scvxj2": "rgba(255, 255, 255, 0.04)",
        "framer-usy4xf": "rgba(255, 255, 255, 0.04)",
        "framer-1nrqj7q": "rgba(255, 255, 255, 0.04)",
        "framer-1l8jyo7": "rgba(255, 255, 255, 0.04)",
        "framer-1wj5wmr": "rgba(255, 255, 255, 0.04)",
        "framer-5dbofz": "rgba(255, 255, 255, 0.04)",
        "framer-1p29g0f": "rgba(255, 255, 255, 0.04)",
        "framer-13hsqgp": "rgba(255, 255, 255, 0.04)",
        "framer-k3f6s7": "rgba(255, 255, 255, 0.04)",
        "framer-czp6kw": "rgba(255, 255, 255, 0.04)",
        "framer-b8p4so": "rgba(255, 255, 255, 0.04)",
        "framer-td5exg": "rgba(255, 255, 255, 0.04)",
        "framer-rlul9t": "rgba(255, 255, 255, 0.04)",
        "framer-1qbi01j": "rgba(255, 255, 255, 0.04)",
        "framer-11yihtu": "rgba(255, 255, 255, 0.04)",
        "framer-1jw3h1j": "rgba(255, 255, 255, 0.04)",
        "framer-1982gyu": "rgba(255, 255, 255, 0.04)",
        "framer-1kx8z1s": "rgba(255, 255, 255, 0.04)",
        "framer-1jo2xb0": "rgba(255, 255, 255, 0.04)",
        "framer-ozo1q7": "rgba(255, 255, 255, 0.04)",
        "framer-lndw3q": "rgba(255, 255, 255, 0.04)",
        "framer-1ggyd5i": "rgba(255, 255, 255, 0.04)",
        "framer-1hi908g": "rgba(255, 255, 255, 0.04)",
        "framer-1y8hrwf": "rgba(255, 255, 255, 0.04)",
        "framer-bnxcb5": "rgba(255, 255, 255, 0.04)",
        "framer-6ip5m0": "rgba(255, 255, 255, 0.04)",
        "framer-5lgj4i": "rgba(255, 255, 255, 0.04)",
        "framer-15gcew7": "rgba(255, 255, 255, 0.04)",
        "framer-1h71ow4": "rgba(255, 255, 255, 0.04)",
        "framer-1n1itqm": "rgba(255, 255, 255, 0.04)",
        "framer-yyvhfo": "rgba(255, 255, 255, 0.04)",
        "framer-1fh5h8g": "rgba(255, 255, 255, 0.04)",
        "framer-1xq5s95": "rgba(255, 255, 255, 0.04)",
        "framer-tecic8": "rgba(255, 255, 255, 0.04)",
        "framer-cdfvoq": "rgba(255, 255, 255, 0.04)",
        "framer-1gkcgnr": "rgba(255, 255, 255, 0.04)",
        "framer-1xajlqd": "rgba(255, 255, 255, 0.04)",
        "framer-wobegw": "rgba(255, 255, 255, 0.04)",
        "framer-xezr57": "rgba(255, 255, 255, 0.04)",
        "framer-is8obf": "rgba(255, 255, 255, 0.04)",
        "framer-1adwqk8": "rgba(255, 255, 255, 0.04)",
        "framer-zgffy0": "rgba(255, 255, 255, 0.04)",
        "framer-1j53vuy": "rgba(255, 255, 255, 0.04)",
        "framer-xsn7x8": "rgba(255, 255, 255, 0.04)",
        "framer-1s80omz": "rgba(255, 255, 255, 0.04)",
        "framer-k6zy4o": "rgba(255, 255, 255, 0.04)",
        "framer-1wflc0e": "rgba(255, 255, 255, 0.04)",
        "framer-2rt8zl": "rgba(255, 255, 255, 0.04)",
        "framer-1drs3dv": "rgba(255, 255, 255, 0.04)",
        "framer-f4fnpl": "rgba(255, 255, 255, 0.04)",
        "framer-1oh6k57": "rgba(255, 255, 255, 0.04)",
        "framer-15ghu57": "rgba(255, 255, 255, 0.04)",
        "framer-u9hm8p": "rgba(255, 255, 255, 0.04)",
        "framer-9ayv4y": "rgba(255, 255, 255, 0.04)",
        "framer-uiax3g": "rgba(255, 255, 255, 0.04)",
        "framer-nhfppx": "rgba(255, 255, 255, 0.04)",
        "framer-10skth4": "rgba(255, 255, 255, 0.04)",
        "framer-zvsym": "rgba(255, 255, 255, 0.04)",
        "framer-1dguqyv": "rgba(255, 255, 255, 0.04)",
        "framer-10j66y7": "rgba(255, 255, 255, 0.04)",
        "framer-asyr5b": "rgba(255, 255, 255, 0.04)",
        "framer-1kiw2qy": "rgba(255, 255, 255, 0.04)",
        "framer-f4zdyj": "rgba(255, 255, 255, 0.04)",
        "framer-qp5ir6": "rgba(255, 255, 255, 0.04)",
        "framer-ugpy4l": "rgba(255, 255, 255, 0.04)",
        "framer-1v5qg4b": "rgba(255, 255, 255, 0.04)",
        "framer-l8awnf": "rgba(255, 255, 255, 0.04)",
        "framer-1gmovvw": "rgba(255, 255, 255, 0.04)",
        "framer-sutdmt": "rgba(255, 255, 255, 0.04)",
        "framer-1trny2v": "rgba(255, 255, 255, 0.04)",
        "framer-1cdohfe": "rgba(255, 255, 255, 0.04)",
        "framer-t9fqjc": "rgba(255, 255, 255, 0.04)",
        "framer-1xtosav": "rgba(255, 255, 255, 0.04)",
        "framer-vk3hjo": "rgba(255, 255, 255, 0.04)",
        "framer-sreof1": "rgba(255, 255, 255, 0.04)",
        "framer-3qmhxn": "rgba(255, 255, 255, 0.04)",
        "framer-hplkdw": "rgba(255, 255, 255, 0.04)",
        "framer-1pthapd": "rgba(255, 255, 255, 0.04)",
        "framer-xc32tt": "rgba(255, 255, 255, 0.04)",
        "framer-1u11iky": "rgba(255, 255, 255, 0.04)",
        "framer-d6cngf": "rgba(255, 255, 255, 0.04)",
        "framer-1i34tns": "rgba(255, 255, 255, 0.04)",
        "framer-906618": "rgba(255, 255, 255, 0.04)",
        "framer-1y2a24g": "rgba(255, 255, 255, 0.04)",
        "framer-1i7zrv5": "rgba(255, 255, 255, 0.04)",
        "framer-1suuahx": "rgba(255, 255, 255, 0.04)",
        "framer-1oyg0cr": "rgba(255, 255, 255, 0.04)",
        "framer-n55er7": "rgba(255, 255, 255, 0.04)",
        "framer-1en2cnq": "rgba(255, 255, 255, 0.04)",
        "framer-psjjo8": "rgba(255, 255, 255, 0.04)",
        "framer-14r2wfh": "rgba(255, 255, 255, 0.04)",
        "framer-fbzlsf": "rgba(255, 255, 255, 0.04)",
        "framer-vmchm3": "rgba(255, 255, 255, 0.04)",
        "framer-i91vgm": "rgba(255, 255, 255, 0.04)",
        "framer-yi8kes": "rgba(255, 255, 255, 0.04)",
        "framer-1n4420v": "rgba(255, 255, 255, 0.04)",
        "framer-198giob": "rgba(255, 255, 255, 0.04)",
        "framer-g8x8gx": "rgba(255, 255, 255, 0.04)",
        "framer-1mhsv49": "rgba(255, 255, 255, 0.04)",
        "framer-1nh0jro": "rgba(255, 255, 255, 0.04)",
        "framer-1lwq65t": "rgba(255, 255, 255, 0.04)",
        "framer-1qd6oi": "rgba(255, 255, 255, 0.04)",
        "framer-7ps415": "rgba(255, 255, 255, 0.04)",
        "framer-sljn5b": "rgba(255, 255, 255, 0.04)",
        "framer-gbdnvn": "rgba(255, 255, 255, 0.04)",
        "framer-1hbglek": "rgba(255, 255, 255, 0.04)",
        "framer-pdko06": "rgba(255, 255, 255, 0.04)",
        "framer-1mx2enx": "rgba(255, 255, 255, 0.04)",
        "framer-sr9rxt": "rgba(255, 255, 255, 0.04)",
        "framer-68e1wx": "rgba(255, 255, 255, 0.04)",
        "framer-1x2z7rq": "rgba(255, 255, 255, 0.04)",
        "framer-15apzd": "rgba(255, 255, 255, 0.04)",
        "framer-iytitg": "rgba(255, 255, 255, 0.04)",
        "framer-v0ogr5": "rgba(255, 255, 255, 0.04)",
        "framer-9vo8zm": "rgba(255, 255, 255, 0.04)",
        "framer-ud6nss": "rgba(255, 255, 255, 0.04)",
        "framer-978p0s": "rgba(255, 255, 255, 0.04)",
        "framer-8pji0e": "rgba(255, 255, 255, 0.04)",
        "framer-12jhrfd": "rgba(255, 255, 255, 0.04)",
        "framer-d2s7aa": "rgba(255, 255, 255, 0.04)",
        "framer-l0sqmy": "rgba(255, 255, 255, 0.04)",
        "framer-1qa7u6k": "rgba(255, 255, 255, 0.04)",
        "framer-tquodz": "rgba(255, 255, 255, 0.04)",
        "framer-yncmmi": "rgba(255, 255, 255, 0.04)",
        "framer-1xx4aok": "rgba(255, 255, 255, 0.04)",
        "framer-1mqv4oz": "rgba(255, 255, 255, 0.04)",
        "framer-vhaobv": "rgba(255, 255, 255, 0.04)",
        "framer-6pkxu0": "rgba(255, 255, 255, 0.04)",
        "framer-c34o2l": "rgba(255, 255, 255, 0.04)",
        "framer-txmp65": "rgba(255, 255, 255, 0.04)",
        "framer-od41ta": "rgba(255, 255, 255, 0.04)",
        "framer-78b9vw": "rgba(255, 255, 255, 0.04)",
        "framer-p4w8us": "rgba(255, 255, 255, 0.04)",
        "framer-1e1cat9": "rgba(255, 255, 255, 0.04)",
        "framer-47lkyg": "rgba(255, 255, 255, 0.04)",
        "framer-1nyvkz": "rgba(255, 255, 255, 0.04)",
        "framer-16wwq2l": "rgba(255, 255, 255, 0.04)",
        "framer-ohb4se": "rgba(255, 255, 255, 0.04)",
        "framer-fdn6q4": "rgba(255, 255, 255, 0.04)",
        "framer-1rsqnb8": "rgba(255, 255, 255, 0.04)",
        "framer-18lxnea": "rgba(255, 255, 255, 0.04)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (32).html"
    },
    {
      "colors": {
        "framer-fnwwxo": "rgba(255, 255, 255, 0.05)",
        "framer-1wyam6m": "rgba(255, 255, 255, 0.2)",
        "framer-1pp6x1n": "rgba(255, 255, 255, 0.2)",
        "framer-1kx8h30": "rgba(255, 255, 255, 0.2)",
        "framer-38qo6l": "rgba(255, 255, 255, 0.2)",
        "framer-1bgkq86": "rgba(255, 255, 255, 0.2)",
        "framer-1odgaps": "rgba(255, 255, 255, 0.2)",
        "framer-ocebul": "rgba(255, 255, 255, 0.2)",
        "framer-htsvoh": "rgba(255, 255, 255, 0.2)",
        "framer-1rjcid1": "rgba(255, 255, 255, 0.2)",
        "framer-1ppu9nu": "rgba(255, 255, 255, 0.2)",
        "framer-b26c6s": "rgba(255, 255, 255, 0.2)",
        "framer-k15ji": "rgba(255, 255, 255, 0.2)",
        "framer-w1jb1u": "rgba(255, 255, 255, 0.2)",
        "framer-1b65fof": "rgba(255, 255, 255, 0.2)",
        "framer-ag946t": "rgba(255, 255, 255, 0.2)",
        "framer-njpiav": "rgba(255, 255, 255, 0.2)",
        "framer-fzosm0": "rgba(255, 255, 255, 0.2)",
        "framer-31j99c": "rgba(255, 255, 255, 0.2)",
        "framer-wbharp": "rgba(255, 255, 255, 0.2)",
        "framer-1o6h43g": "rgba(255, 255, 255, 0.2)",
        "framer-w8h1i4": "rgba(255, 255, 255, 0.2)",
        "framer-u08o4f": "rgba(255, 255, 255, 0.2)",
        "framer-1883ili": "rgba(255, 255, 255, 0.2)",
        "framer-hhqq21": "rgba(255, 255, 255, 0.2)",
        "framer-1qddyrc": "rgba(255, 255, 255, 0.2)",
        "framer-36rsch": "rgba(255, 255, 255, 0.2)",
        "framer-1vhup78": "rgba(255, 255, 255, 0.2)",
        "framer-1wy0vut": "rgba(255, 255, 255, 0.2)",
        "framer-1tldixq": "rgba(255, 255, 255, 0.2)",
        "framer-vcglv4": "rgba(255, 255, 255, 0.2)",
        "framer-mnkyk9": "rgba(255, 255, 255, 0.2)",
        "framer-1gd8uia": "rgba(255, 255, 255, 0.2)",
        "framer-4v17kk": "rgba(255, 255, 255, 0.2)",
        "framer-wcgbdx": "rgba(255, 255, 255, 0.2)",
        "framer-19ge0mq": "rgba(255, 255, 255, 0.2)",
        "framer-142xl0d": "rgba(255, 255, 255, 0.2)",
        "framer-ao5kmt": "rgba(255, 255, 255, 0.2)",
        "framer-1rc6i1r": "rgba(255, 255, 255, 0.2)",
        "framer-1wlwqo": "rgba(255, 255, 255, 0.2)",
        "framer-1tzx2st": "rgba(255, 255, 255, 0.2)",
        "framer-z8gsz9": "rgba(255, 255, 255, 0.2)",
        "framer-1fgz62q": "rgba(255, 255, 255, 0.2)",
        "framer-n6tpd7": "rgba(255, 255, 255, 0.2)",
        "framer-1otl1h8": "rgba(255, 255, 255, 0.2)",
        "framer-1vi730u": "rgba(255, 255, 255, 0.2)",
        "framer-1klteqi": "rgba(255, 255, 255, 0.2)",
        "framer-36msax": "rgba(255, 255, 255, 0.2)",
        "framer-1feur12": "rgba(255, 255, 255, 0.2)",
        "framer-1lyqxag": "rgba(255, 255, 255, 0.2)",
        "framer-5a7aqr": "rgba(255, 255, 255, 0.2)",
        "framer-82cjev": "rgba(255, 255, 255, 0.2)",
        "framer-10a7t8v": "rgba(255, 255, 255, 0.2)",
        "framer-7pex0i": "rgba(255, 255, 255, 0.2)",
        "framer-1r4ihlp": "rgba(255, 255, 255, 0.2)",
        "framer-1cjy5e6": "rgba(255, 255, 255, 0.2)",
        "framer-1f59xpm": "rgba(255, 255, 255, 0.2)",
        "framer-13qpo9p": "rgba(255, 255, 255, 0.2)",
        "framer-160oi7c": "rgba(255, 255, 255, 0.2)",
        "framer-8v07ff": "rgba(255, 255, 255, 0.2)",
        "framer-ry0yv5": "rgba(255, 255, 255, 0.2)",
        "framer-427f3i": "rgba(255, 255, 255, 0.2)",
        "framer-jufpfh": "rgba(255, 255, 255, 0.2)",
        "framer-1c3n6lw": "rgba(255, 255, 255, 0.2)",
        "framer-ekq5up": "rgba(255, 255, 255, 0.2)",
        "framer-1ki962m": "rgba(255, 255, 255, 0.2)",
        "framer-15t1dfp": "rgba(255, 255, 255, 0.2)",
        "framer-3s7e4w": "rgba(255, 255, 255, 0.2)",
        "framer-1w1r0c7": "rgba(255, 255, 255, 0.2)",
        "framer-cvvwij": "rgba(255, 255, 255, 0.2)",
        "framer-1vpvxxf": "rgba(255, 255, 255, 0.2)",
        "framer-149u646": "rgba(255, 255, 255, 0.2)",
        "framer-1o7mum0": "rgba(255, 255, 255, 0.2)",
        "framer-ki1v17": "rgba(255, 255, 255, 0.2)",
        "framer-lhdvz8": "rgba(255, 255, 255, 0.2)",
        "framer-jy0fht": "rgba(255, 255, 255, 0.2)",
        "framer-99ymz4": "rgba(255, 255, 255, 0.2)",
        "framer-p09ia0": "rgba(255, 255, 255, 0.2)",
        "framer-13ehaqm": "rgba(255, 255, 255, 0.2)",
        "framer-1wbmnsw": "rgba(255, 255, 255, 0.2)",
        "framer-1ikz5w4": "rgba(255, 255, 255, 0.2)",
        "framer-z4q1to": "rgba(255, 255, 255, 0.2)",
        "framer-18xz9es": "rgba(255, 255, 255, 0.2)",
        "framer-1l729uo": "rgba(255, 255, 255, 0.2)",
        "framer-ft28bw": "rgba(255, 255, 255, 0.2)",
        "framer-1ewgg5n": "rgba(255, 255, 255, 0.2)",
        "framer-1qmstsw": "rgba(255, 255, 255, 0.2)",
        "framer-cxuw29": "rgba(255, 255, 255, 0.2)",
        "framer-cg40le": "rgba(255, 255, 255, 0.2)",
        "framer-dutair": "rgba(255, 255, 255, 0.2)",
        "framer-4oapi9": "rgba(255, 255, 255, 0.2)",
        "framer-1erawlh": "rgba(255, 255, 255, 0.2)",
        "framer-1y5k2gj": "rgba(255, 255, 255, 0.2)",
        "framer-1lbic0v": "rgba(255, 255, 255, 0.2)",
        "framer-1opocxv": "rgba(255, 255, 255, 0.2)",
        "framer-12khtk0": "rgba(255, 255, 255, 0.2)",
        "framer-bwyhrh": "rgba(255, 255, 255, 0.2)",
        "framer-1uubtjq": "rgba(255, 255, 255, 0.2)",
        "framer-140mxx7": "rgba(255, 255, 255, 0.2)",
        "framer-1cx2l59": "rgba(255, 255, 255, 0.2)",
        "framer-11lvdrf": "rgba(255, 255, 255, 0.2)",
        "framer-10s17r7": "rgba(255, 255, 255, 0.2)",
        "framer-1jsn0l4": "rgba(255, 255, 255, 0.2)",
        "framer-7xfhaj": "rgba(255, 255, 255, 0.2)",
        "framer-1rrd2yl": "rgba(255, 255, 255, 0.2)",
        "framer-wr2mdi": "rgba(255, 255, 255, 0.2)",
        "framer-tm9wqz": "rgba(255, 255, 255, 0.2)",
        "framer-112ouxp": "rgba(255, 255, 255, 0.2)",
        "framer-1wn4wwg": "rgba(255, 255, 255, 0.2)",
        "framer-1qbbaf": "rgba(255, 255, 255, 0.2)",
        "framer-rxy7g3": "rgba(255, 255, 255, 0.2)",
        "framer-18g76l8": "rgba(255, 255, 255, 0.2)",
        "framer-s30zx7": "rgba(255, 255, 255, 0.2)",
        "framer-116wxpu": "rgba(255, 255, 255, 0.05)",
        "framer-1c5xnue": "rgba(255, 255, 255, 0.2)",
        "framer-qf8qx3": "rgba(255, 255, 255, 0.2)",
        "framer-1odc6hn": "rgba(255, 255, 255, 0.2)",
        "framer-19ap9de": "rgba(255, 255, 255, 0.2)",
        "framer-1vff8z3": "rgba(255, 255, 255, 0.2)",
        "framer-ythjyv": "rgba(255, 255, 255, 0.2)",
        "framer-9z37yi": "rgba(255, 255, 255, 0.2)",
        "framer-16w1k6o": "rgba(255, 255, 255, 0.2)",
        "framer-1xcik3l": "rgba(255, 255, 255, 0.2)",
        "framer-oukkhq": "rgba(255, 255, 255, 0.2)",
        "framer-lqila1": "rgba(255, 255, 255, 0.2)",
        "framer-1fdpwik": "rgba(255, 255, 255, 0.2)",
        "framer-ekzdww": "rgba(255, 255, 255, 0.2)",
        "framer-m2a85j": "rgba(255, 255, 255, 0.2)",
        "framer-41rnem": "rgba(255, 255, 255, 0.2)",
        "framer-19zo0xy": "rgba(255, 255, 255, 0.2)",
        "framer-xk8c1l": "rgba(255, 255, 255, 0.2)",
        "framer-lvrz1c": "rgba(255, 255, 255, 0.2)",
        "framer-x277m4": "rgba(255, 255, 255, 0.2)",
        "framer-jkqkpl": "rgba(255, 255, 255, 0.2)",
        "framer-5hr7x3": "rgba(255, 255, 255, 0.2)",
        "framer-1m0phhu": "rgba(255, 255, 255, 0.2)",
        "framer-yi8kxp": "rgba(255, 255, 255, 0.2)",
        "framer-1rjqh9s": "rgba(255, 255, 255, 0.2)",
        "framer-g47dyw": "rgba(255, 255, 255, 0.2)",
        "framer-q0k5a6": "rgba(255, 255, 255, 0.2)",
        "framer-pcgh1x": "rgba(255, 255, 255, 0.2)",
        "framer-xw0rvq": "rgba(255, 255, 255, 0.2)",
        "framer-c3k2a9": "rgba(255, 255, 255, 0.2)",
        "framer-1pdnlep": "rgba(255, 255, 255, 0.2)",
        "framer-1isj3ve": "rgba(255, 255, 255, 0.2)",
        "framer-1nzo316": "rgba(255, 255, 255, 0.2)",
        "framer-ny2nrf": "rgba(255, 255, 255, 0.2)",
        "framer-1dtzjxr": "rgba(255, 255, 255, 0.2)",
        "framer-mu508z": "rgba(255, 255, 255, 0.2)",
        "framer-qpfp6n": "rgba(255, 255, 255, 0.2)",
        "framer-14eawsu": "rgba(255, 255, 255, 0.2)",
        "framer-s21ssb": "rgba(255, 255, 255, 0.2)",
        "framer-hqplw1": "rgba(255, 255, 255, 0.2)",
        "framer-bklpz1": "rgba(255, 255, 255, 0.2)",
        "framer-1imnrwl": "rgba(255, 255, 255, 0.2)",
        "framer-gzpem3": "rgba(255, 255, 255, 0.2)",
        "framer-1idhh85": "rgba(255, 255, 255, 0.2)",
        "framer-1j46jly": "rgba(255, 255, 255, 0.2)",
        "framer-1dsuymd": "rgba(255, 255, 255, 0.2)",
        "framer-zogoby": "rgba(255, 255, 255, 0.2)",
        "framer-1d3g9c1": "rgba(255, 255, 255, 0.2)",
        "framer-1o544t5": "rgba(255, 255, 255, 0.2)",
        "framer-1m6q3w4": "rgba(255, 255, 255, 0.2)",
        "framer-mg2djc": "rgba(255, 255, 255, 0.2)",
        "framer-17ralnl": "rgba(255, 255, 255, 0.2)",
        "framer-1rurt58": "rgba(255, 255, 255, 0.2)",
        "framer-gf48he": "rgba(255, 255, 255, 0.2)",
        "framer-17zgy7z": "rgba(255, 255, 255, 0.2)",
        "framer-1rzm2gb": "rgba(255, 255, 255, 0.2)",
        "framer-y89xtg": "rgba(255, 255, 255, 0.2)",
        "framer-106i2vh": "rgba(255, 255, 255, 0.2)",
        "framer-p1tl7s": "rgba(255, 255, 255, 0.2)",
        "framer-mtqgug": "rgba(255, 255, 255, 0.2)",
        "framer-1788u0c": "rgba(255, 255, 255, 0.2)",
        "framer-1wmn822": "rgba(255, 255, 255, 0.2)",
        "framer-1v5bd5y": "rgba(255, 255, 255, 0.2)",
        "framer-uo544c": "rgba(255, 255, 255, 0.2)",
        "framer-7qtus5": "rgba(255, 255, 255, 0.2)",
        "framer-gqq0zi": "rgba(255, 255, 255, 0.2)",
        "framer-1drnvw6": "rgba(255, 255, 255, 0.2)",
        "framer-17z9tw4": "rgba(255, 255, 255, 0.2)",
        "framer-3bymer": "rgba(255, 255, 255, 0.2)",
        "framer-mnk1l5": "rgba(255, 255, 255, 0.2)",
        "framer-m79my0": "rgba(255, 255, 255, 0.2)",
        "framer-14o7iob": "rgba(255, 255, 255, 0.2)",
        "framer-wez924": "rgba(255, 255, 255, 0.2)",
        "framer-1mgfm9b": "rgba(255, 255, 255, 0.2)",
        "framer-45l0gt": "rgba(255, 255, 255, 0.2)",
        "framer-zf9unh": "rgba(255, 255, 255, 0.2)",
        "framer-11ud222": "rgba(255, 255, 255, 0.2)",
        "framer-1mzlzv1": "rgba(255, 255, 255, 0.2)",
        "framer-1fib5c": "rgba(255, 255, 255, 0.2)",
        "framer-oaiogv": "rgba(255, 255, 255, 0.2)",
        "framer-zep14j": "rgba(255, 255, 255, 0.2)",
        "framer-1brj1ht": "rgba(255, 255, 255, 0.2)",
        "framer-1pqx6tg": "rgba(255, 255, 255, 0.2)",
        "framer-2wbw88": "rgba(255, 255, 255, 0.2)",
        "framer-97hh1c": "rgba(255, 255, 255, 0.2)",
        "framer-1scvxj2": "rgba(255, 255, 255, 0.2)",
        "framer-usy4xf": "rgba(255, 255, 255, 0.2)",
        "framer-1nrqj7q": "rgba(255, 255, 255, 0.2)",
        "framer-1l8jyo7": "rgba(255, 255, 255, 0.2)",
        "framer-1wj5wmr": "rgba(255, 255, 255, 0.2)",
        "framer-5dbofz": "rgba(255, 255, 255, 0.2)",
        "framer-1p29g0f": "rgba(255, 255, 255, 0.2)",
        "framer-13hsqgp": "rgba(255, 255, 255, 0.2)",
        "framer-k3f6s7": "rgba(255, 255, 255, 0.2)",
        "framer-czp6kw": "rgba(255, 255, 255, 0.2)",
        "framer-b8p4so": "rgba(255, 255, 255, 0.2)",
        "framer-td5exg": "rgba(255, 255, 255, 0.2)",
        "framer-rlul9t": "rgba(255, 255, 255, 0.2)",
        "framer-1qbi01j": "rgba(255, 255, 255, 0.2)",
        "framer-11yihtu": "rgba(255, 255, 255, 0.2)",
        "framer-1jw3h1j": "rgba(255, 255, 255, 0.2)",
        "framer-1982gyu": "rgba(255, 255, 255, 0.2)",
        "framer-1kx8z1s": "rgba(255, 255, 255, 0.2)",
        "framer-1jo2xb0": "rgba(255, 255, 255, 0.2)",
        "framer-ozo1q7": "rgba(255, 255, 255, 0.2)",
        "framer-lndw3q": "rgba(255, 255, 255, 0.2)",
        "framer-1ggyd5i": "rgba(255, 255, 255, 0.2)",
        "framer-1hi908g": "rgba(255, 255, 255, 0.2)",
        "framer-1y8hrwf": "rgba(255, 255, 255, 0.2)",
        "framer-bnxcb5": "rgba(255, 255, 255, 0.2)",
        "framer-6ip5m0": "rgba(255, 255, 255, 0.2)",
        "framer-5lgj4i": "rgba(255, 255, 255, 0.2)",
        "framer-15gcew7": "rgba(255, 255, 255, 0.2)",
        "framer-1h71ow4": "rgba(255, 255, 255, 0.05)",
        "framer-1n1itqm": "rgba(255, 255, 255, 0.2)",
        "framer-yyvhfo": "rgba(255, 255, 255, 0.2)",
        "framer-1fh5h8g": "rgba(255, 255, 255, 0.2)",
        "framer-1xq5s95": "rgba(255, 255, 255, 0.2)",
        "framer-tecic8": "rgba(255, 255, 255, 0.2)",
        "framer-cdfvoq": "rgba(255, 255, 255, 0.2)",
        "framer-1gkcgnr": "rgba(255, 255, 255, 0.2)",
        "framer-1xajlqd": "rgba(255, 255, 255, 0.2)",
        "framer-wobegw": "rgba(255, 255, 255, 0.2)",
        "framer-xezr57": "rgba(255, 255, 255, 0.2)",
        "framer-is8obf": "rgba(255, 255, 255, 0.2)",
        "framer-1adwqk8": "rgba(255, 255, 255, 0.2)",
        "framer-zgffy0": "rgba(255, 255, 255, 0.2)",
        "framer-1j53vuy": "rgba(255, 255, 255, 0.2)",
        "framer-xsn7x8": "rgba(255, 255, 255, 0.2)",
        "framer-1s80omz": "rgba(255, 255, 255, 0.2)",
        "framer-k6zy4o": "rgba(255, 255, 255, 0.2)",
        "framer-1wflc0e": "rgba(255, 255, 255, 0.2)",
        "framer-2rt8zl": "rgba(255, 255, 255, 0.2)",
        "framer-1drs3dv": "rgba(255, 255, 255, 0.2)",
        "framer-f4fnpl": "rgba(255, 255, 255, 0.2)",
        "framer-1oh6k57": "rgba(255, 255, 255, 0.2)",
        "framer-15ghu57": "rgba(255, 255, 255, 0.2)",
        "framer-u9hm8p": "rgba(255, 255, 255, 0.2)",
        "framer-9ayv4y": "rgba(255, 255, 255, 0.2)",
        "framer-uiax3g": "rgba(255, 255, 255, 0.2)",
        "framer-nhfppx": "rgba(255, 255, 255, 0.2)",
        "framer-10skth4": "rgba(255, 255, 255, 0.2)",
        "framer-zvsym": "rgba(255, 255, 255, 0.2)",
        "framer-1dguqyv": "rgba(255, 255, 255, 0.2)",
        "framer-10j66y7": "rgba(255, 255, 255, 0.2)",
        "framer-asyr5b": "rgba(255, 255, 255, 0.2)",
        "framer-1kiw2qy": "rgba(255, 255, 255, 0.2)",
        "framer-f4zdyj": "rgba(255, 255, 255, 0.2)",
        "framer-qp5ir6": "rgba(255, 255, 255, 0.2)",
        "framer-ugpy4l": "rgba(255, 255, 255, 0.2)",
        "framer-1v5qg4b": "rgba(255, 255, 255, 0.2)",
        "framer-l8awnf": "rgba(255, 255, 255, 0.2)",
        "framer-1gmovvw": "rgba(255, 255, 255, 0.2)",
        "framer-sutdmt": "rgba(255, 255, 255, 0.2)",
        "framer-1trny2v": "rgba(255, 255, 255, 0.2)",
        "framer-1cdohfe": "rgba(255, 255, 255, 0.2)",
        "framer-t9fqjc": "rgba(255, 255, 255, 0.2)",
        "framer-1xtosav": "rgba(255, 255, 255, 0.2)",
        "framer-vk3hjo": "rgba(255, 255, 255, 0.2)",
        "framer-sreof1": "rgba(255, 255, 255, 0.2)",
        "framer-3qmhxn": "rgba(255, 255, 255, 0.2)",
        "framer-hplkdw": "rgba(255, 255, 255, 0.2)",
        "framer-1pthapd": "rgba(255, 255, 255, 0.2)",
        "framer-xc32tt": "rgba(255, 255, 255, 0.2)",
        "framer-1u11iky": "rgba(255, 255, 255, 0.2)",
        "framer-d6cngf": "rgba(255, 255, 255, 0.2)",
        "framer-1i34tns": "rgba(255, 255, 255, 0.2)",
        "framer-906618": "rgba(255, 255, 255, 0.2)",
        "framer-1y2a24g": "rgba(255, 255, 255, 0.2)",
        "framer-1i7zrv5": "rgba(255, 255, 255, 0.2)",
        "framer-1suuahx": "rgba(255, 255, 255, 0.2)",
        "framer-1oyg0cr": "rgba(255, 255, 255, 0.2)",
        "framer-n55er7": "rgba(255, 255, 255, 0.2)",
        "framer-1en2cnq": "rgba(255, 255, 255, 0.2)",
        "framer-psjjo8": "rgba(255, 255, 255, 0.2)",
        "framer-14r2wfh": "rgba(255, 255, 255, 0.2)",
        "framer-fbzlsf": "rgba(255, 255, 255, 0.2)",
        "framer-vmchm3": "rgba(255, 255, 255, 0.2)",
        "framer-i91vgm": "rgba(255, 255, 255, 0.2)",
        "framer-yi8kes": "rgba(255, 255, 255, 0.2)",
        "framer-1n4420v": "rgba(255, 255, 255, 0.2)",
        "framer-198giob": "rgba(255, 255, 255, 0.2)",
        "framer-g8x8gx": "rgba(255, 255, 255, 0.2)",
        "framer-1mhsv49": "rgba(255, 255, 255, 0.2)",
        "framer-1nh0jro": "rgba(255, 255, 255, 0.2)",
        "framer-1lwq65t": "rgba(255, 255, 255, 0.2)",
        "framer-1qd6oi": "rgba(255, 255, 255, 0.2)",
        "framer-7ps415": "rgba(255, 255, 255, 0.2)",
        "framer-sljn5b": "rgba(255, 255, 255, 0.2)",
        "framer-gbdnvn": "rgba(255, 255, 255, 0.2)",
        "framer-1hbglek": "rgba(255, 255, 255, 0.2)",
        "framer-pdko06": "rgba(255, 255, 255, 0.2)",
        "framer-1mx2enx": "rgba(255, 255, 255, 0.2)",
        "framer-sr9rxt": "rgba(255, 255, 255, 0.2)",
        "framer-68e1wx": "rgba(255, 255, 255, 0.2)",
        "framer-1x2z7rq": "rgba(255, 255, 255, 0.2)",
        "framer-15apzd": "rgba(255, 255, 255, 0.2)",
        "framer-iytitg": "rgba(255, 255, 255, 0.2)",
        "framer-v0ogr5": "rgba(255, 255, 255, 0.2)",
        "framer-9vo8zm": "rgba(255, 255, 255, 0.2)",
        "framer-ud6nss": "rgba(255, 255, 255, 0.2)",
        "framer-978p0s": "rgba(255, 255, 255, 0.2)",
        "framer-8pji0e": "rgba(255, 255, 255, 0.2)",
        "framer-12jhrfd": "rgba(255, 255, 255, 0.2)",
        "framer-d2s7aa": "rgba(255, 255, 255, 0.2)",
        "framer-l0sqmy": "rgba(255, 255, 255, 0.2)",
        "framer-1qa7u6k": "rgba(255, 255, 255, 0.2)",
        "framer-tquodz": "rgba(255, 255, 255, 0.2)",
        "framer-yncmmi": "rgba(255, 255, 255, 0.2)",
        "framer-1xx4aok": "rgba(255, 255, 255, 0.2)",
        "framer-1mqv4oz": "rgba(255, 255, 255, 0.2)",
        "framer-vhaobv": "rgba(255, 255, 255, 0.2)",
        "framer-6pkxu0": "rgba(255, 255, 255, 0.2)",
        "framer-c34o2l": "rgba(255, 255, 255, 0.2)",
        "framer-txmp65": "rgba(255, 255, 255, 0.2)",
        "framer-od41ta": "rgba(255, 255, 255, 0.2)",
        "framer-78b9vw": "rgba(255, 255, 255, 0.2)",
        "framer-p4w8us": "rgba(255, 255, 255, 0.2)",
        "framer-1e1cat9": "rgba(255, 255, 255, 0.2)",
        "framer-47lkyg": "rgba(255, 255, 255, 0.2)",
        "framer-1nyvkz": "rgba(255, 255, 255, 0.2)",
        "framer-16wwq2l": "rgba(255, 255, 255, 0.2)",
        "framer-ohb4se": "rgba(255, 255, 255, 0.2)",
        "framer-fdn6q4": "rgba(255, 255, 255, 0.2)",
        "framer-1rsqnb8": "rgba(255, 255, 255, 0.2)",
        "framer-18lxnea": "rgba(255, 255, 255, 0.2)",
        "framer-fiyyst": "rgba(255, 255, 255, 0.04)",
        "framer-ciyq8x": "rgba(255, 255, 255, 0.04)",
        "framer-1q66old": "rgba(255, 255, 255, 0.04)",
        "framer-1qi4x9e": "rgba(255, 255, 255, 0.04)",
        "framer-1gptz2q": "rgba(255, 255, 255, 0.04)",
        "framer-1455pd0": "rgba(255, 255, 255, 0.04)",
        "framer-1fit9b7": "rgba(255, 255, 255, 0.04)",
        "framer-hi43jy": "rgba(255, 255, 255, 0.04)",
        "framer-1wd6cu5": "rgba(255, 255, 255, 0.04)",
        "framer-1ylwb2d": "rgba(255, 255, 255, 0.04)",
        "framer-1y9yxe2": "rgba(255, 255, 255, 0.04)",
        "framer-qvneen": "rgba(255, 255, 255, 0.04)",
        "framer-wjo0e9": "rgba(255, 255, 255, 0.04)",
        "framer-czpr7r": "rgba(255, 255, 255, 0.04)",
        "framer-vj2fgs": "rgba(255, 255, 255, 0.04)",
        "framer-hoxygt": "rgba(255, 255, 255, 0.04)",
        "framer-48kwqi": "rgba(255, 255, 255, 0.04)",
        "framer-u5krqo": "rgba(255, 255, 255, 0.04)",
        "framer-w896tp": "rgba(255, 255, 255, 0.04)",
        "framer-1wk1y40": "rgba(255, 255, 255, 0.04)",
        "framer-33r2dq": "rgba(255, 255, 255, 0.04)",
        "framer-1gbanx3": "rgba(255, 255, 255, 0.04)",
        "framer-1ux33dn": "rgba(255, 255, 255, 0.04)",
        "framer-3lw8u8": "rgba(255, 255, 255, 0.04)",
        "framer-1czikuk": "rgba(255, 255, 255, 0.04)",
        "framer-q6eebf": "rgba(255, 255, 255, 0.04)",
        "framer-1gdzggg": "rgba(255, 255, 255, 0.04)",
        "framer-tsui6n": "rgba(255, 255, 255, 0.04)",
        "framer-vgwsmu": "rgba(255, 255, 255, 0.04)",
        "framer-1tmsih3": "rgba(255, 255, 255, 0.04)",
        "framer-btodsk": "rgba(255, 255, 255, 0.04)",
        "framer-1c27p2n": "rgba(255, 255, 255, 0.04)",
        "framer-hj95w1": "rgba(255, 255, 255, 0.04)",
        "framer-1dyz5ca": "rgba(255, 255, 255, 0.04)",
        "framer-et0m12": "rgba(255, 255, 255, 0.04)",
        "framer-vnh2vx": "rgba(255, 255, 255, 0.04)",
        "framer-1l61glq": "rgba(255, 255, 255, 0.04)",
        "framer-qzjyt5": "rgba(255, 255, 255, 0.04)",
        "framer-1j65h5c": "rgba(255, 255, 255, 0.04)",
        "framer-ujqrvs": "rgba(255, 255, 255, 0.04)",
        "framer-ooft64": "rgba(255, 255, 255, 0.04)",
        "framer-1wfl7nv": "rgba(255, 255, 255, 0.04)",
        "framer-17irg2n": "rgba(255, 255, 255, 0.04)",
        "framer-l109y1": "rgba(255, 255, 255, 0.04)",
        "framer-14fhv1t": "rgba(255, 255, 255, 0.04)",
        "framer-763vv": "rgba(255, 255, 255, 0.04)",
        "framer-ekdddg": "rgba(255, 255, 255, 0.04)",
        "framer-lczi8i": "rgba(255, 255, 255, 0.04)",
        "framer-1k3zzg8": "rgba(255, 255, 255, 0.04)",
        "framer-1nze31j": "rgba(255, 255, 255, 0.04)",
        "framer-1izz6de": "rgba(255, 255, 255, 0.04)",
        "framer-cva9wu": "rgba(255, 255, 255, 0.04)",
        "framer-myr3v0": "rgba(255, 255, 255, 0.04)",
        "framer-3fv7cz": "rgba(255, 255, 255, 0.04)",
        "framer-1cb7j9a": "rgba(255, 255, 255, 0.04)",
        "framer-bvmogv": "rgba(255, 255, 255, 0.04)",
        "framer-1nvc6l8": "rgba(255, 255, 255, 0.04)",
        "framer-1k694lj": "rgba(255, 255, 255, 0.04)",
        "framer-1br5jo5": "rgba(255, 255, 255, 0.04)",
        "framer-91edth": "rgba(255, 255, 255, 0.04)",
        "framer-19nd5re": "rgba(255, 255, 255, 0.04)",
        "framer-11zy7gz": "rgba(255, 255, 255, 0.04)",
        "framer-183jbxw": "rgba(255, 255, 255, 0.04)",
        "framer-1k2kjzb": "rgba(255, 255, 255, 0.04)",
        "framer-e0p84p": "rgba(255, 255, 255, 0.04)",
        "framer-170af3e": "rgba(255, 255, 255, 0.04)",
        "framer-ghrn1n": "rgba(255, 255, 255, 0.04)",
        "framer-1djai4u": "rgba(255, 255, 255, 0.04)",
        "framer-1ibabel": "rgba(255, 255, 255, 0.04)",
        "framer-8y8sq7": "rgba(255, 255, 255, 0.04)",
        "framer-19kqjve": "rgba(255, 255, 255, 0.04)",
        "framer-1rf3dh1": "rgba(255, 255, 255, 0.04)",
        "framer-18lqt85": "rgba(255, 255, 255, 0.04)",
        "framer-1vt83fg": "rgba(255, 255, 255, 0.04)",
        "framer-1290qui": "rgba(255, 255, 255, 0.04)",
        "framer-10qen5q": "rgba(255, 255, 255, 0.04)",
        "framer-1x7y08s": "rgba(255, 255, 255, 0.04)",
        "framer-li1bn0": "rgba(255, 255, 255, 0.04)",
        "framer-1afif8m": "rgba(255, 255, 255, 0.04)",
        "framer-1xffmu1": "rgba(255, 255, 255, 0.04)",
        "framer-vxzka9": "rgba(255, 255, 255, 0.04)",
        "framer-1oenpnn": "rgba(255, 255, 255, 0.04)",
        "framer-xqqqan": "rgba(255, 255, 255, 0.04)",
        "framer-1xs3c5s": "rgba(255, 255, 255, 0.04)",
        "framer-g5b2fd": "rgba(255, 255, 255, 0.04)",
        "framer-15pc2n8": "rgba(255, 255, 255, 0.04)",
        "framer-dlkqju": "rgba(255, 255, 255, 0.04)",
        "framer-1662edz": "rgba(255, 255, 255, 0.04)",
        "framer-1o6ae4m": "rgba(255, 255, 255, 0.04)",
        "framer-7ut610": "rgba(255, 255, 255, 0.04)",
        "framer-4nsxaf": "rgba(255, 255, 255, 0.04)",
        "framer-kyye8q": "rgba(255, 255, 255, 0.04)",
        "framer-nge7c7": "rgba(255, 255, 255, 0.04)",
        "framer-153oid8": "rgba(255, 255, 255, 0.04)",
        "framer-1i5403r": "rgba(255, 255, 255, 0.04)",
        "framer-zdwg34": "rgba(255, 255, 255, 0.04)",
        "framer-1wosb63": "rgba(255, 255, 255, 0.04)",
        "framer-nf35ps": "rgba(255, 255, 255, 0.04)",
        "framer-qa34xq": "rgba(255, 255, 255, 0.04)",
        "framer-filgd4": "rgba(255, 255, 255, 0.04)",
        "framer-u4d6x3": "rgba(255, 255, 255, 0.04)",
        "framer-ev4n9h": "rgba(255, 255, 255, 0.04)",
        "framer-1jndxip": "rgba(255, 255, 255, 0.04)",
        "framer-ukalac": "rgba(255, 255, 255, 0.04)",
        "framer-7ra5u7": "rgba(255, 255, 255, 0.04)",
        "framer-1q0z42g": "rgba(255, 255, 255, 0.04)",
        "framer-o0cltq": "rgba(255, 255, 255, 0.04)",
        "framer-1ymomzd": "rgba(255, 255, 255, 0.04)",
        "framer-15ogixz": "rgba(255, 255, 255, 0.04)",
        "framer-4uq06b": "rgba(255, 255, 255, 0.04)",
        "framer-5pj1ss": "rgba(255, 255, 255, 0.04)",
        "framer-cjm6cm": "rgba(255, 255, 255, 0.04)",
        "framer-1nwn46": "rgba(255, 255, 255, 0.04)",
        "framer-l4xkwr": "rgba(255, 255, 255, 0.04)",
        "framer-tvhj2b": "rgba(255, 255, 255, 0.04)",
        "framer-86mmqq": "rgba(255, 255, 255, 0.04)",
        "framer-nc7bns": "rgba(255, 255, 255, 0.04)",
        "framer-1cg48np": "rgba(255, 255, 255, 0.04)",
        "framer-wnc4on": "rgba(255, 255, 255, 0.04)",
        "framer-14nw6a7": "rgba(255, 255, 255, 0.04)",
        "framer-xpktl5": "rgba(255, 255, 255, 0.04)",
        "framer-1mqce9a": "rgba(255, 255, 255, 0.04)",
        "framer-6xbkam": "rgba(255, 255, 255, 0.04)",
        "framer-131v8op": "rgba(255, 255, 255, 0.04)",
        "framer-1ddxcby": "rgba(255, 255, 255, 0.04)",
        "framer-1o9uvr4": "rgba(255, 255, 255, 0.04)",
        "framer-gt4ley": "rgba(255, 255, 255, 0.04)",
        "framer-11v9qa8": "rgba(255, 255, 255, 0.04)",
        "framer-h942sb": "rgba(255, 255, 255, 0.04)",
        "framer-2bbq4h": "rgba(255, 255, 255, 0.04)",
        "framer-1b5igrv": "rgba(255, 255, 255, 0.04)",
        "framer-170rkry": "rgba(255, 255, 255, 0.04)",
        "framer-kgstxs": "rgba(255, 255, 255, 0.04)",
        "framer-b7gua7": "rgba(255, 255, 255, 0.04)",
        "framer-1sldj1o": "rgba(255, 255, 255, 0.04)",
        "framer-1svd255": "rgba(255, 255, 255, 0.04)",
        "framer-138y9pl": "rgba(255, 255, 255, 0.04)",
        "framer-1dta0vu": "rgba(255, 255, 255, 0.04)",
        "framer-3z64oo": "rgba(255, 255, 255, 0.04)",
        "framer-1d2d49i": "rgba(255, 255, 255, 0.04)",
        "framer-oyhd3t": "rgba(255, 255, 255, 0.04)",
        "framer-20f2sf": "rgba(255, 255, 255, 0.04)",
        "framer-fd2gbu": "rgba(255, 255, 255, 0.04)",
        "framer-173iqm4": "rgba(255, 255, 255, 0.04)",
        "framer-1nw2i5u": "rgba(255, 255, 255, 0.04)",
        "framer-1gf8f74": "rgba(255, 255, 255, 0.04)",
        "framer-126if7k": "rgba(255, 255, 255, 0.04)",
        "framer-101393o": "rgba(255, 255, 255, 0.04)",
        "framer-1cttzfy": "rgba(255, 255, 255, 0.04)",
        "framer-1bchv1w": "rgba(255, 255, 255, 0.04)",
        "framer-1xspwzf": "rgba(255, 255, 255, 0.04)",
        "framer-hshnmx": "rgba(255, 255, 255, 0.04)",
        "framer-1atgup7": "rgba(255, 255, 255, 0.04)",
        "framer-rm0zjp": "rgba(255, 255, 255, 0.04)",
        "framer-1kk3rk0": "rgba(255, 255, 255, 0.04)",
        "framer-of0mcj": "rgba(255, 255, 255, 0.04)",
        "framer-ysh229": "rgba(255, 255, 255, 0.04)",
        "framer-13o3p9b": "rgba(255, 255, 255, 0.04)",
        "framer-cgvumc": "rgba(255, 255, 255, 0.04)",
        "framer-1vct5ds": "rgba(255, 255, 255, 0.04)",
        "framer-19h6kmj": "rgba(255, 255, 255, 0.04)",
        "framer-1cjvhsx": "rgba(255, 255, 255, 0.04)",
        "framer-12p3vzx": "rgba(255, 255, 255, 0.04)",
        "framer-1oksxci": "rgba(255, 255, 255, 0.04)",
        "framer-14pwok1": "rgba(255, 255, 255, 0.04)",
        "framer-1lswi2p": "rgba(255, 255, 255, 0.04)",
        "framer-19zr038": "rgba(255, 255, 255, 0.04)",
        "framer-mexy1c": "rgba(255, 255, 255, 0.04)",
        "framer-119p38r": "rgba(255, 255, 255, 0.04)",
        "framer-aokgsq": "rgba(255, 255, 255, 0.04)",
        "framer-1vgglw": "rgba(255, 255, 255, 0.04)",
        "framer-9wyu5": "rgba(255, 255, 255, 0.04)",
        "framer-1u89jrq": "rgba(255, 255, 255, 0.04)",
        "framer-ilwm1r": "rgba(255, 255, 255, 0.04)",
        "framer-6c7q3i": "rgba(255, 255, 255, 0.04)",
        "framer-1dhqmpa": "rgba(255, 255, 255, 0.04)",
        "framer-m6uoyn": "rgba(255, 255, 255, 0.04)",
        "framer-1abbc44": "rgba(255, 255, 255, 0.04)",
        "framer-1asdrnx": "rgba(255, 255, 255, 0.04)",
        "framer-1a81c3z": "rgba(255, 255, 255, 0.04)",
        "framer-1yjoi2": "rgba(255, 255, 255, 0.04)",
        "framer-34s8p0": "rgba(255, 255, 255, 0.04)",
        "framer-9wmkwc": "rgba(255, 255, 255, 0.04)",
        "framer-1rzdfox": "rgba(255, 255, 255, 0.04)",
        "framer-1v2j9m": "rgba(255, 255, 255, 0.04)",
        "framer-tvwehy": "rgba(255, 255, 255, 0.04)",
        "framer-19gskhe": "rgba(255, 255, 255, 0.04)",
        "framer-1r7znae": "rgba(255, 255, 255, 0.04)",
        "framer-1x9ttau": "rgba(255, 255, 255, 0.04)",
        "framer-19qi3rg": "rgba(255, 255, 255, 0.04)",
        "framer-1xazehi": "rgba(255, 255, 255, 0.04)",
        "framer-1vj77jj": "rgba(255, 255, 255, 0.04)",
        "framer-t89g24": "rgba(255, 255, 255, 0.04)",
        "framer-1ouxnre": "rgba(255, 255, 255, 0.04)",
        "framer-9izbi9": "rgba(255, 255, 255, 0.04)",
        "framer-hmhbu9": "rgba(255, 255, 255, 0.04)",
        "framer-ldccnz": "rgba(255, 255, 255, 0.04)",
        "framer-12qua62": "rgba(255, 255, 255, 0.04)",
        "framer-tn4f9n": "rgba(255, 255, 255, 0.04)",
        "framer-2bdteh": "rgba(255, 255, 255, 0.04)",
        "framer-26x32d": "rgba(255, 255, 255, 0.04)",
        "framer-z23vsj": "rgba(255, 255, 255, 0.04)",
        "framer-161xr59": "rgba(255, 255, 255, 0.04)",
        "framer-tuje6p": "rgba(255, 255, 255, 0.04)",
        "framer-144agw": "rgba(255, 255, 255, 0.04)",
        "framer-1hbb6d9": "rgba(255, 255, 255, 0.04)",
        "framer-1me8sh4": "rgba(255, 255, 255, 0.04)",
        "framer-1umq5aj": "rgba(255, 255, 255, 0.04)",
        "framer-1lhyzal": "rgba(255, 255, 255, 0.04)",
        "framer-1f3n39": "rgba(255, 255, 255, 0.04)",
        "framer-ilf9u3": "rgba(255, 255, 255, 0.04)",
        "framer-1qw0dpv": "rgba(255, 255, 255, 0.04)",
        "framer-1rs1xsd": "rgba(255, 255, 255, 0.04)",
        "framer-1t6lx8u": "rgba(255, 255, 255, 0.04)",
        "framer-7xapi8": "rgba(255, 255, 255, 0.04)",
        "framer-1yp8hos": "rgba(255, 255, 255, 0.04)",
        "framer-i2cq27": "rgba(255, 255, 255, 0.04)",
        "framer-h7ww8p": "rgba(255, 255, 255, 0.04)",
        "framer-1a5x4f6": "rgba(255, 255, 255, 0.04)",
        "framer-1qwmbzn": "rgba(255, 255, 255, 0.04)",
        "framer-1dmcjdq": "rgba(255, 255, 255, 0.04)",
        "framer-1n7pw7r": "rgba(255, 255, 255, 0.04)",
        "framer-1w51idz": "rgba(255, 255, 255, 0.04)",
        "framer-mxy4ao": "rgba(255, 255, 255, 0.04)",
        "framer-81issc": "rgba(255, 255, 255, 0.04)",
        "framer-1w1gkay": "rgba(255, 255, 255, 0.04)",
        "framer-4cpnfq": "rgba(255, 255, 255, 0.04)",
        "framer-1ewcuw0": "rgba(255, 255, 255, 0.04)",
        "framer-pwwysn": "rgba(255, 255, 255, 0.04)",
        "framer-1xtn7vm": "rgba(255, 255, 255, 0.04)",
        "framer-7dxsze": "rgba(255, 255, 255, 0.04)",
        "framer-9ev4bv": "rgba(255, 255, 255, 0.04)",
        "framer-1p7e9u2": "rgba(255, 255, 255, 0.04)",
        "framer-1a59dez": "rgba(255, 255, 255, 0.04)",
        "framer-7fgdhi": "rgba(255, 255, 255, 0.04)",
        "framer-k8j7my": "rgba(255, 255, 255, 0.04)",
        "framer-1ammoj2": "rgba(255, 255, 255, 0.04)",
        "framer-oivdw5": "rgba(255, 255, 255, 0.04)",
        "framer-14f6ekb": "rgba(255, 255, 255, 0.04)",
        "framer-khhuyo": "rgba(255, 255, 255, 0.04)",
        "framer-i2x3iv": "rgba(255, 255, 255, 0.04)",
        "framer-67j55g": "rgba(255, 255, 255, 0.04)",
        "framer-88mozs": "rgba(255, 255, 255, 0.04)",
        "framer-1dmnjar": "rgba(255, 255, 255, 0.04)",
        "framer-ncelpy": "rgba(255, 255, 255, 0.04)",
        "framer-123er8b": "rgba(255, 255, 255, 0.04)",
        "framer-6y7kl8": "rgba(255, 255, 255, 0.04)",
        "framer-1aa5m0p": "rgba(255, 255, 255, 0.04)",
        "framer-16krrxi": "rgba(255, 255, 255, 0.04)",
        "framer-1fn8zqk": "rgba(255, 255, 255, 0.04)",
        "framer-513uhu": "rgba(255, 255, 255, 0.04)",
        "framer-fa2shx": "rgba(255, 255, 255, 0.04)",
        "framer-1xoruxr": "rgba(255, 255, 255, 0.04)",
        "framer-1bihptf": "rgba(255, 255, 255, 0.04)",
        "framer-zrojpi": "rgba(255, 255, 255, 0.04)",
        "framer-cs61ef": "rgba(255, 255, 255, 0.04)",
        "framer-1q93xu9": "rgba(255, 255, 255, 0.04)",
        "framer-ib3bh1": "rgba(255, 255, 255, 0.04)",
        "framer-pbzt1h": "rgba(255, 255, 255, 0.04)",
        "framer-1h1ziie": "rgba(255, 255, 255, 0.04)",
        "framer-114tpb9": "rgba(255, 255, 255, 0.04)",
        "framer-1119xwz": "rgba(255, 255, 255, 0.04)",
        "framer-3c8f8y": "rgba(255, 255, 255, 0.04)",
        "framer-3luccy": "rgba(255, 255, 255, 0.04)",
        "framer-1mht7x2": "rgba(255, 255, 255, 0.04)",
        "framer-mnwipj": "rgba(255, 255, 255, 0.04)",
        "framer-lwj4e": "rgba(255, 255, 255, 0.04)",
        "framer-1ko98em": "rgba(255, 255, 255, 0.04)",
        "framer-17hq2ey": "rgba(255, 255, 255, 0.04)",
        "framer-dlyppx": "rgba(255, 255, 255, 0.04)",
        "framer-3vyltb": "rgba(255, 255, 255, 0.04)",
        "framer-xi0b9s": "rgba(255, 255, 255, 0.04)",
        "framer-bdvmsa": "rgba(255, 255, 255, 0.04)",
        "framer-1u3l0fl": "rgba(255, 255, 255, 0.04)",
        "framer-1yzqxh2": "rgba(255, 255, 255, 0.04)",
        "framer-1vnn6r": "rgba(255, 255, 255, 0.04)",
        "framer-sve3o0": "rgba(255, 255, 255, 0.04)",
        "framer-1p84nt4": "rgba(255, 255, 255, 0.04)",
        "framer-1pxzgce": "rgba(255, 255, 255, 0.04)",
        "framer-1b278qv": "rgba(255, 255, 255, 0.04)",
        "framer-2gnydd": "rgba(255, 255, 255, 0.04)",
        "framer-1137811": "rgba(255, 255, 255, 0.04)",
        "framer-19jj6c3": "rgba(255, 255, 255, 0.04)",
        "framer-1pzn1av": "rgba(255, 255, 255, 0.04)",
        "framer-tvid17": "rgba(255, 255, 255, 0.04)",
        "framer-11c54mx": "rgba(255, 255, 255, 0.04)",
        "framer-nevvim": "rgba(255, 255, 255, 0.04)",
        "framer-9v6bcb": "rgba(255, 255, 255, 0.04)",
        "framer-1vnrxsp": "rgba(255, 255, 255, 0.04)",
        "framer-wjbowq": "rgba(255, 255, 255, 0.04)",
        "framer-12400e0": "rgba(255, 255, 255, 0.04)",
        "framer-1cqo2n8": "rgba(255, 255, 255, 0.04)",
        "framer-qcjss1": "rgba(255, 255, 255, 0.04)",
        "framer-1ni2oxv": "rgba(255, 255, 255, 0.04)",
        "framer-5ztfcs": "rgba(255, 255, 255, 0.04)",
        "framer-154hrzw": "rgba(255, 255, 255, 0.04)",
        "framer-180ez6m": "rgba(255, 255, 255, 0.04)",
        "framer-h09ge5": "rgba(255, 255, 255, 0.04)",
        "framer-1se7318": "rgba(255, 255, 255, 0.04)",
        "framer-xxfm0q": "rgba(255, 255, 255, 0.04)",
        "framer-14apmt9": "rgba(255, 255, 255, 0.04)",
        "framer-3n8q0u": "rgba(255, 255, 255, 0.04)",
        "framer-j9tfzk": "rgba(255, 255, 255, 0.04)",
        "framer-1xd3thf": "rgba(255, 255, 255, 0.04)",
        "framer-1lfwj1u": "rgba(255, 255, 255, 0.04)",
        "framer-6d08mg": "rgba(255, 255, 255, 0.04)",
        "framer-re0cfu": "rgba(255, 255, 255, 0.04)",
        "framer-1iivgo9": "rgba(255, 255, 255, 0.04)",
        "framer-o3z3op": "rgba(255, 255, 255, 0.04)",
        "framer-182hs8p": "rgba(255, 255, 255, 0.04)",
        "framer-1wdiof9": "rgba(255, 255, 255, 0.04)",
        "framer-wwe331": "rgba(255, 255, 255, 0.04)",
        "framer-k8hw6u": "rgba(255, 255, 255, 0.04)",
        "framer-1j2vt7b": "rgba(255, 255, 255, 0.04)",
        "framer-4iiqzy": "rgba(255, 255, 255, 0.04)",
        "framer-1wwf1us": "rgba(255, 255, 255, 0.04)",
        "framer-7neodo": "rgba(255, 255, 255, 0.04)",
        "framer-724voj": "rgba(255, 255, 255, 0.04)",
        "framer-fn7au": "rgba(255, 255, 255, 0.04)",
        "framer-vi0aff": "rgba(255, 255, 255, 0.04)",
        "framer-8ssv48": "rgba(255, 255, 255, 0.04)",
        "framer-172e0pi": "rgba(255, 255, 255, 0.04)",
        "framer-14t05wr": "rgba(255, 255, 255, 0.04)",
        "framer-15pkux9": "rgba(255, 255, 255, 0.04)",
        "framer-jtyaes": "rgba(255, 255, 255, 0.04)",
        "framer-nt3phc": "rgba(255, 255, 255, 0.04)",
        "framer-ayg0jb": "rgba(255, 255, 255, 0.04)",
        "framer-1pztsn9": "rgba(255, 255, 255, 0.04)",
        "framer-lgrx4h": "rgba(255, 255, 255, 0.04)",
        "framer-inxrm5": "rgba(255, 255, 255, 0.04)",
        "framer-1b16f9k": "rgba(255, 255, 255, 0.04)",
        "framer-mh5rnp": "rgba(255, 255, 255, 0.04)",
        "framer-lutab8": "rgba(255, 255, 255, 0.04)",
        "framer-19j46hv": "rgba(255, 255, 255, 0.04)",
        "framer-1nsspm6": "rgba(255, 255, 255, 0.04)",
        "framer-elrkjf": "rgba(255, 255, 255, 0.04)",
        "framer-1aju3s8": "rgba(255, 255, 255, 0.04)",
        "framer-1tryoci": "rgba(255, 255, 255, 0.04)",
        "framer-s0ja87": "rgba(255, 255, 255, 0.04)",
        "framer-64lgy": "rgba(255, 255, 255, 0.04)",
        "framer-1hxr8zf": "rgba(255, 255, 255, 0.04)",
        "framer-4yinfa": "rgba(255, 255, 255, 0.04)",
        "framer-caipz8": "rgba(255, 255, 255, 0.04)",
        "framer-1pbmtd3": "rgba(255, 255, 255, 0.04)",
        "framer-hd47jj": "rgba(255, 255, 255, 0.04)",
        "framer-7waupn": "rgba(255, 255, 255, 0.04)",
        "framer-1w58xeq": "rgba(255, 255, 255, 0.04)",
        "framer-hjf8gm": "rgba(255, 255, 255, 0.04)",
        "framer-35xeoq": "rgba(255, 255, 255, 0.04)",
        "framer-31hql4": "rgba(255, 255, 255, 0.04)",
        "framer-1btvdyn": "rgba(255, 255, 255, 0.04)",
        "framer-17m8ffk": "rgba(255, 255, 255, 0.04)",
        "framer-1cp9zav": "rgba(255, 255, 255, 0.04)",
        "framer-sc8xd3": "rgba(255, 255, 255, 0.04)",
        "framer-1f7kpi4": "rgba(255, 255, 255, 0.04)",
        "framer-piuxkm": "rgba(255, 255, 255, 0.04)",
        "framer-b3utc5": "rgba(255, 255, 255, 0.04)",
        "framer-35276o": "rgba(255, 255, 255, 0.04)",
        "framer-9foe1e": "rgba(255, 255, 255, 0.04)",
        "framer-1p6p5n9": "rgba(255, 255, 255, 0.04)",
        "framer-fxzqdp": "rgba(255, 255, 255, 0.04)",
        "framer-1259uij": "rgba(255, 255, 255, 0.04)",
        "framer-2b7tb1": "rgba(255, 255, 255, 0.04)",
        "framer-1q067af": "rgba(255, 255, 255, 0.04)",
        "framer-1ia009e": "rgba(255, 255, 255, 0.04)",
        "framer-3lymfn": "rgba(255, 255, 255, 0.04)",
        "framer-dqfk43": "rgba(255, 255, 255, 0.04)",
        "framer-1ren7pe": "rgba(255, 255, 255, 0.04)",
        "framer-3fmmvk": "rgba(255, 255, 255, 0.04)",
        "framer-1xf11tn": "rgba(255, 255, 255, 0.04)",
        "framer-1tzghd": "rgba(255, 255, 255, 0.04)",
        "framer-1j37cf1": "rgba(255, 255, 255, 0.04)",
        "framer-1hzhw0m": "rgba(255, 255, 255, 0.04)",
        "framer-1o0bkla": "rgba(255, 255, 255, 0.04)",
        "framer-op6ecw": "rgba(255, 255, 255, 0.04)",
        "framer-1fcx5x1": "rgba(255, 255, 255, 0.04)",
        "framer-1rby5nx": "rgba(255, 255, 255, 0.04)",
        "framer-1kjsbwd": "rgba(255, 255, 255, 0.04)",
        "framer-1ojfxs9": "rgba(255, 255, 255, 0.04)",
        "framer-z6ek3k": "rgba(255, 255, 255, 0.04)",
        "framer-1qhbfh6": "rgba(255, 255, 255, 0.04)",
        "framer-1pj0haq": "rgba(255, 255, 255, 0.04)",
        "framer-vd0s5d": "rgba(255, 255, 255, 0.04)",
        "framer-1e93pup": "rgba(255, 255, 255, 0.04)",
        "framer-h9oic": "rgba(255, 255, 255, 0.04)",
        "framer-jo8cx0": "rgba(255, 255, 255, 0.04)",
        "framer-1f8ru9z": "rgba(255, 255, 255, 0.04)",
        "framer-1n4ht9o": "rgba(255, 255, 255, 0.04)",
        "framer-d353th": "rgba(255, 255, 255, 0.04)",
        "framer-13orx46": "rgba(255, 255, 255, 0.04)",
        "framer-14izw09": "rgba(255, 255, 255, 0.04)",
        "framer-1ibkax": "rgba(255, 255, 255, 0.04)",
        "framer-r24ou6": "rgba(255, 255, 255, 0.04)",
        "framer-5pakqt": "rgba(255, 255, 255, 0.04)",
        "framer-1d4yakz": "rgba(255, 255, 255, 0.04)",
        "framer-19985uk": "rgba(255, 255, 255, 0.04)",
        "framer-gb01s5": "rgba(255, 255, 255, 0.04)",
        "framer-wcsctp": "rgba(255, 255, 255, 0.04)",
        "framer-gbxnjm": "rgba(255, 255, 255, 0.04)",
        "framer-1n3latx": "rgba(255, 255, 255, 0.04)",
        "framer-ww49ko": "rgba(255, 255, 255, 0.04)",
        "framer-wuga8j": "rgba(255, 255, 255, 0.04)",
        "framer-19eh725": "rgba(255, 255, 255, 0.04)",
        "framer-spao7m": "rgba(255, 255, 255, 0.04)",
        "framer-p37xcr": "rgba(255, 255, 255, 0.04)",
        "framer-9lae15": "rgba(255, 255, 255, 0.04)",
        "framer-1djurc4": "rgba(255, 255, 255, 0.04)",
        "framer-1f9z9h2": "rgba(255, 255, 255, 0.04)",
        "framer-4nf7cp": "rgba(255, 255, 255, 0.04)",
        "framer-ib6lq2": "rgba(255, 255, 255, 0.04)",
        "framer-16jrhdt": "rgba(255, 255, 255, 0.04)",
        "framer-pb4qx6": "rgba(255, 255, 255, 0.04)",
        "framer-1bnvsbw": "rgba(255, 255, 255, 0.04)",
        "framer-svuws1": "rgba(255, 255, 255, 0.04)",
        "framer-18vrrai": "rgba(255, 255, 255, 0.04)",
        "framer-p75je3": "rgba(255, 255, 255, 0.04)",
        "framer-1oim4ap": "rgba(255, 255, 255, 0.04)",
        "framer-ets58q": "rgba(255, 255, 255, 0.04)",
        "framer-189qgi": "rgba(255, 255, 255, 0.04)",
        "framer-1se8eji": "rgba(255, 255, 255, 0.04)",
        "framer-xpdw0t": "rgba(255, 255, 255, 0.04)",
        "framer-114gjxu": "rgba(255, 255, 255, 0.04)",
        "framer-1ckranj": "rgba(255, 255, 255, 0.04)",
        "framer-yd49zj": "rgba(255, 255, 255, 0.04)",
        "framer-832d6a": "rgba(255, 255, 255, 0.04)",
        "framer-9j1mqt": "rgba(255, 255, 255, 0.04)",
        "framer-15qmn6v": "rgba(255, 255, 255, 0.04)",
        "framer-bosrq5": "rgba(255, 255, 255, 0.04)",
        "framer-e7rxl7": "rgba(255, 255, 255, 0.04)",
        "framer-t0me7w": "rgba(255, 255, 255, 0.04)",
        "framer-arxyzc": "rgba(255, 255, 255, 0.04)",
        "framer-w1f0c5": "rgba(255, 255, 255, 0.04)",
        "framer-1gx2zd": "rgba(255, 255, 255, 0.04)",
        "framer-1l5jzao": "rgba(255, 255, 255, 0.04)",
        "framer-lfxxyo": "rgba(255, 255, 255, 0.04)",
        "framer-1938ukf": "rgba(255, 255, 255, 0.04)",
        "framer-1uz9g4b": "rgba(255, 255, 255, 0.04)",
        "framer-skhb4e": "rgba(255, 255, 255, 0.04)",
        "framer-1nc562f": "rgba(255, 255, 255, 0.04)",
        "framer-1r1nb90": "rgba(255, 255, 255, 0.04)",
        "framer-1l7p7cw": "rgba(255, 255, 255, 0.04)",
        "framer-bbd8ba": "rgba(255, 255, 255, 0.04)",
        "framer-174359s": "rgba(255, 255, 255, 0.04)",
        "framer-o1cm7l": "rgba(255, 255, 255, 0.04)",
        "framer-1r2q58v": "rgba(255, 255, 255, 0.04)",
        "framer-ckhbc1": "rgba(255, 255, 255, 0.04)",
        "framer-25euhf": "rgba(255, 255, 255, 0.04)",
        "framer-1bg9jqr": "rgba(255, 255, 255, 0.04)",
        "framer-1hp2xsm": "rgba(255, 255, 255, 0.04)",
        "framer-1w08ot3": "rgba(255, 255, 255, 0.04)",
        "framer-hzs6gu": "rgba(255, 255, 255, 0.04)",
        "framer-1tn0auv": "rgba(255, 255, 255, 0.04)",
        "framer-1yuauh0": "rgba(255, 255, 255, 0.04)",
        "framer-q39ych": "rgba(255, 255, 255, 0.04)",
        "framer-1la9doo": "rgba(255, 255, 255, 0.04)",
        "framer-1i6s172": "rgba(255, 255, 255, 0.04)",
        "framer-1bhiwq4": "rgba(255, 255, 255, 0.04)",
        "framer-1finjmh": "rgba(255, 255, 255, 0.04)",
        "framer-c4f7i5": "rgba(255, 255, 255, 0.04)",
        "framer-3ba7y6": "rgba(255, 255, 255, 0.04)",
        "framer-8o5z7u": "rgba(255, 255, 255, 0.04)",
        "framer-5vb13r": "rgba(255, 255, 255, 0.04)",
        "framer-1qg8j5j": "rgba(255, 255, 255, 0.04)",
        "framer-1cpq7cz": "rgba(255, 255, 255, 0.04)",
        "framer-1e24whu": "rgba(255, 255, 255, 0.04)",
        "framer-f9w1b0": "rgba(255, 255, 255, 0.04)",
        "framer-154i7ad": "rgba(255, 255, 255, 0.04)",
        "framer-trnmme": "rgba(255, 255, 255, 0.04)",
        "framer-1g03gzo": "rgba(255, 255, 255, 0.04)",
        "framer-2uv9z5": "rgba(255, 255, 255, 0.04)",
        "framer-1kh10xg": "rgba(255, 255, 255, 0.04)",
        "framer-177340h": "rgba(255, 255, 255, 0.04)",
        "framer-147tj1p": "rgba(255, 255, 255, 0.04)",
        "framer-1cjjf7q": "rgba(255, 255, 255, 0.04)",
        "framer-jjeffs": "rgba(255, 255, 255, 0.04)",
        "framer-b3oq5w": "rgba(255, 255, 255, 0.04)",
        "framer-lgkn64": "rgba(255, 255, 255, 0.04)",
        "framer-ftinbp": "rgba(255, 255, 255, 0.04)",
        "framer-1qgwf2q": "rgba(255, 255, 255, 0.04)",
        "framer-1s1q0zj": "rgba(255, 255, 255, 0.04)",
        "framer-szasz2": "rgba(255, 255, 255, 0.04)",
        "framer-1bh2qom": "rgba(255, 255, 255, 0.04)",
        "framer-vbr5qt": "rgba(255, 255, 255, 0.04)",
        "framer-ayiqn": "rgba(255, 255, 255, 0.04)",
        "framer-ng52my": "rgba(255, 255, 255, 0.04)",
        "framer-1qc3xh2": "rgba(255, 255, 255, 0.04)",
        "framer-17xhwxn": "rgba(255, 255, 255, 0.04)",
        "framer-kd3teb": "rgba(255, 255, 255, 0.04)",
        "framer-1ds9pvm": "rgba(255, 255, 255, 0.04)",
        "framer-9ou7kr": "rgba(255, 255, 255, 0.04)",
        "framer-19hkz1m": "rgba(255, 255, 255, 0.04)",
        "framer-z7coyc": "rgba(255, 255, 255, 0.04)",
        "framer-hxqr6r": "rgba(255, 255, 255, 0.04)",
        "framer-ssdjgy": "rgba(255, 255, 255, 0.04)",
        "framer-170fwp7": "rgba(255, 255, 255, 0.04)",
        "framer-iorqmd": "rgba(255, 255, 255, 0.04)",
        "framer-ly5had": "rgba(255, 255, 255, 0.04)",
        "framer-kyuip0": "rgba(255, 255, 255, 0.04)",
        "framer-m2toq0": "rgba(255, 255, 255, 0.04)",
        "framer-1hak2gy": "rgba(255, 255, 255, 0.04)",
        "framer-oe69v3": "rgba(255, 255, 255, 0.04)",
        "framer-tfrupv": "rgba(255, 255, 255, 0.04)",
        "framer-ados7m": "rgba(255, 255, 255, 0.04)",
        "framer-1b1arxe": "rgba(255, 255, 255, 0.04)",
        "framer-t2bzkx": "rgba(255, 255, 255, 0.04)",
        "framer-19h60xi": "rgba(255, 255, 255, 0.04)",
        "framer-1roowyp": "rgba(255, 255, 255, 0.04)",
        "framer-b33ovj": "rgba(255, 255, 255, 0.04)",
        "framer-2xrhr6": "rgba(255, 255, 255, 0.04)",
        "framer-bp4hmm": "rgba(255, 255, 255, 0.04)",
        "framer-bj9ogc": "rgba(255, 255, 255, 0.04)",
        "framer-dv99ve": "rgba(255, 255, 255, 0.04)",
        "framer-1o691fb": "rgba(255, 255, 255, 0.04)",
        "framer-1o7i21q": "rgba(255, 255, 255, 0.04)",
        "framer-7y8ymw": "rgba(255, 255, 255, 0.04)",
        "framer-259e94": "rgba(255, 255, 255, 0.04)",
        "framer-1vrgp1i": "rgba(255, 255, 255, 0.04)",
        "framer-1hkr8gz": "rgba(255, 255, 255, 0.04)",
        "framer-1cpl3ru": "rgba(255, 255, 255, 0.04)",
        "framer-4vg5fm": "rgba(255, 255, 255, 0.04)",
        "framer-6yep7x": "rgba(255, 255, 255, 0.04)",
        "framer-yo90z1": "rgba(255, 255, 255, 0.04)",
        "framer-1ffyrfe": "rgba(255, 255, 255, 0.04)",
        "framer-17sy2h9": "rgba(255, 255, 255, 0.04)",
        "framer-1nexr12": "rgba(255, 255, 255, 0.04)",
        "framer-1nxam09": "rgba(255, 255, 255, 0.04)",
        "framer-1u7tsmf": "rgba(255, 255, 255, 0.04)",
        "framer-1s1lgs9": "rgba(255, 255, 255, 0.04)",
        "framer-1tsc97t": "rgba(255, 255, 255, 0.04)",
        "framer-1lik10g": "rgba(255, 255, 255, 0.04)",
        "framer-w91j3h": "rgba(255, 255, 255, 0.04)",
        "framer-1t0gcur": "rgba(255, 255, 255, 0.04)",
        "framer-7i1u99": "rgba(255, 255, 255, 0.04)",
        "framer-zeyecd": "rgba(255, 255, 255, 0.04)",
        "framer-1sm3fde": "rgba(255, 255, 255, 0.04)",
        "framer-hpfi4e": "rgba(255, 255, 255, 0.04)",
        "framer-11nihoc": "rgba(255, 255, 255, 0.04)",
        "framer-dyf9qm": "rgba(255, 255, 255, 0.04)",
        "framer-issvd8": "rgba(255, 255, 255, 0.04)",
        "framer-wtmsdd": "rgba(255, 255, 255, 0.04)",
        "framer-1b7vdsu": "rgba(255, 255, 255, 0.04)",
        "framer-mhhl4m": "rgba(255, 255, 255, 0.04)",
        "framer-kr5yb3": "rgba(255, 255, 255, 0.04)",
        "framer-8s5abl": "rgba(255, 255, 255, 0.04)",
        "framer-f20w32": "rgba(255, 255, 255, 0.04)",
        "framer-1v5wb0d": "rgba(255, 255, 255, 0.04)",
        "framer-4tlth8": "rgba(255, 255, 255, 0.04)",
        "framer-kxfckx": "rgba(255, 255, 255, 0.04)",
        "framer-69n7ji": "rgba(255, 255, 255, 0.04)",
        "framer-1qqpucz": "rgba(255, 255, 255, 0.04)",
        "framer-1kt8yiq": "rgba(255, 255, 255, 0.04)",
        "framer-1qoqjv3": "rgba(255, 255, 255, 0.04)",
        "framer-16obh5m": "rgba(255, 255, 255, 0.04)",
        "framer-1tpfy33": "rgba(255, 255, 255, 0.04)",
        "framer-zxg4my": "rgba(255, 255, 255, 0.04)",
        "framer-c9ojjv": "rgba(255, 255, 255, 0.04)",
        "framer-1j4u6r2": "rgba(255, 255, 255, 0.04)",
        "framer-tclpau": "rgba(255, 255, 255, 0.04)",
        "framer-1ni6xjv": "rgba(255, 255, 255, 0.04)",
        "framer-1es2jab": "rgba(255, 255, 255, 0.04)",
        "framer-10jrcc6": "rgba(255, 255, 255, 0.04)",
        "framer-jcrjvd": "rgba(255, 255, 255, 0.04)",
        "framer-bvrrkp": "rgba(255, 255, 255, 0.04)",
        "framer-18mdrb0": "rgba(255, 255, 255, 0.04)",
        "framer-19ufz0c": "rgba(255, 255, 255, 0.04)",
        "framer-a4eq25": "rgba(255, 255, 255, 0.04)"
      },
      "vClass": null,
      "variantName": null,
      "source": "framer_complete_tree (33).html"
    }
  ],
  "incomingKeys": [
    "framer-1w8ax9q",
    "framer-10zqzn8",
    "framer-16aps75",
    "framer-zxjavu",
    "framer-1cbnxi6",
    "framer-509c9k",
    "framer-1p2nd0x",
    "framer-5zdsy3",
    "framer-rb7tgg",
    "framer-l9h9t",
    "framer-1vebirv",
    "framer-1ek2ntw",
    "framer-udx3b7",
    "framer-1srqsok",
    "framer-9nc9id",
    "framer-1ofdk4s",
    "framer-mc2qtp",
    "framer-hlbzv7",
    "framer-coqz6k",
    "framer-1py28mu",
    "framer-1wx0g94",
    "framer-pdaimz",
    "framer-1uilx9a",
    "framer-14friu6",
    "framer-y9p8sz",
    "framer-38bfbr",
    "framer-835p5p",
    "framer-avufpe",
    "framer-19pc0kj",
    "framer-5qn9pd",
    "framer-6ptcky",
    "framer-1bj87uo",
    "framer-18pms2q",
    "framer-1c1kal9",
    "framer-1gmddus",
    "framer-1ezdpyx",
    "framer-1p8exka",
    "framer-189dxp8",
    "framer-1ulq471",
    "framer-10z8y9q",
    "framer-1apznw0",
    "framer-1loag9g",
    "framer-a6p501",
    "framer-tz4lb",
    "framer-18tigbk",
    "framer-1wvkwoy",
    "framer-iqni9n",
    "framer-1szxjbv",
    "framer-8axohn",
    "framer-1hjgm86",
    "framer-11gf6c6",
    "framer-9czbtf",
    "framer-hpo01f",
    "framer-1phyaib",
    "framer-hobs9u",
    "framer-7g76hm",
    "framer-1n4yjyc",
    "framer-u5k3fd",
    "framer-11twtea",
    "framer-17ypuap",
    "framer-1ws7c6v",
    "framer-1yr6lkt",
    "framer-m99uc9",
    "framer-b9ztq4",
    "framer-1bj1ntz",
    "framer-1wb246e",
    "framer-ytou5k",
    "framer-ak21r0",
    "framer-frl2xa",
    "framer-5vsmr8",
    "framer-ie39ga",
    "framer-312syl",
    "framer-iamo1c",
    "framer-hskubr",
    "framer-1hlpk06",
    "framer-190rppy",
    "framer-1pne890",
    "framer-o93pit",
    "framer-hcii4i",
    "framer-1luxg98",
    "framer-jzsjbf",
    "framer-gw5epp",
    "framer-2z297n",
    "framer-1wcvqav",
    "framer-1dn8st2",
    "framer-n2ea51",
    "framer-y5raoz",
    "framer-1x00w45",
    "framer-wz662h",
    "framer-vwe6fu",
    "framer-zgre45",
    "framer-nlmebn",
    "framer-1ahvqss",
    "framer-25ngdh",
    "framer-1geqn87",
    "framer-1hc7xpv"
  ],
  "queueKeys": [
    "framer-1l1aas3",
    "framer-1w3x67m",
    "framer-ll6m6s",
    "framer-wjz1sh",
    "framer-1hflg6n",
    "framer-1n93qt7",
    "framer-198edd4",
    "framer-z2m9qw",
    "framer-a4roa1",
    "framer-1gmitgm",
    "framer-2z9788",
    "framer-xmnqmt",
    "framer-tqwmm4",
    "framer-1prr6ob",
    "framer-oqx20o",
    "framer-1shp5ym",
    "framer-nrkk9z",
    "framer-7434cq",
    "framer-1d0u0d4",
    "framer-1rwizqt",
    "framer-1u122vr",
    "framer-jg0scu",
    "framer-y4ffnh",
    "framer-ztorm5"
  ],
  "executorKeys": [
    "framer-knm3lj",
    "framer-1dmld5n",
    "framer-uowqcg",
    "framer-1dtqkwe",
    "framer-miej2s",
    "framer-sasqsa",
    "framer-1kgemv6",
    "framer-1cxurzz",
    "framer-4mbxuq",
    "framer-1et7wxn",
    "framer-16cct62",
    "framer-1ghpgks",
    "framer-1f7gz2q",
    "framer-6oheae",
    "framer-16dfwnm",
    "framer-159bmwr",
    "framer-1p1vqsn",
    "framer-5dtsk",
    "framer-1ous5i2",
    "framer-94grge",
    "framer-1py6a95",
    "framer-9sel6v",
    "framer-c6xnnw",
    "framer-1ofowvp",
    "framer-1yc7nkx",
    "framer-6x8zit",
    "framer-1xgqlqz",
    "framer-rin559",
    "framer-31f8j1",
    "framer-18wopk0",
    "framer-1bnefrh",
    "framer-1ewrs3r",
    "framer-1nhkl21",
    "framer-1xd9ey1",
    "framer-1yaeplo",
    "framer-s315hq",
    "framer-1ej8s96",
    "framer-1ljxraj",
    "framer-nll1ev",
    "framer-1k18bi5",
    "framer-ikkyoe",
    "framer-1ofbsd5",
    "framer-17q4w9p",
    "framer-g7v8uo",
    "framer-1aexuar",
    "framer-143pemu",
    "framer-blm95e",
    "framer-1cnksu0"
  ],
  "batchKeys": [
    "framer-3pozg9",
    "framer-13sg4gy",
    "framer-7x0ib4",
    "framer-1pi4ez7",
    "framer-iqs1wz",
    "framer-1bzoqol",
    "framer-rt17wz",
    "framer-ezg90b"
  ],
  "riskKeys": [
    "framer-1jj0ifc",
    "framer-dpwm0b",
    "framer-11sh3kl",
    "framer-atydiq",
    "framer-ndx6n2",
    "framer-wmpa9h",
    "framer-yu6s5s",
    "framer-16j6ocd",
    "framer-1swijur",
    "framer-dcpd2y",
    "framer-19lpopk",
    "framer-1gy3pmp",
    "framer-1v1x89z",
    "framer-1bl2k9n",
    "framer-1l22rll",
    "framer-p404w8",
    "framer-12u4h2y",
    "framer-mcx67j",
    "framer-9bt0ow",
    "framer-1hxcvmh",
    "framer-zsvztq",
    "framer-bfd5pd",
    "framer-1fkr5hp",
    "framer-16tdrzi",
    "framer-1upn6hk",
    "framer-12s24r2",
    "framer-mju97v",
    "framer-hk0b4p",
    "framer-1nob4pv",
    "framer-8pyn9g",
    "framer-1fjaf3s",
    "framer-d98h5j",
    "framer-1j5bhac",
    "framer-13jkm5b",
    "framer-17qv8u8",
    "framer-69q9y1",
    "framer-17ayp1e",
    "framer-1cqt4kz",
    "framer-1lo8o3t",
    "framer-zdc5sg",
    "framer-1of3gxf",
    "framer-1cp4vei",
    "framer-kkby6z",
    "framer-v7u6as",
    "framer-mvorvo",
    "framer-kq0fap",
    "framer-itnu1k",
    "framer-dvz24s",
    "framer-p0q4zf",
    "framer-1k5jk6l",
    "framer-1x657tl",
    "framer-1g37od",
    "framer-10yw6sv",
    "framer-bxygyb",
    "framer-1wx1bo8",
    "framer-rlvslr",
    "framer-xbc3d2",
    "framer-1wot0vl",
    "framer-gfqp5f",
    "framer-vsen48",
    "framer-1q0gr72",
    "framer-1dh0ekj",
    "framer-t0d6f4",
    "framer-1u2kj51",
    "framer-wqsupw",
    "framer-1nh8wlf",
    "framer-5ja1up",
    "framer-1ahk1dw",
    "framer-tmre0j",
    "framer-1fecrzm",
    "framer-14v7fn6",
    "framer-1kt7zzt",
    "framer-77yo50",
    "framer-m6t74m",
    "framer-fny01e",
    "framer-bsrptp",
    "framer-1sctmbp",
    "framer-1xtzavl",
    "framer-1j6nou9",
    "framer-18wavnh",
    "framer-13ft1pc",
    "framer-lwi2nv",
    "framer-1p0ta5s",
    "framer-okk9na",
    "framer-1wscuse",
    "framer-ckjief",
    "framer-1wd74n9",
    "framer-je1js9",
    "framer-11vb55v",
    "framer-zxu9g1",
    "framer-175a80z",
    "framer-qhv2jx",
    "framer-1fuomwv",
    "framer-1pvftwy",
    "framer-7bxvqv",
    "framer-1ebwbwm",
    "framer-1t4div0",
    "framer-18l77et",
    "framer-i5cm9v",
    "framer-va4ics",
    "framer-emgwcw",
    "framer-1s4aw3h",
    "framer-1kr91hz",
    "framer-1fiw6w0",
    "framer-1pil1hc",
    "framer-1bef5is",
    "framer-1s4soym",
    "framer-e5pbl1",
    "framer-tq6zkq",
    "framer-1we93t",
    "framer-nehzx1",
    "framer-1we71xp",
    "framer-1yltltg",
    "framer-b62ir1",
    "framer-qx7dca",
    "framer-97zyep",
    "framer-1hx6plk",
    "framer-187r6wo",
    "framer-1suu08m",
    "framer-1k1f9td",
    "framer-10z6mja",
    "framer-1c6vijq",
    "framer-1dp7hdl",
    "framer-1cuttk9",
    "framer-1x2xnil",
    "framer-1cwvdqi",
    "framer-lhhssf",
    "framer-aeocs",
    "framer-3zdcj2",
    "framer-vpipdz",
    "framer-dev0uk",
    "framer-op9xil",
    "framer-tik92e",
    "framer-iqjc80",
    "framer-tl1004",
    "framer-qaw95m",
    "framer-3h8x2s",
    "framer-m70ahb",
    "framer-1idhpfp",
    "framer-1ypbpdo",
    "framer-128zqc6",
    "framer-1ytw3om",
    "framer-13ytebk",
    "framer-1ww14do",
    "framer-a8pcov",
    "framer-ab8tx3",
    "framer-5uqmqq",
    "framer-1ofu2ul",
    "framer-9gbi0z",
    "framer-f39cdm",
    "framer-74v5au",
    "framer-4jd8se",
    "framer-1v11feq",
    "framer-b7yay1",
    "framer-ib20gg",
    "framer-nmz8wd"
  ],
  "proverKeys": [
    "framer-fiyyst",
    "framer-ciyq8x",
    "framer-1q66old",
    "framer-1qi4x9e",
    "framer-1gptz2q",
    "framer-1455pd0",
    "framer-1fit9b7",
    "framer-hi43jy",
    "framer-1wd6cu5",
    "framer-1ylwb2d",
    "framer-1y9yxe2",
    "framer-qvneen",
    "framer-wjo0e9",
    "framer-czpr7r",
    "framer-vj2fgs",
    "framer-hoxygt",
    "framer-48kwqi",
    "framer-u5krqo",
    "framer-w896tp",
    "framer-1wk1y40",
    "framer-33r2dq",
    "framer-1gbanx3",
    "framer-1ux33dn",
    "framer-3lw8u8",
    "framer-1czikuk",
    "framer-q6eebf",
    "framer-1gdzggg",
    "framer-tsui6n",
    "framer-vgwsmu",
    "framer-1tmsih3",
    "framer-btodsk",
    "framer-1c27p2n",
    "framer-hj95w1",
    "framer-1dyz5ca",
    "framer-et0m12",
    "framer-vnh2vx",
    "framer-1l61glq",
    "framer-qzjyt5",
    "framer-1j65h5c",
    "framer-ujqrvs",
    "framer-ooft64",
    "framer-1wfl7nv",
    "framer-17irg2n",
    "framer-l109y1",
    "framer-14fhv1t",
    "framer-763vv",
    "framer-ekdddg",
    "framer-lczi8i",
    "framer-1k3zzg8",
    "framer-1nze31j",
    "framer-1izz6de",
    "framer-cva9wu",
    "framer-myr3v0",
    "framer-3fv7cz",
    "framer-1cb7j9a",
    "framer-bvmogv",
    "framer-1nvc6l8",
    "framer-1k694lj",
    "framer-1br5jo5",
    "framer-91edth",
    "framer-19nd5re",
    "framer-11zy7gz",
    "framer-183jbxw",
    "framer-1k2kjzb",
    "framer-e0p84p",
    "framer-170af3e",
    "framer-ghrn1n",
    "framer-1djai4u",
    "framer-1ibabel",
    "framer-8y8sq7",
    "framer-19kqjve",
    "framer-1rf3dh1",
    "framer-18lqt85",
    "framer-1vt83fg",
    "framer-1290qui",
    "framer-10qen5q",
    "framer-1x7y08s",
    "framer-li1bn0",
    "framer-1afif8m",
    "framer-1xffmu1",
    "framer-vxzka9",
    "framer-1oenpnn",
    "framer-xqqqan",
    "framer-1xs3c5s",
    "framer-g5b2fd",
    "framer-15pc2n8",
    "framer-dlkqju",
    "framer-1662edz",
    "framer-1o6ae4m",
    "framer-7ut610",
    "framer-4nsxaf",
    "framer-kyye8q",
    "framer-nge7c7",
    "framer-153oid8",
    "framer-1i5403r",
    "framer-zdwg34",
    "framer-1wosb63",
    "framer-nf35ps",
    "framer-qa34xq",
    "framer-filgd4",
    "framer-u4d6x3",
    "framer-ev4n9h",
    "framer-1jndxip",
    "framer-ukalac",
    "framer-7ra5u7",
    "framer-1q0z42g",
    "framer-o0cltq",
    "framer-1ymomzd",
    "framer-15ogixz",
    "framer-4uq06b",
    "framer-5pj1ss",
    "framer-cjm6cm",
    "framer-1nwn46",
    "framer-l4xkwr",
    "framer-tvhj2b",
    "framer-86mmqq",
    "framer-nc7bns",
    "framer-1cg48np",
    "framer-wnc4on",
    "framer-14nw6a7",
    "framer-xpktl5",
    "framer-1mqce9a",
    "framer-6xbkam",
    "framer-131v8op",
    "framer-1ddxcby",
    "framer-1o9uvr4",
    "framer-gt4ley",
    "framer-11v9qa8",
    "framer-h942sb",
    "framer-2bbq4h",
    "framer-1b5igrv",
    "framer-170rkry",
    "framer-kgstxs",
    "framer-b7gua7",
    "framer-1sldj1o",
    "framer-1svd255",
    "framer-138y9pl",
    "framer-1dta0vu",
    "framer-3z64oo",
    "framer-1d2d49i",
    "framer-oyhd3t",
    "framer-20f2sf",
    "framer-fd2gbu",
    "framer-173iqm4",
    "framer-1nw2i5u",
    "framer-1gf8f74",
    "framer-126if7k",
    "framer-101393o",
    "framer-1cttzfy",
    "framer-1bchv1w",
    "framer-1xspwzf",
    "framer-hshnmx",
    "framer-1atgup7",
    "framer-rm0zjp",
    "framer-1kk3rk0",
    "framer-of0mcj",
    "framer-ysh229",
    "framer-13o3p9b",
    "framer-cgvumc",
    "framer-1vct5ds",
    "framer-19h6kmj",
    "framer-1cjvhsx",
    "framer-12p3vzx",
    "framer-1oksxci",
    "framer-14pwok1",
    "framer-1lswi2p",
    "framer-19zr038",
    "framer-mexy1c",
    "framer-119p38r",
    "framer-aokgsq",
    "framer-1vgglw",
    "framer-9wyu5",
    "framer-1u89jrq",
    "framer-ilwm1r",
    "framer-6c7q3i",
    "framer-1dhqmpa",
    "framer-m6uoyn",
    "framer-1abbc44",
    "framer-1asdrnx",
    "framer-1a81c3z",
    "framer-1yjoi2",
    "framer-34s8p0",
    "framer-9wmkwc",
    "framer-1rzdfox",
    "framer-1v2j9m",
    "framer-tvwehy",
    "framer-19gskhe",
    "framer-1r7znae",
    "framer-1x9ttau",
    "framer-19qi3rg",
    "framer-1xazehi",
    "framer-1vj77jj",
    "framer-t89g24",
    "framer-1ouxnre",
    "framer-9izbi9",
    "framer-hmhbu9",
    "framer-ldccnz",
    "framer-12qua62",
    "framer-tn4f9n",
    "framer-2bdteh",
    "framer-26x32d",
    "framer-z23vsj",
    "framer-161xr59",
    "framer-tuje6p",
    "framer-144agw",
    "framer-1hbb6d9",
    "framer-1me8sh4",
    "framer-1umq5aj",
    "framer-1lhyzal",
    "framer-1f3n39",
    "framer-ilf9u3",
    "framer-1qw0dpv",
    "framer-1rs1xsd",
    "framer-1t6lx8u",
    "framer-7xapi8",
    "framer-1yp8hos",
    "framer-i2cq27",
    "framer-h7ww8p",
    "framer-1a5x4f6",
    "framer-1qwmbzn",
    "framer-1dmcjdq",
    "framer-1n7pw7r",
    "framer-1w51idz",
    "framer-mxy4ao",
    "framer-81issc",
    "framer-1w1gkay",
    "framer-4cpnfq",
    "framer-1ewcuw0",
    "framer-pwwysn",
    "framer-1xtn7vm",
    "framer-7dxsze",
    "framer-9ev4bv",
    "framer-1p7e9u2",
    "framer-1a59dez",
    "framer-7fgdhi",
    "framer-k8j7my",
    "framer-1ammoj2",
    "framer-oivdw5",
    "framer-14f6ekb",
    "framer-khhuyo",
    "framer-i2x3iv",
    "framer-67j55g",
    "framer-88mozs",
    "framer-1dmnjar",
    "framer-ncelpy",
    "framer-123er8b",
    "framer-6y7kl8",
    "framer-1aa5m0p",
    "framer-16krrxi",
    "framer-1fn8zqk",
    "framer-513uhu",
    "framer-fa2shx",
    "framer-1xoruxr",
    "framer-1bihptf",
    "framer-zrojpi",
    "framer-cs61ef",
    "framer-1q93xu9",
    "framer-ib3bh1",
    "framer-pbzt1h",
    "framer-1h1ziie",
    "framer-114tpb9",
    "framer-1119xwz",
    "framer-3c8f8y",
    "framer-3luccy",
    "framer-1mht7x2",
    "framer-mnwipj",
    "framer-lwj4e",
    "framer-1ko98em",
    "framer-17hq2ey",
    "framer-dlyppx",
    "framer-3vyltb",
    "framer-xi0b9s",
    "framer-bdvmsa",
    "framer-1u3l0fl",
    "framer-1yzqxh2",
    "framer-1vnn6r",
    "framer-sve3o0",
    "framer-1p84nt4",
    "framer-1pxzgce",
    "framer-1b278qv",
    "framer-2gnydd",
    "framer-1137811",
    "framer-19jj6c3",
    "framer-1pzn1av",
    "framer-tvid17",
    "framer-11c54mx",
    "framer-nevvim",
    "framer-9v6bcb",
    "framer-1vnrxsp",
    "framer-wjbowq",
    "framer-12400e0",
    "framer-1cqo2n8",
    "framer-qcjss1",
    "framer-1ni2oxv",
    "framer-5ztfcs",
    "framer-154hrzw",
    "framer-180ez6m",
    "framer-h09ge5",
    "framer-1se7318",
    "framer-xxfm0q",
    "framer-14apmt9",
    "framer-3n8q0u",
    "framer-j9tfzk",
    "framer-1xd3thf",
    "framer-1lfwj1u",
    "framer-6d08mg",
    "framer-re0cfu",
    "framer-1iivgo9",
    "framer-o3z3op",
    "framer-182hs8p",
    "framer-1wdiof9",
    "framer-wwe331",
    "framer-k8hw6u",
    "framer-1j2vt7b",
    "framer-4iiqzy",
    "framer-1wwf1us",
    "framer-7neodo",
    "framer-724voj",
    "framer-fn7au",
    "framer-vi0aff",
    "framer-8ssv48",
    "framer-172e0pi",
    "framer-14t05wr",
    "framer-15pkux9",
    "framer-jtyaes",
    "framer-nt3phc",
    "framer-ayg0jb",
    "framer-1pztsn9",
    "framer-lgrx4h",
    "framer-inxrm5",
    "framer-1b16f9k",
    "framer-mh5rnp",
    "framer-lutab8",
    "framer-19j46hv",
    "framer-1nsspm6",
    "framer-elrkjf",
    "framer-1aju3s8",
    "framer-1tryoci",
    "framer-s0ja87",
    "framer-64lgy",
    "framer-1hxr8zf",
    "framer-4yinfa",
    "framer-caipz8",
    "framer-1pbmtd3",
    "framer-hd47jj",
    "framer-7waupn",
    "framer-1w58xeq",
    "framer-hjf8gm",
    "framer-35xeoq",
    "framer-31hql4",
    "framer-1btvdyn",
    "framer-17m8ffk",
    "framer-1cp9zav",
    "framer-sc8xd3",
    "framer-1f7kpi4",
    "framer-piuxkm",
    "framer-b3utc5",
    "framer-35276o",
    "framer-9foe1e",
    "framer-1p6p5n9",
    "framer-fxzqdp",
    "framer-1259uij",
    "framer-2b7tb1",
    "framer-1q067af",
    "framer-1ia009e",
    "framer-3lymfn",
    "framer-dqfk43",
    "framer-1ren7pe",
    "framer-3fmmvk",
    "framer-1xf11tn",
    "framer-1tzghd",
    "framer-1j37cf1",
    "framer-1hzhw0m",
    "framer-1o0bkla",
    "framer-op6ecw",
    "framer-1fcx5x1",
    "framer-1rby5nx",
    "framer-1kjsbwd",
    "framer-1ojfxs9",
    "framer-z6ek3k",
    "framer-1qhbfh6",
    "framer-1pj0haq",
    "framer-vd0s5d",
    "framer-1e93pup",
    "framer-h9oic",
    "framer-jo8cx0",
    "framer-1f8ru9z",
    "framer-1n4ht9o",
    "framer-d353th",
    "framer-13orx46",
    "framer-14izw09",
    "framer-1ibkax",
    "framer-r24ou6",
    "framer-5pakqt",
    "framer-1d4yakz",
    "framer-19985uk",
    "framer-gb01s5",
    "framer-wcsctp",
    "framer-gbxnjm",
    "framer-1n3latx",
    "framer-ww49ko",
    "framer-wuga8j",
    "framer-19eh725",
    "framer-spao7m",
    "framer-p37xcr",
    "framer-9lae15",
    "framer-1djurc4",
    "framer-1f9z9h2",
    "framer-4nf7cp",
    "framer-ib6lq2",
    "framer-16jrhdt",
    "framer-pb4qx6",
    "framer-1bnvsbw",
    "framer-svuws1",
    "framer-18vrrai",
    "framer-p75je3",
    "framer-1oim4ap",
    "framer-ets58q",
    "framer-189qgi",
    "framer-1se8eji",
    "framer-xpdw0t",
    "framer-114gjxu",
    "framer-1ckranj",
    "framer-yd49zj",
    "framer-832d6a",
    "framer-9j1mqt",
    "framer-15qmn6v",
    "framer-bosrq5",
    "framer-e7rxl7",
    "framer-t0me7w",
    "framer-arxyzc",
    "framer-w1f0c5",
    "framer-1gx2zd",
    "framer-1l5jzao",
    "framer-lfxxyo",
    "framer-1938ukf",
    "framer-1uz9g4b",
    "framer-skhb4e",
    "framer-1nc562f",
    "framer-1r1nb90",
    "framer-1l7p7cw",
    "framer-bbd8ba",
    "framer-174359s",
    "framer-o1cm7l",
    "framer-1r2q58v",
    "framer-ckhbc1",
    "framer-25euhf",
    "framer-1bg9jqr",
    "framer-1hp2xsm",
    "framer-1w08ot3",
    "framer-hzs6gu",
    "framer-1tn0auv",
    "framer-1yuauh0",
    "framer-q39ych",
    "framer-1la9doo",
    "framer-1i6s172",
    "framer-1bhiwq4",
    "framer-1finjmh",
    "framer-c4f7i5",
    "framer-3ba7y6",
    "framer-8o5z7u",
    "framer-5vb13r",
    "framer-1qg8j5j",
    "framer-1cpq7cz",
    "framer-1e24whu",
    "framer-f9w1b0",
    "framer-154i7ad",
    "framer-trnmme",
    "framer-1g03gzo",
    "framer-2uv9z5",
    "framer-1kh10xg",
    "framer-177340h",
    "framer-147tj1p",
    "framer-1cjjf7q",
    "framer-jjeffs",
    "framer-b3oq5w",
    "framer-lgkn64",
    "framer-ftinbp",
    "framer-1qgwf2q",
    "framer-1s1q0zj",
    "framer-szasz2",
    "framer-1bh2qom",
    "framer-vbr5qt",
    "framer-ayiqn",
    "framer-ng52my",
    "framer-1qc3xh2",
    "framer-17xhwxn",
    "framer-kd3teb",
    "framer-1ds9pvm",
    "framer-9ou7kr",
    "framer-19hkz1m",
    "framer-z7coyc",
    "framer-hxqr6r",
    "framer-ssdjgy",
    "framer-170fwp7",
    "framer-iorqmd",
    "framer-ly5had",
    "framer-kyuip0",
    "framer-m2toq0",
    "framer-1hak2gy",
    "framer-oe69v3",
    "framer-tfrupv",
    "framer-ados7m",
    "framer-1b1arxe",
    "framer-t2bzkx",
    "framer-19h60xi",
    "framer-1roowyp",
    "framer-b33ovj",
    "framer-2xrhr6",
    "framer-bp4hmm",
    "framer-bj9ogc",
    "framer-dv99ve",
    "framer-1o691fb",
    "framer-1o7i21q",
    "framer-7y8ymw",
    "framer-259e94",
    "framer-1vrgp1i",
    "framer-1hkr8gz",
    "framer-1cpl3ru",
    "framer-4vg5fm",
    "framer-6yep7x",
    "framer-yo90z1",
    "framer-1ffyrfe",
    "framer-17sy2h9",
    "framer-1nexr12",
    "framer-1nxam09",
    "framer-1u7tsmf",
    "framer-1s1lgs9",
    "framer-1tsc97t",
    "framer-1lik10g",
    "framer-w91j3h",
    "framer-1t0gcur",
    "framer-7i1u99",
    "framer-zeyecd",
    "framer-1sm3fde",
    "framer-hpfi4e",
    "framer-11nihoc",
    "framer-dyf9qm",
    "framer-issvd8",
    "framer-wtmsdd",
    "framer-1b7vdsu",
    "framer-mhhl4m",
    "framer-kr5yb3",
    "framer-8s5abl",
    "framer-f20w32",
    "framer-1v5wb0d",
    "framer-4tlth8",
    "framer-kxfckx",
    "framer-69n7ji",
    "framer-1qqpucz",
    "framer-1kt8yiq",
    "framer-1qoqjv3",
    "framer-16obh5m",
    "framer-1tpfy33",
    "framer-zxg4my",
    "framer-c9ojjv",
    "framer-1j4u6r2",
    "framer-tclpau",
    "framer-1ni6xjv",
    "framer-1es2jab",
    "framer-10jrcc6",
    "framer-jcrjvd",
    "framer-bvrrkp",
    "framer-18mdrb0",
    "framer-19ufz0c",
    "framer-a4eq25",
    "framer-fnwwxo",
    "framer-1wyam6m",
    "framer-1pp6x1n",
    "framer-1kx8h30",
    "framer-38qo6l",
    "framer-1bgkq86",
    "framer-1odgaps",
    "framer-ocebul",
    "framer-htsvoh",
    "framer-1rjcid1",
    "framer-1ppu9nu",
    "framer-b26c6s",
    "framer-k15ji",
    "framer-w1jb1u",
    "framer-1b65fof",
    "framer-ag946t",
    "framer-njpiav",
    "framer-fzosm0",
    "framer-31j99c",
    "framer-wbharp",
    "framer-1o6h43g",
    "framer-w8h1i4",
    "framer-u08o4f",
    "framer-1883ili",
    "framer-hhqq21",
    "framer-1qddyrc",
    "framer-36rsch",
    "framer-1vhup78",
    "framer-1wy0vut",
    "framer-1tldixq",
    "framer-vcglv4",
    "framer-mnkyk9",
    "framer-1gd8uia",
    "framer-4v17kk",
    "framer-wcgbdx",
    "framer-19ge0mq",
    "framer-142xl0d",
    "framer-ao5kmt",
    "framer-1rc6i1r",
    "framer-1wlwqo",
    "framer-1tzx2st",
    "framer-z8gsz9",
    "framer-1fgz62q",
    "framer-n6tpd7",
    "framer-1otl1h8",
    "framer-1vi730u",
    "framer-1klteqi",
    "framer-36msax",
    "framer-1feur12",
    "framer-1lyqxag",
    "framer-5a7aqr",
    "framer-82cjev",
    "framer-10a7t8v",
    "framer-7pex0i",
    "framer-1r4ihlp",
    "framer-1cjy5e6",
    "framer-1f59xpm",
    "framer-13qpo9p",
    "framer-160oi7c",
    "framer-8v07ff",
    "framer-ry0yv5",
    "framer-427f3i",
    "framer-jufpfh",
    "framer-1c3n6lw",
    "framer-ekq5up",
    "framer-1ki962m",
    "framer-15t1dfp",
    "framer-3s7e4w",
    "framer-1w1r0c7",
    "framer-cvvwij",
    "framer-1vpvxxf",
    "framer-149u646",
    "framer-1o7mum0",
    "framer-ki1v17",
    "framer-lhdvz8",
    "framer-jy0fht",
    "framer-99ymz4",
    "framer-p09ia0",
    "framer-13ehaqm",
    "framer-1wbmnsw",
    "framer-1ikz5w4",
    "framer-z4q1to",
    "framer-18xz9es",
    "framer-1l729uo",
    "framer-ft28bw",
    "framer-1ewgg5n",
    "framer-1qmstsw",
    "framer-cxuw29",
    "framer-cg40le",
    "framer-dutair",
    "framer-4oapi9",
    "framer-1erawlh",
    "framer-1y5k2gj",
    "framer-1lbic0v",
    "framer-1opocxv",
    "framer-12khtk0",
    "framer-bwyhrh",
    "framer-1uubtjq",
    "framer-140mxx7",
    "framer-1cx2l59",
    "framer-11lvdrf",
    "framer-10s17r7",
    "framer-1jsn0l4",
    "framer-7xfhaj",
    "framer-1rrd2yl",
    "framer-wr2mdi",
    "framer-tm9wqz",
    "framer-112ouxp",
    "framer-1wn4wwg",
    "framer-1qbbaf",
    "framer-rxy7g3",
    "framer-18g76l8",
    "framer-s30zx7",
    "framer-116wxpu",
    "framer-1c5xnue",
    "framer-qf8qx3",
    "framer-1odc6hn",
    "framer-19ap9de",
    "framer-1vff8z3",
    "framer-ythjyv",
    "framer-9z37yi",
    "framer-16w1k6o",
    "framer-1xcik3l",
    "framer-oukkhq",
    "framer-lqila1",
    "framer-1fdpwik",
    "framer-ekzdww",
    "framer-m2a85j",
    "framer-41rnem",
    "framer-19zo0xy",
    "framer-xk8c1l",
    "framer-lvrz1c",
    "framer-x277m4",
    "framer-jkqkpl",
    "framer-5hr7x3",
    "framer-1m0phhu",
    "framer-yi8kxp",
    "framer-1rjqh9s",
    "framer-g47dyw",
    "framer-q0k5a6",
    "framer-pcgh1x",
    "framer-xw0rvq",
    "framer-c3k2a9",
    "framer-1pdnlep",
    "framer-1isj3ve",
    "framer-1nzo316",
    "framer-ny2nrf",
    "framer-1dtzjxr",
    "framer-mu508z",
    "framer-qpfp6n",
    "framer-14eawsu",
    "framer-s21ssb",
    "framer-hqplw1",
    "framer-bklpz1",
    "framer-1imnrwl",
    "framer-gzpem3",
    "framer-1idhh85",
    "framer-1j46jly",
    "framer-1dsuymd",
    "framer-zogoby",
    "framer-1d3g9c1",
    "framer-1o544t5",
    "framer-1m6q3w4",
    "framer-mg2djc",
    "framer-17ralnl",
    "framer-1rurt58",
    "framer-gf48he",
    "framer-17zgy7z",
    "framer-1rzm2gb",
    "framer-y89xtg",
    "framer-106i2vh",
    "framer-p1tl7s",
    "framer-mtqgug",
    "framer-1788u0c",
    "framer-1wmn822",
    "framer-1v5bd5y",
    "framer-uo544c",
    "framer-7qtus5",
    "framer-gqq0zi",
    "framer-1drnvw6",
    "framer-17z9tw4",
    "framer-3bymer",
    "framer-mnk1l5",
    "framer-m79my0",
    "framer-14o7iob",
    "framer-wez924",
    "framer-1mgfm9b",
    "framer-45l0gt",
    "framer-zf9unh",
    "framer-11ud222",
    "framer-1mzlzv1",
    "framer-1fib5c",
    "framer-oaiogv",
    "framer-zep14j",
    "framer-1brj1ht",
    "framer-1pqx6tg",
    "framer-2wbw88",
    "framer-97hh1c",
    "framer-1scvxj2",
    "framer-usy4xf",
    "framer-1nrqj7q",
    "framer-1l8jyo7",
    "framer-1wj5wmr",
    "framer-5dbofz",
    "framer-1p29g0f",
    "framer-13hsqgp",
    "framer-k3f6s7",
    "framer-czp6kw",
    "framer-b8p4so",
    "framer-td5exg",
    "framer-rlul9t",
    "framer-1qbi01j",
    "framer-11yihtu",
    "framer-1jw3h1j",
    "framer-1982gyu",
    "framer-1kx8z1s",
    "framer-1jo2xb0",
    "framer-ozo1q7",
    "framer-lndw3q",
    "framer-1ggyd5i",
    "framer-1hi908g",
    "framer-1y8hrwf",
    "framer-bnxcb5",
    "framer-6ip5m0",
    "framer-5lgj4i",
    "framer-15gcew7",
    "framer-1h71ow4",
    "framer-1n1itqm",
    "framer-yyvhfo",
    "framer-1fh5h8g",
    "framer-1xq5s95",
    "framer-tecic8",
    "framer-cdfvoq",
    "framer-1gkcgnr",
    "framer-1xajlqd",
    "framer-wobegw",
    "framer-xezr57",
    "framer-is8obf",
    "framer-1adwqk8",
    "framer-zgffy0",
    "framer-1j53vuy",
    "framer-xsn7x8",
    "framer-1s80omz",
    "framer-k6zy4o",
    "framer-1wflc0e",
    "framer-2rt8zl",
    "framer-1drs3dv",
    "framer-f4fnpl",
    "framer-1oh6k57",
    "framer-15ghu57",
    "framer-u9hm8p",
    "framer-9ayv4y",
    "framer-uiax3g",
    "framer-nhfppx",
    "framer-10skth4",
    "framer-zvsym",
    "framer-1dguqyv",
    "framer-10j66y7",
    "framer-asyr5b",
    "framer-1kiw2qy",
    "framer-f4zdyj",
    "framer-qp5ir6",
    "framer-ugpy4l",
    "framer-1v5qg4b",
    "framer-l8awnf",
    "framer-1gmovvw",
    "framer-sutdmt",
    "framer-1trny2v",
    "framer-1cdohfe",
    "framer-t9fqjc",
    "framer-1xtosav",
    "framer-vk3hjo",
    "framer-sreof1",
    "framer-3qmhxn",
    "framer-hplkdw",
    "framer-1pthapd",
    "framer-xc32tt",
    "framer-1u11iky",
    "framer-d6cngf",
    "framer-1i34tns",
    "framer-906618",
    "framer-1y2a24g",
    "framer-1i7zrv5",
    "framer-1suuahx",
    "framer-1oyg0cr",
    "framer-n55er7",
    "framer-1en2cnq",
    "framer-psjjo8",
    "framer-14r2wfh",
    "framer-fbzlsf",
    "framer-vmchm3",
    "framer-i91vgm",
    "framer-yi8kes",
    "framer-1n4420v",
    "framer-198giob",
    "framer-g8x8gx",
    "framer-1mhsv49",
    "framer-1nh0jro",
    "framer-1lwq65t",
    "framer-1qd6oi",
    "framer-7ps415",
    "framer-sljn5b",
    "framer-gbdnvn",
    "framer-1hbglek",
    "framer-pdko06",
    "framer-1mx2enx",
    "framer-sr9rxt",
    "framer-68e1wx",
    "framer-1x2z7rq",
    "framer-15apzd",
    "framer-iytitg",
    "framer-v0ogr5",
    "framer-9vo8zm",
    "framer-ud6nss",
    "framer-978p0s",
    "framer-8pji0e",
    "framer-12jhrfd",
    "framer-d2s7aa",
    "framer-l0sqmy",
    "framer-1qa7u6k",
    "framer-tquodz",
    "framer-yncmmi",
    "framer-1xx4aok",
    "framer-1mqv4oz",
    "framer-vhaobv",
    "framer-6pkxu0",
    "framer-c34o2l",
    "framer-txmp65",
    "framer-od41ta",
    "framer-78b9vw",
    "framer-p4w8us",
    "framer-1e1cat9",
    "framer-47lkyg",
    "framer-1nyvkz",
    "framer-16wwq2l",
    "framer-ohb4se",
    "framer-fdn6q4",
    "framer-1rsqnb8",
    "framer-18lxnea"
  ],
  "frameMs": {
    "incoming": 280,
    "queue": 300,
    "executor": 220,
    "batch": 360,
    "risk": 160,
    "prover": 280
  }
}
